import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { graphql, ResponseResolver, GraphQLRequest, GraphQLContext } from 'msw'
export type Maybe<T> = T | undefined | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: string;
  Date: string;
  Long: number;
  Object: object;
};

export type ActivateUser = {
  __typename?: 'ActivateUser';
  /** 휴면 계정 활성화 시간 */
  requestExpireTime?: Maybe<Scalars['String']>;
};

export type AgeAuth = {
  __typename?: 'AgeAuth';
  age?: Maybe<Scalars['Int']>;
  authenticatedAt?: Maybe<Scalars['Date']>;
  bypassAgeLimit?: Maybe<Scalars['Boolean']>;
  status: ResultStatus;
};

export enum AgeGrade {
  All = 'All',
  Eighteen = 'Eighteen',
  Fifteen = 'Fifteen',
  Nineteen = 'Nineteen'
}

export type AgreedAgreement = {
  __typename?: 'AgreedAgreement';
  agreedDate: Scalars['Date'];
  isAgreed: Scalars['Boolean'];
  type: AgreementType;
  version: Scalars['Int'];
};

export type Agreement = {
  __typename?: 'Agreement';
  isRequired: Scalars['Boolean'];
  title: Scalars['String'];
  type: AgreementType;
  uid: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
};

export type AgreementContainer = {
  __typename?: 'AgreementContainer';
  itemList: Array<Agreement>;
};

export type AgreementForm = {
  agreed: Scalars['Boolean'];
  type: AgreementType;
  version: Scalars['Int'];
};

/** 약관은 공통약관과 14세 미만의 이용자에 대한 약관으로 나뉜다. */
export type AgreementInfo = {
  __typename?: 'AgreementInfo';
  agreement: AgreementContainer;
  agreementUnder14?: Maybe<AgreementUnder14Container>;
  isRegistered: Scalars['Boolean'];
};

export enum AgreementType {
  ChildMarketingThird = 'ChildMarketingThird',
  ChildPersonalInformationThird = 'ChildPersonalInformationThird',
  ChildPrivacy = 'ChildPrivacy',
  FreeTicketCashPresentNoti = 'FreeTicketCashPresentNoti',
  Friends = 'Friends',
  KakaoTerm = 'KakaoTerm',
  /** 14세 미만 보호자 인증 약관 리스트 */
  LegalAgentPrivacy = 'LegalAgentPrivacy',
  Marketing = 'Marketing',
  NightMarketing = 'NightMarketing',
  None = 'None',
  Over14 = 'Over14',
  PersonalInformation = 'PersonalInformation',
  PersonalInformationThird = 'PersonalInformationThird',
  Privacy = 'Privacy',
  TermsPaid = 'TermsPaid',
  Under14 = 'Under14'
}

export type AgreementUnder14Container = {
  __typename?: 'AgreementUnder14Container';
  /**
   * 14세 이상 여부를 확인할 수 있는 약관 타입 정보입니다. 14세 미만 유저의 경우 보호자 동의 팝업을 보여줍니다.
   * 현재는 J타입이 내려옵니다.
   */
  atLeast14AgeType: AgreementType;
  itemList: Array<Agreement>;
  title: Scalars['String'];
};

export type AlarmSection = Section & {
  __typename?: 'AlarmSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type Announcement = {
  __typename?: 'Announcement';
  contents: Scalars['String'];
  createDt: Scalars['Date'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type AnnouncementContainer = {
  __typename?: 'AnnouncementContainer';
  items: Array<Announcement>;
  totalCount: Scalars['Int'];
};

/** 공지 및 도움말을 볼 수 있는 타겟. 인앱에서 들어온 경우 해당 OS 정보 */
export enum AnnouncementTarget {
  All = 'All',
  Android = 'Android',
  Ios = 'Ios'
}

export type AppBadge = {
  __typename?: 'AppBadge';
  /** 혜택함 > 오늘의 선물 N뱃지 */
  giftLastAddedDate?: Maybe<Scalars['Date']>;
  /** 마지막 알람 등록일 */
  myNewsLastAddedDate?: Maybe<Scalars['Date']>;
  /** 마지막 공지사항 등록일 */
  noticeLastAddedDate?: Maybe<Scalars['Date']>;
};

export type AppConfig = {
  __typename?: 'AppConfig';
  appBadge?: Maybe<AppBadge>;
  appInit?: Maybe<AppInit>;
  appSetting?: Maybe<AppSetting>;
};

export type AppInit = {
  __typename?: 'AppInit';
  /** 본인인증 타입 */
  certType?: Maybe<CertType>;
};

export type AppSetting = {
  __typename?: 'AppSetting';
  /** 취향 선호 장르 */
  tastesGenre?: Maybe<Scalars['String']>;
  /** 취향홈 메뉴 uid */
  tastesHome?: Maybe<Scalars['Int']>;
  tastesServiceLang?: Maybe<TastesServiceLang>;
};

export type AppSettingInput = {
  tastesGenre?: Maybe<Scalars['String']>;
  tastesHome?: Maybe<Scalars['Int']>;
  tastesServiceLang?: Maybe<Scalars['String']>;
};

export type AppSettingPayload = {
  __typename?: 'AppSettingPayload';
  status: ResultStatus;
};

/** AssetPropertyVo 에 대응됨 */
export type AssetProperty = {
  __typename?: 'AssetProperty';
  /** * 배너 이미지 */
  bannerImage?: Maybe<Scalars['String']>;
  /** * (신규에셋) banner set */
  bannerSet?: Maybe<BannerSet>;
  /** * (작품 표지 신규에셋) card cover */
  cardCover?: Maybe<CardCover>;
  /** * 카드 이미지 */
  cardImage?: Maybe<Scalars['String']>;
  /** * (신규에셋) card set */
  cardSet?: Maybe<CardSet>;
  /** * 카드 텍스트 이미지 */
  cardTextImage?: Maybe<Scalars['String']>;
  /** 클린뷰 이미지 */
  cleanImage?: Maybe<Scalars['String']>;
  /** * IPX 영상 */
  ipxVideo?: Maybe<Scalars['String']>;
};

export type AuthBankAccountInput = {
  /** 계좌 번호 */
  bankAccountNumber: Scalars['String'];
  /** 예금주 */
  bankAccountOwnerName: Scalars['String'];
  /** 은행코드 */
  bankCode: Scalars['String'];
};

export type AuthInfo = {
  __typename?: 'AuthInfo';
  age: Scalars['Int'];
  /** App으로 바로 넘겨야하는 값이라 server string 그대로 보내야함(Date 사용하면 안됨) */
  updatedAt?: Maybe<Scalars['String']>;
};

export type AuthInput = {
  accessToken?: Maybe<Scalars['String']>;
  appUserId?: Maybe<Scalars['Int']>;
};

export type AuthRequestInfo = {
  __typename?: 'AuthRequestInfo';
  /** certType = NICE, KAKAOBANK 인 경우 전달 (S2S 인증 URL) */
  authUrl?: Maybe<Scalars['String']>;
};

export type AuthRequestInfoError = {
  message: Scalars['String'];
};

export enum AuthRequestType {
  /** 보호자 본인 인증 */
  Parents = 'Parents',
  /** 본인 인증 */
  Self = 'Self'
}

/** AuthorVo 에 대응됨 */
export type Author = {
  __typename?: 'Author';
  id: Scalars['ID'];
  /** 작가명 */
  name: Scalars['String'];
  /** 역할 (writer, illustrator 등) */
  role: Scalars['String'];
  /** 역할이 화면에 표시되는 값(글, 그림 등) */
  roleDisplayName: Scalars['String'];
};

/** AuthorsVo 에 대응됨 */
export type Authors = {
  __typename?: 'Authors';
  id: Scalars['ID'];
  /** 그림 */
  illustrator?: Maybe<Scalars['String']>;
  /** 원작 */
  originalAuthor?: Maybe<Scalars['String']>;
  /** 기획 */
  plan?: Maybe<Scalars['String']>;
  /** 연출 */
  production?: Maybe<Scalars['String']>;
  /** 감수 */
  reviewer?: Maybe<Scalars['String']>;
  /** 사운드 */
  sound?: Maybe<Scalars['String']>;
  /** 역자 */
  translator?: Maybe<Scalars['String']>;
  /** 영상 */
  video?: Maybe<Scalars['String']>;
  /** 글 */
  writer?: Maybe<Scalars['String']>;
};

export type AutoCompleteItem = {
  __typename?: 'AutoCompleteItem';
  text: Scalars['String'];
  url: Scalars['String'];
};

export type AutomaticEvent = {
  __typename?: 'AutomaticEvent';
  destinationInfoIos?: Maybe<Scalars['String']>;
  destinationInfoWeb?: Maybe<Scalars['String']>;
  destinationTypeAndroid?: Maybe<Scalars['String']>;
  destinationTypeIos?: Maybe<Scalars['String']>;
  itemOrder?: Maybe<Scalars['String']>;
  resourceHeight?: Maybe<Scalars['Int']>;
  resourceUrl?: Maybe<Scalars['String']>;
  resourceWidth?: Maybe<Scalars['Int']>;
  schemeAndroid?: Maybe<Scalars['String']>;
  schemeIos?: Maybe<Scalars['String']>;
  schemeWeb?: Maybe<Scalars['String']>;
};

export enum BadgeType {
  Badge0HourWaitfreeStatic = 'Badge0HourWaitfreeStatic',
  Badge1HourWaitfreeStatic = 'Badge1HourWaitfreeStatic',
  Badge2HourWaitfreeStatic = 'Badge2HourWaitfreeStatic',
  Badge3HourWaitfree = 'Badge3HourWaitfree',
  Badge3HourWaitfreeStatic = 'Badge3HourWaitfreeStatic',
  BadgeAge15Static = 'BadgeAge15Static',
  BadgeAge18Static = 'BadgeAge18Static',
  BadgeAge19CensorshipStatic = 'BadgeAge19CensorshipStatic',
  BadgeAge19Static = 'BadgeAge19Static',
  BadgeEventStatic = 'BadgeEventStatic',
  BadgeLock = 'BadgeLock',
  BadgeNewStatic = 'BadgeNewStatic',
  BadgeNovelStatic = 'BadgeNovelStatic',
  BadgeRealFreeStatic = 'BadgeRealFreeStatic',
  BadgeUnlock = 'BadgeUnlock',
  BadgeUpStatic = 'BadgeUpStatic',
  BadgeWaitFreeStatic = 'BadgeWaitFreeStatic'
}

export type BankCode = {
  __typename?: 'BankCode';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BannerItem = Item & {
  __typename?: 'BannerItem';
  altText?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  /** bmBadge */
  badgeList: Array<BadgeType>;
  bannerType: BannerType;
  /** square, rectangle */
  bannerViewType: BannerViewType;
  caption?: Maybe<Scalars['String']>;
  characterImage?: Maybe<Scalars['String']>;
  discountRate?: Maybe<Scalars['Int']>;
  discountRateText?: Maybe<Scalars['String']>;
  eventLog?: Maybe<EventLog>;
  id: Scalars['ID'];
  metaList?: Maybe<Array<Scalars['String']>>;
  scheme?: Maybe<Scalars['String']>;
  seriesId?: Maybe<Scalars['Long']>;
  serviceProperty?: Maybe<ServiceProperty>;
  statusBadge?: Maybe<BadgeType>;
  thumbnail: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  titleImage?: Maybe<Scalars['String']>;
  type: ItemType;
  videoUrl?: Maybe<Scalars['String']>;
};

export type BannerSet = {
  __typename?: 'BannerSet';
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  titleImage?: Maybe<Scalars['String']>;
};

export enum BannerType {
  Image = 'Image',
  Video = 'Video'
}

export enum BannerViewType {
  /** 16:9 배너 */
  Rectangle = 'Rectangle',
  /** 1:1 배너 */
  Square = 'Square',
  /** 알수없음. 이 케이스일 가능성은 없음 */
  Unknown = 'Unknown'
}

export type BestCommentListInput = {
  page: Scalars['Int'];
  productId?: Maybe<Scalars['Long']>;
  seriesId: Scalars['Long'];
  size?: Maybe<Scalars['Int']>;
};

export type BigBannerGroup = Group & {
  __typename?: 'BigBannerGroup';
  bannerViewType: BannerViewType;
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export type BigBannerSection = Section & {
  __typename?: 'BigBannerSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};


export enum BillingStatusCode {
  /** 환불 가능한 잔액이 존재하지 않음 */
  InsufficientBalance = 'InsufficientBalance',
  /** 유효하지 않은 은행 계좌 */
  InvalidBankAccount = 'InvalidBankAccount',
  /** 은행 계좌 소유자의 이름(은행API의 전달값)과 사용자의 이름이 일치하지 않음 */
  NotEqualBankAccountOwnerName = 'NotEqualBankAccountOwnerName',
  /** 이미 환불 요청이 진행중임 */
  RequestAlreadyInProgress = 'RequestAlreadyInProgress',
  /** 환불 가능한 캐시가 존재하지 않음(요청 금액 > 실제 요청한 금액) */
  RequestAmountExceedsAvailableAmount = 'RequestAmountExceedsAvailableAmount',
  /** 환불 요청한 금액이 실제 환불 금액과 일치하지 않음 */
  RequestAmountNotMatched = 'RequestAmountNotMatched',
  /** 성공 */
  Success = 'Success',
  /** 본인인증 되지 않은 사용자 */
  Unauthenticated = 'Unauthenticated',
  /** 언노운 */
  Unknown = 'Unknown'
}

export type BlockUserInput = {
  state: Scalars['Boolean'];
  userUid: Scalars['Int'];
};

export type BlockUserList = {
  __typename?: 'BlockUserList';
  list: Array<Scalars['Int']>;
};

/** 판매정책 참고 : https://podotree.atlassian.net/wiki/spaces/SVC/pages/2630911724#2.-%EC%BD%98%ED%85%90%EC%B8%A0%ED%99%88-%EA%B5%AC%EC%A1%B0 */
export enum Bm {
  /** 무료BM */
  Free = 'Free',
  /** 무료BM + 미리보기 */
  FreePreview = 'FreePreview',
  /** 복합(유료 + 무료)BM */
  MixedPay = 'MixedPay',
  /** 복합(기다무 + 무료)BM */
  MixedWaitfree = 'MixedWaitfree',
  /** 유료BM */
  Pay = 'Pay',
  /** 유료BM + 기다무 */
  PayWaitfree = 'PayWaitfree'
}

export type BuyCashHistoryList = {
  __typename?: 'BuyCashHistoryList';
  banner?: Maybe<HistoryLineBanner>;
  expiredCredit?: Maybe<ExpiredCredit>;
  list: Array<History>;
  paging?: Maybe<Paging>;
};

/** BuyHistoryDto에 대응됨 */
export type BuyHistory = {
  __typename?: 'BuyHistory';
  createdDt?: Maybe<Scalars['Date']>;
  isRefundable?: Maybe<Scalars['Boolean']>;
  saleType?: Maybe<SaleType>;
  ticketKind?: Maybe<TicketKind>;
  ticketType?: Maybe<TicketType>;
  ticketUid?: Maybe<Scalars['BigInt']>;
  title?: Maybe<Scalars['String']>;
};

export type CardCover = {
  __typename?: 'CardCover';
  coverImg?: Maybe<Scalars['String']>;
  coverRestricted?: Maybe<Scalars['Boolean']>;
};

export type CardSection = RecommendSection & Section & {
  __typename?: 'CardSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  isRecommendArea?: Maybe<Scalars['Boolean']>;
  isRecommendedItems?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type CardSet = {
  __typename?: 'CardSet';
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Scalars['String']>;
};

export type CardViewGroup = Group & {
  __typename?: 'CardViewGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  meta?: Maybe<ListViewGroupMeta>;
  type: GroupType;
};

export type CardViewItem = Item & {
  __typename?: 'CardViewItem';
  /** 19세 작품 + 만 19세 미만(혹, 미인증)인 경우 썸네일 가리기 등 별도 처리를 해야합니다. */
  ageGrade: AgeGrade;
  ageGradeBadge?: Maybe<BadgeType>;
  altText?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  /** bmBadge */
  badgeList: Array<BadgeType>;
  caption?: Maybe<Scalars['String']>;
  cardCover?: Maybe<CardCover>;
  categoryType?: Maybe<CategoryType>;
  discountRate?: Maybe<Scalars['Int']>;
  discountRateText?: Maybe<Scalars['String']>;
  eventLog?: Maybe<EventLog>;
  id: Scalars['ID'];
  isBook?: Maybe<Scalars['Boolean']>;
  isEventBanner?: Maybe<Scalars['Boolean']>;
  isLegacy?: Maybe<Scalars['Boolean']>;
  rank?: Maybe<Scalars['String']>;
  rankVariation?: Maybe<Scalars['Int']>;
  scheme?: Maybe<Scalars['String']>;
  selfCensorship?: Maybe<Scalars['Boolean']>;
  statusBadge?: Maybe<BadgeType>;
  subtitleList?: Maybe<Array<Scalars['String']>>;
  thumbnail: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: ItemType;
};

export type Cash = {
  __typename?: 'Cash';
  discountRate?: Maybe<Scalars['Int']>;
  setDiscountRate?: Maybe<Scalars['Int']>;
};

export type CashFriendsSection = SchemeSection & Section & {
  __typename?: 'CashFriendsSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  scheme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type CategorySelectedDayPair = {
  __typename?: 'CategorySelectedDayPair';
  categoryTabUid?: Maybe<Scalars['Int']>;
  dayTabUid?: Maybe<Scalars['Int']>;
};

export enum CategoryType {
  /** 책: 16 */
  Book = 'Book',
  /** 카톡소설: 1000 */
  KatalkNovel = 'KatalkNovel',
  /** 톡드립: 18 */
  TalkDrip = 'TalkDrip',
  Unknown = 'Unknown',
  /** 웹소설: 11 */
  Webnovel = 'Webnovel',
  /** 웹툰: 10 */
  Webtoon = 'Webtoon'
}

export enum CertType {
  /** 드림시큐리티 V2 */
  DreamSecurity = 'DreamSecurity',
  /** 카카오뱅크 */
  KakaoBank = 'KakaoBank',
  /** 나이스평가정보 */
  Nice = 'Nice'
}

export type ChangeEmailPasswordInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  verifyUuid: Scalars['String'];
};

export type Character = {
  __typename?: 'Character';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type CheckEmailVerifyCodeInput = {
  verifyCode: Scalars['String'];
  verifyType: SendEmailVerifyType;
  verifyUuid: Scalars['String'];
};

export type CheckUnregister = {
  __typename?: 'CheckUnregister';
  hasPaidCash: Scalars['Boolean'];
  hasPaidTickets: Scalars['Boolean'];
  paidCashAmount?: Maybe<Scalars['Int']>;
};

export type CleanViewGroup = Group & {
  __typename?: 'CleanViewGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export type CleanViewItem = Item & {
  __typename?: 'CleanViewItem';
  /** 19세 작품 + 만 19세 미만(혹, 미인증)인 경우 썸네일 가리기 등 별도 처리를 해야합니다. */
  ageGrade: AgeGrade;
  ageGradeBadge?: Maybe<BadgeType>;
  /** bmBadge */
  badgeList: Array<BadgeType>;
  discountRate?: Maybe<Scalars['Int']>;
  discountRateText?: Maybe<Scalars['String']>;
  eventLog?: Maybe<EventLog>;
  id: Scalars['ID'];
  rank?: Maybe<Scalars['String']>;
  scheme?: Maybe<Scalars['String']>;
  selfCensorship?: Maybe<Scalars['Boolean']>;
  /** 동영상뷰어, 숏영상뷰어는 재생 아이콘 노출. */
  showPlayerIcon: Scalars['Boolean'];
  statusBadge?: Maybe<BadgeType>;
  subtitleList?: Maybe<Array<Scalars['String']>>;
  thumbnail: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: ItemType;
};

export type ClickLog = {
  __typename?: 'ClickLog';
  copy?: Maybe<Scalars['String']>;
  imp_id?: Maybe<Scalars['String']>;
  imp_provider?: Maybe<Scalars['String']>;
  layer1?: Maybe<Scalars['String']>;
  layer2?: Maybe<Scalars['String']>;
  ordnum?: Maybe<Scalars['String']>;
  setnum?: Maybe<Scalars['String']>;
};

export type CommentCommonPayload = {
  __typename?: 'CommentCommonPayload';
  recordid?: Maybe<Scalars['ID']>;
  status: ResultStatus;
};

export type CommentItem = {
  __typename?: 'CommentItem';
  blocked?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  commentStatus?: Maybe<Scalars['String']>;
  commentType?: Maybe<Scalars['String']>;
  commentUid: Scalars['Int'];
  createDt?: Maybe<Scalars['Date']>;
  deleted?: Maybe<Scalars['Boolean']>;
  emoticon?: Maybe<Emoticon>;
  expose?: Maybe<Scalars['Boolean']>;
  hidden?: Maybe<Scalars['String']>;
  isBest?: Maybe<Scalars['Boolean']>;
  isSpoiler?: Maybe<Scalars['Boolean']>;
  likeCount?: Maybe<Scalars['Int']>;
  liked?: Maybe<Scalars['Boolean']>;
  live?: Maybe<Scalars['String']>;
  myReplyCount?: Maybe<Scalars['Int']>;
  orderValue?: Maybe<Scalars['Int']>;
  parentUid?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Long']>;
  replyCount?: Maybe<Scalars['Int']>;
  seriesId?: Maybe<Scalars['Long']>;
  title?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  userThumbnailUrl?: Maybe<Scalars['String']>;
  userUid?: Maybe<Scalars['Int']>;
};

export type CommentList = {
  __typename?: 'CommentList';
  bestTotalCount?: Maybe<Scalars['Int']>;
  commentList: Array<CommentItem>;
  isEnd: Scalars['Boolean'];
  selectedSortOpt?: Maybe<SortOption>;
  sortOptList?: Maybe<Array<Maybe<SortOption>>>;
  totalCount: Scalars['Int'];
};

export type CommentListInput = {
  lastCommentUid?: Maybe<Scalars['Int']>;
  lastCreatedDt?: Maybe<Scalars['String']>;
  lastLikeCount?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['Int']>;
  page: Scalars['Int'];
  parentUid?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Long']>;
  seriesId?: Maybe<Scalars['Long']>;
  size?: Maybe<Scalars['Int']>;
  /** 최신순 latest 좋아요순 like  (default : latest) */
  sortType?: Maybe<Scalars['String']>;
};

/**
 * 이용권 충전 화면을 나타내는 타입입니다
 * TicketListResultVo 에 대응됩니다
 */
export type ContentBuyTicketPage = {
  __typename?: 'ContentBuyTicketPage';
  bannerList: Array<SimpleImageBanner>;
  ticketInfo?: Maybe<ContentTicketInfo>;
};

/**
 * 무료 이용권 지급 확인
 * @link ticket/free_check
 */
export type ContentCheckFreeTicket = {
  __typename?: 'ContentCheckFreeTicket';
  list: Array<TicketSum>;
};

/** ContentDetailVo 에 대응됨 */
export type ContentDetail = {
  __typename?: 'ContentDetail';
  ageGrade?: Maybe<AgeGrade>;
  /** 카테고리 정보. 대분류 | 장르 */
  category?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** 발행자 */
  publisherName?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['String']>;
  /**
   * 전자책 정가
   * 예: 500원/1권 당
   */
  retailPrice?: Maybe<Scalars['String']>;
};

/** 콘텐츠홈 작품소개 영역에서 보여지는 데이터입니다 */
export type ContentHomeAbout = {
  __typename?: 'ContentHomeAbout';
  authorList: Array<Author>;
  characterList?: Maybe<Array<Maybe<Character>>>;
  description: Scalars['String'];
  detail?: Maybe<ContentDetail>;
  detailInfoList?: Maybe<Array<ContentHomeDetailInfo>>;
  guideTitle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  screenshotList: Array<Scalars['String']>;
  /** 테마키워드. 최대 15개 노출 */
  themeKeywordList: Array<ThemeKeyword>;
};

export enum ContentHomeBadgeType {
  Badge0HourWaitfree = 'Badge0HourWaitfree',
  Badge1HourWaitfree = 'Badge1HourWaitfree',
  Badge2HourWaitfree = 'Badge2HourWaitfree',
  Badge3HourWaitfree = 'Badge3HourWaitfree',
  Badge15Static = 'Badge15Static',
  Badge19SelfStatic = 'Badge19SelfStatic',
  Badge19Static = 'Badge19Static',
  BadgeWaitfree = 'BadgeWaitfree',
  LabelBadgeDayOfWeek = 'LabelBadgeDayOfWeek',
  LabelBadgeSaleIng = 'LabelBadgeSaleIng',
  LabelBadgeSaleRest = 'LabelBadgeSaleRest',
  LabelBadgeSaleStop = 'LabelBadgeSaleStop',
  LabelBadgeWaitInfo = 'LabelBadgeWaitInfo'
}

/** 콘텐츠홈 요약회차 리스트 */
export type ContentHomeBriefList = {
  __typename?: 'ContentHomeBriefList';
  id: Scalars['ID'];
  list: Array<SingleListViewItem>;
  seriesId: Scalars['Long'];
  totalCount: Scalars['Int'];
};

export type ContentHomeDetailInfo = {
  __typename?: 'ContentHomeDetailInfo';
  info?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
};

export type ContentHomeInfo = {
  __typename?: 'ContentHomeInfo';
  about?: Maybe<ContentHomeAbout>;
  recommend?: Maybe<ContentHomeRecommend>;
};

export type ContentHomeInfoRankingLanding = {
  __typename?: 'ContentHomeInfoRankingLanding';
  rank?: Maybe<Scalars['String']>;
  scheme?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type ContentHomeLabelBadge = {
  __typename?: 'ContentHomeLabelBadge';
  badgeType?: Maybe<ContentHomeBadgeType>;
  label?: Maybe<Scalars['String']>;
};

/** 콘텐츠홈 소식탭 영역에서 보여지는 데이터입니다 */
export type ContentHomeNotice = {
  __typename?: 'ContentHomeNotice';
  id: Scalars['ID'];
  lineBannerList: Array<LineBannerItem>;
  noticeListContainer?: Maybe<SeriesNoticeListContainer>;
  /** TODO: 스펙상 RecommendEventVo로 쓰여있는데 확인 필요함 */
  relatedEventList: Array<RecommendEvent>;
  seriesId: Scalars['Long'];
  topNotice?: Maybe<SeriesNotice>;
};

export type ContentHomeNoticeInput = {
  page: Scalars['Long'];
  seriesId: Scalars['Long'];
};

export type ContentHomeOverview = {
  __typename?: 'ContentHomeOverview';
  /** 콘텐츠홈 상단에 노출될 작품 관련 정보 */
  content?: Maybe<Series>;
  displayAd?: Maybe<DisplayAd>;
  id: Scalars['ID'];
  /** 최근 소식 일시 */
  lastNoticeDate?: Maybe<Scalars['Date']>;
  /** 웹툰 <-> 웹소설 동일작 크로스오버 */
  relatedSeries?: Maybe<Series>;
  seriesId: Scalars['Long'];
  /** 캐시타입 작품홈 세트 리스트 */
  setList?: Maybe<Array<Maybe<NormalListViewItem>>>;
};

export type ContentHomeRecommend = {
  __typename?: 'ContentHomeRecommend';
  id: Scalars['ID'];
  list: Array<ContentRecommendGroup>;
  seriesId: Scalars['Long'];
};

/**
 * 콘텐츠에 보유한 이용권 목록
 * @link TicketMyResultVo
 */
export type ContentMyTicket = {
  __typename?: 'ContentMyTicket';
  /**
   * 원본키 : library.not_own_count \
   * 미소장 회차 수
   */
  notOwnCount?: Maybe<Scalars['Int']>;
  /**
   * 원본키 : library.not_read_count \
   * 미열람 회차 수
   */
  notReadCount?: Maybe<Scalars['Int']>;
  /**
   * 원본키 : my.ticket_own_count \
   * 보유 소장 이용권 수 (기다무 제외)
   */
  ticketOwnCount: Scalars['Int'];
  /**
   * 원본키 : my.ticket_rental_count \
   * 보유 대여 이용권 수 (기다무 제외)
   */
  ticketRentalCount: Scalars['Int'];
  waitfree?: Maybe<ContentWaitfreeInfo>;
};

/** 콘텐츠홈, 뷰어엔드 추천 영역 표현을 위한 그룹 표현하기 위한 그룹. */
export type ContentRecommendGroup = Group & {
  __typename?: 'ContentRecommendGroup';
  dataKey?: Maybe<Scalars['String']>;
  /** 추천 사유 */
  description?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  /** 추천을 위한 layer */
  impLabel?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Item>>;
  title?: Maybe<Scalars['String']>;
  type: GroupType;
};

export type ContentSetList = {
  __typename?: 'ContentSetList';
  setList?: Maybe<Array<NormalListViewItem>>;
};

export type ContentSetOverview = {
  __typename?: 'ContentSetOverview';
  productList?: Maybe<Array<Maybe<PosterViewItem>>>;
  series?: Maybe<Series>;
  set?: Maybe<Set>;
};

export type ContentTicketHistoryBuy = {
  __typename?: 'ContentTicketHistoryBuy';
  isEnd?: Maybe<Scalars['Boolean']>;
  list?: Maybe<Array<BuyHistory>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ContentTicketHistoryBuyDetail = {
  __typename?: 'ContentTicketHistoryBuyDetail';
  availableAmount?: Maybe<Scalars['Int']>;
  createdDt?: Maybe<Scalars['Date']>;
  expiredAmount?: Maybe<Scalars['Int']>;
  isSet?: Maybe<Scalars['Boolean']>;
  list?: Maybe<Array<TicketHistoryBuyExtraSimple>>;
  payId?: Maybe<Scalars['BigInt']>;
  price?: Maybe<Scalars['Int']>;
  ticketType?: Maybe<TicketType>;
  ticketTypeText?: Maybe<Scalars['String']>;
};

/**
 * 콘텐츠에 구매 가능한 이용권 목록
 * @link TicketListResultVo
 */
export type ContentTicketInfo = {
  __typename?: 'ContentTicketInfo';
  isSaleOwnTicket: Scalars['Boolean'];
  isSaleRentalTicket: Scalars['Boolean'];
  /**
   * 원본키 : own_ticket_list
   * 구매 가능한 이용권 목록 > 소장
   */
  purchasableOwnTicketList: Array<TicketInfoApi>;
  /**
   * 원본키 : rental_ticket_list
   * 구매 가능한 이용권 목록 > 대여
   */
  purchasableRentalTicketList: Array<TicketInfoApi>;
  rentalPeriodByMinute?: Maybe<Scalars['Int']>;
};

/** @link TicketMyResultVo.waitfree */
export type ContentWaitfreeInfo = {
  __typename?: 'ContentWaitfreeInfo';
  activation: Scalars['Boolean'];
  baseDate?: Maybe<Scalars['Date']>;
  chargedAt?: Maybe<Scalars['Date']>;
  chargedComplete?: Maybe<Scalars['Boolean']>;
  /** 사용자의 현재 기다무이용권 충전시간 (분) */
  chargedPeriodByMinute?: Maybe<Scalars['Int']>;
};

/**
 * 싱글이냐 시리즈냐 여부
 * ContentsTypeVo 에 대응됩
 */
export enum ContentsType {
  Series = 'Series',
  Set = 'Set',
  Single = 'Single'
}

/** 다음에 읽을 회차. 보관함, 콘텐츠홈에서 사용 */
export type ContinueInfo = {
  __typename?: 'ContinueInfo';
  continueProductType?: Maybe<ContinueProductType>;
  /** 최신 회차 업데이트가 있는지 여부 */
  hasNewSingle?: Maybe<Scalars['Boolean']>;
  /** 미열람 회차가 있는지 여부 */
  hasUnreadSingle?: Maybe<Scalars['Boolean']>;
  isFree?: Maybe<Scalars['Boolean']>;
  /** 마지막 읽은 회차 */
  lastReadProductId?: Maybe<Scalars['Long']>;
  productId: Scalars['Long'];
  scheme: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export enum ContinueProductType {
  First = 'First',
  /** 이어보기와 동일 */
  Last = 'Last',
  Next = 'Next'
}

export enum CreditStatus {
  /** R07 (잔액환불) */
  BalanceRefund = 'BalanceRefund',
  /** R02 (충전취소) */
  CancelCharge = 'CancelCharge',
  /** R10 (충전취소환불) */
  CancelChargeRefund = 'CancelChargeRefund',
  /** R23 (소진부분취소) */
  CancelExhaustedPart = 'CancelExhaustedPart',
  /** R22 (소진취소) */
  CancelExhaustion = 'CancelExhaustion',
  /** R01 (충전) */
  Charge = 'Charge',
  /** R05 (관리자지급) */
  EventCash = 'EventCash',
  /** R21 (소진) */
  Exhaust = 'Exhaust',
  /** R11 (캐시소멸) */
  ExtinctCash = 'ExtinctCash',
  /** R03 (환불) */
  Refund = 'Refund',
  /** R08 (이관적립) */
  TransferAccumulation = 'TransferAccumulation',
  /** R09 (이관차감) */
  TransferDeduction = 'TransferDeduction',
  /** R06 (관리자회수) */
  WithdrawByAdmin = 'WithdrawByAdmin',
  /** R04 (기간만료회수) */
  WithdrawEventCash = 'WithdrawEventCash'
}

export type CustomProps = {
  __typename?: 'CustomProps';
  banner_uid?: Maybe<Scalars['String']>;
  content_cnt?: Maybe<Scalars['String']>;
  event_layer?: Maybe<Scalars['String']>;
  event_series_id?: Maybe<Scalars['String']>;
  event_ticket_type?: Maybe<Scalars['String']>;
  helix_id?: Maybe<Scalars['String']>;
  helix_seed?: Maybe<Scalars['String']>;
  helix_yn?: Maybe<Scalars['String']>;
  landing_path?: Maybe<Scalars['String']>;
  play_url?: Maybe<Scalars['String']>;
  rec_id?: Maybe<Scalars['String']>;
  section_type?: Maybe<Scalars['String']>;
  view_type?: Maybe<Scalars['String']>;
};


export enum DayOfWeekBmType {
  A = 'A',
  P = 'P',
  W = 'W'
}

/** 요일연재 레이아웃 API */
export type DayOfWeekLayout = {
  __typename?: 'DayOfWeekLayout';
  dayList: Array<FilterOption>;
  referenceList: Array<FilterOption>;
  selectedDay: FilterOption;
  selectedReference: FilterOption;
  selectedSort: FilterOption;
  sortList: Array<FilterOption>;
};

/** 요일연재 리스트 API */
export type DayOfWeekList = {
  __typename?: 'DayOfWeekList';
  banner?: Maybe<BannerItem>;
  isEnd: Scalars['Boolean'];
  list: Array<CardViewItem>;
  title: Scalars['String'];
};

export type DayOfWeekSection = Section & TabSection & {
  __typename?: 'DayOfWeekSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  sectionMainTabList?: Maybe<Array<SectionMainTab>>;
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type DeclareCommentInput = {
  commentUid: Scalars['Int'];
  declareComment?: Maybe<Scalars['String']>;
  declareType: Scalars['String'];
};

export type DeclareCommonPayload = {
  __typename?: 'DeclareCommonPayload';
  /** 불법촬영물 신고의 경우 CK(카카오 클린센터)에서 제공하는 신고 URL을 리턴해줌 */
  landingUrl?: Maybe<Scalars['String']>;
  status: ResultStatus;
};

export type DeleteInvenPayload = {
  __typename?: 'DeleteInvenPayload';
  status: ResultStatus;
};

export type DependOnLoggedInSection = {
  /** 로그인 상태일 때 보여줄 스킴 */
  loggedInScheme?: Maybe<Scalars['String']>;
  /** 로그인 상태일 때 보여줄 타이틀 */
  loggedInTitle?: Maybe<Scalars['String']>;
};

export type Device = {
  __typename?: 'Device';
  createdDt: Scalars['Date'];
  deviceModel: Scalars['String'];
  deviceUid: Scalars['String'];
  isCurrentDevice: Scalars['Boolean'];
  lastUsedDt: Scalars['Date'];
};

export type DeviceInfo = {
  __typename?: 'DeviceInfo';
  deviceLimitCount: Scalars['Int'];
  deviceList: Array<Device>;
  deviceReplaceableCount: Scalars['Int'];
};

export type DeviceStatusPayload = {
  __typename?: 'DeviceStatusPayload';
  status: ResultStatus;
};

export type DisplayAd = {
  __typename?: 'DisplayAd';
  bannerUid?: Maybe<Scalars['String']>;
  momentUid?: Maybe<Scalars['String']>;
  sectionUid?: Maybe<Scalars['String']>;
  treviUid?: Maybe<Scalars['String']>;
};

export type DisplayAdGroup = Group & {
  __typename?: 'DisplayAdGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export type DisplayAdItem = Item & {
  __typename?: 'DisplayAdItem';
  displayAd: DisplayAd;
  id: Scalars['ID'];
  type: ItemType;
};

export type DisplayAdSection = Section & {
  __typename?: 'DisplayAdSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type DkpgRequestPayload = {
  __typename?: 'DkpgRequestPayload';
  status?: Maybe<ResultStatus>;
};

export type DrawGotchaInput = {
  adLocId?: Maybe<Scalars['String']>;
  gotchaId: Scalars['String'];
  redeem?: Maybe<Scalars['String']>;
};

export type DrawGotchaPayload = {
  __typename?: 'DrawGotchaPayload';
  expireDateText?: Maybe<Scalars['String']>;
  receiveDate?: Maybe<Scalars['Date']>;
  spinWheelDesc?: Maybe<Scalars['String']>;
  status?: Maybe<GotchaStatus>;
  winPrize?: Maybe<Scalars['String']>;
  winPrizeType?: Maybe<WinPrizeType>;
};

export type DrmInfo = {
  __typename?: 'DrmInfo';
  /** INI DRM 인 경우 필요 */
  assertion?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  fairplayCertificateUrl?: Maybe<Scalars['String']>;
  fairplayLicenseUrl?: Maybe<Scalars['String']>;
  /** PAGE DRM 인 경우 필요 */
  provider?: Maybe<Scalars['String']>;
  serverType?: Maybe<DrmServerType>;
  /** PAGE DRM 인 경우 필요 */
  token?: Maybe<Scalars['String']>;
  type?: Maybe<DrmType>;
  widevineLicenseUrl?: Maybe<Scalars['String']>;
};

export enum DrmServerType {
  Ini = 'INI',
  Page = 'PAGE'
}

export enum DrmType {
  Fairplay = 'FAIRPLAY',
  None = 'NONE',
  Playready = 'PLAYREADY',
  Widevine = 'WIDEVINE'
}

export type DynamicLayout = {
  __typename?: 'DynamicLayout';
  description?: Maybe<Scalars['String']>;
  scheme?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type DynamicLayoutReference = {
  __typename?: 'DynamicLayoutReference';
  dynamicLayout?: Maybe<DynamicLayout>;
  layoutReference?: Maybe<Array<LayoutReferenceViewData>>;
};

export type Emoticon = {
  __typename?: 'Emoticon';
  itemId: Scalars['String'];
  itemSubType: Scalars['Int'];
  itemVer?: Maybe<Scalars['Int']>;
  resourceId: Scalars['Int'];
};

export type EpisodeSection = SchemeSection & Section & {
  __typename?: 'EpisodeSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  scheme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type EventBannerGroup = Group & {
  __typename?: 'EventBannerGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export type EventBannerItem = Item & {
  __typename?: 'EventBannerItem';
  badgeList: Array<BadgeType>;
  bannerType: BannerType;
  /** square, rectangle */
  bannerViewType: BannerViewType;
  caption?: Maybe<Scalars['String']>;
  eventLog?: Maybe<EventLog>;
  id: Scalars['ID'];
  scheme?: Maybe<Scalars['String']>;
  statusBadge?: Maybe<BadgeType>;
  subtitleList?: Maybe<Array<Scalars['String']>>;
  thumbnail: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  titleImage?: Maybe<Scalars['String']>;
  type: ItemType;
  videoUrl?: Maybe<Scalars['String']>;
};

/**
 * 티아라 이벤트 로그
 * 이 로그가 있으면 data-t-obj 에 그대로 들어가고, 그대로 수집된다
 */
export type EventLog = {
  __typename?: 'EventLog';
  click?: Maybe<ClickLog>;
  customProps?: Maybe<CustomProps>;
  eventMeta?: Maybe<EventMeta>;
  fromGraphql?: Maybe<Scalars['Boolean']>;
  viewimp_contents?: Maybe<ViewImpContents>;
};

export type EventMeta = {
  __typename?: 'EventMeta';
  category?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  series?: Maybe<Scalars['String']>;
  series_id?: Maybe<Scalars['String']>;
  subcategory?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type EventSection = SchemeSection & Section & {
  __typename?: 'EventSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  scheme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type ExpiredCredit = {
  __typename?: 'ExpiredCredit';
  expiredAt: Scalars['Date'];
  expiredSum: Scalars['Int'];
};

export enum ExtraLabelType {
  CancelCharge = 'CancelCharge',
  CancelIapMarket = 'CancelIAPMarket',
  Expired = 'Expired',
  ExtinctCash = 'ExtinctCash',
  RefundTicket = 'RefundTicket',
  WithdrawByAdmin = 'WithdrawByAdmin',
  WithdrawByAdminPlayPoints = 'WithdrawByAdminPlayPoints'
}

export type FilterOption = {
  __typename?: 'FilterOption';
  keys?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  param: Scalars['String'];
  translateProperty?: Maybe<TranslateProperty>;
};

export type Font = {
  __typename?: 'Font';
  flag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Long']>;
  target?: Maybe<Scalars['String']>;
};

export enum FreeTicketType {
  /** 헬릭스 선물 */
  HelixGift = 'HelixGift',
  /** 오늘의 선물 */
  TodayGift = 'TodayGift'
}

export type GetEventInfoInput = {
  hashedEventId: Scalars['String'];
  isMobile?: Maybe<Scalars['Boolean']>;
  isWebInApp?: Maybe<Scalars['Boolean']>;
  target?: Maybe<Scalars['String']>;
};

export type GetEventInfoPayload = {
  __typename?: 'GetEventInfoPayload';
  agreed?: Maybe<Scalars['String']>;
  appUserId?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  contentInfoList?: Maybe<Array<AutomaticEvent>>;
  eventId?: Maybe<Scalars['Long']>;
  eventTitle?: Maybe<Scalars['String']>;
  eventVersion?: Maybe<Scalars['String']>;
  head?: Maybe<Scalars['String']>;
  isNeedUpdate?: Maybe<Scalars['Boolean']>;
  nickname?: Maybe<Scalars['String']>;
  orgCode?: Maybe<Scalars['String']>;
  resultCode: Scalars['Int'];
  stoken?: Maybe<Scalars['String']>;
  userUid?: Maybe<Scalars['Int']>;
};

export type GetGlobalAgreementInfoInput = {
  authToken?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  selfVerifyUuid?: Maybe<Scalars['String']>;
  /** SNS 로그인시 사용하는 값입니다. google 로그인의 경우 userId는 없기 때문에 optional입니다. */
  userId?: Maybe<Scalars['String']>;
};

export type GlobalAgreementInfo = {
  __typename?: 'GlobalAgreementInfo';
  agreement: AgreementContainer;
  isRegistered: Scalars['Boolean'];
};

export type GlobalCheckParentVerifyInput = {
  verifyCode: Scalars['String'];
  verifyUuid: Scalars['String'];
};

export type GlobalEmailSignupInput = {
  agreedTerms: Array<AgreementForm>;
  birthday?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  email: Scalars['String'];
  parentVerifyUuid?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  provider: Scalars['String'];
  pushToken?: Maybe<Scalars['String']>;
  selfVerifyUuid: Scalars['String'];
};

export type GlobalParentVerificationIsCompleted = {
  __typename?: 'GlobalParentVerificationIsCompleted';
  isCompleted: Scalars['Boolean'];
};

export type GlobalSavePrivateInput = {
  birthday: Scalars['String'];
  parentVerifyUuid?: Maybe<Scalars['String']>;
};

export type GlobalSendParentVerifyInput = {
  childName: Scalars['String'];
  email: Scalars['String'];
};

export type GlobalSendParentVerifyPayload = {
  __typename?: 'GlobalSendParentVerifyPayload';
  verifyUuid: Scalars['String'];
};

export type GlobalSignupPayload = {
  __typename?: 'GlobalSignupPayload';
  refreshToken: Scalars['String'];
  responseTime: Scalars['String'];
  serverToken: Scalars['String'];
  user: GlobalUser;
};

export type GlobalSnsSignupInput = {
  agreedTerms: Array<AgreementForm>;
  authToken: Scalars['String'];
  birthday?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  parentVerifyUuid?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  pushToken?: Maybe<Scalars['String']>;
  /** SNS 로그인시 사용하는 값입니다. google 로그인의 경우 userId는 없기 때문에 optional입니다. */
  userId?: Maybe<Scalars['String']>;
};

export type GlobalUser = {
  __typename?: 'GlobalUser';
  age?: Maybe<Scalars['Int']>;
  countryCode: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  memberId: Scalars['String'];
  nickname: Scalars['String'];
  profileThumbnailUrl: Scalars['String'];
  userCommentBlockMsg?: Maybe<Scalars['String']>;
  userUid: Scalars['Int'];
};

export enum GotchaEntryType {
  CashSponsorAd = 'CashSponsorAd',
  Direct = 'Direct',
  None = 'None',
  Redeem = 'Redeem'
}

export type GotchaInfo = {
  __typename?: 'GotchaInfo';
  adLocId?: Maybe<Scalars['String']>;
  bannerAdLocId?: Maybe<Scalars['String']>;
  belowDesc?: Maybe<Scalars['String']>;
  bgColor: Scalars['String'];
  bgImg: Scalars['String'];
  buttonColor?: Maybe<Scalars['String']>;
  buttonImg?: Maybe<Scalars['String']>;
  entryType?: Maybe<GotchaEntryType>;
  expireDateText?: Maybe<Scalars['String']>;
  extBannerImg?: Maybe<Scalars['String']>;
  extBannerLink?: Maybe<Scalars['String']>;
  gotchaId: Scalars['String'];
  maxCash?: Maybe<Scalars['Int']>;
  receiveDate?: Maybe<Scalars['Date']>;
  resultImg: Scalars['String'];
  spinWheelDesc?: Maybe<Scalars['String']>;
  spinWheelImgs: Array<Scalars['String']>;
  spinWheelReadyImgs: Array<Scalars['String']>;
  status: GotchaStatus;
  title: Scalars['String'];
  topTitleImg: Scalars['String'];
  type?: Maybe<GotchaType>;
  winPrize?: Maybe<Scalars['String']>;
  winPrizeType?: Maybe<WinPrizeType>;
};

export enum GotchaStatus {
  Already = 'Already',
  Disable = 'Disable',
  Draw = 'Draw',
  Duplicate = 'Duplicate',
  Error = 'Error',
  Expire = 'Expire',
  Fail = 'Fail',
  First = 'First',
  Noauth = 'Noauth',
  Success = 'Success',
  TicketFail = 'TicketFail',
  UnknownApiStatus = 'UnknownApiStatus',
  WaitRedeemResult = 'WaitRedeemResult'
}

export enum GotchaType {
  CashSponsor = 'CashSponsor',
  Standalone = 'Standalone'
}

/**
 * 하나의 섹션에 여러개의 그룹이 존재할 수 있다.
 * 아이템들의 껍데기 단위라고 볼 수 있음.
 * 기획에서 얘기하는 최소 뷰 그룹 단위로 볼 수 있음
 */
export type Group = {
  /** Layout 에서 Group 에 들어올 컬렉션 리스트를 가져오기 위한 레퍼런스 파람 */
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export enum GroupType {
  /** TOP 섹션 등에 사용되는 배너로 어떤 해상도에서든 너비를 가득 채웁니다 */
  BigBanner = 'BigBanner',
  /** 카드뷰, 카드배너 뷰 */
  CardView = 'CardView',
  /** 클린뷰 */
  CleanView = 'CleanView',
  /** 콘텐츠홈, 뷰어엔드 추천 영역 표현을 위한 그룹 */
  ContentRecommend = 'ContentRecommend',
  DisplayAd = 'DisplayAd',
  /** 이벤트, 캐시프렌즈 섹션 에서 사용되는 배너 */
  EventBanner = 'EventBanner',
  /** 가로스크롤뷰 */
  HorizontalScroll = 'HorizontalScroll',
  /** 띠배너 */
  LineBanner = 'LineBanner',
  /** 리스트뷰 */
  ListView = 'ListView',
  /** 메인홈/서브홈에서 사용하는 랭킹 리스트뷰 */
  MainRankingListView = 'MainRankingListView',
  /** 16:9 직사각형 뷰 */
  OnAir = 'OnAir',
  /** 포스터뷰 */
  PosterView = 'PosterView',
  /** 프로모션 배너. 소녀리버와 같이 프로모션 용으로 사용하는 얇은 띠 형태의 배너 */
  PromotionBanner = 'PromotionBanner',
  /** 배너 섹션에서 사용됩니다. 모바일에선 스와이프, 태블릿일 때 펼쳐집니다. */
  ResponsiveBanner = 'ResponsiveBanner',
  /** 테마 섹션등에 사용되는 단일 배너로 태블릿 이상에서는 화면의 절반만 차지하게 됩니다. UI가 일반 배너와 다르므로 별도로 타입을 만들었습니다. */
  StandaloneBanner = 'StandaloneBanner',
  /** 서브섹션에서 사용되는 STANDALONE_BANNER 배너 + 카드 조합유 */
  StandaloneBannerAndSubCard = 'StandaloneBannerAndSubCard',
  /** 전략카테고리 */
  StrategyView = 'StrategyView',
  /** STANDALONE_BANNER_AND_SUB_CARD group 내에 group in group으로 표현되는 카드 그룹 */
  SubCard = 'SubCard',
  /** 오늘 신작 페이지에서 ListViewGroup들을 묶어서 표현하기 위한 그룹. */
  TodaySeries = 'TodaySeries',
  Unknown = 'Unknown'
}

export enum HelixAgeBadge {
  Age15 = 'Age15',
  Age19 = 'Age19',
  SelfCensorship = 'SelfCensorship'
}

export enum HelixBmBadge {
  Free = 'Free',
  New = 'New',
  Up = 'Up',
  Waitfree = 'Waitfree',
  Waitfree0h = 'Waitfree0h',
  Waitfree1h = 'Waitfree1h',
  Waitfree2h = 'Waitfree2h',
  Waitfree3h = 'Waitfree3h'
}

export type HelixSeries = {
  __typename?: 'HelixSeries';
  ageGrade?: Maybe<AgeGrade>;
  ageGradeBadge?: Maybe<BadgeType>;
  badgeList: Array<BadgeType>;
  category: Scalars['String'];
  eventLog?: Maybe<EventLog>;
  id: Scalars['ID'];
  itemOrder: Scalars['Int'];
  scheme: Scalars['String'];
  selfCensorship?: Maybe<Scalars['Boolean']>;
  seriesId: Scalars['Long'];
  subCategory: Scalars['String'];
  thumbnailUrl: Scalars['String'];
  ticketCount: Scalars['Int'];
  title: Scalars['String'];
  viewCount: Scalars['String'];
};

export type HelixSeriesList = {
  __typename?: 'HelixSeriesList';
  ageGradeNum: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['ID'];
  list: Array<HelixSeries>;
  nickname: Scalars['String'];
  notification: Scalars['String'];
  selfCensorship?: Maybe<Scalars['Boolean']>;
  seriesId: Scalars['Long'];
  seriesThumbnailUrl: Scalars['String'];
  seriesTitle: Scalars['String'];
  status: HelixSeriesStatus;
  ticketExpireDt: Scalars['Date'];
  uid: Scalars['Long'];
};

export enum HelixSeriesStatus {
  Active = 'Active',
  Closed = 'Closed',
  Ended = 'Ended'
}

export type HelixThemeSection = MetaInfoTypeSection & Section & {
  __typename?: 'HelixThemeSection';
  description?: Maybe<Scalars['String']>;
  groups: Array<Group>;
  id: Scalars['ID'];
  isRecommendArea?: Maybe<Scalars['Boolean']>;
  metaInfoType?: Maybe<MetaInfoType>;
  scheme?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type HelixTodayGiftList = {
  __typename?: 'HelixTodayGiftList';
  helixGiftTitle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  list: Array<NormalListViewItem>;
};

export type History = {
  __typename?: 'History';
  createDt: Scalars['Date'];
  creditMasterId?: Maybe<Scalars['BigInt']>;
  detailText?: Maybe<Scalars['String']>;
  detailText2?: Maybe<Scalars['String']>;
  displayDt?: Maybe<Scalars['Date']>;
  expiredAt?: Maybe<Scalars['Date']>;
  extraLabelType?: Maybe<ExtraLabelType>;
  historyType: HistoryType;
  id: Scalars['ID'];
  price?: Maybe<Scalars['String']>;
  priceColor?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  purchasedItem: Scalars['String'];
  purchasedItemColor?: Maybe<Scalars['String']>;
  remainDays?: Maybe<Scalars['Int']>;
  seriesId?: Maybe<Scalars['Long']>;
};

export type HistoryLineBanner = {
  __typename?: 'HistoryLineBanner';
  bannerType: HistoryLineBannerType;
  bgColor?: Maybe<Scalars['String']>;
  scheme?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export enum HistoryLineBannerType {
  Helix = 'HELIX',
  Million = 'MILLION',
  Recent = 'RECENT'
}

export type HistoryList = {
  __typename?: 'HistoryList';
  expiredCredit?: Maybe<ExpiredCredit>;
  isEnd: Scalars['Boolean'];
  list: Array<History>;
};

export enum HistoryType {
  /** 캐시 충전 내역 */
  CashCharging = 'CashCharging',
  /** 캐시 시용 내역 */
  CashUsage = 'CashUsage',
  /** 이용권 충전 내역 */
  CouponReCharge = 'CouponReCharge',
  /** 이용권 사용 내역 */
  CouponUsage = 'CouponUsage'
}

export type HorizontalScrollGroup = Group & {
  __typename?: 'HorizontalScrollGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export type ImageDownloadData = {
  __typename?: 'ImageDownloadData';
  files: Array<ImageDownloadFile>;
  /**
   * 이미지 사이 간격 설정 여부
   *
   * margin으로 만든 값입니다.
   */
  gapBetweenImages: Scalars['Boolean'];
  /**
   * 가능한 열람 방식
   *
   * orientation으로 만든 값입니다.
   */
  readType: ReadType;
  totalCount?: Maybe<Scalars['Int']>;
  totalSize?: Maybe<Scalars['Long']>;
  /**
   * 페이지 넘김 방향
   *
   * direction으로 만든 값입니다.
   */
  viewDirection: ViewDirection;
};

export type ImageDownloadFile = {
  __typename?: 'ImageDownloadFile';
  height?: Maybe<Scalars['Int']>;
  /** 이미지 뷰어에서 사용하는 페이지 번호 */
  no: Scalars['Int'];
  /** 웹에서만 사용하는 원타임 URL */
  secureUrl: Scalars['String'];
  size?: Maybe<Scalars['Long']>;
  /** slide.xml에서 가져오길 기대되는 임시 width, height */
  width?: Maybe<Scalars['Int']>;
};

export type ImageViewerData = ViewerData & {
  __typename?: 'ImageViewerData';
  imageDownloadData: ImageDownloadData;
  type: ViewerDataType;
};

export type InvenList = {
  __typename?: 'InvenList';
  catOptList: Array<SortOption>;
  displayAd?: Maybe<DisplayAd>;
  id: Scalars['ID'];
  isEnd: Scalars['Boolean'];
  list: Array<NormalListViewItem>;
  selectedCatOpt: SortOption;
  selectedSortOpt: SortOption;
  sortOptList: Array<SortOption>;
  totalCount: Scalars['Int'];
};

export type InvenListInput = {
  categoryUid?: Maybe<Scalars['Int']>;
  isEditPage?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  sortType?: Maybe<Scalars['String']>;
};

export type InvenMyInfo = {
  __typename?: 'InvenMyInfo';
  displayAd?: Maybe<DisplayAd>;
  id: Scalars['ID'];
  myInfo: MyInfo;
};

export type InvenRecommendList = {
  __typename?: 'InvenRecommendList';
  id: Scalars['ID'];
  list: Array<PosterViewItem>;
};

/** 그룹 내에 존재하는 아이템 리스트 */
export type Item = {
  id: Scalars['ID'];
  type: ItemType;
};

export type ItemBanner = {
  __typename?: 'ItemBanner';
  adLocId?: Maybe<Scalars['String']>;
  adTrackingId?: Maybe<Scalars['String']>;
  bgcolor?: Maybe<Scalars['String']>;
  destination?: Maybe<Scalars['String']>;
  destinationType?: Maybe<Scalars['String']>;
  expireDt?: Maybe<Scalars['String']>;
  image: Scalars['String'];
  imageHeight?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  imageWidth?: Maybe<Scalars['Int']>;
  impId?: Maybe<Scalars['String']>;
  scheme: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  uid: Scalars['Long'];
};

export enum ItemType {
  /** 메인, 카테고리 홈, 쿼드에서 사용되는 배너 */
  Banner = 'Banner',
  CardView = 'CardView',
  CleanView = 'CleanView',
  Da = 'Da',
  /** 이벤트, 캐시프렌즈 섹션 에서 사용되는 배너 */
  EventBanner = 'EventBanner',
  LineBanner = 'LineBanner',
  /** 카드뷰, 포스터뷰 등에서 더보기 */
  More = 'More',
  /** 일반리스트(일반적으로 작품 표현시 사용) */
  NormalListView = 'NormalListView',
  OnAir = 'OnAir',
  PosterView = 'PosterView',
  PromotionBanner = 'PromotionBanner',
  /** 선물함, 기다무플러스 페이지 등의 프로모션 영역에서 사용되는 아이템 */
  PromotionCardView = 'PromotionCardView',
  /** 랭킹 v2(카드뷰) */
  RankingCardView = 'RankingCardView',
  /** 랭킹리스트 */
  RankingListView = 'RankingListView',
  /** 랭킹 포스터뷰 */
  RankingPosterView = 'RankingPosterView',
  /** 회차리스트(콘텐츠홈에서 회차 표현시 쓰임) */
  SingleListView = 'SingleListView',
  /** 테마에서 사용되는 항상 한개만 표현되는 배너 */
  StandaloneBanner = 'StandaloneBanner',
  /** 전략카테고리. 쿼드, 홈 동일 */
  StrategyView = 'StrategyView',
  Unknown = 'Unknown'
}

export type KakaoBankSelfCertSupportedDeviceInput = {
  /** 기기 모델명 */
  deviceModel: Scalars['String'];
};

export type KakaoCashReportData = {
  __typename?: 'KakaoCashReportData';
  amount: Scalars['Int'];
  createdAt: Scalars['String'];
  /** 결제 관리 아이디(현금성 결제건에 대해서 노출, omissible) */
  creditMasterId?: Maybe<Scalars['String']>;
  creditStatus?: Maybe<CreditStatus>;
  /** 결제 완료 일자 */
  displayDate: Scalars['String'];
  /** 이벤트 명 */
  eventName: Scalars['String'];
  /** 만료 일자 */
  expiredAt: Scalars['String'];
  /** 결제 수단 */
  paymentMethod: Scalars['String'];
  /** 구매 상품 */
  purchasedItem: Scalars['String'];
  /** R04: 무상캐시 회수 명칭이 있다면 노출. credit_status(R05: 무상캐시) 지급시, event_name을 지정했다면 노출. */
  serviceEventName: Scalars['String'];
};

/**
 * 실제로 존재하는 landing_type은 아니지만 관리의 용이성을 위해 추가하였습니다.
 * 회차(Single)는 Poster 랜딩 타입이 존재하지 않습니다.
 */
export enum LandingType {
  SeriesCard = 'SeriesCard',
  SeriesList = 'SeriesList',
  SeriesPoster = 'SeriesPoster',
  SetList = 'SetList',
  SetPoster = 'SetPoster',
  SingleList = 'SingleList'
}

/** LastViewInfoDto 에 대응됨 */
export type LastViewInfo = {
  __typename?: 'LastViewInfo';
  /** * 완독 여부 */
  isDone?: Maybe<Scalars['Boolean']>;
  /** * 마지막 열람 일시 */
  lastViewDate: Scalars['String'];
  /** * 마지막 열람 위치 (10000분율로 표시된 비율) */
  rate?: Maybe<Scalars['Int']>;
  /** * 마지막 열람 챕터 (챕터가 없는 경우 0) */
  spineIndex: Scalars['Int'];
};

/**
 * 페이지 단위 레이아웃(구 : section_container)
 * 주로 기획에서 얘기하는 가장 큰 단위로 보면 됨(메인홈, 쿼드, GNB)
 */
export type Layout = {
  __typename?: 'Layout';
  id: Scalars['ID'];
  /** 일반적으로 API 상의 Screen과 Layout은 1:1 매칭됩니다. */
  screenUid?: Maybe<Scalars['Int']>;
  sections: Array<Section>;
  type: LayoutType;
};

/** Group 의 dataKey 를 통해 가져오는 데이터입니다 */
export type LayoutReferenceViewData = {
  __typename?: 'LayoutReferenceViewData';
  dataKey: Scalars['String'];
  items?: Maybe<Array<Item>>;
};

export enum LayoutType {
  Landing = 'Landing',
  /** `/layout` API 를 통해 만들어지는 타입. 현재는 메인홈 / 서브홈 */
  Layout = 'Layout'
}

/**
 * 구 Slide 의 잔재인 SlideStandV3ItemVO 를 지원하기 위한 Single
 * 필요한 것만 채우는 중
 */
export type LegacySingle = {
  __typename?: 'LegacySingle';
  ageGrade?: Maybe<AgeGrade>;
  isFree: Scalars['Boolean'];
  productId: Scalars['Long'];
  slideType: SlideType;
};

export type LikeCommentInput = {
  commentUid: Scalars['Int'];
  like: Scalars['Boolean'];
};

export type LikeCommentPayload = {
  __typename?: 'LikeCommentPayload';
  likeCount: Scalars['Int'];
  recordid?: Maybe<Scalars['ID']>;
  status: ResultStatus;
};

export type LineBannerGroup = Group & {
  __typename?: 'LineBannerGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export type LineBannerItem = Item & {
  __typename?: 'LineBannerItem';
  bgColor?: Maybe<Scalars['String']>;
  eventLog?: Maybe<EventLog>;
  id: Scalars['ID'];
  rightImage?: Maybe<Scalars['String']>;
  scheme?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: ItemType;
};

export type LineBannerSection = Section & {
  __typename?: 'LineBannerSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type ListViewGroup = Group & {
  __typename?: 'ListViewGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  meta?: Maybe<ListViewGroupMeta>;
  type: GroupType;
};

export type ListViewGroupMeta = {
  __typename?: 'ListViewGroupMeta';
  count?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export enum Locale {
  En = 'en',
  Ko = 'ko',
  Th = 'th'
}

export type LocaleMap = {
  __typename?: 'LocaleMap';
  en?: Maybe<Scalars['String']>;
  ko?: Maybe<Scalars['String']>;
  th?: Maybe<Scalars['String']>;
};


export type MainRankingListViewGroup = Group & {
  __typename?: 'MainRankingListViewGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export type MainRankingSection = SchemeSection & Section & TabSection & {
  __typename?: 'MainRankingSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  scheme?: Maybe<Scalars['String']>;
  sectionMainTabList?: Maybe<Array<SectionMainTab>>;
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

/** 메뉴 */
export type Menu = {
  id: Scalars['ID'];
  title: Scalars['String'];
  type: MenuType;
  uid: Scalars['Int'];
};

export enum MenuType {
  Subtab = 'Subtab'
}

/**
 * 테마/가로스크롤 섹션에 노출되는 정보를 운영툴에서 제어하기 위한 목적의 필드입니다.
 * 만약 해당 섹션에서 이 값이 null / undefined 라면 아무것도 노출하지 않습니다
 * 기타 섹션에선 ViewCount 를 기본으로 노출합니다
 */
export enum MetaInfoType {
  AuthorName = 'AuthorName',
  Category = 'Category',
  CategoryAndAuthor = 'CategoryAndAuthor',
  /** normallist row2에 들어가는 대분류, 중분류, 작가 */
  CategoryAndSubCategoryAndAuthorName = 'CategoryAndSubCategoryAndAuthorName',
  CategoryAndViewCount = 'CategoryAndViewCount',
  IssueStatus = 'IssueStatus',
  /** 모두다 숨김 */
  None = 'None',
  /** 요일연재 메뉴에 추가된 평점순 노출을 위한 정보입니다. */
  Rating = 'Rating',
  RecommendReason = 'RecommendReason',
  SubCategory = 'SubCategory',
  /** 아래는 API에서 주는 상태가 아닌 피그마의 상태를 표현하기 위해 지정한 값입니다. */
  SubCategoryAndViewCount = 'SubCategoryAndViewCount',
  /** 테마, 가로스크롤테마 외 섹션 기본 정책. ViewCount 가 있으면 보여줌. */
  ViewCount = 'ViewCount'
}

export type MetaInfoTypeSection = {
  metaInfoType?: Maybe<MetaInfoType>;
};

/** 카드뷰, 포스터뷰 등에서 더보기 */
export type MoreItem = Item & {
  __typename?: 'MoreItem';
  id: Scalars['ID'];
  isPosterView?: Maybe<Scalars['Boolean']>;
  scheme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: ItemType;
};

export type Mutation = {
  __typename?: 'Mutation';
  addDevice: DeviceStatusPayload;
  appSetting: AppSettingPayload;
  blockUser: CommentCommonPayload;
  buyAndUseTicket: TicketBuyAndUseMutationPayload;
  buyTicket: TicketBuyMutationPayload;
  changeEmailPassword: ResultStatus;
  checkEmailVerifyCode: ResultStatus;
  declareComment: DeclareCommonPayload;
  deleteDevice: DeviceStatusPayload;
  deleteInvenLike: DeleteInvenPayload;
  deleteInvenPaid: DeleteInvenPayload;
  deleteInvenRecent: DeleteInvenPayload;
  deleteReceiptInfo: ReceiptInfoStatusPayload;
  drawGotcha: DrawGotchaPayload;
  getEventInfo: GetEventInfoPayload;
  globalCheckParentVerify: ResultStatus;
  globalEmailSignup: GlobalSignupPayload;
  globalSavePrivate: ResultStatus;
  globalSendParentVerify: GlobalSendParentVerifyPayload;
  globalSnsSignup: GlobalSignupPayload;
  /** 카카오뱅크 본인 인증 지원 기기 확인 */
  kakaoBankSelfCertSupportedDevice: Scalars['Boolean'];
  likeComment: LikeCommentPayload;
  /** 첫 화 보기 열람 로그 */
  openPreview: ResultStatus;
  /** 카카오뱅크 PASS 인증 페이지 진입하기 위한 인증정보를 가져옵니다. */
  prepareKakaoBankAuthRequestInfo: PrepareAuthRequestInfoPayload;
  receiveTicketFree: TodayGift;
  /** 환불 요청 */
  refundRequest: RefundRequestPayload;
  refundTicket: RefundTicketStatusPayload;
  removeComment: CommentCommonPayload;
  removeMyNews: RemoveMyNewsPayload;
  rouletteDraw: RouletteDrawPayload;
  saveAuthInfo: SaveAuthInfoPayload;
  sendEmailVerifyCode: SendEmailVerifyCodePayload;
  setAgreement: SetAgreementPayload;
  setBuyTicket: TicketSetBuyMutationPayload;
  setGlobalAgreement: SetGlobalAgreementPayload;
  setMyRating: SetMyRatingPayload;
  setSeriesAlarm: SetSeriesAlarmPayload;
  setSeriesLike: SetSeriesLikePayload;
  setTvPointAgreement: SetTvPointAgreementPayload;
  unregisterUser: UnregisterUserStatusPayload;
  updateNickname: UpdateNicknamePayload;
  updateReceiptInfo?: Maybe<ReceiptInfo>;
  useRedeem: RedeemCode;
  useTicket: TicketUseMutationPayload;
  viewerLastPage: ResultStatus;
  viewerOpenPage: ResultStatus;
  writeComment: WriteCommentPayload;
};


export type MutationAddDeviceArgs = {
  deviceModel: Scalars['String'];
};


export type MutationAppSettingArgs = {
  input: AppSettingInput;
};


export type MutationBlockUserArgs = {
  blockUserInput: BlockUserInput;
};


export type MutationBuyAndUseTicketArgs = {
  input: TicketBuyAndUseMutationInput;
};


export type MutationBuyTicketArgs = {
  input: TicketBuyMutationInput;
};


export type MutationChangeEmailPasswordArgs = {
  input: ChangeEmailPasswordInput;
};


export type MutationCheckEmailVerifyCodeArgs = {
  checkEmailVerifyCodeInput: CheckEmailVerifyCodeInput;
};


export type MutationDeclareCommentArgs = {
  declareCommentInput: DeclareCommentInput;
};


export type MutationDeleteDeviceArgs = {
  deviceUid: Scalars['String'];
};


export type MutationDeleteInvenLikeArgs = {
  seriesIdList: Array<Scalars['String']>;
};


export type MutationDeleteInvenPaidArgs = {
  seriesIdList: Array<Scalars['String']>;
};


export type MutationDeleteInvenRecentArgs = {
  seriesIdList: Array<Scalars['String']>;
};


export type MutationDrawGotchaArgs = {
  hasMapUid?: Maybe<Scalars['Boolean']>;
  input: DrawGotchaInput;
};


export type MutationGetEventInfoArgs = {
  input: GetEventInfoInput;
};


export type MutationGlobalCheckParentVerifyArgs = {
  input: GlobalCheckParentVerifyInput;
};


export type MutationGlobalEmailSignupArgs = {
  input: GlobalEmailSignupInput;
};


export type MutationGlobalSavePrivateArgs = {
  input: GlobalSavePrivateInput;
};


export type MutationGlobalSendParentVerifyArgs = {
  input: GlobalSendParentVerifyInput;
};


export type MutationGlobalSnsSignupArgs = {
  input: GlobalSnsSignupInput;
};


export type MutationKakaoBankSelfCertSupportedDeviceArgs = {
  input: KakaoBankSelfCertSupportedDeviceInput;
};


export type MutationLikeCommentArgs = {
  likeCommentInput: LikeCommentInput;
};


export type MutationOpenPreviewArgs = {
  input: OpenPreviewMutationInput;
};


export type MutationPrepareKakaoBankAuthRequestInfoArgs = {
  input: PrepareAuthRequestInfoInput;
};


export type MutationReceiveTicketFreeArgs = {
  input: TicketFreeMutationInput;
};


export type MutationRefundRequestArgs = {
  input: RefundRequestInput;
};


export type MutationRefundTicketArgs = {
  ticketUid: Scalars['String'];
};


export type MutationRemoveCommentArgs = {
  commentUid: Scalars['Int'];
};


export type MutationRemoveMyNewsArgs = {
  input: RemoveMyNewsInput;
};


export type MutationRouletteDrawArgs = {
  hasMapUid?: Maybe<Scalars['Boolean']>;
  input: RouletteDrawInput;
};


export type MutationSaveAuthInfoArgs = {
  input: SaveAuthInfoInput;
};


export type MutationSendEmailVerifyCodeArgs = {
  sendEmailVerifyCodeInput: SendEmailVerifyCodeInput;
};


export type MutationSetAgreementArgs = {
  input: SetAgreementInput;
};


export type MutationSetBuyTicketArgs = {
  input: TicketSetBuyMutationInput;
};


export type MutationSetGlobalAgreementArgs = {
  input: SetGlobalAgreementInput;
};


export type MutationSetMyRatingArgs = {
  setMyRatingInput: SetMyRatingInput;
};


export type MutationSetSeriesAlarmArgs = {
  setSeriesAlarmInput: SetSeriesAlarmInput;
};


export type MutationSetSeriesLikeArgs = {
  setSeriesLikeInput: SetSeriesLikeInput;
};


export type MutationSetTvPointAgreementArgs = {
  isAgree?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateNicknameArgs = {
  input: UpdateNicknameInput;
};


export type MutationUpdateReceiptInfoArgs = {
  input: UpdateReceiptInfoInput;
};


export type MutationUseRedeemArgs = {
  input: RedeemCodeInput;
};


export type MutationUseTicketArgs = {
  input: TicketUseMutationInput;
};


export type MutationViewerLastPageArgs = {
  input: ViewerLastPageMutationInput;
};


export type MutationViewerOpenPageArgs = {
  input: ViewerOpenPageMutationInput;
};


export type MutationWriteCommentArgs = {
  writeCommentInput: WriteCommentInput;
};

export type MyInfo = {
  __typename?: 'MyInfo';
  cashBalance: Scalars['Int'];
  nickname?: Maybe<Scalars['String']>;
  numUnusedGift?: Maybe<Scalars['Int']>;
  profileImg?: Maybe<Scalars['String']>;
  useCashPassVip: Scalars['Boolean'];
};

/** 알림 아이템 */
export type MyNewsItem = {
  __typename?: 'MyNewsItem';
  adLocId?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  logName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  newsId: Scalars['Long'];
  scheme?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: MyNewsType;
};

export type MyNewsList = {
  __typename?: 'MyNewsList';
  displayAd?: Maybe<DisplayAd>;
  id: Scalars['ID'];
  news?: Maybe<Array<MyNewsItem>>;
};

export type MyNewsListInput = {
  refresh?: Maybe<Scalars['Boolean']>;
  tab: MyNewsTabType;
};

export enum MyNewsTabType {
  /** 전체 */
  All = 'ALL',
  /** 내소식 */
  My = 'MY',
  /** 업데이트 */
  Up = 'UP'
}

export enum MyNewsType {
  /** 좌측 썸네일이 동그란 형태 */
  Normal = 'Normal',
  /** 좌측 썸네일이 세로 형태 */
  Series = 'Series',
  /** 좌측 썸네일이 동그란 형태 + 삭제 가능 */
  UserRelated = 'UserRelated'
}

export type MyRating = {
  __typename?: 'MyRating';
  myRating?: Maybe<Scalars['Float']>;
};

export type NearItem = {
  __typename?: 'NearItem';
  ageGrade: AgeGrade;
  isFree?: Maybe<Scalars['Boolean']>;
  productId: Scalars['Long'];
  slideType: SlideType;
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * 작품 리스트뷰. 기획/디자인에선 일반리스트(현재 2.1 버전)으로 얘기함
 * 주로 콘텐츠홈 추천, 보관함 등에 사용됨
 */
export type NormalListViewItem = Item & {
  __typename?: 'NormalListViewItem';
  /** 19세 작품 + 만 19세 미만(혹, 미인증)인 경우 썸네일 가리기 등 별도 처리를 해야합니다. */
  ageGrade: AgeGrade;
  ageGradeBadge?: Maybe<BadgeType>;
  altText?: Maybe<Scalars['String']>;
  /** bmBadge */
  badgeList: Array<BadgeType>;
  /** 다음에 읽을 회차. 보관함, 콘텐츠홈에서 사용 */
  continueData?: Maybe<ContinueInfo>;
  /** 이어보기 스킴 */
  continueScheme?: Maybe<Scalars['String']>;
  /** 단행본 세트 상품 할인 가격 */
  discountPrice?: Maybe<Scalars['Int']>;
  /** 단행본 세트 상품 할인율 */
  discountRate?: Maybe<Scalars['Int']>;
  discountRateText?: Maybe<Scalars['String']>;
  eventLog?: Maybe<EventLog>;
  /** 선물함 선물받기 버튼을 위한 이벤트 로그입니다. */
  giftEventLog?: Maybe<EventLog>;
  id: Scalars['ID'];
  /** 알람 활성화 여부 */
  isAlaramOn?: Maybe<Scalars['Boolean']>;
  /** 좌측 체크모드 여부. 선택구매 등 체크 활성화시 on. 기본 false */
  isCheckMode: Scalars['Boolean'];
  /** 체크모드 on 일 때만 활용됨. 기본 false */
  isChecked: Scalars['Boolean'];
  /** 헬릭스 선물 아이템인지 여부 */
  isHelixGift?: Maybe<Scalars['Boolean']>;
  /** 선물을 받았는지 여부. */
  isReceived?: Maybe<Scalars['Boolean']>;
  /** 회차 일반리스트인경우. 일반리스트는 일반적으론 작품이지만 회차섹션, 회차랜딩에선 회차로도 쓰인다 */
  isSingle?: Maybe<Scalars['Boolean']>;
  /** 다음회차 스킴 */
  nextProductScheme?: Maybe<Scalars['String']>;
  /** 단행본 세트 상품 원래 가격 */
  price?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Long']>;
  /** 랭킹 */
  rank?: Maybe<Scalars['String']>;
  /** 1열. 타이틀영역 / 2줄 대응 */
  row1?: Maybe<Scalars['String']>;
  /** 2열. 레이블 리스트. 일반적으로 카테고리 | 장르 | 작가 표현 시 사용 */
  row2?: Maybe<Array<Scalars['String']>>;
  /** 3열. 뱃지와 메타정보 영역 */
  row3?: Maybe<NormalListViewItemRow3>;
  /** 4열. 추가 레이블 영역. X화 이어보기 등 표현 */
  row4?: Maybe<Array<Scalars['String']>>;
  /** 5열. 일반적으로 유효기간 표시 등 제약 표현 시 사용 */
  row5?: Maybe<Scalars['String']>;
  /** 클릭 시 이동 스킴 */
  scheme?: Maybe<Scalars['String']>;
  selfCensorship?: Maybe<Scalars['Boolean']>;
  seriesId?: Maybe<Scalars['Long']>;
  /** 동영상뷰어, 숏영상뷰어는 재생 아이콘 노출. */
  showPlayerIcon: Scalars['Boolean'];
  /** 회차인 경우 바로 이용권 사용을 위해 slideType 도 추가합니다 */
  singleSlideType?: Maybe<SlideType>;
  statusBadge?: Maybe<BadgeType>;
  /**
   * 일반리스트 좌측 썸네일.
   * 기본적으로 세로 썸네일(1:1.43). 일부 동영상뷰어의 경우 가로 썸네일
   */
  thumbnail: Scalars['String'];
  ticketUid?: Maybe<Scalars['Long']>;
  type: ItemType;
};

export type NormalListViewItemRow3 = {
  __typename?: 'NormalListViewItemRow3';
  id: Scalars['ID'];
  /** 아이템 메타 정보. 일반적으로 구독자수, 업데이트 날짜, 무료 여부 등 표현 */
  metaList?: Maybe<Array<Scalars['String']>>;
};

export enum NotiType {
  /** 뽑기권 알림 */
  Award = 'Award',
  /** 캐시 알림 */
  Cash = 'Cash',
  /** 캐시프렌즈 광고 */
  CashFriends = 'CashFriends',
  /** 이벤트 알림 */
  Event = 'Event',
  /** 친구 선물, 선물무 */
  Friend = 'Friend',
  /** 선물 알림 */
  Gift = 'Gift',
  /** 좋아요 알림 */
  Like = 'Like',
  /** 기타 마케팅 푸시 */
  Marketing = 'Marketing',
  /** 공지사항 알림 */
  Notice = 'Notice',
  /** 대댓글 알림 */
  Reply = 'Reply',
  /** 이용권 선물 푸시 */
  Ticket = 'Ticket',
  /** 시리즈 업데이트 알림 */
  Update = 'Update'
}


export type OnAirGroup = Group & {
  __typename?: 'OnAirGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export type OnAirItem = Item & {
  __typename?: 'OnAirItem';
  caption?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  scheme?: Maybe<Scalars['String']>;
  subtitleList?: Maybe<Array<Scalars['String']>>;
  thumbnail: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  titleImage?: Maybe<Scalars['String']>;
  type: ItemType;
  videoUrl?: Maybe<Scalars['String']>;
};

export type OnAirSection = Section & {
  __typename?: 'OnAirSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

/** 연재상태. 연재중, 완결, 휴재중 */
export enum OnIssue {
  /** 완결 on_issue = N */
  End = 'End',
  /** 연재중 on_issue = Y */
  Ing = 'Ing',
  /** 휴재중 on_issue = P */
  Pause = 'Pause',
  Unknown = 'Unknown'
}

export type OpenPreviewMutationInput = {
  productId: Scalars['Long'];
  seriesId: Scalars['Long'];
};

/** OperatorPropertyVo 에 대응됨 */
export type OperatorProperty = {
  __typename?: 'OperatorProperty';
  /** TOP, 빅 배너 지표 트래킹을 위한 banner.uid */
  bannerUid?: Maybe<Scalars['Long']>;
  cashInfo?: Maybe<Cash>;
  /** * 운영문구 */
  copy?: Maybe<Scalars['String']>;
  /** 헬릭스 추천 ID */
  helixImpId?: Maybe<Scalars['String']>;
  isBook?: Maybe<Scalars['Boolean']>;
  /** 수동 업로드 배너일 경우 이벤트 배지 표시 여부 */
  isEvent?: Maybe<Scalars['Boolean']>;
  /** EPub 뷰어일 때 텍스트뷰어 변환이 성공한 경우 */
  isTextViewer?: Maybe<Scalars['Boolean']>;
  /** 시리즈 연동 배너일 경우 뷰 카운트 노출 여부 */
  isViewCount?: Maybe<Scalars['Boolean']>;
  /** 요일연재 > 페이지 추천순 상위에 노출되는 수동 운영 작품 구분을 위한 로그 */
  rec_id?: Maybe<Scalars['String']>;
  /** 자율 심의 여부 */
  selfCensorship?: Maybe<Scalars['Boolean']>;
  /** * 운영이미지 */
  thumbnail?: Maybe<Scalars['String']>;
  /** 캐시 타입 이용권 정보 */
  ticketInfo?: Maybe<Array<SingleTicketInfo>>;
  /** 운영툴에서 설정한 동일 작품의 제목 */
  title?: Maybe<Scalars['String']>;
};

export enum OsType {
  All = 'All',
  /** 안드로이드(A) */
  Android = 'Android',
  /** iOS(I) */
  Ios = 'Ios',
  /** 웹(W) */
  Web = 'Web'
}

/** 커서 기반 페이지네이션에서 현재 요청의 페이지 정보 */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type Paging = {
  __typename?: 'Paging';
  lastPageId?: Maybe<Scalars['BigInt']>;
  shouldReloadPage?: Maybe<Scalars['Boolean']>;
};

export type Popup = {
  __typename?: 'Popup';
  popupList?: Maybe<Array<PopupInfo>>;
  useWelcome: Scalars['Boolean'];
};

export type PopupInfo = {
  __typename?: 'PopupInfo';
  adLocId?: Maybe<Scalars['String']>;
  bannerList: Array<ItemBanner>;
  bannerViewType: Scalars['String'];
  bgColor: Scalars['String'];
  endDt: Scalars['String'];
  execUrl: Scalars['String'];
  imageList?: Maybe<Array<Scalars['String']>>;
  imageString?: Maybe<Scalars['String']>;
  imageUrlList?: Maybe<Array<Scalars['String']>>;
  legacy: Scalars['Int'];
  popupId: Scalars['Long'];
  popupOrder?: Maybe<Scalars['Int']>;
  startDt: Scalars['String'];
  targetType?: Maybe<Scalars['String']>;
  targetValue?: Maybe<Scalars['String']>;
  targeted: Scalars['Int'];
  type?: Maybe<PopupType>;
  version: Scalars['Int'];
};

export enum PopupType {
  /** E : EXID */
  E = 'E',
  /** T : Trevi / Tessera */
  T = 'T'
}

export type PosterViewGroup = Group & {
  __typename?: 'PosterViewGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  meta?: Maybe<ListViewGroupMeta>;
  type: GroupType;
};

export type PosterViewItem = Item & {
  __typename?: 'PosterViewItem';
  /** 19세 작품 + 만 19세 미만(혹, 미인증)인 경우 썸네일 가리기 등 별도 처리를 해야합니다. */
  ageGrade: AgeGrade;
  ageGradeBadge?: Maybe<BadgeType>;
  altText?: Maybe<Scalars['String']>;
  /** bmBadge */
  badgeList: Array<BadgeType>;
  discountRate?: Maybe<Scalars['Int']>;
  discountRateText?: Maybe<Scalars['String']>;
  eventLog?: Maybe<EventLog>;
  id: Scalars['ID'];
  labelBadgeList?: Maybe<Array<Scalars['String']>>;
  rank?: Maybe<Scalars['String']>;
  rankVariation?: Maybe<Scalars['Int']>;
  scheme?: Maybe<Scalars['String']>;
  selfCensorship?: Maybe<Scalars['Boolean']>;
  seriesId?: Maybe<Scalars['Long']>;
  showDimmedThumbnail?: Maybe<Scalars['Boolean']>;
  /** 동영상뷰어, 숏영상뷰어는 재생 아이콘 노출. */
  showPlayerIcon: Scalars['Boolean'];
  statusBadge?: Maybe<BadgeType>;
  subtitleList?: Maybe<Array<Scalars['String']>>;
  thumbnail: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: ItemType;
};

export type PrepareAuthRequestInfoError = ReqInfoNotExist;

export type PrepareAuthRequestInfoInput = {
  authRequestType: AuthRequestType;
  /** 본인인증 테스트모드 요청 */
  bypassSelfAuth?: Maybe<Scalars['Boolean']>;
  certType: CertType;
  /** 본인인증 결과 페이지 URL */
  returnUrl?: Maybe<Scalars['String']>;
};

export type PrepareAuthRequestInfoPayload = {
  __typename?: 'PrepareAuthRequestInfoPayload';
  authRequestInfo?: Maybe<AuthRequestInfo>;
  authRequestInfoErrors: Array<PrepareAuthRequestInfoError>;
};

/** PreviewDto 에 대응됨 */
export type Preview = {
  __typename?: 'Preview';
  item?: Maybe<Single>;
  nextItem?: Maybe<Single>;
  usingScroll?: Maybe<Scalars['Boolean']>;
};

export type PreviewComment = {
  __typename?: 'PreviewComment';
  comment?: Maybe<Scalars['String']>;
  commentUid?: Maybe<Scalars['Int']>;
  emoticon?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  userThumbnailUrl?: Maybe<Scalars['String']>;
  userUid?: Maybe<Scalars['Int']>;
};

export enum ProductType {
  Buy = 'Buy',
  BuyVod = 'BuyVod',
  FreeTicket = 'FreeTicket',
  Package = 'Package',
  Premium = 'Premium',
  Preview = 'Preview',
  Rent = 'Rent',
  RentVod = 'RentVod',
  Series = 'Series',
  SeriesTicket = 'SeriesTicket',
  Single = 'Single',
  SingleInSeries = 'SingleInSeries',
  WaitFree = 'WaitFree',
  WaitFreePlus = 'WaitFreePlus',
  Web = 'Web'
}

export type PromotionBannerGroup = Group & {
  __typename?: 'PromotionBannerGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export type PromotionBannerItem = Item & {
  __typename?: 'PromotionBannerItem';
  eventLog?: Maybe<EventLog>;
  id: Scalars['ID'];
  leftImage: Scalars['String'];
  rightImage?: Maybe<Scalars['String']>;
  scheme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: ItemType;
};

export type PromotionBannerSection = Section & {
  __typename?: 'PromotionBannerSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type PromotionCardViewItem = Item & {
  __typename?: 'PromotionCardViewItem';
  ageGrade: AgeGrade;
  copy?: Maybe<Scalars['String']>;
  discountRate?: Maybe<Scalars['Int']>;
  discountRateText?: Maybe<Scalars['String']>;
  eventLog?: Maybe<EventLog>;
  giftEventLog?: Maybe<EventLog>;
  id: Scalars['ID'];
  scheme?: Maybe<Scalars['String']>;
  thumbnail: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  todayGift?: Maybe<TodayGift>;
  type: ItemType;
};

/** PurchaseInfoVo 에 대응됨 */
export type PurchaseInfo = {
  __typename?: 'PurchaseInfo';
  expired: Scalars['Boolean'];
  purchaseType: PurchaseType;
  /**
   * * 대여 만료 일시
   * * purchase_type이 대여인 경우만 표시
   */
  rentExpireDate?: Maybe<Scalars['Date']>;
};

/** PurchaseTypeVo 에 대응됨 */
export enum PurchaseType {
  /** 소장(buy) */
  Buy = 'Buy',
  /** 미구매(not_purchased) */
  NotPurchased = 'NotPurchased',
  /** 대여(rent) */
  Rent = 'Rent',
  /** 세트 소장 */
  SetBuy = 'SetBuy',
  /** 세트 대여 */
  SetRent = 'SetRent'
}

export type Query = {
  __typename?: 'Query';
  /** 휴면 계정 활성화합니다. */
  activateUser: ActivateUser;
  /**
   * 유저 연령인증 정보 조회
   * **주의! age_auth api 는 보호자 인증이 만료되지 않은 상태에서 호출하면 본인인증 정보가 날아가는 mutable api 입니다. 또한 age 정보가 변경되었을 때 이 쿼리를 호출하면 JWT 토큰이 age 값으로 업데이트 됩니다**
   */
  ageAuth?: Maybe<AgeAuth>;
  /** 공통 약관(agreement)과 14세 미만 약관(agreementUnder14)을 필드로 구분하여 가져온다 */
  agreements?: Maybe<AgreementInfo>;
  /** 유저의 설정 정보를 가져옵니다. */
  appConfig?: Maybe<AppConfig>;
  /** 은행 계좌 인증 */
  authBankAccount: DkpgRequestPayload;
  /** 은행 코드 목록 조회 */
  bankCodeList?: Maybe<Array<Maybe<BankCode>>>;
  /** 베스트 댓글 리스트 */
  bestCommentList?: Maybe<CommentList>;
  /** 차단된 유저 리스트 */
  blockUserList?: Maybe<BlockUserList>;
  /** 캐시 충전내역을 가져옵니다. */
  buyCashHistory?: Maybe<BuyCashHistoryList>;
  /** 이용권 충전내역을 가져옵니다. */
  buyTicketHistory?: Maybe<HistoryList>;
  checkUnregister?: Maybe<CheckUnregister>;
  /** 댓글 아이템 */
  commentItem?: Maybe<CommentItem>;
  /** 댓글 리스트 */
  commentList?: Maybe<CommentList>;
  /** 콘텐츠 이용권 충전 창 정보 */
  contentBuyTicketPage?: Maybe<ContentBuyTicketPage>;
  contentCheckFreeTicket?: Maybe<ContentCheckFreeTicket>;
  /**
   * 작품소개 탭 구성정보
   * /api/v1/content/about 의 응답값
   */
  contentHomeAbout?: Maybe<ContentHomeAbout>;
  /**
   * 요약 회차 목록
   * /api/v1/content/product/brief_list
   */
  contentHomeBriefList?: Maybe<ContentHomeBriefList>;
  /**
   * 콘텐츠 홈 정보 탭을 위한 쿼리
   * overview + about + recommend 를 한번에 가져와 정보를 조합해 내려줍니다.
   */
  contentHomeInfo?: Maybe<ContentHomeInfo>;
  /**
   * 소식 탭 구성정보
   * /api/v1/content/notice 의 응답값
   */
  contentHomeNotice?: Maybe<ContentHomeNotice>;
  /**
   * 홈 화면을 구성하는 기본 정보
   * /api/v1/content/overview 의 응답값
   */
  contentHomeOverview?: Maybe<ContentHomeOverview>;
  /**
   * 전체 회차 목록
   * /api/v1/content/product/list
   */
  contentHomeProductList?: Maybe<SingleListConnection>;
  /**
   * 추천 콘텐츠
   * /api/v2/content/recommend
   */
  contentHomeRecommend?: Maybe<ContentHomeRecommend>;
  /** 콘텐츠에 보유한 이용권 목록 */
  contentMyTicket?: Maybe<ContentMyTicket>;
  /** 콘텐츠 회차탭 마지막 본 회차 커서 index 정보 */
  contentProductCursorIndex?: Maybe<Scalars['Long']>;
  contentSetList?: Maybe<ContentSetList>;
  /** 세트 상품 컨텐츠 홈 */
  contentSetOverview?: Maybe<ContentSetOverview>;
  /** 콘텐츠 이용권 세부 내역 정보 */
  contentTicketDetail?: Maybe<TicketDetail>;
  /** 콘텐츠 구매 내역 조회 */
  contentTicketHistoryBuy?: Maybe<ContentTicketHistoryBuy>;
  /** 콘텐츠 구매 내역 상세 */
  contentTicketHistoryBuyDetail?: Maybe<ContentTicketHistoryBuyDetail>;
  /** 콘텐츠 이용권 구매 내역 목록 */
  contentTicketInfo?: Maybe<TicketInSeries>;
  /** 요일연재 레이아웃 조회 */
  dayOfWeekLayout?: Maybe<DayOfWeekLayout>;
  /** 요일연재 리스트 */
  dayOfWeekList?: Maybe<DayOfWeekList>;
  /** 등록된 기기 목록을 조회한다 */
  deviceInfo: DeviceInfo;
  /** INI DRM Licnese 발급을 위한 Token을 발급합니다. */
  drmAssertion?: Maybe<Scalars['String']>;
  /** dynamicLayout 을 포함한 ViewData를 가져온다 */
  dynamicLayoutReference?: Maybe<DynamicLayoutReference>;
  /** fairplay 영상 재생을 위한 certificate url을 가져옵니다. */
  fairplayCertificateUrl?: Maybe<Scalars['String']>;
  /** globalAgreements는 단순 조회 외에 유저의 상태를 체크합니다. 재가입 제한 여부(탈퇴 후 7일 경과 확인), 제재유저, 신규 유저 및 기가입 유저일 경우 업데이트 약관 확인을 위해 사용합니다. */
  getGlobalAgreements: GlobalAgreementInfo;
  getGlobalParentVerificationIsCompleted?: Maybe<GlobalParentVerificationIsCompleted>;
  /** 뽑기권 정보조회 */
  gotcha?: Maybe<GotchaInfo>;
  /** 헬릭스 랜딩페이지 작품 목록 조회 */
  helixSeriesList?: Maybe<HelixSeriesList>;
  /**
   * 전체 도움말을 가져온다.
   * 도움말 페이지는 페이징이 없으므로 한방에(size: 500) 가져옴
   */
  helps?: Maybe<AnnouncementContainer>;
  /** 보관함 좋아요 탭 목록을 가져옵니다. */
  invenLikeList?: Maybe<InvenList>;
  /** 보관함에 존재하는 내 정보 관련 데이터를 가져옵니다. */
  invenMyInfo?: Maybe<InvenMyInfo>;
  /** 보관함 구매한 작품 탭 목록을 가져옵니다. */
  invenPaidList?: Maybe<InvenList>;
  /** 보관함 최근 본 탭 목록을 가져옵니다. */
  invenRecentList?: Maybe<InvenList>;
  /** 보관함 추천작품 정보를 가져옵니다 */
  invenRecommendList?: Maybe<InvenRecommendList>;
  layout?: Maybe<Layout>;
  /** 여러 개의 screenUid를 통해 다수의 레이아웃을 한 번에 가져온다 */
  layoutList?: Maybe<Array<Layout>>;
  /** ref 타입의 ViewData 를 가져온다 */
  layoutReference: Array<LayoutReferenceViewData>;
  /** 내가 작성한 댓글리스트 */
  myCommentList?: Maybe<CommentList>;
  /** 알림 목록을 가져옵니다. */
  myNewsList?: Maybe<MyNewsList>;
  /** 내가 준 별점 정보를 가져옵니다. */
  myRating?: Maybe<MyRating>;
  /**
   * 전체 공지사항을 가져온다.
   * API 에는 페이징 처리가 되어있으나 그 수가 많지 않고 빈번하게 호출되는 페이지가 아니라 한방에(size: 10000) 가져옴
   */
  notices?: Maybe<AnnouncementContainer>;
  /**
   * 팝업 정보를 가져옵니다
   * /api/v9/store/popup
   */
  popup?: Maybe<Popup>;
  /** PASS 인증 페이지 진입하기 위한 인증정보를 가져옵니다. */
  prepareAuthRequestInfo: PrepareAuthRequestInfoPayload;
  /** 뷰어 오픈 전 티켓 유무 등 체크 */
  readyToUseTicket?: Maybe<ReadyToUseTicket>;
  /** 캐시 내역 현금영수증 발행 정보 */
  receiptInfo?: Maybe<ReceiptInfo>;
  /** 현금영수증 발행 정보 */
  receiptInfoResult?: Maybe<ReceiptInfoResult>;
  /** 환불 가능한 잔액 조회 */
  refundableAmount?: Maybe<RefundableAmount>;
  /** 대댓글 리스트 */
  replyCommentList?: Maybe<CommentList>;
  rouletteInfo?: Maybe<RouletteInfo>;
  sampleError?: Maybe<SampleError>;
  /** 검색어 자동완성 데이터를 가져옵니다. */
  searchAutoComplete?: Maybe<SearchAutoComplete>;
  /** 보관함에서 입력한 검색어로 보유 아이템을 검색합니다. */
  searchInvenList?: Maybe<InvenList>;
  /** 키워드 검색 결과 정보를 가져옵니다. */
  searchKeyword?: Maybe<SearchKeyword>;
  /** 검색 메인 페이지 데이터(인기 검색어 순위, 키토크 순위)를 가져옵니다. */
  searchMain?: Maybe<SearchMain>;
  /** 테마 키워드 검색 결과 정보를 가져옵니다. */
  searchThemeKeyword?: Maybe<SearchThemeKeyword>;
  /** 가입 약관 외에 15/19세 인증, 결제 관련 인증할 때 약관을 가져옵니다. (보호자 인증 포함) */
  selfCertAgreement?: Maybe<AgreementContainer>;
  seriesCardViewLandingList?: Maybe<SeriesCardViewLandingList>;
  seriesListViewLandingList?: Maybe<SeriesListViewLandingList>;
  seriesPosterViewLandingList?: Maybe<SeriesPosterViewLandingList>;
  setListViewLandingList?: Maybe<SetListViewLandingList>;
  setPosterViewLandingList?: Maybe<SetPosterViewLandingList>;
  setReadyToUseTicket?: Maybe<SetReadyToUseTicket>;
  shortcutList?: Maybe<ShortcutList>;
  /**
   * 정말 간단하게 연령정보 등 필수 정보만 가져올 수 있는 API
   * 이용권 플로우 이전, 회차 연령정보 확인 전 호출함
   */
  simpleSeriesSingleInfo?: Maybe<SimpleSeriesSingleInfo>;
  singleListViewLandingList?: Maybe<SingleListViewLandingList>;
  /** get/single preview 값을 가져옵니다 */
  singlePreview?: Maybe<SinglePreview>;
  /** 요일연재 고정랜딩 레이아웃을 가져온다 */
  staticLandingDayOfWeekLayout: Layout;
  /** 요일연재 고정랜딩 섹션을 가져온다(업데이트 용도) */
  staticLandingDayOfWeekSection: Section;
  /** 이벤트 고정랜딩 레이아웃을 가져온다 */
  staticLandingEventLayout: Layout;
  /** 이벤트 고정랜딩 섹션을 가져온다(업데이트 용도) */
  staticLandingEventSection: Section;
  /** 무료 시리즈 고정랜딩 레이아웃을 가져온다 */
  staticLandingFreeSeriesLayout: Layout;
  /** 무료 시리즈 고정랜딩 섹션을 가져온다(업데이트 용도) */
  staticLandingFreeSeriesSection: Section;
  /** 장르 전체 고정랜딩 레이아웃을 가져온다 */
  staticLandingGenreLayout: Layout;
  /** 장르 전체 고정랜딩 섹션을 가져온다(업데이트 용도) */
  staticLandingGenreSection: Section;
  /** 오리지널 고정랜딩 레이아웃을 가져온다 */
  staticLandingOriginalLayout: Layout;
  /** 오리지널 고정랜딩 섹션을 가져온다(업데이트 용도) */
  staticLandingOriginalSection: Section;
  /** 랭킹 고정랜딩 레이아웃을 가져온다 */
  staticLandingRankingLayout: Layout;
  /** 랭킹 고정랜딩 섹션을 가져온다(업데이트 용도) */
  staticLandingRankingSection: Section;
  /** 오늘신작 고정랜딩 레이아웃을 가져온다 */
  staticLandingTodayNewLayout: Layout;
  /** 오늘신작 고정랜딩 섹션을 가져온다(업데이트 용도) */
  staticLandingTodayNewSection: Section;
  /** 오늘UP 고정랜딩 레이아웃을 가져온다 */
  staticLandingTodayUpLayout: Layout;
  /** 오늘UP 고정랜딩 섹션을 가져온다(업데이트 용도) */
  staticLandingTodayUpSection: Section;
  tastesServiceLang?: Maybe<TastesServiceLang>;
  /** 선물함 아이템 리스트 + 헬릭스 */
  todayGiftList?: Maybe<TodayGiftList>;
  /** TV포인트 약관동의 정보 */
  tvPointAgreement?: Maybe<TvPointAgreement>;
  /** 캐시 사용내역을 가져옵니다. */
  useCashHistory?: Maybe<HistoryList>;
  /** 이용권 사용내역을 가져옵니다. */
  useTicketHistory?: Maybe<HistoryList>;
  /** 계정 정보와 유저 캐시 정보를 가져옵니다. */
  userAndCash?: Maybe<UserAndCashPayload>;
  /** 유저 캐시 정보를 가져옵니다. */
  userCash?: Maybe<UserCash>;
  version: Scalars['String'];
  /**
   * 뷰어 엔드 정보를 가져옵니다
   * /api/v2/viewer/end
   */
  viewerEnd?: Maybe<ViewerEnd>;
  /**
   * viewer data를 가져옵니다
   * /api/v1/viewer/data
   */
  viewerInfo?: Maybe<ViewerInfo>;
  /** 페이지 DRM Licnese 발급을 위한 Token을 발급합니다. */
  vodToken?: Maybe<VodToken>;
  /**
   * 웰컴페이지 정보를 가져옵니다
   * /api/v9/store/popup/welcome
   */
  welcome?: Maybe<Welcome>;
};


export type QueryActivateUserArgs = {
  authInput?: Maybe<AuthInput>;
};


export type QueryAgeAuthArgs = {
  ageLimit: Scalars['Int'];
};


export type QueryAuthBankAccountArgs = {
  input: AuthBankAccountInput;
};


export type QueryBestCommentListArgs = {
  bestCommentListInput: BestCommentListInput;
};


export type QueryBuyCashHistoryArgs = {
  lastPageId?: Maybe<Scalars['BigInt']>;
  page: Scalars['Int'];
  usePaging?: Maybe<Scalars['Boolean']>;
};


export type QueryBuyTicketHistoryArgs = {
  freeOnly?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryCommentItemArgs = {
  parentUid: Scalars['Int'];
  seriesId?: Maybe<Scalars['Long']>;
};


export type QueryCommentListArgs = {
  commentListInput: CommentListInput;
};


export type QueryContentBuyTicketPageArgs = {
  seriesId: Scalars['Long'];
};


export type QueryContentCheckFreeTicketArgs = {
  seriesId: Scalars['Long'];
};


export type QueryContentHomeAboutArgs = {
  seriesId: Scalars['Long'];
};


export type QueryContentHomeBriefListArgs = {
  seriesId: Scalars['Long'];
};


export type QueryContentHomeInfoArgs = {
  seriesId: Scalars['Long'];
};


export type QueryContentHomeNoticeArgs = {
  contentHomeNoticeInput: ContentHomeNoticeInput;
};


export type QueryContentHomeOverviewArgs = {
  seriesId: Scalars['Long'];
};


export type QueryContentHomeProductListArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  boughtOnly?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  seriesId: Scalars['Long'];
  sortType?: Maybe<Scalars['String']>;
};


export type QueryContentHomeRecommendArgs = {
  seriesId: Scalars['Long'];
};


export type QueryContentMyTicketArgs = {
  includeSingle?: Maybe<Scalars['Boolean']>;
  includeWaitfree?: Maybe<Scalars['Boolean']>;
  onlyPaidTicket?: Maybe<Scalars['Boolean']>;
  seriesId: Scalars['Long'];
};


export type QueryContentProductCursorIndexArgs = {
  seriesId: Scalars['Long'];
  sortType?: Maybe<Scalars['String']>;
};


export type QueryContentSetListArgs = {
  productId: Scalars['Long'];
  seriesId: Scalars['Long'];
};


export type QueryContentSetOverviewArgs = {
  setId: Scalars['String'];
};


export type QueryContentTicketDetailArgs = {
  seriesId: Scalars['Long'];
  ticketUid: Scalars['String'];
};


export type QueryContentTicketHistoryBuyArgs = {
  page?: Maybe<Scalars['Int']>;
  seriesId: Scalars['Long'];
};


export type QueryContentTicketHistoryBuyDetailArgs = {
  seriesId: Scalars['Long'];
  ticketId: Scalars['String'];
};


export type QueryContentTicketInfoArgs = {
  page?: Maybe<Scalars['Int']>;
  seriesId: Scalars['Long'];
};


export type QueryDayOfWeekLayoutArgs = {
  dayUid?: Maybe<Scalars['Int']>;
};


export type QueryDayOfWeekListArgs = {
  dayUid?: Maybe<Scalars['Int']>;
  hasBanner?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  referenceKey: Scalars['String'];
  size?: Maybe<Scalars['Int']>;
  sortType?: Maybe<Scalars['String']>;
};


export type QueryDrmAssertionArgs = {
  contentPackId: Scalars['String'];
  productId: Scalars['Long'];
};


export type QueryDynamicLayoutReferenceArgs = {
  dataKey: Scalars['String'];
  metaInfoType?: Maybe<MetaInfoType>;
  sectionType: SectionType;
};


export type QueryGetGlobalAgreementsArgs = {
  globalAgreementInput: GetGlobalAgreementInfoInput;
};


export type QueryGetGlobalParentVerificationIsCompletedArgs = {
  input: Scalars['String'];
};


export type QueryGotchaArgs = {
  adLocId?: Maybe<Scalars['String']>;
  gotchaId: Scalars['String'];
  hasMapUid?: Maybe<Scalars['Boolean']>;
};


export type QueryHelixSeriesListArgs = {
  mapUid: Scalars['String'];
};


export type QueryHelpsArgs = {
  target?: Maybe<AnnouncementTarget>;
};


export type QueryInvenLikeListArgs = {
  invenListInput: InvenListInput;
};


export type QueryInvenPaidListArgs = {
  invenListInput: InvenListInput;
};


export type QueryInvenRecentListArgs = {
  invenListInput: InvenListInput;
};


export type QueryInvenRecommendListArgs = {
  type: Scalars['String'];
};


export type QueryLayoutArgs = {
  screenUid: Scalars['Int'];
  type?: Maybe<LayoutType>;
};


export type QueryLayoutListArgs = {
  screenUidList: Array<Scalars['Int']>;
  type?: Maybe<LayoutType>;
};


export type QueryLayoutReferenceArgs = {
  dataKey: Scalars['String'];
  metaInfoType?: Maybe<MetaInfoType>;
  sectionType: SectionType;
};


export type QueryMyCommentListArgs = {
  page: Scalars['Int'];
};


export type QueryMyNewsListArgs = {
  myNewsListInput: MyNewsListInput;
};


export type QueryMyRatingArgs = {
  productId: Scalars['Long'];
  seriesId: Scalars['Long'];
};


export type QueryNoticesArgs = {
  target?: Maybe<AnnouncementTarget>;
};


export type QueryPrepareAuthRequestInfoArgs = {
  input: PrepareAuthRequestInfoInput;
};


export type QueryReadyToUseTicketArgs = {
  productId: Scalars['Long'];
  seriesId: Scalars['Long'];
};


export type QueryReceiptInfoResultArgs = {
  creditMasterId: Scalars['BigInt'];
};


export type QueryReplyCommentListArgs = {
  commentListInput: CommentListInput;
};


export type QueryRouletteInfoArgs = {
  hasMapUid?: Maybe<Scalars['Boolean']>;
  rouletteAdLocId?: Maybe<Scalars['String']>;
  rouletteId: Scalars['String'];
};


export type QuerySampleErrorArgs = {
  pagewebErrorType: Scalars['String'];
};


export type QuerySearchAutoCompleteArgs = {
  searchAutoCompleteInput: SearchAutoCompleteInput;
};


export type QuerySearchInvenListArgs = {
  searchInvenListInput: SearchInvenListInput;
};


export type QuerySearchKeywordArgs = {
  searchKeywordInput: SearchKeywordInput;
};


export type QuerySearchThemeKeywordArgs = {
  searchThemeKeywordInput: SearchThemeKeywordInput;
};


export type QuerySelfCertAgreementArgs = {
  authRequestType: AuthRequestType;
};


export type QuerySeriesCardViewLandingListArgs = {
  dataKey: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  themeKeywordUid?: Maybe<Scalars['String']>;
};


export type QuerySeriesListViewLandingListArgs = {
  dataKey: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  themeKeywordUid?: Maybe<Scalars['String']>;
};


export type QuerySeriesPosterViewLandingListArgs = {
  dataKey: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  themeKeywordUid?: Maybe<Scalars['String']>;
};


export type QuerySetListViewLandingListArgs = {
  dataKey: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};


export type QuerySetPosterViewLandingListArgs = {
  dataKey: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
};


export type QuerySetReadyToUseTicketArgs = {
  seriesId: Scalars['Long'];
  setId: Scalars['Long'];
};


export type QuerySimpleSeriesSingleInfoArgs = {
  productId?: Maybe<Scalars['Long']>;
  seriesId: Scalars['Long'];
};


export type QuerySingleListViewLandingListArgs = {
  dataKey: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  themeKeywordUid?: Maybe<Scalars['String']>;
};


export type QuerySinglePreviewArgs = {
  productId: Scalars['Long'];
};


export type QueryStaticLandingDayOfWeekLayoutArgs = {
  input: StaticLandingDayOfWeekParamInput;
};


export type QueryStaticLandingDayOfWeekSectionArgs = {
  param: StaticLandingDayOfWeekParamInput;
  sectionId: Scalars['ID'];
};


export type QueryStaticLandingEventLayoutArgs = {
  input: StaticLandingEventParamInput;
};


export type QueryStaticLandingEventSectionArgs = {
  param: StaticLandingEventParamInput;
  sectionId: Scalars['ID'];
};


export type QueryStaticLandingFreeSeriesLayoutArgs = {
  input: StaticLandingFreeSeriesParamInput;
};


export type QueryStaticLandingFreeSeriesSectionArgs = {
  param: StaticLandingFreeSeriesParamInput;
  sectionId: Scalars['ID'];
};


export type QueryStaticLandingGenreLayoutArgs = {
  input: StaticLandingGenreParamInput;
};


export type QueryStaticLandingGenreSectionArgs = {
  param: StaticLandingGenreParamInput;
  sectionId: Scalars['ID'];
};


export type QueryStaticLandingOriginalLayoutArgs = {
  input: StaticLandingOriginalParamInput;
};


export type QueryStaticLandingOriginalSectionArgs = {
  param: StaticLandingOriginalParamInput;
  sectionId: Scalars['ID'];
};


export type QueryStaticLandingRankingLayoutArgs = {
  input: StaticLandingRankingParamInput;
};


export type QueryStaticLandingRankingSectionArgs = {
  param: StaticLandingRankingParamInput;
  sectionId: Scalars['ID'];
};


export type QueryStaticLandingTodayNewLayoutArgs = {
  input: StaticLandingTodayNewParamInput;
};


export type QueryStaticLandingTodayNewSectionArgs = {
  param: StaticLandingTodayNewParamInput;
  sectionId: Scalars['ID'];
};


export type QueryStaticLandingTodayUpLayoutArgs = {
  input: StaticLandingTodayUpParamInput;
};


export type QueryStaticLandingTodayUpSectionArgs = {
  param: StaticLandingTodayUpParamInput;
  sectionId: Scalars['ID'];
};


export type QueryTodayGiftListArgs = {
  categoryUid?: Maybe<Scalars['String']>;
  subCategoryUid?: Maybe<Scalars['String']>;
};


export type QueryUseCashHistoryArgs = {
  page: Scalars['Int'];
};


export type QueryUseTicketHistoryArgs = {
  freeOnly?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
};


export type QueryUserAndCashArgs = {
  authInput?: Maybe<AuthInput>;
};


export type QueryViewerEndArgs = {
  viewerEndInput: ViewerEndInput;
};


export type QueryViewerInfoArgs = {
  productId: Scalars['Long'];
  seriesId: Scalars['Long'];
};


export type QueryVodTokenArgs = {
  contentPackId: Scalars['String'];
  drmType: DrmType;
  productId: Scalars['Long'];
};

/**
 * 쿼리가 어디로부터 실행되었는지 판단할 때 사용됩니다.
 * 주로 티켓 사용 시 콘텐츠홈과 뷰어 분기할 때 사용합니다
 */
export enum QueryFromPage {
  ContentHome = 'ContentHome',
  Inven = 'Inven',
  /** 회차섹션 */
  Section = 'Section',
  /** 세트상품 구매페이지 */
  SetOverview = 'SetOverview',
  Viewer = 'Viewer',
  /** 뷰어 진입 */
  ViewerEntry = 'ViewerEntry'
}

export type RankingListViewItem = Item & {
  __typename?: 'RankingListViewItem';
  /** 19세 작품 + 만 19세 미만(혹, 미인증)인 경우 썸네일 가리기 등 별도 처리를 해야합니다. */
  ageGrade: AgeGrade;
  ageGradeBadge?: Maybe<BadgeType>;
  /** bmBadge */
  badgeList: Array<BadgeType>;
  descriptionList?: Maybe<Array<Scalars['String']>>;
  discountRate?: Maybe<Scalars['Int']>;
  discountRateText?: Maybe<Scalars['String']>;
  eventLog?: Maybe<EventLog>;
  id: Scalars['ID'];
  metaList?: Maybe<Array<Scalars['String']>>;
  rank?: Maybe<Scalars['String']>;
  scheme?: Maybe<Scalars['String']>;
  selfCensorship?: Maybe<Scalars['Boolean']>;
  statusBadge?: Maybe<BadgeType>;
  thumbnail: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  type: ItemType;
};

export type RankingSection = SchemeSection & Section & {
  __typename?: 'RankingSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  scheme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type RankingV2Section = SchemeSection & Section & {
  __typename?: 'RankingV2Section';
  groups: Array<Group>;
  id: Scalars['ID'];
  scheme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export enum ReadAccessType {
  /** * 읽을수 있음(RAT2) */
  CanRead = 'CanRead',
  /** * 열람가능한 연재상품(RAT4) */
  CanReadSerialize = 'CanReadSerialize',
  /** * 대여했으나 만료됨(RAT3) */
  Expired = 'Expired',
  /** 구매하지 않음(RAT1) */
  NotPurchased = 'NotPurchased',
  /** * 웹에서 열람 불가능한 상품(RAT5) */
  UnreadableWeb = 'UnreadableWeb',
  /** * 웹에서 연령제한으로 열람 불가(RAT6) */
  UnreadableWebAgeLimit = 'UnreadableWebAgeLimit'
}

/** 가능한 열람 방식 */
export enum ReadType {
  /** 둘다(페이지 넘김, 스크롤) 허용 */
  Both = 'Both',
  /** 페이지 넘김만 허용 */
  Page = 'Page',
  /** 스크롤만 허용 */
  Scroll = 'Scroll'
}

export type ReadyToUseTicket = {
  __typename?: 'ReadyToUseTicket';
  /** 사용 가능한 이용권 정보(사용자가 갖고있는 이용권) */
  available?: Maybe<TicketAvailable>;
  my?: Maybe<TicketMy>;
  /** 대여기간 만료 [보던 화/다음 화]선택 팝업 시 다음화를 보여주기 위한 필드 */
  nextItem?: Maybe<LegacySingle>;
  /** 구매 가능한 이용권 정보(시스템에서 오픈해놓은 이용권) */
  purchase?: Maybe<TicketPurchase>;
  rentalPeriodByMinute?: Maybe<Scalars['Int']>;
  series?: Maybe<TicketSeries>;
  single?: Maybe<TicketSingle>;
};

export type ReceiptInfo = {
  __typename?: 'ReceiptInfo';
  accountId?: Maybe<Scalars['Long']>;
  receiptInfo?: Maybe<Scalars['String']>;
  receiptInfoType?: Maybe<ReceiptInfoType>;
};

export type ReceiptInfoResult = {
  __typename?: 'ReceiptInfoResult';
  createdAt?: Maybe<Scalars['String']>;
  receiptAuthNum?: Maybe<Scalars['Long']>;
  receiptCancelNum?: Maybe<Scalars['Long']>;
  receiptCancelPrice?: Maybe<Scalars['Int']>;
  receiptInfo?: Maybe<Scalars['String']>;
  receiptInfoType?: Maybe<ReceiptInfoType>;
  receiptPrice?: Maybe<Scalars['Int']>;
  receiptType?: Maybe<ReceiptResultType>;
};

export type ReceiptInfoStatusPayload = {
  __typename?: 'ReceiptInfoStatusPayload';
  status?: Maybe<ResultStatus>;
};

export enum ReceiptInfoType {
  /** 지출증빙(현금영수증 카드번호) */
  BusinessCard = 'BusinessCard',
  /** 지출증빙(사업자용) */
  BusinessNumber = 'BusinessNumber',
  /** 개인 소득공제(현금 영수증 카드 번호) */
  PersonalCard = 'PersonalCard',
  /** 개인 소득공제(휴대폰) */
  PersonalPhone = 'PersonalPhone',
  /**
   * 자진발급
   * 이 타입은, 유저가 선택할 수 없고 구글 기프트카드에서 결제할 경우 자진발급으로 발행됩니다.
   */
  Self = 'Self'
}

export enum ReceiptResultType {
  Canceled = 'Canceled',
  Normal = 'Normal'
}

export type RecentViewedSection = DependOnLoggedInSection & MetaInfoTypeSection & SchemeSection & Section & {
  __typename?: 'RecentViewedSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  loggedInScheme?: Maybe<Scalars['String']>;
  loggedInTitle?: Maybe<Scalars['String']>;
  metaInfoType?: Maybe<MetaInfoType>;
  scheme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

/** 콘텐츠홈 소식탭에서 쓰이는 이벤트 배너입니다 */
export type RecommendEvent = {
  __typename?: 'RecommendEvent';
  bannerUid: Scalars['Int'];
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
  itemOrder: Scalars['Int'];
  scheme: Scalars['String'];
  title: Scalars['String'];
};

export type RecommendSection = {
  /** is_fetch_recommend 필드가 있다면 이 섹션을 "추천 영역" 이라고 부른다 */
  isRecommendArea?: Maybe<Scalars['Boolean']>;
  /** is_fetch_recommend 가 true 라면 이 섹션 내부의 아이템을 "추천 아이템" 으로 간주한다(helix_yn = y). */
  isRecommendedItems?: Maybe<Scalars['Boolean']>;
};

export type RedeemCode = {
  __typename?: 'RedeemCode';
  age?: Maybe<AgeGrade>;
  amount?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['Int']>;
  resultCode?: Maybe<Scalars['Int']>;
  seriesId?: Maybe<Scalars['Long']>;
  shouldRedirect?: Maybe<Scalars['Boolean']>;
  ticket?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<RedeemCodeType>;
};

export type RedeemCodeInput = {
  agentCode: Scalars['String'];
  code: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
};

export enum RedeemCodeType {
  Credit = 'CREDIT',
  Gacha = 'GACHA',
  None = 'NONE',
  Point = 'POINT',
  Ticket = 'TICKET',
  TicketBuy = 'TICKET_BUY',
  TicketRent = 'TICKET_RENT'
}

export type RefundRequestInput = {
  /** 계좌 번호 */
  bankAccountNumber: Scalars['String'];
  /** 계좌 소유자명 */
  bankAccountOwnerName: Scalars['String'];
  /** 은행 코드 */
  bankCode: Scalars['String'];
  /** 환불 알림 이메일 주소 */
  email: Scalars['String'];
  /** 최종 환불 가능 금액 */
  finalRefundableAmount: Scalars['Int'];
  /** 환불 사유 */
  reason: Scalars['String'];
  /** 환불 수수료 */
  refundFee: Scalars['Int'];
  /** 환불 타입 */
  refundType: RefundType;
  /** 환불 가능 금액 */
  refundableAmount: Scalars['Int'];
};

export type RefundRequestPayload = {
  __typename?: 'RefundRequestPayload';
  status: BillingStatusCode;
  statusCode?: Maybe<Scalars['Int']>;
};

export type RefundTicketStatusPayload = {
  __typename?: 'RefundTicketStatusPayload';
  status?: Maybe<ResultStatus>;
};

export enum RefundType {
  /** 고객변심 */
  CustomerChangeMind = 'CustomerChangeMind',
  /** 기타 */
  Etc = 'Etc',
  /** 도용 */
  Fraud = 'Fraud',
  /** 미성년자 결제 */
  MinorsPayment = 'MinorsPayment'
}

/**
 * 환불 가능 금액
 * https://docs.google.com/spreadsheets/d/1pGaW1f__ZiwEy-0xpBAmZsECTS8cgKRnFCGpp5cA09o/edit#gid=997514494
 */
export type RefundableAmount = {
  __typename?: 'RefundableAmount';
  /** 최종 환불 가능 금액(환불 가능 금액 - 환불 수수료) */
  finalRefundableAmount?: Maybe<Scalars['Int']>;
  /** 환불 불가 금액(인앱결제) */
  notRefundableAmount?: Maybe<Scalars['Int']>;
  /** 환불 수수료 */
  refundFee?: Maybe<Scalars['Int']>;
  /** 환불 가능 금액 */
  refundableAmount?: Maybe<Scalars['Int']>;
  /** 유상 캐시 잔액 = 충전 캐시 잔액 */
  totalRemainAmount?: Maybe<Scalars['Int']>;
  /** 사용된 이벤트 캐시 */
  usedEventCash?: Maybe<Scalars['Int']>;
};

export type RefundableTicketInfo = {
  __typename?: 'RefundableTicketInfo';
  expiredEventCash?: Maybe<Scalars['Int']>;
  initialCount?: Maybe<Scalars['Int']>;
  normalCash?: Maybe<Scalars['Int']>;
  notRefundableExpiredEventCash?: Maybe<Scalars['Int']>;
  notRefundablePoint?: Maybe<Scalars['Int']>;
  notRefundableVodCash?: Maybe<Scalars['Int']>;
  paidTicketCount?: Maybe<Scalars['Int']>;
  point?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  qty?: Maybe<Scalars['Int']>;
  refundExceptEventCash?: Maybe<Scalars['Int']>;
  refundTicketCount?: Maybe<Scalars['Int']>;
  refundableNormalCash?: Maybe<Scalars['Int']>;
  refundableValidEventCash?: Maybe<Scalars['Int']>;
  remainCount?: Maybe<Scalars['Int']>;
  totalPaidCash?: Maybe<Scalars['Int']>;
  usedExpiredEventCash?: Maybe<Scalars['Int']>;
  usedNormalCash?: Maybe<Scalars['Int']>;
  usedPaidTicketPrice?: Maybe<Scalars['Int']>;
  usedPoint?: Maybe<Scalars['Int']>;
  usedValidEventCash?: Maybe<Scalars['Int']>;
  usedVodCash?: Maybe<Scalars['Int']>;
  validEventCash?: Maybe<Scalars['Int']>;
  vodCash?: Maybe<Scalars['Int']>;
};

export type RemoveMyNewsInput = {
  newsId: Scalars['Long'];
};

export type RemoveMyNewsPayload = {
  __typename?: 'RemoveMyNewsPayload';
  newsId: Scalars['Long'];
};

export type ReqInfoNotExist = AuthRequestInfoError & {
  __typename?: 'ReqInfoNotExist';
  message: Scalars['String'];
};

export type ResponsiveBannerGroup = Group & {
  __typename?: 'ResponsiveBannerGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export enum ResultStatus {
  Fail = 'Fail',
  Success = 'Success'
}

export enum RouletteApiErrorHandleType {
  Close = 'Close',
  Reload = 'Reload'
}

export type RouletteDrawInput = {
  redeem?: Maybe<Scalars['String']>;
  rouletteAdLocId?: Maybe<Scalars['String']>;
  rouletteId: Scalars['String'];
};

export type RouletteDrawPayload = {
  __typename?: 'RouletteDrawPayload';
  expirationDate?: Maybe<Scalars['String']>;
  prize?: Maybe<Scalars['String']>;
  prizeType?: Maybe<RouletteWinPrizeType>;
  rouletteStatus?: Maybe<RouletteStatus>;
  winningDate?: Maybe<Scalars['String']>;
};

export enum RouletteEntryType {
  CashSponsorAd = 'CashSponsorAd',
  Direct = 'Direct',
  DirectV2 = 'DirectV2',
  None = 'None',
  Redeem = 'Redeem',
  RedeemV2 = 'RedeemV2'
}

export type RouletteInfo = {
  __typename?: 'RouletteInfo';
  apiErrorHandleType?: Maybe<RouletteApiErrorHandleType>;
  apiErrorMsg?: Maybe<Scalars['String']>;
  badgeImageUrl?: Maybe<Scalars['String']>;
  bannerAdLocId?: Maybe<Scalars['String']>;
  bannerImageUrl?: Maybe<Scalars['String']>;
  bannerLink?: Maybe<Scalars['String']>;
  bgColor?: Maybe<Scalars['String']>;
  bgImg?: Maybe<Scalars['String']>;
  entryType?: Maybe<RouletteEntryType>;
  expirationDate?: Maybe<Scalars['String']>;
  headerTitle: Scalars['String'];
  isOldRoulette: Scalars['Boolean'];
  isRedeemType: Scalars['Boolean'];
  isSponsorType: Scalars['Boolean'];
  maxCash?: Maybe<Scalars['Int']>;
  prize?: Maybe<Scalars['String']>;
  prizeImageUrl?: Maybe<Scalars['String']>;
  prizeType?: Maybe<RouletteWinPrizeType>;
  resultBottomTextList: Array<Scalars['String']>;
  rouletteAdLocId?: Maybe<Scalars['String']>;
  rouletteId: Scalars['String'];
  rouletteStatus: RouletteStatus;
  screenTitle: Scalars['String'];
  type?: Maybe<RouletteType>;
  winningDate?: Maybe<Scalars['Date']>;
};

export enum RouletteStatus {
  Already = 'Already',
  BudgetCrunch = 'BudgetCrunch',
  Disable = 'Disable',
  Draw = 'Draw',
  Duplicate = 'Duplicate',
  Error = 'Error',
  Expire = 'Expire',
  Fail = 'Fail',
  First = 'First',
  Noauth = 'Noauth',
  Success = 'Success',
  TicketFail = 'TicketFail',
  Unknown = 'Unknown',
  UnknownApiStatus = 'UnknownApiStatus',
  WaitRedeemResult = 'WaitRedeemResult'
}

export enum RouletteType {
  CashSponsor = 'CashSponsor',
  Standalone = 'Standalone'
}

export enum RouletteWinPrizeType {
  Cash = 'Cash',
  Goods = 'Goods',
  Ticket = 'Ticket'
}

export enum SaleMethod {
  Cash = 'CASH',
  Ticket = 'TICKET'
}

/**
 * 판매중 / 판매중지 여부
 * SlideType 의 ST61는 판매중, ST62, ST64 는 판매중지입니다.
 * 나머지는 모두 API 에서 에러를 내보내주니 Unknown 으로 둡니다
 */
export enum SaleState {
  Ing = 'Ing',
  Stop = 'Stop',
  Unknown = 'Unknown'
}

export enum SaleType {
  Refund = 'Refund',
  Sale = 'Sale'
}

export type SalesTicket = {
  __typename?: 'SalesTicket';
  address: Scalars['String'];
  category: Scalars['String'];
  categoryUid: Scalars['String'];
  createDt: Scalars['String'];
  itemCode: Scalars['String'];
  itemCount: Scalars['Int'];
  paidNum: Scalars['Int'];
  paidYn: Scalars['Int'];
  payId: Scalars['Int'];
  price: Scalars['Int'];
  publisherUid: Scalars['Int'];
  qty: Scalars['Int'];
  receiveUserUid: Scalars['Int'];
  saleType: SaleType;
  seriesId: Scalars['Long'];
  seriesTitle: Scalars['String'];
  subCategory: Scalars['String'];
  subCategoryUid: Scalars['Int'];
  ticketType: TicketType;
  ticketUid: Scalars['Long'];
  uid: Scalars['Int'];
  userAgent: Scalars['String'];
  userUid: Scalars['Int'];
};

export type SalesTicketItem = {
  __typename?: 'SalesTicketItem';
  category?: Maybe<Scalars['String']>;
  createDt?: Maybe<Scalars['String']>;
  itemCount?: Maybe<Scalars['Int']>;
  paidNum?: Maybe<Scalars['Int']>;
  payId?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
  qty?: Maybe<Scalars['Int']>;
  saleType?: Maybe<SaleType>;
  seriesId?: Maybe<Scalars['Int']>;
  seriesTitle?: Maybe<Scalars['String']>;
  subCategory?: Maybe<Scalars['String']>;
  ticketExpireDt?: Maybe<Scalars['String']>;
  ticketType?: Maybe<TicketType>;
  ticketUid?: Maybe<Scalars['String']>;
};

export type SampleError = {
  __typename?: 'SampleError';
  sample?: Maybe<Scalars['String']>;
};

export type SaveAuthInfoInput = {
  agreementFormList?: Maybe<Array<AgreementForm>>;
  authRequestType: AuthRequestType;
  certType: CertType;
  /**
   * 인증에 필요한 키
   * DREAMSECURITY: encryptMOKKeyToken
   * NICE: web_transaction_id|request_no
   * KAKAOBANK: composite_key
   */
  authKey: Scalars['String'];
  /**
   * 인증 정보 덮어쓰기 값입니다.
   * 회원가입과 같이 인증정보가 없는 경우 false로 설정합니다.
   */
  overwriteAgreement?: Maybe<Scalars['Boolean']>;
  processInSignUp?: Maybe<Scalars['Boolean']>;
};

export type SaveAuthInfoPayload = {
  __typename?: 'SaveAuthInfoPayload';
  authInfo?: Maybe<AuthInfo>;
};

export type SchemeSection = {
  /** 특정 섹션은 스킴이 존재할 수 있습니다 */
  scheme?: Maybe<Scalars['String']>;
};

export type Screen = {
  __typename?: 'Screen';
  ageGrade?: Maybe<AgeGrade>;
  categoryUid?: Maybe<Scalars['Int']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  landingType?: Maybe<StaticLandingType>;
  title: Scalars['String'];
  type: Scalars['String'];
  uid: Scalars['Int'];
};

export type ScrollThemeSection = MetaInfoTypeSection & SchemeSection & Section & {
  __typename?: 'ScrollThemeSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  metaInfoType?: Maybe<MetaInfoType>;
  scheme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type SearchAutoComplete = {
  __typename?: 'SearchAutoComplete';
  id: Scalars['ID'];
  keyword: Scalars['String'];
  list: Array<AutoCompleteItem>;
};

export type SearchAutoCompleteInput = {
  keyword: Scalars['String'];
  size?: Maybe<Scalars['Int']>;
};

export type SearchInvenListInput = {
  categoryUid: Scalars['Int'];
  page: Scalars['Int'];
  sortType: Scalars['String'];
  type: Scalars['String'];
  word: Scalars['String'];
};

export type SearchKeyword = {
  __typename?: 'SearchKeyword';
  categoryOptionList: Array<SortOption>;
  id: Scalars['ID'];
  isEnd: Scalars['Boolean'];
  keyword: Scalars['String'];
  list: Array<NormalListViewItem>;
  page: Scalars['Int'];
  selectedCategoryOption: SortOption;
  selectedSortOption: SortOption;
  showOnlyComplete: Scalars['Boolean'];
  sortOptionList: Array<SortOption>;
  total: Scalars['Int'];
};

export type SearchKeywordInput = {
  categoryUid?: Maybe<Scalars['String']>;
  keyword: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  /** 완료작만 보기 필터 */
  showOnlyComplete?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['Int']>;
  sortType?: Maybe<SearchKeywordSortType>;
};

export enum SearchKeywordSortType {
  Accuracy = 'Accuracy',
  /** Latest는 기본값입니다. */
  Latest = 'Latest'
}

export type SearchMain = {
  __typename?: 'SearchMain';
  id: Scalars['ID'];
  keywordRankList: Array<SearchPopularKeywordRank>;
};

export type SearchPopularKeywordRank = {
  __typename?: 'SearchPopularKeywordRank';
  id: Scalars['ID'];
  keyword: Scalars['String'];
  rank: Scalars['Int'];
  url: Scalars['String'];
};

export type SearchThemeKeyword = {
  __typename?: 'SearchThemeKeyword';
  categoryOptionList: Array<SortOption>;
  filterList: Array<Scalars['String']>;
  id: Scalars['ID'];
  isEnd: Scalars['Boolean'];
  list: Array<NormalListViewItem>;
  page: Scalars['Int'];
  selectedCategoryOption: SortOption;
  selectedSortOption: SortOption;
  sortOptionList: Array<SortOption>;
  total: Scalars['Int'];
};

export type SearchThemeKeywordInput = {
  categoryUid?: Maybe<Scalars['Int']>;
  filterList: Array<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  sortType?: Maybe<SearchThemeKeywordSortType>;
};

export enum SearchThemeKeywordSortType {
  Comment = 'Comment',
  Latest = 'Latest',
  Like = 'Like',
  Popular = 'Popular',
  /** Update는 디폴트 값입니다. */
  Update = 'Update'
}

/**
 * 레이아웃 내의 구분 단위. 기획에서 얘기하는 두 번째로 큰 단위
 * 예를 들면 카테고리홈의 전략카테고리, 빅배너 섹션이나
 * 쿼드의 LNB, 쿼드 콘텐츠 영역
 */
export type Section = {
  groups: Array<Group>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  /** DB 상의 유니크한 값. API 에서 줄 때도 있고 안줄때도 있음 */
  uid?: Maybe<Scalars['Int']>;
};

/** 섹션에 선택 탭이 있을 경우 해당 탭 */
export type SectionMainTab = {
  __typename?: 'SectionMainTab';
  additionalString?: Maybe<Scalars['String']>;
  isSelected?: Maybe<Scalars['Boolean']>;
  /** 메인랭킹의 경우 탭 별로 더보기 동작이 달라진다. API 에서 주는대로 더보기를 변경하기 위한 값 */
  scheme?: Maybe<Scalars['String']>;
  /** 섹션메인탭이 있다면 해당 탭의 서브탭은 무조건 하나라도 존재해야한다.(그래야 groupId 를 지정할 수 있기 때문) */
  subTabList: Array<SectionSubTab>;
  title?: Maybe<Scalars['String']>;
  uid: Scalars['Int'];
};

/** 섹션 메인에 해당하는 서브탭이 있을 경우 해당 탭 */
export type SectionSubTab = {
  __typename?: 'SectionSubTab';
  groupId?: Maybe<Scalars['String']>;
  isSelected?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  uid: Scalars['Int'];
};

/**
 * API 의 type 과 동일하게 감
 * 즉, SectionTypeVo 와 동일함
 */
export enum SectionType {
  BigBanner = 'BigBanner',
  CardBanner = 'CardBanner',
  /** DA */
  CashfriendsAd = 'CashfriendsAd',
  DayOfWeek = 'DayOfWeek',
  /** DA 섹션 (랜딩 섹션에서 활용) */
  DisplayAd = 'DisplayAd',
  Episode = 'Episode',
  Event = 'Event',
  HelixTheme = 'HelixTheme',
  /** 랜딩 - 요일연재 */
  LandingDayOfWeek = 'LandingDayOfWeek',
  /** 랜딩 - 이벤트 */
  LandingEvent = 'LandingEvent',
  /** 랜딩 - 무료 시리즈 */
  LandingFreeSeries = 'LandingFreeSeries',
  /** 랜딩 - 장르 전체 */
  LandingGenre = 'LandingGenre',
  /** 랜딩 - 오리지널 */
  LandingOriginal = 'LandingOriginal',
  /** 랜딩 - 랭킹 */
  LandingRanking = 'LandingRanking',
  /** 랜딩 - 오늘 신작 */
  LandingTodayNew = 'LandingTodayNew',
  /** 랜딩 - 오늘 UP */
  LandingTodayUp = 'LandingTodayUp',
  LineBanner = 'LineBanner',
  MainRanking = 'MainRanking',
  New = 'New',
  OnAir = 'OnAir',
  PromotionBanner = 'PromotionBanner',
  Ranking = 'Ranking',
  RankingV2 = 'RankingV2',
  RecentViewed = 'RecentViewed',
  RecommendEvent = 'RecommendEvent',
  ScrollTheme = 'ScrollTheme',
  SeriesBasedRecommend = 'SeriesBasedRecommend',
  Theme = 'Theme',
  /** API 내부적으론 V1, V2 로 구분되나 실제 화면 그릴때는 구분이 필요없어 TOP 하나로 통일합니다 */
  Top = 'Top',
  Unknown = 'Unknown',
  Updatealarm = 'Updatealarm',
  UserBasedRecommend = 'UserBasedRecommend'
}

export type SendEmailVerifyCodeInput = {
  email: Scalars['String'];
  verifyType: SendEmailVerifyType;
};

export type SendEmailVerifyCodePayload = {
  __typename?: 'SendEmailVerifyCodePayload';
  verifyUuid: Scalars['String'];
};

export enum SendEmailVerifyType {
  PasswordReset = 'PASSWORD_RESET',
  Self = 'SELF'
}

/** ItemSeriesDTO 에 대응됨 */
export type Series = {
  __typename?: 'Series';
  ageGrade: AgeGrade;
  assetProperty?: Maybe<AssetProperty>;
  authors?: Maybe<Scalars['String']>;
  badge?: Maybe<BadgeType>;
  /** 콘텐츠홈 판매정책(BM) (BusinessModel 과 다름. BM 은 NEXT 부터 도입된 개념으로 유료BM, 무료BM, 예외BM이 있음) */
  bm?: Maybe<Bm>;
  /** 대분류명 */
  category: Scalars['String'];
  categoryType: CategoryType;
  categoryUid: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  discountRate?: Maybe<Scalars['Int']>;
  discountRateText?: Maybe<Scalars['String']>;
  /** 무료회차수 */
  freeSlideCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isAllFree: Scalars['Boolean'];
  /** 기다무 여부 */
  isWaitfree: Scalars['Boolean'];
  landThumbnail?: Maybe<Scalars['String']>;
  lang: Locale;
  /** 최근 업데이트 일시 */
  lastSlideAddedDate?: Maybe<Scalars['Date']>;
  /** 연재상태 */
  onIssue?: Maybe<OnIssue>;
  operatorProperty?: Maybe<OperatorProperty>;
  /** 연재 요일정보 */
  pubPeriod?: Maybe<Scalars['String']>;
  /** 판매 타입 구분 */
  saleMethod?: Maybe<SaleMethod>;
  /** 판매중 / 판매중지 여부 */
  saleState?: Maybe<SaleState>;
  seriesId: Scalars['Long'];
  serviceProperty?: Maybe<ServiceProperty>;
  startSaleDt?: Maybe<Scalars['Date']>;
  state: SlideState;
  /** 중분류명 */
  subcategory: Scalars['String'];
  subcategoryUid?: Maybe<Scalars['Int']>;
  thumbnail: Scalars['String'];
  title: Scalars['String'];
  translateProperty?: Maybe<TranslateProperty>;
  /** 기다무 열람 불가 회차 수 (최신 회차 기준) */
  waitfreeBlockCount?: Maybe<Scalars['Int']>;
  /** 기다무 충전 완료 대기시간 (분) */
  waitfreePeriodByMinute?: Maybe<Scalars['Int']>;
};

export type SeriesBasedRecommendSection = Section & {
  __typename?: 'SeriesBasedRecommendSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type SeriesCardViewLandingList = {
  __typename?: 'SeriesCardViewLandingList';
  category?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEnd: Scalars['Boolean'];
  list: Array<CardViewItem>;
  page: Scalars['Int'];
  selectedThemeKeywordOpt?: Maybe<SortOption>;
  themeKeywordOptList?: Maybe<Array<SortOption>>;
  title?: Maybe<Scalars['String']>;
  topImage?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
  type: Scalars['String'];
};

export type SeriesListViewLandingList = {
  __typename?: 'SeriesListViewLandingList';
  category?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEnd: Scalars['Boolean'];
  list: Array<NormalListViewItem>;
  page: Scalars['Int'];
  selectedThemeKeywordOpt?: Maybe<SortOption>;
  themeKeywordOptList?: Maybe<Array<SortOption>>;
  title?: Maybe<Scalars['String']>;
  topImage?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
  type: Scalars['String'];
};

export type SeriesNotice = {
  __typename?: 'SeriesNotice';
  /** 공지사항 생성 날짜 */
  createDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** 공지사항 노출 여부 */
  isExposure?: Maybe<Scalars['Boolean']>;
  /** 시스템 공지사항 여부 */
  isSystemNotice?: Maybe<Scalars['Boolean']>;
  /** 공지사항 수정 날짜 */
  modifyDate?: Maybe<Scalars['String']>;
  noticeType: SeriesNoticeType;
  /** 작가 Id */
  publisherUid?: Maybe<Scalars['Int']>;
  seriesId: Scalars['Long'];
  seriesTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** 공지사항 Id */
  uid: Scalars['Int'];
};

export type SeriesNoticeListContainer = {
  __typename?: 'SeriesNoticeListContainer';
  currentPage: Scalars['Int'];
  id: Scalars['ID'];
  isEnd: Scalars['Boolean'];
  noticeList: Array<SeriesNotice>;
  totalCount: Scalars['Int'];
};

export enum SeriesNoticeType {
  /** 작가의 말(S) */
  AuthorSay = 'AuthorSay',
  /** 화질제약(D) */
  Down = 'Down',
  /** 이벤트(E) */
  Event = 'Event',
  /** 안내(N) */
  Notice = 'Notice',
  /** 휴재(R) */
  Rest = 'Rest',
  Unknown = 'Unknown'
}

export type SeriesPosterViewLandingList = {
  __typename?: 'SeriesPosterViewLandingList';
  category?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEnd: Scalars['Boolean'];
  list: Array<PosterViewItem>;
  page: Scalars['Int'];
  selectedThemeKeywordOpt?: Maybe<SortOption>;
  themeKeywordOptList?: Maybe<Array<SortOption>>;
  title?: Maybe<Scalars['String']>;
  topImage?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
  type: Scalars['String'];
};

export type SeriesPreview = {
  __typename?: 'SeriesPreview';
  author?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  landThumbnail?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** ServicePropertyDto 에 대응됨 */
export type ServiceProperty = {
  __typename?: 'ServiceProperty';
  /** * 댓글 수 */
  commentCount?: Maybe<Scalars['Int']>;
  /** * 알림 ON */
  isAlarmOn?: Maybe<Scalars['Boolean']>;
  /** * 좋아요 ON */
  isLikeOn?: Maybe<Scalars['Boolean']>;
  /** * 마지막 열람 정보(열람 위치, 열람 일시) */
  lastViewInfo?: Maybe<LastViewInfo>;
  /** * 이어 보기 */
  pageContinue?: Maybe<ContinueInfo>;
  preview?: Maybe<Preview>;
  /** * 대여 소장 정보(대여/소장 여부, 대여 만료 일시) */
  purchaseInfo?: Maybe<PurchaseInfo>;
  /** * 구매 일시 */
  purchasedDate?: Maybe<Scalars['String']>;
  /** * 별점 수 */
  ratingCount?: Maybe<Scalars['Int']>;
  /** * 별점 합계 */
  ratingSum?: Maybe<Scalars['Int']>;
  /** * 열람 수 (UV) */
  readCount?: Maybe<Scalars['Int']>;
  /** * 보유 이용권 수 */
  ticketCount?: Maybe<Scalars['Int']>;
  /** 회차 가격 정보 */
  ticketInfo?: Maybe<SingleTicketInfo>;
  /** * 오늘의 선물 */
  todayGift?: Maybe<TodayGift>;
  /** * 열람 수 (PV) */
  viewCount?: Maybe<Scalars['Int']>;
  waitfreeTicket?: Maybe<WaitfreeTicket>;
};

/** ItemSetDTO에 대응됨 */
export type Set = {
  __typename?: 'Set';
  ageGrade?: Maybe<AgeGrade>;
  allVolumes?: Maybe<Scalars['Boolean']>;
  assetProperty?: Maybe<AssetProperty>;
  authors?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  categoryUid?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  discountPrice?: Maybe<Scalars['Int']>;
  discountRate?: Maybe<Scalars['Int']>;
  discountRateText?: Maybe<Scalars['String']>;
  endSaleDt?: Maybe<Scalars['Date']>;
  operatorProperty?: Maybe<OperatorProperty>;
  price?: Maybe<Scalars['Int']>;
  productCount?: Maybe<Scalars['Int']>;
  rentalPeriodByMinute?: Maybe<Scalars['Int']>;
  seriesId?: Maybe<Scalars['Long']>;
  serviceProperty?: Maybe<ServiceProperty>;
  setId?: Maybe<Scalars['Long']>;
  startSaleDt?: Maybe<Scalars['Date']>;
  subcategory?: Maybe<Scalars['String']>;
  subcategoryUid?: Maybe<Scalars['Int']>;
  thumbnail?: Maybe<Scalars['String']>;
  ticketKind?: Maybe<TicketKind>;
  ticketType?: Maybe<TicketType>;
  title?: Maybe<Scalars['String']>;
};

export type SetAgreementInput = {
  agreementFormList: Array<AgreementForm>;
};

export type SetAgreementPayload = {
  __typename?: 'SetAgreementPayload';
  agreementList: Array<AgreedAgreement>;
  status: ResultStatus;
};

export type SetGlobalAgreementInput = {
  authToken?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  settings: Array<AgreementForm>;
  /** SNS 로그인시 사용하는 값입니다. google 로그인의 경우 userId는 없기 때문에 optional입니다. */
  userId?: Maybe<Scalars['String']>;
};

export type SetGlobalAgreementPayload = {
  __typename?: 'SetGlobalAgreementPayload';
  agreementList: Array<AgreedAgreement>;
};

export type SetListViewLandingList = {
  __typename?: 'SetListViewLandingList';
  id: Scalars['ID'];
  isEnd: Scalars['Boolean'];
  list: Array<NormalListViewItem>;
  page: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  topImage?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
  type: Scalars['String'];
};

export type SetMyRatingInput = {
  productId: Scalars['Long'];
  rating: Scalars['Float'];
  seriesId: Scalars['Long'];
};

export type SetMyRatingPayload = {
  __typename?: 'SetMyRatingPayload';
  status: ResultStatus;
};

export type SetPosterViewLandingList = {
  __typename?: 'SetPosterViewLandingList';
  id: Scalars['ID'];
  isEnd: Scalars['Boolean'];
  list: Array<PosterViewItem>;
  page: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
  topImage?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
  type: Scalars['String'];
};

/** SetProductDto에 대응됨 */
export type SetProduct = {
  __typename?: 'SetProduct';
  productId?: Maybe<Scalars['String']>;
  purchaseInfo?: Maybe<PurchaseInfo>;
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type SetReadyToUseTicket = {
  __typename?: 'SetReadyToUseTicket';
  my?: Maybe<SetTicketMy>;
  /** 구매 가능한 이용권 정보(시스템에서 오픈해놓은 이용권) */
  purchase?: Maybe<TicketPurchase>;
};

export type SetSeriesAlarmInput = {
  isAlarmOn: Scalars['Boolean'];
  seriesId: Scalars['Long'];
};

export type SetSeriesAlarmPayload = {
  __typename?: 'SetSeriesAlarmPayload';
  record?: Maybe<Scalars['Boolean']>;
  recordId?: Maybe<Scalars['ID']>;
  status: ResultStatus;
};

export type SetSeriesLikeInput = {
  isLike: Scalars['Boolean'];
  seriesId: Scalars['Long'];
};

export type SetSeriesLikePayload = {
  __typename?: 'SetSeriesLikePayload';
  record?: Maybe<Scalars['Boolean']>;
  recordId?: Maybe<Scalars['ID']>;
  status: ResultStatus;
};

export type SetTicketMy = {
  __typename?: 'SetTicketMy';
  cashAmount?: Maybe<Scalars['Int']>;
  /** 세트 내 소장 회차 포함 여부 */
  hasOwnProduct?: Maybe<Scalars['Boolean']>;
  /** 세트 내 대여 회차 포함 여부 */
  hasRentalProduct?: Maybe<Scalars['Boolean']>;
};

export type SetTvPointAgreementPayload = {
  __typename?: 'SetTvPointAgreementPayload';
  status: ResultStatus;
};

export type ShortVodPreviewViewerInfo = {
  __typename?: 'ShortVodPreviewViewerInfo';
  item: Single;
  seriesItem: Series;
  viewerData?: Maybe<VodViewerData>;
};

export enum ShortcutHomeType {
  /** 책 */
  Book = 'Book',
  /** 취향 */
  Taste = 'Taste',
  /** 웹소설 */
  WebNovel = 'WebNovel',
  /** 웹툰 */
  Webtoon = 'Webtoon'
}

export type ShortcutItem = {
  __typename?: 'ShortcutItem';
  icon?: Maybe<Scalars['String']>;
  scheme: Scalars['String'];
  title: Scalars['String'];
};

export type ShortcutItemList = {
  __typename?: 'ShortcutItemList';
  list: Array<ShortcutItem>;
  title: Scalars['String'];
  totalCount?: Maybe<Scalars['Int']>;
};

export type ShortcutList = {
  __typename?: 'ShortcutList';
  menuList?: Maybe<Array<Maybe<ShortcutMenuItem>>>;
  promotionBanner?: Maybe<PromotionBannerItem>;
  shortcutList?: Maybe<Array<Maybe<ShortcutItemList>>>;
};

export type ShortcutMenuItem = {
  __typename?: 'ShortcutMenuItem';
  shortcutHomeType?: Maybe<ShortcutHomeType>;
  shortcutHomeUrl?: Maybe<Scalars['String']>;
};

/**
 * 간단하게 이미지로만 표현되는 배너
 * 주로 이용권 구매창 등에서의 tvpoint, cashfriends 배너 같은 곳에 쓰임
 * 니콜라스 BannerDto 에 대응
 */
export type SimpleImageBanner = {
  __typename?: 'SimpleImageBanner';
  bgColor?: Maybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  scheme: Scalars['String'];
  shouldOpenNewWindow: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
  uid: Scalars['Long'];
};

export type SimpleSeriesSingleInfo = {
  __typename?: 'SimpleSeriesSingleInfo';
  seriesAgeGrade?: Maybe<AgeGrade>;
  seriesSaleState?: Maybe<SaleState>;
  singleAgeGrade?: Maybe<AgeGrade>;
  singleIsFree?: Maybe<Scalars['Boolean']>;
  singleIsTextViewer?: Maybe<Scalars['Boolean']>;
  singleSaleState?: Maybe<SaleState>;
  singleSlideType?: Maybe<SlideType>;
};

export type SimpleSet = {
  __typename?: 'SimpleSet';
  discountRate: Scalars['Int'];
  isMultiple: Scalars['Boolean'];
  setId: Scalars['Long'];
};

/** ItemSingleDTO 에 대응됨 */
export type Single = {
  __typename?: 'Single';
  ageGrade: AgeGrade;
  assetProperty?: Maybe<AssetProperty>;
  badge?: Maybe<BadgeType>;
  discountRate?: Maybe<Scalars['Int']>;
  discountRateText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFree: Scalars['Boolean'];
  /** 비축분 */
  isHidden?: Maybe<Scalars['Boolean']>;
  isShortsDrama?: Maybe<Scalars['Boolean']>;
  /** 기다무(+) 열람 불가 */
  isWaitfreeBlocked?: Maybe<Scalars['Boolean']>;
  /** 업데이트 일시 */
  lastReleasedDate?: Maybe<Scalars['Date']>;
  operatorProperty?: Maybe<OperatorProperty>;
  /** 페이지 수 */
  pageCount?: Maybe<Scalars['Int']>;
  productId: Scalars['Long'];
  /** 비축분 -> 무료 전환 일시 텍스트 */
  remainText?: Maybe<Scalars['String']>;
  /** 판매중 / 판매중지 여부 */
  saleState?: Maybe<SaleState>;
  series?: Maybe<Series>;
  seriesId?: Maybe<Scalars['Long']>;
  serviceProperty?: Maybe<ServiceProperty>;
  /** 회차 용량(소수점 표현) */
  size?: Maybe<Scalars['Long']>;
  slideType: SlideType;
  /** 회차 상태 */
  state?: Maybe<SlideState>;
  thumbnail: Scalars['String'];
  title: Scalars['String'];
};

export enum SingleBadgeType {
  Badge15Static = 'Badge15Static',
  Badge19SelfStatic = 'Badge19SelfStatic',
  Badge19Static = 'Badge19Static',
  BadgeTimeStatic = 'BadgeTimeStatic',
  BadgeUpStatic = 'BadgeUpStatic',
  LabelBadgeFree = 'LabelBadgeFree',
  LabelBadgeOwn = 'LabelBadgeOwn',
  LabelBadgeRent = 'LabelBadgeRent'
}

export type SingleEdge = {
  __typename?: 'SingleEdge';
  /** 커서 키에 사용됨 */
  cursor: Scalars['String'];
  node: SingleListViewItem;
};

export type SingleListConnection = {
  __typename?: 'SingleListConnection';
  edges: Array<SingleEdge>;
  pageInfo: PageInfo;
  selectedSortOption: SortOption;
  sortOptionList: Array<SortOption>;
  totalCount: Scalars['Int'];
};

/** 회차 리스트뷰 아이템. 주로 콘텐츠홈의 회차 영역에 쓰임 */
export type SingleListViewItem = Item & {
  __typename?: 'SingleListViewItem';
  discountRate?: Maybe<Scalars['Int']>;
  discountRateText?: Maybe<Scalars['String']>;
  eventLog?: Maybe<EventLog>;
  id: Scalars['ID'];
  /** 좌측 체크모드 여부. 선택구매 등 체크 활성화시 on. 기본 false */
  isCheckMode: Scalars['Boolean'];
  /** 체크모드 on 일 때만 활용됨. 기본 false */
  isChecked: Scalars['Boolean'];
  /** 열람여부 */
  isViewed?: Maybe<Scalars['Boolean']>;
  /** 1열. 타이틀영역 / 2줄 대응 */
  row1?: Maybe<Scalars['String']>;
  /** 2열. 레이블 리스트. 일반적으로 카테고리 | 장르 | 작가 표현 시 사용 */
  row2?: Maybe<Array<Scalars['String']>>;
  /** 3열. 추가 레이블 영역. 기다무 열람 불가 등 표시 */
  row3?: Maybe<SingleListViewItemRow3>;
  /** 클릭 시 이동 스킴 */
  scheme?: Maybe<Scalars['String']>;
  /** 동영상뷰어, 숏영상뷰어는 재생 아이콘 노출. */
  showPlayerIcon: Scalars['Boolean'];
  /** 메타 관련 */
  single: Single;
  /**
   * 일반리스트 좌측 썸네일.
   * 기본적으로 세로 썸네일(1:1.43 -> 2:3). 일부 동영상뷰어의 경우 가로 썸네일
   */
  thumbnail: Scalars['String'];
  type: ItemType;
};

export type SingleListViewItemRow3 = {
  __typename?: 'SingleListViewItemRow3';
  /**
   * 메타 왼쪽에 표현되는 작품 뱃지 리스트
   * lock, statusBadge(업데이트 뱃지), 무료
   */
  badgeList?: Maybe<Array<SingleBadgeType>>;
  /** 세트 상품 가격 표시 영역 */
  priceList?: Maybe<Array<Scalars['String']>>;
  /** 아이템 메타 정보. 일반적으로 구독자수, 업데이트 날짜, 무료 여부 등 표현 */
  text: Scalars['String'];
};

export type SingleListViewLandingList = {
  __typename?: 'SingleListViewLandingList';
  id: Scalars['ID'];
  isEnd: Scalars['Boolean'];
  list: Array<NormalListViewItem>;
  page: Scalars['Int'];
  selectedThemeKeywordOpt?: Maybe<SortOption>;
  themeKeywordOptList?: Maybe<Array<SortOption>>;
  title?: Maybe<Scalars['String']>;
  topImage?: Maybe<Scalars['String']>;
  totalCount: Scalars['Int'];
  type: ContentsType;
};

export type SinglePreview = {
  __typename?: 'SinglePreview';
  author: Scalars['String'];
  categoryUid: Scalars['Int'];
  isFree?: Maybe<Scalars['Boolean']>;
  landThumbnail?: Maybe<Scalars['String']>;
  productId: Scalars['Long'];
  readAccessType?: Maybe<ReadAccessType>;
  saleState?: Maybe<SaleState>;
  seriesId: Scalars['Long'];
  seriesLang: Locale;
  seriesPreview?: Maybe<SeriesPreview>;
  slideType: SlideType;
  thumbnail: Scalars['String'];
  title: Scalars['String'];
};

/**
 * TicketInfoDto에 대응됨.
 * 기존 TicketInfo 타입과 구분하기 위해 SingleTicketInfo로 네이밍
 */
export type SingleTicketInfo = {
  __typename?: 'SingleTicketInfo';
  discountPrice?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  ticketType?: Maybe<TicketType>;
};

/**
 * ST61, ST62, ST64 만 콘텐츠홈에 접근할 수 있습니다.
 * 나머지는 API 에서 에러를 전달합니다
 * 참고 : https://kakaopagecorp.slack.com/archives/C040YR56D/p1653627296733579?thread_ts=1653485802.168879&cid=C040YR56D
 * SlideStateVo 에 대응됨
 */
export enum SlideState {
  None = 'None',
  /** ST21 : 제작중 */
  St21 = 'ST21',
  /** ST22 : 제작완료 */
  St22 = 'ST22',
  /** ST23 : 발행됨 */
  St23 = 'ST23',
  /** ST30 : 미발행 */
  St30 = 'ST30',
  /** ST40 : 심사신청 */
  St40 = 'ST40',
  /** ST41 : 임시승인 */
  St41 = 'ST41',
  /** ST45 : 심사할당 */
  St45 = 'ST45',
  /** ST50 : 심사중 */
  St50 = 'ST50',
  /** ST51 : 승인완료 */
  St51 = 'ST51',
  /** ST52 : 승인반려 */
  St52 = 'ST52',
  /** ST53 : 후심사중 */
  St53 = 'ST53',
  /** ST54 : 심사보류 */
  St54 = 'ST54',
  /** ST61 : 판매중 */
  St61 = 'ST61',
  /** ST62 : 판매중지 (발행자가 직접 중지) */
  St62 = 'ST62',
  /** ST63 : 판매예약 */
  St63 = 'ST63',
  /** ST64 : 판매금지 (운영자가 판매 금지 시킨 경우, 발행자는 금지 풀릴 때까지 판매할) */
  St64 = 'ST64',
  /** ST99 : 알수없음 */
  St99 = 'ST99'
}

export enum SlideType {
  /** SD04 */
  AudioBook = 'AudioBook',
  /** SD03 */
  Comic = 'Comic',
  /** SD02 */
  Epub = 'EPUB',
  None = 'None',
  /** SD01 */
  Slide = 'Slide',
  /** SD08 */
  TalkHumor = 'TalkHumor',
  /** SD07 */
  TalkNovel = 'TalkNovel',
  /** SD06 */
  Vod = 'VOD',
  /** SD05 */
  VideoOnly = 'VideoOnly'
}

/** 랜딩 등에서 옵션 선택 시 사용됩니다 */
export type SortOption = {
  __typename?: 'SortOption';
  id: Scalars['ID'];
  name: Scalars['String'];
  param: Scalars['String'];
};

export type StandaloneBannerAndSubCardGroup = Group & {
  __typename?: 'StandaloneBannerAndSubCardGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export type StandaloneBannerGroup = Group & {
  __typename?: 'StandaloneBannerGroup';
  bannerViewType: BannerViewType;
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export type StaticLandingDayOfWeekParamInput = {
  bmType?: Maybe<DayOfWeekBmType>;
  categoryUid: Scalars['Int'];
  dayTabUid?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  screenUid?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  subcategoryUid?: Maybe<Scalars['String']>;
  type?: Maybe<LayoutType>;
};

export type StaticLandingDayOfWeekSection = Section & {
  __typename?: 'StaticLandingDayOfWeekSection';
  businessModelList: Array<SortOption>;
  dayTabList: Array<SortOption>;
  groups: Array<Group>;
  id: Scalars['ID'];
  isEnd?: Maybe<Scalars['Boolean']>;
  /** 응답을 표현하는 param 입니다. 현재 요청이 어떤 카테고리, 서브카테고리, BM, 탭, page 인지에 대해 나타내는 필드입니다 */
  param: StaticLandingDayOfWeekSectionParam;
  promotionBanner?: Maybe<PromotionBannerItem>;
  subcategoryList: Array<SortOption>;
  title?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type StaticLandingDayOfWeekSectionParam = {
  __typename?: 'StaticLandingDayOfWeekSectionParam';
  businessModel?: Maybe<SortOption>;
  categoryUid: Scalars['Int'];
  dayTab?: Maybe<SortOption>;
  page?: Maybe<Scalars['Int']>;
  screenUid?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  subcategory?: Maybe<SortOption>;
};

export type StaticLandingEventParamInput = {
  categoryUid: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};

export type StaticLandingEventSection = Section & {
  __typename?: 'StaticLandingEventSection';
  categoryTabList: Array<SortOption>;
  groups: Array<Group>;
  id: Scalars['ID'];
  isEnd?: Maybe<Scalars['Boolean']>;
  /** 응답을 표현하는 param 입니다. 현재 요청이 어떤 카테고리, 몇 페이지인지 대해 나타내는 필드입니다 */
  param: StaticLandingEventSectionParam;
  title?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type StaticLandingEventSectionParam = {
  __typename?: 'StaticLandingEventSectionParam';
  categoryUid: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};

export type StaticLandingFreeSeriesParamInput = {
  categoryUid: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
  screenUid?: Maybe<Scalars['Int']>;
  tabUid?: Maybe<Scalars['String']>;
  type?: Maybe<LayoutType>;
};

export type StaticLandingFreeSeriesSection = Section & {
  __typename?: 'StaticLandingFreeSeriesSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  isEnd?: Maybe<Scalars['Boolean']>;
  /** 응답을 표현하는 param 입니다. 현재 요청이 어떤 카테고리, 탭 옵션인지에 대해 나타내는 필드입니다 */
  param: StaticLandingFreeSeriesSectionParam;
  promotionBanner?: Maybe<PromotionBannerItem>;
  tabList: Array<SortOption>;
  title?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type StaticLandingFreeSeriesSectionParam = {
  __typename?: 'StaticLandingFreeSeriesSectionParam';
  categoryUid: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
  screenUid?: Maybe<Scalars['Int']>;
  tab?: Maybe<SortOption>;
};

export type StaticLandingGenreParamInput = {
  categoryUid: Scalars['Int'];
  isComplete?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  screenUid?: Maybe<Scalars['Int']>;
  sortType?: Maybe<Scalars['String']>;
  subcategoryUid?: Maybe<Scalars['String']>;
  type?: Maybe<LayoutType>;
};

export type StaticLandingGenreSection = Section & {
  __typename?: 'StaticLandingGenreSection';
  displayAd?: Maybe<DisplayAd>;
  groups: Array<Group>;
  id: Scalars['ID'];
  isEnd?: Maybe<Scalars['Boolean']>;
  /** 응답을 표현하는 param 입니다. 현재 요청이 어떤 카테고리, 서브카테고리 인지에 대해 나타내는 필드입니다 */
  param: StaticLandingGenreSectionParam;
  promotionBanner?: Maybe<PromotionBannerItem>;
  sortTypeList: Array<SortOption>;
  subcategoryList: Array<SortOption>;
  title?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type StaticLandingGenreSectionParam = {
  __typename?: 'StaticLandingGenreSectionParam';
  categoryUid: Scalars['Int'];
  isComplete?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  screenUid?: Maybe<Scalars['Int']>;
  sortType?: Maybe<SortOption>;
  subcategory?: Maybe<SortOption>;
};

export type StaticLandingOriginalParamInput = {
  categoryUid: Scalars['Int'];
  isComplete?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  screenUid?: Maybe<Scalars['Int']>;
  sortType?: Maybe<Scalars['String']>;
  subcategoryUid?: Maybe<Scalars['String']>;
};

export type StaticLandingOriginalSection = Section & {
  __typename?: 'StaticLandingOriginalSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  isEnd?: Maybe<Scalars['Boolean']>;
  originalCount?: Maybe<Scalars['Int']>;
  /** 응답을 표현하는 param 입니다. 현재 요청이 어떤 카테고리, 서브카테고리, 정렬 옵션, 완결작 보기 여부인지에 대해 나타내는 필드입니다 */
  param: StaticLandingOriginalSectionParam;
  recommendItemList?: Maybe<Array<CardViewItem>>;
  sortTypeList: Array<SortOption>;
  subcategoryList: Array<SortOption>;
  title?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type StaticLandingOriginalSectionParam = {
  __typename?: 'StaticLandingOriginalSectionParam';
  categoryUid: Scalars['Int'];
  isComplete?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['Int']>;
  screenUid?: Maybe<Scalars['Int']>;
  sortType?: Maybe<SortOption>;
  subcategory?: Maybe<SortOption>;
};

export type StaticLandingRankingParamInput = {
  categoryUid: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
  rankingType?: Maybe<Scalars['String']>;
  screenUid?: Maybe<Scalars['Int']>;
  subcategoryUid?: Maybe<Scalars['String']>;
  type?: Maybe<LayoutType>;
};

export type StaticLandingRankingSection = Section & {
  __typename?: 'StaticLandingRankingSection';
  categoryTabList: Array<SortOption>;
  displayAd?: Maybe<DisplayAd>;
  groups: Array<Group>;
  id: Scalars['ID'];
  isEnd?: Maybe<Scalars['Boolean']>;
  /** 응답을 표현하는 param 입니다. 현재 요청이 어떤 카테고리, 서브카테고리 인지에 대해 나타내는 필드입니다 */
  param: StaticLandingRankingSectionParam;
  promotionBanner?: Maybe<PromotionBannerItem>;
  rankingTime?: Maybe<Scalars['String']>;
  rankingTypeList: Array<SortOption>;
  subcategoryList: Array<SortOption>;
  title?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
  viewType: Scalars['String'];
  withOperationArea?: Maybe<Scalars['Boolean']>;
};

export type StaticLandingRankingSectionParam = {
  __typename?: 'StaticLandingRankingSectionParam';
  categoryUid: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
  rankingType?: Maybe<SortOption>;
  screenUid?: Maybe<Scalars['Int']>;
  subcategory?: Maybe<SortOption>;
};

export type StaticLandingTodayNewParamInput = {
  categoryUid: Scalars['Int'];
  screenUid?: Maybe<Scalars['Int']>;
  subcategoryUid?: Maybe<Scalars['String']>;
  type?: Maybe<LayoutType>;
};

export type StaticLandingTodayNewSection = Section & {
  __typename?: 'StaticLandingTodayNewSection';
  categoryTabList: Array<SortOption>;
  groups: Array<Group>;
  id: Scalars['ID'];
  /** 응답을 표현하는 param 입니다. 현재 요청이 어떤 카테고리, 서브카테고리 인지에 대해 나타내는 필드입니다 */
  param: StaticLandingTodayNewSectionParam;
  promotionBanner?: Maybe<PromotionBannerItem>;
  subcategoryList: Array<SortOption>;
  title?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
  viewType: Scalars['String'];
};

export type StaticLandingTodayNewSectionParam = {
  __typename?: 'StaticLandingTodayNewSectionParam';
  categoryUid: Scalars['Int'];
  screenUid?: Maybe<Scalars['Int']>;
  subcategory?: Maybe<SortOption>;
};

export type StaticLandingTodayUpParamInput = {
  categoryUid: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
  subcategoryUid?: Maybe<Scalars['String']>;
};

export type StaticLandingTodayUpSection = Section & {
  __typename?: 'StaticLandingTodayUpSection';
  categoryTabList: Array<SortOption>;
  groups: Array<Group>;
  id: Scalars['ID'];
  isEnd?: Maybe<Scalars['Boolean']>;
  /** 응답을 표현하는 param 입니다. 현재 요청이 어떤 카테고리, 서브카테고리 인지에 대해 나타내는 필드입니다. */
  param: StaticLandingTodayUpSectionParam;
  subcategoryList: Array<SortOption>;
  title?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type StaticLandingTodayUpSectionParam = {
  __typename?: 'StaticLandingTodayUpSectionParam';
  categoryUid: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
  subcategory?: Maybe<SortOption>;
};

/**
 * 고정랜딩리스트
 * StaticLandingTypeVo 에 대응
 */
export enum StaticLandingType {
  /** 요일연재 */
  DayOfWeek = 'DayOfWeek',
  /** 이벤트 */
  Event = 'Event',
  /** 무료시리즈 */
  FreeSeries = 'FreeSeries',
  /** 장르전체 */
  Genre = 'Genre',
  /** 오리지널 */
  Original = 'Original',
  /** 랭킹 */
  Ranking = 'Ranking',
  /** 오늘 신작 */
  TodayNew = 'TodayNew',
  /** 오늘 UP */
  TodayUp = 'TodayUp',
  /** 오늘 UP 내가 보던 작품 */
  TodayUpInven = 'TodayUpInven'
}

export type StrategyCategoryGroup = Group & {
  __typename?: 'StrategyCategoryGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export type StrategyCategorySection = Section & {
  __typename?: 'StrategyCategorySection';
  groups: Array<Group>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type StrategyViewItem = Item & {
  __typename?: 'StrategyViewItem';
  count?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  scheme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: ItemType;
};

export type SubCardGroup = Group & {
  __typename?: 'SubCardGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export type SubtabMenu = Menu & {
  __typename?: 'SubtabMenu';
  id: Scalars['ID'];
  screenList: Array<Screen>;
  title: Scalars['String'];
  type: MenuType;
  uid: Scalars['Int'];
};

export type TabSection = {
  /** 요일연재, 메인랭킹 처럼 섹션에 탭이 존재하는 경우 이 값으로 표현 */
  sectionMainTabList?: Maybe<Array<SectionMainTab>>;
};

export type TalkDownloadData = {
  __typename?: 'TalkDownloadData';
  dec?: Maybe<Scalars['String']>;
  host: Scalars['String'];
  path: Scalars['String'];
  talkViewerType?: Maybe<TalkViewerType>;
};

export type TalkViewerData = ViewerData & {
  __typename?: 'TalkViewerData';
  talkDownloadData: TalkDownloadData;
  type: ViewerDataType;
};

export enum TalkViewerType {
  Tap = 'Tap',
  TapScroll = 'TapScroll'
}

export type TastesServiceLang = {
  __typename?: 'TastesServiceLang';
  selectableServiceLang: Array<TastesServiceLangItem>;
  userServiceLang?: Maybe<Scalars['String']>;
};

export type TastesServiceLangItem = {
  __typename?: 'TastesServiceLangItem';
  code: Scalars['String'];
  title: Scalars['String'];
};

export type TextViewerContentData = {
  __typename?: 'TextViewerContentData';
  chapterId: Scalars['Long'];
  contentId: Scalars['Long'];
  secureUrl: Scalars['String'];
};

export type TextViewerData = ViewerData & {
  __typename?: 'TextViewerData';
  atsServerUrl?: Maybe<Scalars['String']>;
  contentsList: Array<TextViewerContentData>;
  metaSecureUrl?: Maybe<Scalars['String']>;
  type: ViewerDataType;
};

/** 테마 키워드 */
export type ThemeKeyword = {
  __typename?: 'ThemeKeyword';
  scheme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uid: Scalars['Int'];
};

export type ThemeKeywordSection = {
  /** 테마섹션 처럼 섹션에 키워드 리스트가 존재하는 경우 이 값으로 표현 */
  themeKeywordList?: Maybe<Array<ThemeKeyword>>;
};

export type ThemeSection = MetaInfoTypeSection & SchemeSection & Section & ThemeKeywordSection & {
  __typename?: 'ThemeSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  metaInfoType?: Maybe<MetaInfoType>;
  scheme?: Maybe<Scalars['String']>;
  themeKeywordList?: Maybe<Array<ThemeKeyword>>;
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type TicketAvailable = {
  __typename?: 'TicketAvailable';
  ticketOwnType?: Maybe<TicketType>;
  ticketRentalType?: Maybe<TicketType>;
};

export type TicketBuyAndUseMutationInput = {
  productId: Scalars['Long'];
  ticketId: Scalars['String'];
};

export type TicketBuyAndUseMutationPayload = {
  __typename?: 'TicketBuyAndUseMutationPayload';
  buyTicketinfo?: Maybe<Scalars['Int']>;
  remainCash?: Maybe<Scalars['Int']>;
  ticketUid?: Maybe<Scalars['BigInt']>;
};

export type TicketBuyItem = {
  quantity: Scalars['Int'];
  ticketId: Scalars['String'];
};

export type TicketBuyMutationInput = {
  seriesId: Scalars['Long'];
  ticketKind: TicketKind;
  ticketList: Array<TicketBuyItem>;
};

export type TicketBuyMutationPayload = {
  __typename?: 'TicketBuyMutationPayload';
  purchasedTicketCount: Scalars['Int'];
  remainCash: Scalars['Int'];
};

export type TicketDetail = {
  __typename?: 'TicketDetail';
  dateCompare?: Maybe<Scalars['Int']>;
  isVod?: Maybe<Scalars['Boolean']>;
  productType?: Maybe<Scalars['String']>;
  refundTicketInfo?: Maybe<RefundableTicketInfo>;
  refundableCash?: Maybe<Scalars['Int']>;
  refundableTicketNum?: Maybe<Scalars['Int']>;
  salesTicket?: Maybe<SalesTicketItem>;
  ticketUid?: Maybe<Scalars['String']>;
  vodDiscountPrice?: Maybe<Scalars['Int']>;
};

export type TicketFreeMutationInput = {
  seriesId?: Maybe<Scalars['Long']>;
  ticketUid: Scalars['Long'];
  type: FreeTicketType;
};

/** TicketHistoryBuyExtraSimpleVo에 대응됨 */
export type TicketHistoryBuyExtraSimple = {
  __typename?: 'TicketHistoryBuyExtraSimple';
  productId?: Maybe<Scalars['Long']>;
  status?: Maybe<TicketStatus>;
  title?: Maybe<Scalars['String']>;
};

export type TicketInSeries = {
  __typename?: 'TicketInSeries';
  isEnd: Scalars['Boolean'];
  refundInfo?: Maybe<Array<TicketItemInSeries>>;
  seriesTitle: Scalars['String'];
};

/**
 * 이용권 정보
 * NEXT 에서 심플하게 보여지는 TicketInfo 임
 * TicketInfoVo 에 매칭됨
 */
export type TicketInfo = {
  __typename?: 'TicketInfo';
  discountPrice?: Maybe<Scalars['Int']>;
  discountRate?: Maybe<Scalars['Int']>;
  price: Scalars['Int'];
  rentalPeriodByMinute?: Maybe<Scalars['Int']>;
  ticketId: Scalars['String'];
  ticketKind: TicketKind;
  ticketType: TicketType;
};

/**
 * 이용권 정보
 * TicketInfoApiVo 에 매칭됨
 */
export type TicketInfoApi = {
  __typename?: 'TicketInfoApi';
  /** 할인율. (price / paid_num) * (total_num - paid_num) */
  discount: Scalars['Int'];
  /** 무비데이 여부 */
  isMovieDay?: Maybe<Scalars['Boolean']>;
  /** 티켓 하나당 가격 (프로모션 적용안됨) - NEXT 기준으론 price 와 동일 */
  originPrice: Scalars['Int'];
  /**
   * 원본키 : pkg_num
   * 노출 순서
   */
  packageOrder?: Maybe<Scalars['Int']>;
  /**
   * 원본키 : paid_num
   * 실제 구매시 유저가 지불할 티켓 수량
   */
  paidTicketCount: Scalars['Int'];
  /** 티켓 하나당 가격 (프로모션 적용된) */
  price: Scalars['Int'];
  /** VOD 대여 만료 기간 */
  rentExpireDurationMin?: Maybe<Scalars['Int']>;
  seriesId: Scalars['Long'];
  seriesTitle: Scalars['String'];
  ticketId: Scalars['ID'];
  ticketKind: TicketKind;
  ticketType: TicketType;
  /**
   * 원본키 : total_num
   * 지급되는 이용권 전체 수
   */
  totalTicketCount: Scalars['Int'];
  /** VOD 프로모션 고유 ID */
  vodPromotionUid?: Maybe<Scalars['Int']>;
  /** VOD 서비스 고유 ID */
  vodServiceUid?: Maybe<Scalars['Int']>;
};

export type TicketItemInSeries = {
  __typename?: 'TicketItemInSeries';
  createDt: Scalars['Date'];
  initialAmount: Scalars['Int'];
  productType: Scalars['String'];
  remainCount: Scalars['Int'];
  saleType: SaleType;
  ticketKind: TicketKind;
  ticketStatusText?: Maybe<Scalars['String']>;
  ticketType: TicketType;
  uid: Scalars['String'];
};

export enum TicketKind {
  /** 소장(TicketType 이 TT로 시작) */
  Own = 'Own',
  /** 대여(TicketType 이 RT로 시작) */
  Rent = 'Rent',
  /** 알 수 없는 타입 */
  Unknown = 'Unknown'
}

export type TicketMy = {
  __typename?: 'TicketMy';
  cashAmount?: Maybe<Scalars['Int']>;
  /** 보유 소장 이용권 수 (기다무 제외) */
  ticketOwnCount: Scalars['Int'];
  /** 보유 대여 이용권 수 (기다무 제외) */
  ticketRentalCount: Scalars['Int'];
};

export enum TicketProcess {
  /** 열람할 수 있는 회차 */
  AlreadyConfirmed = 'AlreadyConfirmed',
  /** 콘텐츠홈의 경우 소장권만 존재할 경우 '소장권을 사용하시겠습니까?' 확인 팝업 한번 뜨고 확인하면 사용 */
  AskOwnTicketUse = 'AskOwnTicketUse',
  /**
   * 마지막 본 회차를 중간페이지 까지만 본 경우 + 대여만료 시 [보던화 / 다음화] 팝업
   * 이 프로세스 이후엔 반드시 nextProcess 가 존재한다.
   */
  AskProductChoiceCauseExpired = 'AskProductChoiceCauseExpired',
  /**
   * 대여만료 시 다시 대여하시겠습니까? 호출.
   * 이 프로세스 이후엔 반드시 nextProcess 가 존재한다.
   */
  AskReopenCauseExpired = 'AskReopenCauseExpired',
  /** 소장/대여 선택 팝업 */
  AskTicketChoice = 'AskTicketChoice',
  /** 이용권(대여/소장) 모두 보유하지 않은 케이스에선 팝업 미노출 및 이용권 충전창으로 이동 */
  BuyTicket = 'BuyTicket',
  /** 외부(콘텐츠홈, 회차섹션, 보관함)에서 체크할 수 없는 경우 뷰어로 위임합니다. */
  DelegateVerifyToViewerEntry = 'DelegateVerifyToViewerEntry',
  /** 정주행의 경우 대여권/소장권이 없을 경우 티켓 구입 프로세스로 진행되어야한다 */
  ForceBuyTicket = 'ForceBuyTicket',
  /** 뷰어의 경우 소장권만 존재할 경우 바로 해당 티켓 사용 */
  ForceUseOwnTicket = 'ForceUseOwnTicket',
  /** 정주행의 경우 대여권이 있을 경우 바로 대여권 티켓 사용 */
  ForceUseRentalTicket = 'ForceUseRentalTicket',
  /** 뷰어의 경우 소장권만 존재할 경우 팝업을 띄우지 않고 바로 사용함 */
  OwnTicketUsed = 'OwnTicketUsed'
}

export type TicketPurchase = {
  __typename?: 'TicketPurchase';
  set?: Maybe<SimpleSet>;
  ticketOwn?: Maybe<TicketInfo>;
  ticketRental?: Maybe<TicketInfo>;
};

export type TicketSeries = {
  __typename?: 'TicketSeries';
  isWaitfree: Scalars['Boolean'];
  saleMethod?: Maybe<SaleMethod>;
  waitfreeBlockCount: Scalars['Int'];
};

export type TicketSetBuyMutationInput = {
  seriesId: Scalars['Long'];
  setId: Scalars['Long'];
  ticketId: Scalars['String'];
};

export type TicketSetBuyMutationPayload = {
  __typename?: 'TicketSetBuyMutationPayload';
  remainCash?: Maybe<Scalars['Int']>;
};

export type TicketSingle = {
  __typename?: 'TicketSingle';
  /** 뷰어를 나오는 시점(lastPage)가 마지막인지 여부(마지막까지 읽다가 앞장으로 돌아간 뒤 뷰어를 이탈했다면 is_done=false) */
  isDone: Scalars['Boolean'];
  readAccessType: ReadAccessType;
  title: Scalars['String'];
  waitfreeBlock: Scalars['Boolean'];
};

export enum TicketStatus {
  None = 'None',
  Ts01 = 'TS01',
  Ts02 = 'TS02',
  Ts03 = 'TS03'
}

/**
 * 콘텐츠홈 무료이용권 몇장 받았는지 나타낼 때 사용
 * TicketVo 에 매핑
 */
export type TicketSum = {
  __typename?: 'TicketSum';
  count: Scalars['Int'];
  /** 해당 이용권에 설정된 유효기간 */
  ticketExpireAt?: Maybe<Scalars['Date']>;
  ticketKind: TicketKind;
  ticketType: TicketType;
};

export enum TicketType {
  /**
   * type: TT09 \
   * kind: 소장이용권 \
   * 무료여부: 무료 \
   * desc: 리워드 소장 이용권 \
   */
  BuyCampaign = 'BuyCampaign',
  /**
   * type: TT12 \
   * kind: 소장이용권 \
   * 무료여부: 유료 \
   * desc: 캐시 즉납형 할인 단일 소장권 \
   */
  BuyCashDiscountSingle = 'BuyCashDiscountSingle',
  /**
   * type: TT11 \
   * kind: 소장이용권 \
   * 무료여부: 유료 \
   * desc: 캐시 즉납형 단일 소장권 \
   */
  BuyCashSingle = 'BuyCashSingle',
  /**
   * type: TT04 \
   * kind: 소장이용권 \
   * 무료여부: 무료 \
   * desc: 쿠폰 발급 이용권 \
   */
  BuyCoupon = 'BuyCoupon',
  /**
   * type: TT03 \
   * kind: 소장이용권 \
   * 무료여부: 무료 \
   * desc: 이벤트 발급 이용권 \
   * 사용자에게 즉시 지급되지 않음 - 작품홈 진입시 (NEXT 기준)
   */
  BuyEvent = 'BuyEvent',
  /**
   * type: TT07 \
   * kind: 소장이용권 \
   * 무료여부: 무료 \
   * desc: 선물하면 무료 소장 이용권 \
   * 선물무 기능이 종료되어 현재 사용되지 않음
   */
  BuyGiftFree = 'BuyGiftFree',
  /**
   * type: TT08 \
   * kind: 소장이용권 \
   * 무료여부: 유료 \
   * desc: 즉납형 소장 이용권 \
   * 현재 사용되고 있지 않음
   */
  BuyMoviePpv = 'BuyMoviePpv',
  /**
   * type: TT00 \
   * kind: 소장이용권 \
   * 무료여부: 무료 \
   * desc: 신규 고객 혜택
   */
  BuyNewCustomerGift = 'BuyNewCustomerGift',
  /**
   * type: TT02 \
   * kind: 소장이용권 \
   * 무료여부: 유료 \
   * desc: 시리즈 이용권 패키지 \
   */
  BuyPackage = 'BuyPackage',
  /**
   * type: TT13 \
   * kind: 소장이용권 \
   * 무료여부: 유료 \
   * desc: 세트 소장권 패키지 \
   */
  BuySet = 'BuySet',
  /**
   * type: TT01 \
   * kind: 소장이용권 \
   * 무료여부: 유료 \
   * desc: 단일 이용권 \
   */
  BuySingle = 'BuySingle',
  /**
   * type: TT06 \
   * kind: 소장이용권 \
   * 무료여부: 무료 \
   * desc: 오늘의 선물 소장 이용권 \
   */
  BuyTodayGift = 'BuyTodayGift',
  /**
   * type: TT05 \
   * kind: 소장이용권 \
   * 무료여부: 무료 \
   * desc: 기다리면 무료 소장 이용 \
   * 정의만 되어 있고 사용되지 않음
   */
  BuyWaitFree = 'BuyWaitFree',
  /**
   * type: TT10 \
   * kind: 소장이용권 \
   * 무료여부: 무료 \
   * desc: 레전드패스(기다리면 무료 플러스) 소장 이용권 \
   * @deprecated
   */
  BuyWaitFreePlus = 'BuyWaitFreePlus',
  /**
   * type: ET99 \
   * kind: 비활성 \
   * 무료여부: 무료 \
   * desc: 비활성 이용권 \
   * 정의만 되어 있고 사용되지 않음
   */
  Deactivate = 'Deactivate',
  /**
   * type: UT01 \
   * kind: 프리미엄 \
   * 무료여부: 무료 \
   * desc: 프리미엄 이용권 \
   * 스펙 아웃된 이용권으로 환불을 제외한 서비스 로직에서 제거됨
   */
  Premium = 'Premium',
  /**
   * type: RT09 \
   * kind: 대여이용권 \
   * 무료여부: 무료 \
   * desc: 리워드 대여 이용권 \
   */
  RentCampaign = 'RentCampaign',
  /**
   * type: RT12 \
   * kind: 대여이용권 \
   * 무료여부: 유료 \
   * desc: 캐시 즉납형 할인 단일 대여권 \
   */
  RentCashDiscountSingle = 'RentCashDiscountSingle',
  /**
   * type: RT11 \
   * kind: 대여이용권 \
   * 무료여부: 유료 \
   * desc: 캐시 즉납형 단일 대여권 \
   */
  RentCashSingle = 'RentCashSingle',
  /**
   * type: RT04 \
   * kind: 대여이용권 \
   * 무료여부: 무료 \
   * desc: 쿠폰 발급 대여 이용권 \
   */
  RentCoupon = 'RentCoupon',
  /**
   * type: RT03 \
   * kind: 대여이용권 \
   * 무료여부: 무료 \
   * desc: 이벤트 발급 대여 이용권 \
   * 사용자에게 즉시 지급되지 않음 - 작품홈 진입시 (NEXT 기준)
   */
  RentEvent = 'RentEvent',
  /**
   * type: RT07 \
   * kind: 대여이용권 \
   * 무료여부: 무료 \
   * desc: 선물하면 무료 대여 이용권 \
   * 선물무 기능이 종료되어 현재 사용되지 않음
   */
  RentGiftFree = 'RentGiftFree',
  /**
   * type: RT08 \
   * kind: 대여이용권 \
   * 무료여부: 유료 \
   * desc: 즉납형 대여 이용권 \
   * 현재 사용되고 있지 않음
   */
  RentMoviePpv = 'RentMoviePpv',
  /**
   * type: RT00 \
   * kind: 대여이용권 \
   * 무료여부: 무료 \
   * desc: 신규 대여 고객 혜택 \
   */
  RentNewCustomerGift = 'RentNewCustomerGift',
  /**
   * type: RT02 \
   * kind: 대여이용권 \
   * 무료여부: 유료 \
   * desc: 시리즈 대여 이용권 패키지 \
   */
  RentPackage = 'RentPackage',
  /**
   * type: RT13 \
   * kind: 대여이용권 \
   * 무료여부: 유료 \
   * desc: 세트 소장권 패키지 \
   */
  RentSet = 'RentSet',
  /**
   * type: RT01 \
   * kind: 대여이용권 \
   * 무료여부: 유료 \
   * desc: 단일 대여 이용권 \
   */
  RentSingle = 'RentSingle',
  /**
   * type: RT06 \
   * kind: 대여이용권 \
   * 무료여부: 무료 \
   * desc: 오늘의 선물 대여 이용권 \
   */
  RentTodayGift = 'RentTodayGift',
  /**
   * type: RT05 \
   * kind: 대여이용권 \
   * 무료여부: 무료 \
   * desc: 기다리면 무료 대여 이용권 \
   */
  RentWaitFree = 'RentWaitFree',
  /**
   * type: RT10 \
   * kind: 대여이용권 \
   * 무료여부: 무료 \
   * desc: 레전드패스(기다리면 무료 플러스) 대여 이용권 \
   * @deprecated
   */
  RentWaitFreePlus = 'RentWaitFreePlus',
  /**
   * type: ST01 \
   * kind: 연재예정편 \
   * 무료여부: 무료 \
   * desc: 연재 예정작 이용권 \
   * 2022/2/10 릴리즈 이후 사용되지 않음
   */
  WebSeries = 'WebSeries'
}

export type TicketUseMutationInput = {
  productId: Scalars['Long'];
  ticketType?: Maybe<TicketType>;
};

export type TicketUseMutationPayload = {
  __typename?: 'TicketUseMutationPayload';
  /**
   * 사용한 이용권 ID
   * 스마트푸시를 위해 open_page 에 전달해야하는 값
   */
  ticketUid?: Maybe<Scalars['BigInt']>;
  /**
   * 기다무 충전일시
   * ticket_type = RT05 인 경우
   */
  waitfreeChargedAt?: Maybe<Scalars['Date']>;
};

/** TodayGiftVo 에 대응됨 */
export type TodayGift = {
  __typename?: 'TodayGift';
  id: Scalars['ID'];
  /** 선물 수령여부 */
  isReceived?: Maybe<Scalars['Boolean']>;
  /** 헬릭스 선물 수령 작품 id */
  seriesId?: Maybe<Scalars['Long']>;
  /** 선물로 지급되는 이용권 수 */
  ticketCount: Scalars['Int'];
  /**
   * 선물로 지급받은 이용권 만료 일시 \
   * 선물로 지급받은 이력이 존재하는 경우 전달됨
   */
  ticketExpireAt?: Maybe<Scalars['Date']>;
  /** 선물로 지급되는 이용권의 유효기간 유무에 따른 유효기간 노출 텍스트 */
  ticketExpiredText?: Maybe<Scalars['String']>;
  /** 이용권 종류(소장, 대여) */
  ticketKind: TicketKind;
  /** 선물로 지급되는 이용권 타입 */
  ticketType: TicketType;
  /** 오늘의 선물 ID */
  uid: Scalars['Int'];
};

export type TodayGiftList = {
  __typename?: 'TodayGiftList';
  categoryList: Array<SortOption>;
  displayAd?: Maybe<DisplayAd>;
  helixDescription?: Maybe<Scalars['String']>;
  helixList: Array<HelixTodayGiftList>;
  id: Scalars['ID'];
  list: Array<NormalListViewItem>;
  promotionList: Array<NormalListViewItem>;
  promotionTitle?: Maybe<Scalars['String']>;
  receivableTicketCount?: Maybe<Scalars['Int']>;
  selectedCategory: SortOption;
  selectedSubCategory?: Maybe<SortOption>;
  subCategoryList: Array<SortOption>;
};

export type TodaySeriesGroup = Group & {
  __typename?: 'TodaySeriesGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

export type TopSection = RecommendSection & Section & {
  __typename?: 'TopSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  isRecommendArea?: Maybe<Scalars['Boolean']>;
  isRecommendedItems?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type TranslateProperty = {
  __typename?: 'TranslateProperty';
  category?: Maybe<LocaleMap>;
  name?: Maybe<LocaleMap>;
  sub_category?: Maybe<LocaleMap>;
  title?: Maybe<LocaleMap>;
};

export type TvPointAgreement = {
  __typename?: 'TvPointAgreement';
  isAgree: Scalars['Boolean'];
};

/** 지원하지 않는 타입의 VO 가 들어왔을 때 이 타입이 리턴됩니다 */
export type UnknownGroup = Group & {
  __typename?: 'UnknownGroup';
  dataKey?: Maybe<Scalars['String']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID'];
  items?: Maybe<Array<Item>>;
  type: GroupType;
};

/** 지원하지 않는 타입의 VO 가 들어왔을 때 이 타입이 리턴됩니다 */
export type UnknownItem = Item & {
  __typename?: 'UnknownItem';
  id: Scalars['ID'];
  type: ItemType;
  voType?: Maybe<Scalars['String']>;
};

export type UnknownSection = Section & {
  __typename?: 'UnknownSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type UnregisterUserStatusPayload = {
  __typename?: 'UnregisterUserStatusPayload';
  status?: Maybe<ResultStatus>;
};

export type UpdateNicknameInput = {
  nickname: Scalars['String'];
};

export type UpdateNicknamePayload = {
  __typename?: 'UpdateNicknamePayload';
  nickname: Scalars['String'];
  shouldUpdateProfile: Scalars['Boolean'];
  status: ResultStatus;
};

export type UpdateReceiptInfoInput = {
  receiptInfo: Scalars['String'];
  /**
   * 현금 영수증 발행 정보 타입
   * 1: 개인 소득공제(휴대폰)
   * 2: 개인 소득공제(현금 영수증 카드 번호)
   * 3: 지출증빙(사업자용)
   * 4: 지출증빙(현금영수증 카드번호)
   */
  receiptInfoType: Scalars['Int'];
};

export type UsedTicket = {
  __typename?: 'UsedTicket';
  cancelDt: Scalars['String'];
  category: Scalars['String'];
  createDt: Scalars['String'];
  paidTicket: Scalars['String'];
  pid: Scalars['String'];
  productType: ProductType;
  publisherUid: Scalars['String'];
  readEndDt: Scalars['String'];
  saleType: Scalars['String'];
  seriesId: Scalars['Long'];
  seriesTitle: Scalars['String'];
  singleTitle: Scalars['String'];
  ticketUid: Scalars['String'];
  uid: Scalars['String'];
  userUid: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  age?: Maybe<Scalars['Int']>;
  /** 카카오 앱 아이디 */
  appUserId?: Maybe<Scalars['String']>;
  authenticatedAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  /** 카카오 계정 아이디 */
  kakaoAccountId?: Maybe<Scalars['Int']>;
  /** 프로필이 업데이트가 필요한지 여부를 체크해둔다. */
  needProfileUpdate?: Maybe<Scalars['Boolean']>;
  nickname?: Maybe<Scalars['String']>;
  state?: Maybe<UserState>;
  thumbnail?: Maybe<Scalars['String']>;
  type?: Maybe<UserType>;
  /** 카카오페이지 아이디 */
  uid?: Maybe<Scalars['ID']>;
  /** @deprecated API에서 사용되지 않는 필드입니다. */
  userId?: Maybe<Scalars['String']>;
};

/**
 * user 정보를 담은 Payload 입니다.
 * 미로그인 시 user, cash 는 null 이 됩니다
 */
export type UserAndCashPayload = {
  __typename?: 'UserAndCashPayload';
  cash?: Maybe<UserCash>;
  user?: Maybe<User>;
};


/**
 * user 정보를 담은 Payload 입니다.
 * 미로그인 시 user, cash 는 null 이 됩니다
 */
export type UserAndCashPayloadCashArgs = {
  authInput?: Maybe<AuthInput>;
};


/**
 * user 정보를 담은 Payload 입니다.
 * 미로그인 시 user, cash 는 null 이 됩니다
 */
export type UserAndCashPayloadUserArgs = {
  authInput?: Maybe<AuthInput>;
};

export type UserBasedRecommendSection = Section & {
  __typename?: 'UserBasedRecommendSection';
  groups: Array<Group>;
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  type: SectionType;
  uid?: Maybe<Scalars['Int']>;
};

export type UserCash = {
  __typename?: 'UserCash';
  detail?: Maybe<UserCashDetail>;
  expiredCredit?: Maybe<ExpiredCredit>;
  /** 이벤트 캐시 + 충전 캐시 포함된 전체 캐시 */
  remainCash?: Maybe<Scalars['Int']>;
};

export type UserCashDetail = {
  __typename?: 'UserCashDetail';
  eventSum?: Maybe<Scalars['Int']>;
  paidSum?: Maybe<Scalars['Int']>;
  totalBalance?: Maybe<Scalars['Int']>;
};

export enum UserState {
  /** 휴면계정(UST4) */
  DormantAccount = 'DormantAccount',
  /** 탈퇴자(UST2) */
  LeaveMember = 'LeaveMember',
  /** 로그인 요함 */
  NeedLogin = 'NeedLogin',
  /** 비회원(USTN) */
  NonMember = 'NonMember',
  /** 준회원(UST0) */
  PreMember = 'PreMember',
  /** 정회원(UST1) */
  RegularMember = 'RegularMember'
}

export enum UserType {
  /** 블랙리스트 등록(UT01) */
  BlackList = 'BlackList',
  /** 일반(UT00) */
  Normal = 'Normal',
  Unknown = 'Unknown'
}

/** 페이지 넘김 방향 */
export enum ViewDirection {
  /** 역방향 */
  Backward = 'Backward',
  /** 정방향 */
  Forward = 'Forward'
}

export type ViewImpContents = {
  __typename?: 'ViewImpContents';
  id?: Maybe<Scalars['String']>;
  imp_area_ordnum?: Maybe<Scalars['String']>;
  imp_id?: Maybe<Scalars['String']>;
  imp_ordnum?: Maybe<Scalars['String']>;
  imp_provider?: Maybe<Scalars['String']>;
  imp_type?: Maybe<Scalars['String']>;
  layer1?: Maybe<Scalars['String']>;
  layer2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ViewerData = {
  type: ViewerDataType;
};

export enum ViewerDataType {
  /** 이미지 뷰어를 위한 타입 (사용될 스키마에 대한 정의가 명확하지 않아 Object로 내려줄 예정) */
  ImageViewerData = 'ImageViewerData',
  /** 톡뷰어를 위한 타입 */
  TalkViewerData = 'TalkViewerData',
  /** 텍스트 뷰어를 위한 타입 */
  TextViewerData = 'TextViewerData',
  /** 비디오 뷰어를 위한 타입 (사용되지 되는 스카마와 아닌 스키마가 명확하지 않아 Object로 내려줄 예정) */
  VodViewerData = 'VodViewerData'
}

export type ViewerEnd = {
  __typename?: 'ViewerEnd';
  alarmOn: Scalars['Boolean'];
  commentCount: Scalars['Int'];
  contentRecommendGroup?: Maybe<ContentRecommendGroup>;
  /** displayAd 미구현으로 옵셔널 */
  displayAd?: Maybe<DisplayAd>;
  likeOn: Scalars['Boolean'];
  nextItem?: Maybe<Single>;
  onIssue: OnIssue;
  /** 앱에 뷰어엔드 원본 데이터를 넘겨주어야함 */
  originalRawDataStr?: Maybe<Scalars['String']>;
  ratingCount: Scalars['Int'];
  ratingSum: Scalars['Long'];
  /** 웹툰 <-> 웹소설 동일작 크로스오버 */
  relatedSeries?: Maybe<Series>;
  /** 뷰어엔드 미리보기 댓글 정보 */
  viewerEndPreviewComment?: Maybe<ViewerEndComment>;
};

export type ViewerEndComment = {
  __typename?: 'ViewerEndComment';
  comment: PreviewComment;
  sortOpt: SortOption;
};

export type ViewerEndInput = {
  apiPath?: Maybe<Scalars['String']>;
  productId: Scalars['Long'];
  seriesId: Scalars['Long'];
};

export type ViewerInfo = {
  __typename?: 'ViewerInfo';
  displayAd?: Maybe<DisplayAd>;
  item: Single;
  nextItem?: Maybe<NearItem>;
  prevItem?: Maybe<NearItem>;
  seriesItem: Series;
  viewerData?: Maybe<ViewerData>;
};

export type ViewerLastPageMutationInput = {
  isDone?: Maybe<Scalars['Boolean']>;
  productId: Scalars['Long'];
  rate: Scalars['Int'];
  seriesId: Scalars['Long'];
  spineIndex?: Maybe<Scalars['Int']>;
};

export type ViewerOpenPageMutationInput = {
  productId: Scalars['Long'];
  seriesId: Scalars['Long'];
  ticketUid?: Maybe<Scalars['BigInt']>;
};

export type VodDownloadData = {
  __typename?: 'VodDownloadData';
  contentPackId: Scalars['String'];
  drmServerType: DrmServerType;
  drmType: DrmType;
  duration: Scalars['Long'];
  endpointUrl: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};

export type VodToken = {
  __typename?: 'VodToken';
  provider?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type VodViewerData = ViewerData & {
  __typename?: 'VodViewerData';
  drmInfo?: Maybe<DrmInfo>;
  type: ViewerDataType;
  vodDownloadData?: Maybe<VodDownloadData>;
};

/** WaitfreeTicketDto 에 대응됨 */
export type WaitfreeTicket = {
  __typename?: 'WaitfreeTicket';
  /** 충전시각 */
  chargedAt: Scalars['Date'];
  /** 이용권 개수 */
  chargedCount: Scalars['Int'];
  /** 충전 주기 */
  chargedPeriod: Scalars['Int'];
};

export type Welcome = {
  __typename?: 'Welcome';
  recommendContents: WelcomeRecommendContents;
  welcomeInfo: WelcomeInfo;
};

export type WelcomeButtonInfo = {
  __typename?: 'WelcomeButtonInfo';
  kageId: Scalars['String'];
  scheme: Scalars['String'];
  title: Scalars['String'];
};

export type WelcomeInfo = {
  __typename?: 'WelcomeInfo';
  userNickname: Scalars['String'];
  welcomeButtons: Array<WelcomeButtonInfo>;
  welcomeCash?: Maybe<Scalars['Int']>;
  welcomeMessage?: Maybe<Scalars['String']>;
};

export type WelcomeRecommendContents = {
  __typename?: 'WelcomeRecommendContents';
  novelList: Array<WelcomeRecommendItem>;
  webtoonList: Array<WelcomeRecommendItem>;
};

export type WelcomeRecommendItem = {
  __typename?: 'WelcomeRecommendItem';
  authors: Scalars['String'];
  category: Scalars['String'];
  categoryUid?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  freeSlideCount: Scalars['Int'];
  scheme: Scalars['String'];
  seriesId: Scalars['Long'];
  subCategory: Scalars['String'];
  subCategoryUid?: Maybe<Scalars['Int']>;
  themeKeywordList: Array<Scalars['String']>;
  thumbnail: Scalars['String'];
  title: Scalars['String'];
  viewCount: Scalars['Long'];
};

export enum WinPrizeType {
  Cash = 'Cash',
  Goods = 'Goods',
  Ticket = 'Ticket'
}

export type WriteCommentInput = {
  collectionUid?: Maybe<Scalars['Int']>;
  comment: Scalars['String'];
  emoticon?: Maybe<Scalars['String']>;
  isSpoiler?: Maybe<Scalars['Boolean']>;
  parentUid?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Long']>;
  seriesId?: Maybe<Scalars['Long']>;
};

export type WriteCommentPayload = {
  __typename?: 'WriteCommentPayload';
  blockMsg?: Maybe<Scalars['String']>;
  recordid?: Maybe<Scalars['ID']>;
  status: ResultStatus;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  ActivateUser: ResolverTypeWrapper<ActivateUser>;
  AgeAuth: ResolverTypeWrapper<AgeAuth>;
  AgeGrade: AgeGrade;
  AgreedAgreement: ResolverTypeWrapper<AgreedAgreement>;
  Agreement: ResolverTypeWrapper<Agreement>;
  AgreementContainer: ResolverTypeWrapper<AgreementContainer>;
  AgreementForm: AgreementForm;
  AgreementInfo: ResolverTypeWrapper<AgreementInfo>;
  AgreementType: AgreementType;
  AgreementUnder14Container: ResolverTypeWrapper<AgreementUnder14Container>;
  AlarmSection: ResolverTypeWrapper<AlarmSection>;
  Announcement: ResolverTypeWrapper<Announcement>;
  AnnouncementContainer: ResolverTypeWrapper<AnnouncementContainer>;
  AnnouncementTarget: AnnouncementTarget;
  AppBadge: ResolverTypeWrapper<AppBadge>;
  AppConfig: ResolverTypeWrapper<AppConfig>;
  AppInit: ResolverTypeWrapper<AppInit>;
  AppSetting: ResolverTypeWrapper<AppSetting>;
  AppSettingInput: AppSettingInput;
  AppSettingPayload: ResolverTypeWrapper<AppSettingPayload>;
  AssetProperty: ResolverTypeWrapper<AssetProperty>;
  AuthBankAccountInput: AuthBankAccountInput;
  AuthInfo: ResolverTypeWrapper<AuthInfo>;
  AuthInput: AuthInput;
  AuthRequestInfo: ResolverTypeWrapper<AuthRequestInfo>;
  AuthRequestInfoError: ResolversTypes['ReqInfoNotExist'];
  AuthRequestType: AuthRequestType;
  Author: ResolverTypeWrapper<Author>;
  Authors: ResolverTypeWrapper<Authors>;
  AutoCompleteItem: ResolverTypeWrapper<AutoCompleteItem>;
  AutomaticEvent: ResolverTypeWrapper<AutomaticEvent>;
  BadgeType: BadgeType;
  BankCode: ResolverTypeWrapper<BankCode>;
  BannerItem: ResolverTypeWrapper<BannerItem>;
  BannerSet: ResolverTypeWrapper<BannerSet>;
  BannerType: BannerType;
  BannerViewType: BannerViewType;
  BestCommentListInput: BestCommentListInput;
  BigBannerGroup: ResolverTypeWrapper<BigBannerGroup>;
  BigBannerSection: ResolverTypeWrapper<BigBannerSection>;
  BigInt: ResolverTypeWrapper<Scalars['BigInt']>;
  BillingStatusCode: BillingStatusCode;
  BlockUserInput: BlockUserInput;
  BlockUserList: ResolverTypeWrapper<BlockUserList>;
  Bm: Bm;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  BuyCashHistoryList: ResolverTypeWrapper<BuyCashHistoryList>;
  BuyHistory: ResolverTypeWrapper<BuyHistory>;
  CardCover: ResolverTypeWrapper<CardCover>;
  CardSection: ResolverTypeWrapper<CardSection>;
  CardSet: ResolverTypeWrapper<CardSet>;
  CardViewGroup: ResolverTypeWrapper<CardViewGroup>;
  CardViewItem: ResolverTypeWrapper<CardViewItem>;
  Cash: ResolverTypeWrapper<Cash>;
  CashFriendsSection: ResolverTypeWrapper<CashFriendsSection>;
  CategorySelectedDayPair: ResolverTypeWrapper<CategorySelectedDayPair>;
  CategoryType: CategoryType;
  CertType: CertType;
  ChangeEmailPasswordInput: ChangeEmailPasswordInput;
  Character: ResolverTypeWrapper<Character>;
  CheckEmailVerifyCodeInput: CheckEmailVerifyCodeInput;
  CheckUnregister: ResolverTypeWrapper<CheckUnregister>;
  CleanViewGroup: ResolverTypeWrapper<CleanViewGroup>;
  CleanViewItem: ResolverTypeWrapper<CleanViewItem>;
  ClickLog: ResolverTypeWrapper<ClickLog>;
  CommentCommonPayload: ResolverTypeWrapper<CommentCommonPayload>;
  CommentItem: ResolverTypeWrapper<CommentItem>;
  CommentList: ResolverTypeWrapper<CommentList>;
  CommentListInput: CommentListInput;
  ContentBuyTicketPage: ResolverTypeWrapper<ContentBuyTicketPage>;
  ContentCheckFreeTicket: ResolverTypeWrapper<ContentCheckFreeTicket>;
  ContentDetail: ResolverTypeWrapper<ContentDetail>;
  ContentHomeAbout: ResolverTypeWrapper<ContentHomeAbout>;
  ContentHomeBadgeType: ContentHomeBadgeType;
  ContentHomeBriefList: ResolverTypeWrapper<ContentHomeBriefList>;
  ContentHomeDetailInfo: ResolverTypeWrapper<ContentHomeDetailInfo>;
  ContentHomeInfo: ResolverTypeWrapper<ContentHomeInfo>;
  ContentHomeInfoRankingLanding: ResolverTypeWrapper<ContentHomeInfoRankingLanding>;
  ContentHomeLabelBadge: ResolverTypeWrapper<ContentHomeLabelBadge>;
  ContentHomeNotice: ResolverTypeWrapper<ContentHomeNotice>;
  ContentHomeNoticeInput: ContentHomeNoticeInput;
  ContentHomeOverview: ResolverTypeWrapper<ContentHomeOverview>;
  ContentHomeRecommend: ResolverTypeWrapper<ContentHomeRecommend>;
  ContentMyTicket: ResolverTypeWrapper<ContentMyTicket>;
  ContentRecommendGroup: ResolverTypeWrapper<ContentRecommendGroup>;
  ContentSetList: ResolverTypeWrapper<ContentSetList>;
  ContentSetOverview: ResolverTypeWrapper<ContentSetOverview>;
  ContentTicketHistoryBuy: ResolverTypeWrapper<ContentTicketHistoryBuy>;
  ContentTicketHistoryBuyDetail: ResolverTypeWrapper<ContentTicketHistoryBuyDetail>;
  ContentTicketInfo: ResolverTypeWrapper<ContentTicketInfo>;
  ContentWaitfreeInfo: ResolverTypeWrapper<ContentWaitfreeInfo>;
  ContentsType: ContentsType;
  ContinueInfo: ResolverTypeWrapper<ContinueInfo>;
  ContinueProductType: ContinueProductType;
  CreditStatus: CreditStatus;
  CustomProps: ResolverTypeWrapper<CustomProps>;
  Date: ResolverTypeWrapper<Scalars['Date']>;
  DayOfWeekBmType: DayOfWeekBmType;
  DayOfWeekLayout: ResolverTypeWrapper<DayOfWeekLayout>;
  DayOfWeekList: ResolverTypeWrapper<DayOfWeekList>;
  DayOfWeekSection: ResolverTypeWrapper<DayOfWeekSection>;
  DeclareCommentInput: DeclareCommentInput;
  DeclareCommonPayload: ResolverTypeWrapper<DeclareCommonPayload>;
  DeleteInvenPayload: ResolverTypeWrapper<DeleteInvenPayload>;
  DependOnLoggedInSection: ResolversTypes['RecentViewedSection'];
  Device: ResolverTypeWrapper<Device>;
  DeviceInfo: ResolverTypeWrapper<DeviceInfo>;
  DeviceStatusPayload: ResolverTypeWrapper<DeviceStatusPayload>;
  DisplayAd: ResolverTypeWrapper<DisplayAd>;
  DisplayAdGroup: ResolverTypeWrapper<DisplayAdGroup>;
  DisplayAdItem: ResolverTypeWrapper<DisplayAdItem>;
  DisplayAdSection: ResolverTypeWrapper<DisplayAdSection>;
  DkpgRequestPayload: ResolverTypeWrapper<DkpgRequestPayload>;
  DrawGotchaInput: DrawGotchaInput;
  DrawGotchaPayload: ResolverTypeWrapper<DrawGotchaPayload>;
  DrmInfo: ResolverTypeWrapper<DrmInfo>;
  DrmServerType: DrmServerType;
  DrmType: DrmType;
  DynamicLayout: ResolverTypeWrapper<DynamicLayout>;
  DynamicLayoutReference: ResolverTypeWrapper<DynamicLayoutReference>;
  Emoticon: ResolverTypeWrapper<Emoticon>;
  EpisodeSection: ResolverTypeWrapper<EpisodeSection>;
  EventBannerGroup: ResolverTypeWrapper<EventBannerGroup>;
  EventBannerItem: ResolverTypeWrapper<EventBannerItem>;
  EventLog: ResolverTypeWrapper<EventLog>;
  EventMeta: ResolverTypeWrapper<EventMeta>;
  EventSection: ResolverTypeWrapper<EventSection>;
  ExpiredCredit: ResolverTypeWrapper<ExpiredCredit>;
  ExtraLabelType: ExtraLabelType;
  FilterOption: ResolverTypeWrapper<FilterOption>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  Font: ResolverTypeWrapper<Font>;
  FreeTicketType: FreeTicketType;
  GetEventInfoInput: GetEventInfoInput;
  GetEventInfoPayload: ResolverTypeWrapper<GetEventInfoPayload>;
  GetGlobalAgreementInfoInput: GetGlobalAgreementInfoInput;
  GlobalAgreementInfo: ResolverTypeWrapper<GlobalAgreementInfo>;
  GlobalCheckParentVerifyInput: GlobalCheckParentVerifyInput;
  GlobalEmailSignupInput: GlobalEmailSignupInput;
  GlobalParentVerificationIsCompleted: ResolverTypeWrapper<GlobalParentVerificationIsCompleted>;
  GlobalSavePrivateInput: GlobalSavePrivateInput;
  GlobalSendParentVerifyInput: GlobalSendParentVerifyInput;
  GlobalSendParentVerifyPayload: ResolverTypeWrapper<GlobalSendParentVerifyPayload>;
  GlobalSignupPayload: ResolverTypeWrapper<GlobalSignupPayload>;
  GlobalSnsSignupInput: GlobalSnsSignupInput;
  GlobalUser: ResolverTypeWrapper<GlobalUser>;
  GotchaEntryType: GotchaEntryType;
  GotchaInfo: ResolverTypeWrapper<GotchaInfo>;
  GotchaStatus: GotchaStatus;
  GotchaType: GotchaType;
  Group: ResolversTypes['BigBannerGroup'] | ResolversTypes['CardViewGroup'] | ResolversTypes['CleanViewGroup'] | ResolversTypes['ContentRecommendGroup'] | ResolversTypes['DisplayAdGroup'] | ResolversTypes['EventBannerGroup'] | ResolversTypes['HorizontalScrollGroup'] | ResolversTypes['LineBannerGroup'] | ResolversTypes['ListViewGroup'] | ResolversTypes['MainRankingListViewGroup'] | ResolversTypes['OnAirGroup'] | ResolversTypes['PosterViewGroup'] | ResolversTypes['PromotionBannerGroup'] | ResolversTypes['ResponsiveBannerGroup'] | ResolversTypes['StandaloneBannerAndSubCardGroup'] | ResolversTypes['StandaloneBannerGroup'] | ResolversTypes['StrategyCategoryGroup'] | ResolversTypes['SubCardGroup'] | ResolversTypes['TodaySeriesGroup'] | ResolversTypes['UnknownGroup'];
  GroupType: GroupType;
  HelixAgeBadge: HelixAgeBadge;
  HelixBmBadge: HelixBmBadge;
  HelixSeries: ResolverTypeWrapper<HelixSeries>;
  HelixSeriesList: ResolverTypeWrapper<HelixSeriesList>;
  HelixSeriesStatus: HelixSeriesStatus;
  HelixThemeSection: ResolverTypeWrapper<HelixThemeSection>;
  HelixTodayGiftList: ResolverTypeWrapper<HelixTodayGiftList>;
  History: ResolverTypeWrapper<History>;
  HistoryLineBanner: ResolverTypeWrapper<HistoryLineBanner>;
  HistoryLineBannerType: HistoryLineBannerType;
  HistoryList: ResolverTypeWrapper<HistoryList>;
  HistoryType: HistoryType;
  HorizontalScrollGroup: ResolverTypeWrapper<HorizontalScrollGroup>;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  ImageDownloadData: ResolverTypeWrapper<ImageDownloadData>;
  ImageDownloadFile: ResolverTypeWrapper<ImageDownloadFile>;
  ImageViewerData: ResolverTypeWrapper<ImageViewerData>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  InvenList: ResolverTypeWrapper<InvenList>;
  InvenListInput: InvenListInput;
  InvenMyInfo: ResolverTypeWrapper<InvenMyInfo>;
  InvenRecommendList: ResolverTypeWrapper<InvenRecommendList>;
  Item: ResolversTypes['BannerItem'] | ResolversTypes['CardViewItem'] | ResolversTypes['CleanViewItem'] | ResolversTypes['DisplayAdItem'] | ResolversTypes['EventBannerItem'] | ResolversTypes['LineBannerItem'] | ResolversTypes['MoreItem'] | ResolversTypes['NormalListViewItem'] | ResolversTypes['OnAirItem'] | ResolversTypes['PosterViewItem'] | ResolversTypes['PromotionBannerItem'] | ResolversTypes['PromotionCardViewItem'] | ResolversTypes['RankingListViewItem'] | ResolversTypes['SingleListViewItem'] | ResolversTypes['StrategyViewItem'] | ResolversTypes['UnknownItem'];
  ItemBanner: ResolverTypeWrapper<ItemBanner>;
  ItemType: ItemType;
  KakaoBankSelfCertSupportedDeviceInput: KakaoBankSelfCertSupportedDeviceInput;
  KakaoCashReportData: ResolverTypeWrapper<KakaoCashReportData>;
  LandingType: LandingType;
  LastViewInfo: ResolverTypeWrapper<LastViewInfo>;
  Layout: ResolverTypeWrapper<Layout>;
  LayoutReferenceViewData: ResolverTypeWrapper<LayoutReferenceViewData>;
  LayoutType: LayoutType;
  LegacySingle: ResolverTypeWrapper<LegacySingle>;
  LikeCommentInput: LikeCommentInput;
  LikeCommentPayload: ResolverTypeWrapper<LikeCommentPayload>;
  LineBannerGroup: ResolverTypeWrapper<LineBannerGroup>;
  LineBannerItem: ResolverTypeWrapper<LineBannerItem>;
  LineBannerSection: ResolverTypeWrapper<LineBannerSection>;
  ListViewGroup: ResolverTypeWrapper<ListViewGroup>;
  ListViewGroupMeta: ResolverTypeWrapper<ListViewGroupMeta>;
  Locale: Locale;
  LocaleMap: ResolverTypeWrapper<LocaleMap>;
  Long: ResolverTypeWrapper<Scalars['Long']>;
  MainRankingListViewGroup: ResolverTypeWrapper<MainRankingListViewGroup>;
  MainRankingSection: ResolverTypeWrapper<MainRankingSection>;
  Menu: ResolversTypes['SubtabMenu'];
  MenuType: MenuType;
  MetaInfoType: MetaInfoType;
  MetaInfoTypeSection: ResolversTypes['HelixThemeSection'] | ResolversTypes['RecentViewedSection'] | ResolversTypes['ScrollThemeSection'] | ResolversTypes['ThemeSection'];
  MoreItem: ResolverTypeWrapper<MoreItem>;
  Mutation: ResolverTypeWrapper<{}>;
  MyInfo: ResolverTypeWrapper<MyInfo>;
  MyNewsItem: ResolverTypeWrapper<MyNewsItem>;
  MyNewsList: ResolverTypeWrapper<MyNewsList>;
  MyNewsListInput: MyNewsListInput;
  MyNewsTabType: MyNewsTabType;
  MyNewsType: MyNewsType;
  MyRating: ResolverTypeWrapper<MyRating>;
  NearItem: ResolverTypeWrapper<NearItem>;
  NormalListViewItem: ResolverTypeWrapper<NormalListViewItem>;
  NormalListViewItemRow3: ResolverTypeWrapper<NormalListViewItemRow3>;
  NotiType: NotiType;
  Object: ResolverTypeWrapper<Scalars['Object']>;
  OnAirGroup: ResolverTypeWrapper<OnAirGroup>;
  OnAirItem: ResolverTypeWrapper<OnAirItem>;
  OnAirSection: ResolverTypeWrapper<OnAirSection>;
  OnIssue: OnIssue;
  OpenPreviewMutationInput: OpenPreviewMutationInput;
  OperatorProperty: ResolverTypeWrapper<OperatorProperty>;
  OsType: OsType;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  Paging: ResolverTypeWrapper<Paging>;
  Popup: ResolverTypeWrapper<Popup>;
  PopupInfo: ResolverTypeWrapper<PopupInfo>;
  PopupType: PopupType;
  PosterViewGroup: ResolverTypeWrapper<PosterViewGroup>;
  PosterViewItem: ResolverTypeWrapper<PosterViewItem>;
  PrepareAuthRequestInfoError: ResolversTypes['ReqInfoNotExist'];
  PrepareAuthRequestInfoInput: PrepareAuthRequestInfoInput;
  PrepareAuthRequestInfoPayload: ResolverTypeWrapper<Omit<PrepareAuthRequestInfoPayload, 'authRequestInfoErrors'> & { authRequestInfoErrors: Array<ResolversTypes['PrepareAuthRequestInfoError']> }>;
  Preview: ResolverTypeWrapper<Preview>;
  PreviewComment: ResolverTypeWrapper<PreviewComment>;
  ProductType: ProductType;
  PromotionBannerGroup: ResolverTypeWrapper<PromotionBannerGroup>;
  PromotionBannerItem: ResolverTypeWrapper<PromotionBannerItem>;
  PromotionBannerSection: ResolverTypeWrapper<PromotionBannerSection>;
  PromotionCardViewItem: ResolverTypeWrapper<PromotionCardViewItem>;
  PurchaseInfo: ResolverTypeWrapper<PurchaseInfo>;
  PurchaseType: PurchaseType;
  Query: ResolverTypeWrapper<{}>;
  QueryFromPage: QueryFromPage;
  RankingListViewItem: ResolverTypeWrapper<RankingListViewItem>;
  RankingSection: ResolverTypeWrapper<RankingSection>;
  RankingV2Section: ResolverTypeWrapper<RankingV2Section>;
  ReadAccessType: ReadAccessType;
  ReadType: ReadType;
  ReadyToUseTicket: ResolverTypeWrapper<ReadyToUseTicket>;
  ReceiptInfo: ResolverTypeWrapper<ReceiptInfo>;
  ReceiptInfoResult: ResolverTypeWrapper<ReceiptInfoResult>;
  ReceiptInfoStatusPayload: ResolverTypeWrapper<ReceiptInfoStatusPayload>;
  ReceiptInfoType: ReceiptInfoType;
  ReceiptResultType: ReceiptResultType;
  RecentViewedSection: ResolverTypeWrapper<RecentViewedSection>;
  RecommendEvent: ResolverTypeWrapper<RecommendEvent>;
  RecommendSection: ResolversTypes['CardSection'] | ResolversTypes['TopSection'];
  RedeemCode: ResolverTypeWrapper<RedeemCode>;
  RedeemCodeInput: RedeemCodeInput;
  RedeemCodeType: RedeemCodeType;
  RefundRequestInput: RefundRequestInput;
  RefundRequestPayload: ResolverTypeWrapper<RefundRequestPayload>;
  RefundTicketStatusPayload: ResolverTypeWrapper<RefundTicketStatusPayload>;
  RefundType: RefundType;
  RefundableAmount: ResolverTypeWrapper<RefundableAmount>;
  RefundableTicketInfo: ResolverTypeWrapper<RefundableTicketInfo>;
  RemoveMyNewsInput: RemoveMyNewsInput;
  RemoveMyNewsPayload: ResolverTypeWrapper<RemoveMyNewsPayload>;
  ReqInfoNotExist: ResolverTypeWrapper<ReqInfoNotExist>;
  ResponsiveBannerGroup: ResolverTypeWrapper<ResponsiveBannerGroup>;
  ResultStatus: ResultStatus;
  RouletteApiErrorHandleType: RouletteApiErrorHandleType;
  RouletteDrawInput: RouletteDrawInput;
  RouletteDrawPayload: ResolverTypeWrapper<RouletteDrawPayload>;
  RouletteEntryType: RouletteEntryType;
  RouletteInfo: ResolverTypeWrapper<RouletteInfo>;
  RouletteStatus: RouletteStatus;
  RouletteType: RouletteType;
  RouletteWinPrizeType: RouletteWinPrizeType;
  SaleMethod: SaleMethod;
  SaleState: SaleState;
  SaleType: SaleType;
  SalesTicket: ResolverTypeWrapper<SalesTicket>;
  SalesTicketItem: ResolverTypeWrapper<SalesTicketItem>;
  SampleError: ResolverTypeWrapper<SampleError>;
  SaveAuthInfoInput: SaveAuthInfoInput;
  SaveAuthInfoPayload: ResolverTypeWrapper<SaveAuthInfoPayload>;
  SchemeSection: ResolversTypes['CashFriendsSection'] | ResolversTypes['EpisodeSection'] | ResolversTypes['EventSection'] | ResolversTypes['MainRankingSection'] | ResolversTypes['RankingSection'] | ResolversTypes['RankingV2Section'] | ResolversTypes['RecentViewedSection'] | ResolversTypes['ScrollThemeSection'] | ResolversTypes['ThemeSection'];
  Screen: ResolverTypeWrapper<Screen>;
  ScrollThemeSection: ResolverTypeWrapper<ScrollThemeSection>;
  SearchAutoComplete: ResolverTypeWrapper<SearchAutoComplete>;
  SearchAutoCompleteInput: SearchAutoCompleteInput;
  SearchInvenListInput: SearchInvenListInput;
  SearchKeyword: ResolverTypeWrapper<SearchKeyword>;
  SearchKeywordInput: SearchKeywordInput;
  SearchKeywordSortType: SearchKeywordSortType;
  SearchMain: ResolverTypeWrapper<SearchMain>;
  SearchPopularKeywordRank: ResolverTypeWrapper<SearchPopularKeywordRank>;
  SearchThemeKeyword: ResolverTypeWrapper<SearchThemeKeyword>;
  SearchThemeKeywordInput: SearchThemeKeywordInput;
  SearchThemeKeywordSortType: SearchThemeKeywordSortType;
  Section: ResolversTypes['AlarmSection'] | ResolversTypes['BigBannerSection'] | ResolversTypes['CardSection'] | ResolversTypes['CashFriendsSection'] | ResolversTypes['DayOfWeekSection'] | ResolversTypes['DisplayAdSection'] | ResolversTypes['EpisodeSection'] | ResolversTypes['EventSection'] | ResolversTypes['HelixThemeSection'] | ResolversTypes['LineBannerSection'] | ResolversTypes['MainRankingSection'] | ResolversTypes['OnAirSection'] | ResolversTypes['PromotionBannerSection'] | ResolversTypes['RankingSection'] | ResolversTypes['RankingV2Section'] | ResolversTypes['RecentViewedSection'] | ResolversTypes['ScrollThemeSection'] | ResolversTypes['SeriesBasedRecommendSection'] | ResolversTypes['StaticLandingDayOfWeekSection'] | ResolversTypes['StaticLandingEventSection'] | ResolversTypes['StaticLandingFreeSeriesSection'] | ResolversTypes['StaticLandingGenreSection'] | ResolversTypes['StaticLandingOriginalSection'] | ResolversTypes['StaticLandingRankingSection'] | ResolversTypes['StaticLandingTodayNewSection'] | ResolversTypes['StaticLandingTodayUpSection'] | ResolversTypes['StrategyCategorySection'] | ResolversTypes['ThemeSection'] | ResolversTypes['TopSection'] | ResolversTypes['UnknownSection'] | ResolversTypes['UserBasedRecommendSection'];
  SectionMainTab: ResolverTypeWrapper<SectionMainTab>;
  SectionSubTab: ResolverTypeWrapper<SectionSubTab>;
  SectionType: SectionType;
  SendEmailVerifyCodeInput: SendEmailVerifyCodeInput;
  SendEmailVerifyCodePayload: ResolverTypeWrapper<SendEmailVerifyCodePayload>;
  SendEmailVerifyType: SendEmailVerifyType;
  Series: ResolverTypeWrapper<Series>;
  SeriesBasedRecommendSection: ResolverTypeWrapper<SeriesBasedRecommendSection>;
  SeriesCardViewLandingList: ResolverTypeWrapper<SeriesCardViewLandingList>;
  SeriesListViewLandingList: ResolverTypeWrapper<SeriesListViewLandingList>;
  SeriesNotice: ResolverTypeWrapper<SeriesNotice>;
  SeriesNoticeListContainer: ResolverTypeWrapper<SeriesNoticeListContainer>;
  SeriesNoticeType: SeriesNoticeType;
  SeriesPosterViewLandingList: ResolverTypeWrapper<SeriesPosterViewLandingList>;
  SeriesPreview: ResolverTypeWrapper<SeriesPreview>;
  ServiceProperty: ResolverTypeWrapper<ServiceProperty>;
  Set: ResolverTypeWrapper<Set>;
  SetAgreementInput: SetAgreementInput;
  SetAgreementPayload: ResolverTypeWrapper<SetAgreementPayload>;
  SetGlobalAgreementInput: SetGlobalAgreementInput;
  SetGlobalAgreementPayload: ResolverTypeWrapper<SetGlobalAgreementPayload>;
  SetListViewLandingList: ResolverTypeWrapper<SetListViewLandingList>;
  SetMyRatingInput: SetMyRatingInput;
  SetMyRatingPayload: ResolverTypeWrapper<SetMyRatingPayload>;
  SetPosterViewLandingList: ResolverTypeWrapper<SetPosterViewLandingList>;
  SetProduct: ResolverTypeWrapper<SetProduct>;
  SetReadyToUseTicket: ResolverTypeWrapper<SetReadyToUseTicket>;
  SetSeriesAlarmInput: SetSeriesAlarmInput;
  SetSeriesAlarmPayload: ResolverTypeWrapper<SetSeriesAlarmPayload>;
  SetSeriesLikeInput: SetSeriesLikeInput;
  SetSeriesLikePayload: ResolverTypeWrapper<SetSeriesLikePayload>;
  SetTicketMy: ResolverTypeWrapper<SetTicketMy>;
  SetTvPointAgreementPayload: ResolverTypeWrapper<SetTvPointAgreementPayload>;
  ShortVodPreviewViewerInfo: ResolverTypeWrapper<ShortVodPreviewViewerInfo>;
  ShortcutHomeType: ShortcutHomeType;
  ShortcutItem: ResolverTypeWrapper<ShortcutItem>;
  ShortcutItemList: ResolverTypeWrapper<ShortcutItemList>;
  ShortcutList: ResolverTypeWrapper<ShortcutList>;
  ShortcutMenuItem: ResolverTypeWrapper<ShortcutMenuItem>;
  SimpleImageBanner: ResolverTypeWrapper<SimpleImageBanner>;
  SimpleSeriesSingleInfo: ResolverTypeWrapper<SimpleSeriesSingleInfo>;
  SimpleSet: ResolverTypeWrapper<SimpleSet>;
  Single: ResolverTypeWrapper<Single>;
  SingleBadgeType: SingleBadgeType;
  SingleEdge: ResolverTypeWrapper<SingleEdge>;
  SingleListConnection: ResolverTypeWrapper<SingleListConnection>;
  SingleListViewItem: ResolverTypeWrapper<SingleListViewItem>;
  SingleListViewItemRow3: ResolverTypeWrapper<SingleListViewItemRow3>;
  SingleListViewLandingList: ResolverTypeWrapper<SingleListViewLandingList>;
  SinglePreview: ResolverTypeWrapper<SinglePreview>;
  SingleTicketInfo: ResolverTypeWrapper<SingleTicketInfo>;
  SlideState: SlideState;
  SlideType: SlideType;
  SortOption: ResolverTypeWrapper<SortOption>;
  StandaloneBannerAndSubCardGroup: ResolverTypeWrapper<StandaloneBannerAndSubCardGroup>;
  StandaloneBannerGroup: ResolverTypeWrapper<StandaloneBannerGroup>;
  StaticLandingDayOfWeekParamInput: StaticLandingDayOfWeekParamInput;
  StaticLandingDayOfWeekSection: ResolverTypeWrapper<StaticLandingDayOfWeekSection>;
  StaticLandingDayOfWeekSectionParam: ResolverTypeWrapper<StaticLandingDayOfWeekSectionParam>;
  StaticLandingEventParamInput: StaticLandingEventParamInput;
  StaticLandingEventSection: ResolverTypeWrapper<StaticLandingEventSection>;
  StaticLandingEventSectionParam: ResolverTypeWrapper<StaticLandingEventSectionParam>;
  StaticLandingFreeSeriesParamInput: StaticLandingFreeSeriesParamInput;
  StaticLandingFreeSeriesSection: ResolverTypeWrapper<StaticLandingFreeSeriesSection>;
  StaticLandingFreeSeriesSectionParam: ResolverTypeWrapper<StaticLandingFreeSeriesSectionParam>;
  StaticLandingGenreParamInput: StaticLandingGenreParamInput;
  StaticLandingGenreSection: ResolverTypeWrapper<StaticLandingGenreSection>;
  StaticLandingGenreSectionParam: ResolverTypeWrapper<StaticLandingGenreSectionParam>;
  StaticLandingOriginalParamInput: StaticLandingOriginalParamInput;
  StaticLandingOriginalSection: ResolverTypeWrapper<StaticLandingOriginalSection>;
  StaticLandingOriginalSectionParam: ResolverTypeWrapper<StaticLandingOriginalSectionParam>;
  StaticLandingRankingParamInput: StaticLandingRankingParamInput;
  StaticLandingRankingSection: ResolverTypeWrapper<StaticLandingRankingSection>;
  StaticLandingRankingSectionParam: ResolverTypeWrapper<StaticLandingRankingSectionParam>;
  StaticLandingTodayNewParamInput: StaticLandingTodayNewParamInput;
  StaticLandingTodayNewSection: ResolverTypeWrapper<StaticLandingTodayNewSection>;
  StaticLandingTodayNewSectionParam: ResolverTypeWrapper<StaticLandingTodayNewSectionParam>;
  StaticLandingTodayUpParamInput: StaticLandingTodayUpParamInput;
  StaticLandingTodayUpSection: ResolverTypeWrapper<StaticLandingTodayUpSection>;
  StaticLandingTodayUpSectionParam: ResolverTypeWrapper<StaticLandingTodayUpSectionParam>;
  StaticLandingType: StaticLandingType;
  StrategyCategoryGroup: ResolverTypeWrapper<StrategyCategoryGroup>;
  StrategyCategorySection: ResolverTypeWrapper<StrategyCategorySection>;
  StrategyViewItem: ResolverTypeWrapper<StrategyViewItem>;
  String: ResolverTypeWrapper<Scalars['String']>;
  SubCardGroup: ResolverTypeWrapper<SubCardGroup>;
  SubtabMenu: ResolverTypeWrapper<SubtabMenu>;
  TabSection: ResolversTypes['DayOfWeekSection'] | ResolversTypes['MainRankingSection'];
  TalkDownloadData: ResolverTypeWrapper<TalkDownloadData>;
  TalkViewerData: ResolverTypeWrapper<TalkViewerData>;
  TalkViewerType: TalkViewerType;
  TastesServiceLang: ResolverTypeWrapper<TastesServiceLang>;
  TastesServiceLangItem: ResolverTypeWrapper<TastesServiceLangItem>;
  TextViewerContentData: ResolverTypeWrapper<TextViewerContentData>;
  TextViewerData: ResolverTypeWrapper<TextViewerData>;
  ThemeKeyword: ResolverTypeWrapper<ThemeKeyword>;
  ThemeKeywordSection: ResolversTypes['ThemeSection'];
  ThemeSection: ResolverTypeWrapper<ThemeSection>;
  TicketAvailable: ResolverTypeWrapper<TicketAvailable>;
  TicketBuyAndUseMutationInput: TicketBuyAndUseMutationInput;
  TicketBuyAndUseMutationPayload: ResolverTypeWrapper<TicketBuyAndUseMutationPayload>;
  TicketBuyItem: TicketBuyItem;
  TicketBuyMutationInput: TicketBuyMutationInput;
  TicketBuyMutationPayload: ResolverTypeWrapper<TicketBuyMutationPayload>;
  TicketDetail: ResolverTypeWrapper<TicketDetail>;
  TicketFreeMutationInput: TicketFreeMutationInput;
  TicketHistoryBuyExtraSimple: ResolverTypeWrapper<TicketHistoryBuyExtraSimple>;
  TicketInSeries: ResolverTypeWrapper<TicketInSeries>;
  TicketInfo: ResolverTypeWrapper<TicketInfo>;
  TicketInfoApi: ResolverTypeWrapper<TicketInfoApi>;
  TicketItemInSeries: ResolverTypeWrapper<TicketItemInSeries>;
  TicketKind: TicketKind;
  TicketMy: ResolverTypeWrapper<TicketMy>;
  TicketProcess: TicketProcess;
  TicketPurchase: ResolverTypeWrapper<TicketPurchase>;
  TicketSeries: ResolverTypeWrapper<TicketSeries>;
  TicketSetBuyMutationInput: TicketSetBuyMutationInput;
  TicketSetBuyMutationPayload: ResolverTypeWrapper<TicketSetBuyMutationPayload>;
  TicketSingle: ResolverTypeWrapper<TicketSingle>;
  TicketStatus: TicketStatus;
  TicketSum: ResolverTypeWrapper<TicketSum>;
  TicketType: TicketType;
  TicketUseMutationInput: TicketUseMutationInput;
  TicketUseMutationPayload: ResolverTypeWrapper<TicketUseMutationPayload>;
  TodayGift: ResolverTypeWrapper<TodayGift>;
  TodayGiftList: ResolverTypeWrapper<TodayGiftList>;
  TodaySeriesGroup: ResolverTypeWrapper<TodaySeriesGroup>;
  TopSection: ResolverTypeWrapper<TopSection>;
  TranslateProperty: ResolverTypeWrapper<TranslateProperty>;
  TvPointAgreement: ResolverTypeWrapper<TvPointAgreement>;
  UnknownGroup: ResolverTypeWrapper<UnknownGroup>;
  UnknownItem: ResolverTypeWrapper<UnknownItem>;
  UnknownSection: ResolverTypeWrapper<UnknownSection>;
  UnregisterUserStatusPayload: ResolverTypeWrapper<UnregisterUserStatusPayload>;
  UpdateNicknameInput: UpdateNicknameInput;
  UpdateNicknamePayload: ResolverTypeWrapper<UpdateNicknamePayload>;
  UpdateReceiptInfoInput: UpdateReceiptInfoInput;
  UsedTicket: ResolverTypeWrapper<UsedTicket>;
  User: ResolverTypeWrapper<User>;
  UserAndCashPayload: ResolverTypeWrapper<UserAndCashPayload>;
  UserBasedRecommendSection: ResolverTypeWrapper<UserBasedRecommendSection>;
  UserCash: ResolverTypeWrapper<UserCash>;
  UserCashDetail: ResolverTypeWrapper<UserCashDetail>;
  UserState: UserState;
  UserType: UserType;
  ViewDirection: ViewDirection;
  ViewImpContents: ResolverTypeWrapper<ViewImpContents>;
  ViewerData: ResolversTypes['ImageViewerData'] | ResolversTypes['TalkViewerData'] | ResolversTypes['TextViewerData'] | ResolversTypes['VodViewerData'];
  ViewerDataType: ViewerDataType;
  ViewerEnd: ResolverTypeWrapper<ViewerEnd>;
  ViewerEndComment: ResolverTypeWrapper<ViewerEndComment>;
  ViewerEndInput: ViewerEndInput;
  ViewerInfo: ResolverTypeWrapper<ViewerInfo>;
  ViewerLastPageMutationInput: ViewerLastPageMutationInput;
  ViewerOpenPageMutationInput: ViewerOpenPageMutationInput;
  VodDownloadData: ResolverTypeWrapper<VodDownloadData>;
  VodToken: ResolverTypeWrapper<VodToken>;
  VodViewerData: ResolverTypeWrapper<VodViewerData>;
  WaitfreeTicket: ResolverTypeWrapper<WaitfreeTicket>;
  Welcome: ResolverTypeWrapper<Welcome>;
  WelcomeButtonInfo: ResolverTypeWrapper<WelcomeButtonInfo>;
  WelcomeInfo: ResolverTypeWrapper<WelcomeInfo>;
  WelcomeRecommendContents: ResolverTypeWrapper<WelcomeRecommendContents>;
  WelcomeRecommendItem: ResolverTypeWrapper<WelcomeRecommendItem>;
  WinPrizeType: WinPrizeType;
  WriteCommentInput: WriteCommentInput;
  WriteCommentPayload: ResolverTypeWrapper<WriteCommentPayload>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  ActivateUser: ActivateUser;
  AgeAuth: AgeAuth;
  AgreedAgreement: AgreedAgreement;
  Agreement: Agreement;
  AgreementContainer: AgreementContainer;
  AgreementForm: AgreementForm;
  AgreementInfo: AgreementInfo;
  AgreementUnder14Container: AgreementUnder14Container;
  AlarmSection: AlarmSection;
  Announcement: Announcement;
  AnnouncementContainer: AnnouncementContainer;
  AppBadge: AppBadge;
  AppConfig: AppConfig;
  AppInit: AppInit;
  AppSetting: AppSetting;
  AppSettingInput: AppSettingInput;
  AppSettingPayload: AppSettingPayload;
  AssetProperty: AssetProperty;
  AuthBankAccountInput: AuthBankAccountInput;
  AuthInfo: AuthInfo;
  AuthInput: AuthInput;
  AuthRequestInfo: AuthRequestInfo;
  AuthRequestInfoError: ResolversParentTypes['ReqInfoNotExist'];
  Author: Author;
  Authors: Authors;
  AutoCompleteItem: AutoCompleteItem;
  AutomaticEvent: AutomaticEvent;
  BankCode: BankCode;
  BannerItem: BannerItem;
  BannerSet: BannerSet;
  BestCommentListInput: BestCommentListInput;
  BigBannerGroup: BigBannerGroup;
  BigBannerSection: BigBannerSection;
  BigInt: Scalars['BigInt'];
  BlockUserInput: BlockUserInput;
  BlockUserList: BlockUserList;
  Boolean: Scalars['Boolean'];
  BuyCashHistoryList: BuyCashHistoryList;
  BuyHistory: BuyHistory;
  CardCover: CardCover;
  CardSection: CardSection;
  CardSet: CardSet;
  CardViewGroup: CardViewGroup;
  CardViewItem: CardViewItem;
  Cash: Cash;
  CashFriendsSection: CashFriendsSection;
  CategorySelectedDayPair: CategorySelectedDayPair;
  ChangeEmailPasswordInput: ChangeEmailPasswordInput;
  Character: Character;
  CheckEmailVerifyCodeInput: CheckEmailVerifyCodeInput;
  CheckUnregister: CheckUnregister;
  CleanViewGroup: CleanViewGroup;
  CleanViewItem: CleanViewItem;
  ClickLog: ClickLog;
  CommentCommonPayload: CommentCommonPayload;
  CommentItem: CommentItem;
  CommentList: CommentList;
  CommentListInput: CommentListInput;
  ContentBuyTicketPage: ContentBuyTicketPage;
  ContentCheckFreeTicket: ContentCheckFreeTicket;
  ContentDetail: ContentDetail;
  ContentHomeAbout: ContentHomeAbout;
  ContentHomeBriefList: ContentHomeBriefList;
  ContentHomeDetailInfo: ContentHomeDetailInfo;
  ContentHomeInfo: ContentHomeInfo;
  ContentHomeInfoRankingLanding: ContentHomeInfoRankingLanding;
  ContentHomeLabelBadge: ContentHomeLabelBadge;
  ContentHomeNotice: ContentHomeNotice;
  ContentHomeNoticeInput: ContentHomeNoticeInput;
  ContentHomeOverview: ContentHomeOverview;
  ContentHomeRecommend: ContentHomeRecommend;
  ContentMyTicket: ContentMyTicket;
  ContentRecommendGroup: ContentRecommendGroup;
  ContentSetList: ContentSetList;
  ContentSetOverview: ContentSetOverview;
  ContentTicketHistoryBuy: ContentTicketHistoryBuy;
  ContentTicketHistoryBuyDetail: ContentTicketHistoryBuyDetail;
  ContentTicketInfo: ContentTicketInfo;
  ContentWaitfreeInfo: ContentWaitfreeInfo;
  ContinueInfo: ContinueInfo;
  CustomProps: CustomProps;
  Date: Scalars['Date'];
  DayOfWeekLayout: DayOfWeekLayout;
  DayOfWeekList: DayOfWeekList;
  DayOfWeekSection: DayOfWeekSection;
  DeclareCommentInput: DeclareCommentInput;
  DeclareCommonPayload: DeclareCommonPayload;
  DeleteInvenPayload: DeleteInvenPayload;
  DependOnLoggedInSection: ResolversParentTypes['RecentViewedSection'];
  Device: Device;
  DeviceInfo: DeviceInfo;
  DeviceStatusPayload: DeviceStatusPayload;
  DisplayAd: DisplayAd;
  DisplayAdGroup: DisplayAdGroup;
  DisplayAdItem: DisplayAdItem;
  DisplayAdSection: DisplayAdSection;
  DkpgRequestPayload: DkpgRequestPayload;
  DrawGotchaInput: DrawGotchaInput;
  DrawGotchaPayload: DrawGotchaPayload;
  DrmInfo: DrmInfo;
  DynamicLayout: DynamicLayout;
  DynamicLayoutReference: DynamicLayoutReference;
  Emoticon: Emoticon;
  EpisodeSection: EpisodeSection;
  EventBannerGroup: EventBannerGroup;
  EventBannerItem: EventBannerItem;
  EventLog: EventLog;
  EventMeta: EventMeta;
  EventSection: EventSection;
  ExpiredCredit: ExpiredCredit;
  FilterOption: FilterOption;
  Float: Scalars['Float'];
  Font: Font;
  GetEventInfoInput: GetEventInfoInput;
  GetEventInfoPayload: GetEventInfoPayload;
  GetGlobalAgreementInfoInput: GetGlobalAgreementInfoInput;
  GlobalAgreementInfo: GlobalAgreementInfo;
  GlobalCheckParentVerifyInput: GlobalCheckParentVerifyInput;
  GlobalEmailSignupInput: GlobalEmailSignupInput;
  GlobalParentVerificationIsCompleted: GlobalParentVerificationIsCompleted;
  GlobalSavePrivateInput: GlobalSavePrivateInput;
  GlobalSendParentVerifyInput: GlobalSendParentVerifyInput;
  GlobalSendParentVerifyPayload: GlobalSendParentVerifyPayload;
  GlobalSignupPayload: GlobalSignupPayload;
  GlobalSnsSignupInput: GlobalSnsSignupInput;
  GlobalUser: GlobalUser;
  GotchaInfo: GotchaInfo;
  Group: ResolversParentTypes['BigBannerGroup'] | ResolversParentTypes['CardViewGroup'] | ResolversParentTypes['CleanViewGroup'] | ResolversParentTypes['ContentRecommendGroup'] | ResolversParentTypes['DisplayAdGroup'] | ResolversParentTypes['EventBannerGroup'] | ResolversParentTypes['HorizontalScrollGroup'] | ResolversParentTypes['LineBannerGroup'] | ResolversParentTypes['ListViewGroup'] | ResolversParentTypes['MainRankingListViewGroup'] | ResolversParentTypes['OnAirGroup'] | ResolversParentTypes['PosterViewGroup'] | ResolversParentTypes['PromotionBannerGroup'] | ResolversParentTypes['ResponsiveBannerGroup'] | ResolversParentTypes['StandaloneBannerAndSubCardGroup'] | ResolversParentTypes['StandaloneBannerGroup'] | ResolversParentTypes['StrategyCategoryGroup'] | ResolversParentTypes['SubCardGroup'] | ResolversParentTypes['TodaySeriesGroup'] | ResolversParentTypes['UnknownGroup'];
  HelixSeries: HelixSeries;
  HelixSeriesList: HelixSeriesList;
  HelixThemeSection: HelixThemeSection;
  HelixTodayGiftList: HelixTodayGiftList;
  History: History;
  HistoryLineBanner: HistoryLineBanner;
  HistoryList: HistoryList;
  HorizontalScrollGroup: HorizontalScrollGroup;
  ID: Scalars['ID'];
  ImageDownloadData: ImageDownloadData;
  ImageDownloadFile: ImageDownloadFile;
  ImageViewerData: ImageViewerData;
  Int: Scalars['Int'];
  InvenList: InvenList;
  InvenListInput: InvenListInput;
  InvenMyInfo: InvenMyInfo;
  InvenRecommendList: InvenRecommendList;
  Item: ResolversParentTypes['BannerItem'] | ResolversParentTypes['CardViewItem'] | ResolversParentTypes['CleanViewItem'] | ResolversParentTypes['DisplayAdItem'] | ResolversParentTypes['EventBannerItem'] | ResolversParentTypes['LineBannerItem'] | ResolversParentTypes['MoreItem'] | ResolversParentTypes['NormalListViewItem'] | ResolversParentTypes['OnAirItem'] | ResolversParentTypes['PosterViewItem'] | ResolversParentTypes['PromotionBannerItem'] | ResolversParentTypes['PromotionCardViewItem'] | ResolversParentTypes['RankingListViewItem'] | ResolversParentTypes['SingleListViewItem'] | ResolversParentTypes['StrategyViewItem'] | ResolversParentTypes['UnknownItem'];
  ItemBanner: ItemBanner;
  KakaoBankSelfCertSupportedDeviceInput: KakaoBankSelfCertSupportedDeviceInput;
  KakaoCashReportData: KakaoCashReportData;
  LastViewInfo: LastViewInfo;
  Layout: Layout;
  LayoutReferenceViewData: LayoutReferenceViewData;
  LegacySingle: LegacySingle;
  LikeCommentInput: LikeCommentInput;
  LikeCommentPayload: LikeCommentPayload;
  LineBannerGroup: LineBannerGroup;
  LineBannerItem: LineBannerItem;
  LineBannerSection: LineBannerSection;
  ListViewGroup: ListViewGroup;
  ListViewGroupMeta: ListViewGroupMeta;
  LocaleMap: LocaleMap;
  Long: Scalars['Long'];
  MainRankingListViewGroup: MainRankingListViewGroup;
  MainRankingSection: MainRankingSection;
  Menu: ResolversParentTypes['SubtabMenu'];
  MetaInfoTypeSection: ResolversParentTypes['HelixThemeSection'] | ResolversParentTypes['RecentViewedSection'] | ResolversParentTypes['ScrollThemeSection'] | ResolversParentTypes['ThemeSection'];
  MoreItem: MoreItem;
  Mutation: {};
  MyInfo: MyInfo;
  MyNewsItem: MyNewsItem;
  MyNewsList: MyNewsList;
  MyNewsListInput: MyNewsListInput;
  MyRating: MyRating;
  NearItem: NearItem;
  NormalListViewItem: NormalListViewItem;
  NormalListViewItemRow3: NormalListViewItemRow3;
  Object: Scalars['Object'];
  OnAirGroup: OnAirGroup;
  OnAirItem: OnAirItem;
  OnAirSection: OnAirSection;
  OpenPreviewMutationInput: OpenPreviewMutationInput;
  OperatorProperty: OperatorProperty;
  PageInfo: PageInfo;
  Paging: Paging;
  Popup: Popup;
  PopupInfo: PopupInfo;
  PosterViewGroup: PosterViewGroup;
  PosterViewItem: PosterViewItem;
  PrepareAuthRequestInfoError: ResolversParentTypes['ReqInfoNotExist'];
  PrepareAuthRequestInfoInput: PrepareAuthRequestInfoInput;
  PrepareAuthRequestInfoPayload: Omit<PrepareAuthRequestInfoPayload, 'authRequestInfoErrors'> & { authRequestInfoErrors: Array<ResolversParentTypes['PrepareAuthRequestInfoError']> };
  Preview: Preview;
  PreviewComment: PreviewComment;
  PromotionBannerGroup: PromotionBannerGroup;
  PromotionBannerItem: PromotionBannerItem;
  PromotionBannerSection: PromotionBannerSection;
  PromotionCardViewItem: PromotionCardViewItem;
  PurchaseInfo: PurchaseInfo;
  Query: {};
  RankingListViewItem: RankingListViewItem;
  RankingSection: RankingSection;
  RankingV2Section: RankingV2Section;
  ReadyToUseTicket: ReadyToUseTicket;
  ReceiptInfo: ReceiptInfo;
  ReceiptInfoResult: ReceiptInfoResult;
  ReceiptInfoStatusPayload: ReceiptInfoStatusPayload;
  RecentViewedSection: RecentViewedSection;
  RecommendEvent: RecommendEvent;
  RecommendSection: ResolversParentTypes['CardSection'] | ResolversParentTypes['TopSection'];
  RedeemCode: RedeemCode;
  RedeemCodeInput: RedeemCodeInput;
  RefundRequestInput: RefundRequestInput;
  RefundRequestPayload: RefundRequestPayload;
  RefundTicketStatusPayload: RefundTicketStatusPayload;
  RefundableAmount: RefundableAmount;
  RefundableTicketInfo: RefundableTicketInfo;
  RemoveMyNewsInput: RemoveMyNewsInput;
  RemoveMyNewsPayload: RemoveMyNewsPayload;
  ReqInfoNotExist: ReqInfoNotExist;
  ResponsiveBannerGroup: ResponsiveBannerGroup;
  RouletteDrawInput: RouletteDrawInput;
  RouletteDrawPayload: RouletteDrawPayload;
  RouletteInfo: RouletteInfo;
  SalesTicket: SalesTicket;
  SalesTicketItem: SalesTicketItem;
  SampleError: SampleError;
  SaveAuthInfoInput: SaveAuthInfoInput;
  SaveAuthInfoPayload: SaveAuthInfoPayload;
  SchemeSection: ResolversParentTypes['CashFriendsSection'] | ResolversParentTypes['EpisodeSection'] | ResolversParentTypes['EventSection'] | ResolversParentTypes['MainRankingSection'] | ResolversParentTypes['RankingSection'] | ResolversParentTypes['RankingV2Section'] | ResolversParentTypes['RecentViewedSection'] | ResolversParentTypes['ScrollThemeSection'] | ResolversParentTypes['ThemeSection'];
  Screen: Screen;
  ScrollThemeSection: ScrollThemeSection;
  SearchAutoComplete: SearchAutoComplete;
  SearchAutoCompleteInput: SearchAutoCompleteInput;
  SearchInvenListInput: SearchInvenListInput;
  SearchKeyword: SearchKeyword;
  SearchKeywordInput: SearchKeywordInput;
  SearchMain: SearchMain;
  SearchPopularKeywordRank: SearchPopularKeywordRank;
  SearchThemeKeyword: SearchThemeKeyword;
  SearchThemeKeywordInput: SearchThemeKeywordInput;
  Section: ResolversParentTypes['AlarmSection'] | ResolversParentTypes['BigBannerSection'] | ResolversParentTypes['CardSection'] | ResolversParentTypes['CashFriendsSection'] | ResolversParentTypes['DayOfWeekSection'] | ResolversParentTypes['DisplayAdSection'] | ResolversParentTypes['EpisodeSection'] | ResolversParentTypes['EventSection'] | ResolversParentTypes['HelixThemeSection'] | ResolversParentTypes['LineBannerSection'] | ResolversParentTypes['MainRankingSection'] | ResolversParentTypes['OnAirSection'] | ResolversParentTypes['PromotionBannerSection'] | ResolversParentTypes['RankingSection'] | ResolversParentTypes['RankingV2Section'] | ResolversParentTypes['RecentViewedSection'] | ResolversParentTypes['ScrollThemeSection'] | ResolversParentTypes['SeriesBasedRecommendSection'] | ResolversParentTypes['StaticLandingDayOfWeekSection'] | ResolversParentTypes['StaticLandingEventSection'] | ResolversParentTypes['StaticLandingFreeSeriesSection'] | ResolversParentTypes['StaticLandingGenreSection'] | ResolversParentTypes['StaticLandingOriginalSection'] | ResolversParentTypes['StaticLandingRankingSection'] | ResolversParentTypes['StaticLandingTodayNewSection'] | ResolversParentTypes['StaticLandingTodayUpSection'] | ResolversParentTypes['StrategyCategorySection'] | ResolversParentTypes['ThemeSection'] | ResolversParentTypes['TopSection'] | ResolversParentTypes['UnknownSection'] | ResolversParentTypes['UserBasedRecommendSection'];
  SectionMainTab: SectionMainTab;
  SectionSubTab: SectionSubTab;
  SendEmailVerifyCodeInput: SendEmailVerifyCodeInput;
  SendEmailVerifyCodePayload: SendEmailVerifyCodePayload;
  Series: Series;
  SeriesBasedRecommendSection: SeriesBasedRecommendSection;
  SeriesCardViewLandingList: SeriesCardViewLandingList;
  SeriesListViewLandingList: SeriesListViewLandingList;
  SeriesNotice: SeriesNotice;
  SeriesNoticeListContainer: SeriesNoticeListContainer;
  SeriesPosterViewLandingList: SeriesPosterViewLandingList;
  SeriesPreview: SeriesPreview;
  ServiceProperty: ServiceProperty;
  Set: Set;
  SetAgreementInput: SetAgreementInput;
  SetAgreementPayload: SetAgreementPayload;
  SetGlobalAgreementInput: SetGlobalAgreementInput;
  SetGlobalAgreementPayload: SetGlobalAgreementPayload;
  SetListViewLandingList: SetListViewLandingList;
  SetMyRatingInput: SetMyRatingInput;
  SetMyRatingPayload: SetMyRatingPayload;
  SetPosterViewLandingList: SetPosterViewLandingList;
  SetProduct: SetProduct;
  SetReadyToUseTicket: SetReadyToUseTicket;
  SetSeriesAlarmInput: SetSeriesAlarmInput;
  SetSeriesAlarmPayload: SetSeriesAlarmPayload;
  SetSeriesLikeInput: SetSeriesLikeInput;
  SetSeriesLikePayload: SetSeriesLikePayload;
  SetTicketMy: SetTicketMy;
  SetTvPointAgreementPayload: SetTvPointAgreementPayload;
  ShortVodPreviewViewerInfo: ShortVodPreviewViewerInfo;
  ShortcutItem: ShortcutItem;
  ShortcutItemList: ShortcutItemList;
  ShortcutList: ShortcutList;
  ShortcutMenuItem: ShortcutMenuItem;
  SimpleImageBanner: SimpleImageBanner;
  SimpleSeriesSingleInfo: SimpleSeriesSingleInfo;
  SimpleSet: SimpleSet;
  Single: Single;
  SingleEdge: SingleEdge;
  SingleListConnection: SingleListConnection;
  SingleListViewItem: SingleListViewItem;
  SingleListViewItemRow3: SingleListViewItemRow3;
  SingleListViewLandingList: SingleListViewLandingList;
  SinglePreview: SinglePreview;
  SingleTicketInfo: SingleTicketInfo;
  SortOption: SortOption;
  StandaloneBannerAndSubCardGroup: StandaloneBannerAndSubCardGroup;
  StandaloneBannerGroup: StandaloneBannerGroup;
  StaticLandingDayOfWeekParamInput: StaticLandingDayOfWeekParamInput;
  StaticLandingDayOfWeekSection: StaticLandingDayOfWeekSection;
  StaticLandingDayOfWeekSectionParam: StaticLandingDayOfWeekSectionParam;
  StaticLandingEventParamInput: StaticLandingEventParamInput;
  StaticLandingEventSection: StaticLandingEventSection;
  StaticLandingEventSectionParam: StaticLandingEventSectionParam;
  StaticLandingFreeSeriesParamInput: StaticLandingFreeSeriesParamInput;
  StaticLandingFreeSeriesSection: StaticLandingFreeSeriesSection;
  StaticLandingFreeSeriesSectionParam: StaticLandingFreeSeriesSectionParam;
  StaticLandingGenreParamInput: StaticLandingGenreParamInput;
  StaticLandingGenreSection: StaticLandingGenreSection;
  StaticLandingGenreSectionParam: StaticLandingGenreSectionParam;
  StaticLandingOriginalParamInput: StaticLandingOriginalParamInput;
  StaticLandingOriginalSection: StaticLandingOriginalSection;
  StaticLandingOriginalSectionParam: StaticLandingOriginalSectionParam;
  StaticLandingRankingParamInput: StaticLandingRankingParamInput;
  StaticLandingRankingSection: StaticLandingRankingSection;
  StaticLandingRankingSectionParam: StaticLandingRankingSectionParam;
  StaticLandingTodayNewParamInput: StaticLandingTodayNewParamInput;
  StaticLandingTodayNewSection: StaticLandingTodayNewSection;
  StaticLandingTodayNewSectionParam: StaticLandingTodayNewSectionParam;
  StaticLandingTodayUpParamInput: StaticLandingTodayUpParamInput;
  StaticLandingTodayUpSection: StaticLandingTodayUpSection;
  StaticLandingTodayUpSectionParam: StaticLandingTodayUpSectionParam;
  StrategyCategoryGroup: StrategyCategoryGroup;
  StrategyCategorySection: StrategyCategorySection;
  StrategyViewItem: StrategyViewItem;
  String: Scalars['String'];
  SubCardGroup: SubCardGroup;
  SubtabMenu: SubtabMenu;
  TabSection: ResolversParentTypes['DayOfWeekSection'] | ResolversParentTypes['MainRankingSection'];
  TalkDownloadData: TalkDownloadData;
  TalkViewerData: TalkViewerData;
  TastesServiceLang: TastesServiceLang;
  TastesServiceLangItem: TastesServiceLangItem;
  TextViewerContentData: TextViewerContentData;
  TextViewerData: TextViewerData;
  ThemeKeyword: ThemeKeyword;
  ThemeKeywordSection: ResolversParentTypes['ThemeSection'];
  ThemeSection: ThemeSection;
  TicketAvailable: TicketAvailable;
  TicketBuyAndUseMutationInput: TicketBuyAndUseMutationInput;
  TicketBuyAndUseMutationPayload: TicketBuyAndUseMutationPayload;
  TicketBuyItem: TicketBuyItem;
  TicketBuyMutationInput: TicketBuyMutationInput;
  TicketBuyMutationPayload: TicketBuyMutationPayload;
  TicketDetail: TicketDetail;
  TicketFreeMutationInput: TicketFreeMutationInput;
  TicketHistoryBuyExtraSimple: TicketHistoryBuyExtraSimple;
  TicketInSeries: TicketInSeries;
  TicketInfo: TicketInfo;
  TicketInfoApi: TicketInfoApi;
  TicketItemInSeries: TicketItemInSeries;
  TicketMy: TicketMy;
  TicketPurchase: TicketPurchase;
  TicketSeries: TicketSeries;
  TicketSetBuyMutationInput: TicketSetBuyMutationInput;
  TicketSetBuyMutationPayload: TicketSetBuyMutationPayload;
  TicketSingle: TicketSingle;
  TicketSum: TicketSum;
  TicketUseMutationInput: TicketUseMutationInput;
  TicketUseMutationPayload: TicketUseMutationPayload;
  TodayGift: TodayGift;
  TodayGiftList: TodayGiftList;
  TodaySeriesGroup: TodaySeriesGroup;
  TopSection: TopSection;
  TranslateProperty: TranslateProperty;
  TvPointAgreement: TvPointAgreement;
  UnknownGroup: UnknownGroup;
  UnknownItem: UnknownItem;
  UnknownSection: UnknownSection;
  UnregisterUserStatusPayload: UnregisterUserStatusPayload;
  UpdateNicknameInput: UpdateNicknameInput;
  UpdateNicknamePayload: UpdateNicknamePayload;
  UpdateReceiptInfoInput: UpdateReceiptInfoInput;
  UsedTicket: UsedTicket;
  User: User;
  UserAndCashPayload: UserAndCashPayload;
  UserBasedRecommendSection: UserBasedRecommendSection;
  UserCash: UserCash;
  UserCashDetail: UserCashDetail;
  ViewImpContents: ViewImpContents;
  ViewerData: ResolversParentTypes['ImageViewerData'] | ResolversParentTypes['TalkViewerData'] | ResolversParentTypes['TextViewerData'] | ResolversParentTypes['VodViewerData'];
  ViewerEnd: ViewerEnd;
  ViewerEndComment: ViewerEndComment;
  ViewerEndInput: ViewerEndInput;
  ViewerInfo: ViewerInfo;
  ViewerLastPageMutationInput: ViewerLastPageMutationInput;
  ViewerOpenPageMutationInput: ViewerOpenPageMutationInput;
  VodDownloadData: VodDownloadData;
  VodToken: VodToken;
  VodViewerData: VodViewerData;
  WaitfreeTicket: WaitfreeTicket;
  Welcome: Welcome;
  WelcomeButtonInfo: WelcomeButtonInfo;
  WelcomeInfo: WelcomeInfo;
  WelcomeRecommendContents: WelcomeRecommendContents;
  WelcomeRecommendItem: WelcomeRecommendItem;
  WriteCommentInput: WriteCommentInput;
  WriteCommentPayload: WriteCommentPayload;
};

export type ActivateUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivateUser'] = ResolversParentTypes['ActivateUser']> = {
  requestExpireTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgeAuthResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgeAuth'] = ResolversParentTypes['AgeAuth']> = {
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  authenticatedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  bypassAgeLimit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreedAgreementResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreedAgreement'] = ResolversParentTypes['AgreedAgreement']> = {
  agreedDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  isAgreed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AgreementType'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Agreement'] = ResolversParentTypes['Agreement']> = {
  isRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['AgreementType'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementContainerResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementContainer'] = ResolversParentTypes['AgreementContainer']> = {
  itemList?: Resolver<Array<ResolversTypes['Agreement']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementInfo'] = ResolversParentTypes['AgreementInfo']> = {
  agreement?: Resolver<ResolversTypes['AgreementContainer'], ParentType, ContextType>;
  agreementUnder14?: Resolver<Maybe<ResolversTypes['AgreementUnder14Container']>, ParentType, ContextType>;
  isRegistered?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementUnder14ContainerResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementUnder14Container'] = ResolversParentTypes['AgreementUnder14Container']> = {
  atLeast14AgeType?: Resolver<ResolversTypes['AgreementType'], ParentType, ContextType>;
  itemList?: Resolver<Array<ResolversTypes['Agreement']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AlarmSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['AlarmSection'] = ResolversParentTypes['AlarmSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnnouncementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Announcement'] = ResolversParentTypes['Announcement']> = {
  contents?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createDt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnnouncementContainerResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnnouncementContainer'] = ResolversParentTypes['AnnouncementContainer']> = {
  items?: Resolver<Array<ResolversTypes['Announcement']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppBadgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppBadge'] = ResolversParentTypes['AppBadge']> = {
  giftLastAddedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  myNewsLastAddedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  noticeLastAddedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppConfig'] = ResolversParentTypes['AppConfig']> = {
  appBadge?: Resolver<Maybe<ResolversTypes['AppBadge']>, ParentType, ContextType>;
  appInit?: Resolver<Maybe<ResolversTypes['AppInit']>, ParentType, ContextType>;
  appSetting?: Resolver<Maybe<ResolversTypes['AppSetting']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppInitResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppInit'] = ResolversParentTypes['AppInit']> = {
  certType?: Resolver<Maybe<ResolversTypes['CertType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppSettingResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppSetting'] = ResolversParentTypes['AppSetting']> = {
  tastesGenre?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tastesHome?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tastesServiceLang?: Resolver<Maybe<ResolversTypes['TastesServiceLang']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppSettingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppSettingPayload'] = ResolversParentTypes['AppSettingPayload']> = {
  status?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AssetPropertyResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssetProperty'] = ResolversParentTypes['AssetProperty']> = {
  bannerImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bannerSet?: Resolver<Maybe<ResolversTypes['BannerSet']>, ParentType, ContextType>;
  cardCover?: Resolver<Maybe<ResolversTypes['CardCover']>, ParentType, ContextType>;
  cardImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardSet?: Resolver<Maybe<ResolversTypes['CardSet']>, ParentType, ContextType>;
  cardTextImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cleanImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ipxVideo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthInfo'] = ResolversParentTypes['AuthInfo']> = {
  age?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthRequestInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthRequestInfo'] = ResolversParentTypes['AuthRequestInfo']> = {
  authUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthRequestInfoErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AuthRequestInfoError'] = ResolversParentTypes['AuthRequestInfoError']> = {
  __resolveType: TypeResolveFn<'ReqInfoNotExist', ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AuthorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Author'] = ResolversParentTypes['Author']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  roleDisplayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AuthorsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Authors'] = ResolversParentTypes['Authors']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  illustrator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalAuthor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  plan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  production?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reviewer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sound?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  translator?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  video?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  writer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutoCompleteItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutoCompleteItem'] = ResolversParentTypes['AutoCompleteItem']> = {
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AutomaticEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['AutomaticEvent'] = ResolversParentTypes['AutomaticEvent']> = {
  destinationInfoIos?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationInfoWeb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationTypeAndroid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationTypeIos?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemOrder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resourceHeight?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resourceUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resourceWidth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  schemeAndroid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schemeIos?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schemeWeb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BankCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankCode'] = ResolversParentTypes['BankCode']> = {
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BannerItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['BannerItem'] = ResolversParentTypes['BannerItem']> = {
  altText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeList?: Resolver<Array<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  bannerType?: Resolver<ResolversTypes['BannerType'], ParentType, ContextType>;
  bannerViewType?: Resolver<ResolversTypes['BannerViewType'], ParentType, ContextType>;
  caption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  characterImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountRateText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['EventLog']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metaList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  seriesId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  serviceProperty?: Resolver<Maybe<ResolversTypes['ServiceProperty']>, ParentType, ContextType>;
  statusBadge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  videoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BannerSetResolvers<ContextType = any, ParentType extends ResolversParentTypes['BannerSet'] = ResolversParentTypes['BannerSet']> = {
  backgroundColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mainImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BigBannerGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['BigBannerGroup'] = ResolversParentTypes['BigBannerGroup']> = {
  bannerViewType?: Resolver<ResolversTypes['BannerViewType'], ParentType, ContextType>;
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BigBannerSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BigBannerSection'] = ResolversParentTypes['BigBannerSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface BigIntScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BigInt'], any> {
  name: 'BigInt';
}

export type BlockUserListResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlockUserList'] = ResolversParentTypes['BlockUserList']> = {
  list?: Resolver<Array<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyCashHistoryListResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyCashHistoryList'] = ResolversParentTypes['BuyCashHistoryList']> = {
  banner?: Resolver<Maybe<ResolversTypes['HistoryLineBanner']>, ParentType, ContextType>;
  expiredCredit?: Resolver<Maybe<ResolversTypes['ExpiredCredit']>, ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['History']>, ParentType, ContextType>;
  paging?: Resolver<Maybe<ResolversTypes['Paging']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuyHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['BuyHistory'] = ResolversParentTypes['BuyHistory']> = {
  createdDt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  isRefundable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  saleType?: Resolver<Maybe<ResolversTypes['SaleType']>, ParentType, ContextType>;
  ticketKind?: Resolver<Maybe<ResolversTypes['TicketKind']>, ParentType, ContextType>;
  ticketType?: Resolver<Maybe<ResolversTypes['TicketType']>, ParentType, ContextType>;
  ticketUid?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardCoverResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardCover'] = ResolversParentTypes['CardCover']> = {
  coverImg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  coverRestricted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardSection'] = ResolversParentTypes['CardSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecommendArea?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isRecommendedItems?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardSetResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardSet'] = ResolversParentTypes['CardSet']> = {
  backgroundColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardViewGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardViewGroup'] = ResolversParentTypes['CardViewGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['ListViewGroupMeta']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CardViewItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardViewItem'] = ResolversParentTypes['CardViewItem']> = {
  ageGrade?: Resolver<ResolversTypes['AgeGrade'], ParentType, ContextType>;
  ageGradeBadge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  altText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  backgroundColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeList?: Resolver<Array<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  caption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cardCover?: Resolver<Maybe<ResolversTypes['CardCover']>, ParentType, ContextType>;
  categoryType?: Resolver<Maybe<ResolversTypes['CategoryType']>, ParentType, ContextType>;
  discountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountRateText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['EventLog']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isBook?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEventBanner?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLegacy?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  rank?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rankVariation?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selfCensorship?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  statusBadge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  subtitleList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CashResolvers<ContextType = any, ParentType extends ResolversParentTypes['Cash'] = ResolversParentTypes['Cash']> = {
  discountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  setDiscountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CashFriendsSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['CashFriendsSection'] = ResolversParentTypes['CashFriendsSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CategorySelectedDayPairResolvers<ContextType = any, ParentType extends ResolversParentTypes['CategorySelectedDayPair'] = ResolversParentTypes['CategorySelectedDayPair']> = {
  categoryTabUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  dayTabUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CharacterResolvers<ContextType = any, ParentType extends ResolversParentTypes['Character'] = ResolversParentTypes['Character']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckUnregisterResolvers<ContextType = any, ParentType extends ResolversParentTypes['CheckUnregister'] = ResolversParentTypes['CheckUnregister']> = {
  hasPaidCash?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPaidTickets?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  paidCashAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CleanViewGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['CleanViewGroup'] = ResolversParentTypes['CleanViewGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CleanViewItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CleanViewItem'] = ResolversParentTypes['CleanViewItem']> = {
  ageGrade?: Resolver<ResolversTypes['AgeGrade'], ParentType, ContextType>;
  ageGradeBadge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  badgeList?: Resolver<Array<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  discountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountRateText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['EventLog']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rank?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selfCensorship?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  showPlayerIcon?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  statusBadge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  subtitleList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClickLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClickLog'] = ResolversParentTypes['ClickLog']> = {
  copy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imp_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imp_provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  layer1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  layer2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ordnum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  setnum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommentCommonPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommentCommonPayload'] = ResolversParentTypes['CommentCommonPayload']> = {
  recordid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommentItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommentItem'] = ResolversParentTypes['CommentItem']> = {
  blocked?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commentStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commentType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commentUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createDt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  emoticon?: Resolver<Maybe<ResolversTypes['Emoticon']>, ParentType, ContextType>;
  expose?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hidden?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isBest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSpoiler?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  likeCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  liked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  live?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  myReplyCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  orderValue?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  parentUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  replyCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seriesId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userThumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CommentListResolvers<ContextType = any, ParentType extends ResolversParentTypes['CommentList'] = ResolversParentTypes['CommentList']> = {
  bestTotalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  commentList?: Resolver<Array<ResolversTypes['CommentItem']>, ParentType, ContextType>;
  isEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  selectedSortOpt?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  sortOptList?: Resolver<Maybe<Array<Maybe<ResolversTypes['SortOption']>>>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentBuyTicketPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentBuyTicketPage'] = ResolversParentTypes['ContentBuyTicketPage']> = {
  bannerList?: Resolver<Array<ResolversTypes['SimpleImageBanner']>, ParentType, ContextType>;
  ticketInfo?: Resolver<Maybe<ResolversTypes['ContentTicketInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentCheckFreeTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentCheckFreeTicket'] = ResolversParentTypes['ContentCheckFreeTicket']> = {
  list?: Resolver<Array<ResolversTypes['TicketSum']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentDetail'] = ResolversParentTypes['ContentDetail']> = {
  ageGrade?: Resolver<Maybe<ResolversTypes['AgeGrade']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  publisherName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rank?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retailPrice?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentHomeAboutResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentHomeAbout'] = ResolversParentTypes['ContentHomeAbout']> = {
  authorList?: Resolver<Array<ResolversTypes['Author']>, ParentType, ContextType>;
  characterList?: Resolver<Maybe<Array<Maybe<ResolversTypes['Character']>>>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  detail?: Resolver<Maybe<ResolversTypes['ContentDetail']>, ParentType, ContextType>;
  detailInfoList?: Resolver<Maybe<Array<ResolversTypes['ContentHomeDetailInfo']>>, ParentType, ContextType>;
  guideTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  screenshotList?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  themeKeywordList?: Resolver<Array<ResolversTypes['ThemeKeyword']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentHomeBriefListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentHomeBriefList'] = ResolversParentTypes['ContentHomeBriefList']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['SingleListViewItem']>, ParentType, ContextType>;
  seriesId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentHomeDetailInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentHomeDetailInfo'] = ResolversParentTypes['ContentHomeDetailInfo']> = {
  info?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentHomeInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentHomeInfo'] = ResolversParentTypes['ContentHomeInfo']> = {
  about?: Resolver<Maybe<ResolversTypes['ContentHomeAbout']>, ParentType, ContextType>;
  recommend?: Resolver<Maybe<ResolversTypes['ContentHomeRecommend']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentHomeInfoRankingLandingResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentHomeInfoRankingLanding'] = ResolversParentTypes['ContentHomeInfoRankingLanding']> = {
  rank?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentHomeLabelBadgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentHomeLabelBadge'] = ResolversParentTypes['ContentHomeLabelBadge']> = {
  badgeType?: Resolver<Maybe<ResolversTypes['ContentHomeBadgeType']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentHomeNoticeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentHomeNotice'] = ResolversParentTypes['ContentHomeNotice']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineBannerList?: Resolver<Array<ResolversTypes['LineBannerItem']>, ParentType, ContextType>;
  noticeListContainer?: Resolver<Maybe<ResolversTypes['SeriesNoticeListContainer']>, ParentType, ContextType>;
  relatedEventList?: Resolver<Array<ResolversTypes['RecommendEvent']>, ParentType, ContextType>;
  seriesId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  topNotice?: Resolver<Maybe<ResolversTypes['SeriesNotice']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentHomeOverviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentHomeOverview'] = ResolversParentTypes['ContentHomeOverview']> = {
  content?: Resolver<Maybe<ResolversTypes['Series']>, ParentType, ContextType>;
  displayAd?: Resolver<Maybe<ResolversTypes['DisplayAd']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastNoticeDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  relatedSeries?: Resolver<Maybe<ResolversTypes['Series']>, ParentType, ContextType>;
  seriesId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  setList?: Resolver<Maybe<Array<Maybe<ResolversTypes['NormalListViewItem']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentHomeRecommendResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentHomeRecommend'] = ResolversParentTypes['ContentHomeRecommend']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['ContentRecommendGroup']>, ParentType, ContextType>;
  seriesId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentMyTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentMyTicket'] = ResolversParentTypes['ContentMyTicket']> = {
  notOwnCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notReadCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ticketOwnCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ticketRentalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  waitfree?: Resolver<Maybe<ResolversTypes['ContentWaitfreeInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentRecommendGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentRecommendGroup'] = ResolversParentTypes['ContentRecommendGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  impLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentSetListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentSetList'] = ResolversParentTypes['ContentSetList']> = {
  setList?: Resolver<Maybe<Array<ResolversTypes['NormalListViewItem']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentSetOverviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentSetOverview'] = ResolversParentTypes['ContentSetOverview']> = {
  productList?: Resolver<Maybe<Array<Maybe<ResolversTypes['PosterViewItem']>>>, ParentType, ContextType>;
  series?: Resolver<Maybe<ResolversTypes['Series']>, ParentType, ContextType>;
  set?: Resolver<Maybe<ResolversTypes['Set']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentTicketHistoryBuyResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentTicketHistoryBuy'] = ResolversParentTypes['ContentTicketHistoryBuy']> = {
  isEnd?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<ResolversTypes['BuyHistory']>>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentTicketHistoryBuyDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentTicketHistoryBuyDetail'] = ResolversParentTypes['ContentTicketHistoryBuyDetail']> = {
  availableAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  createdDt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  expiredAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isSet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  list?: Resolver<Maybe<Array<ResolversTypes['TicketHistoryBuyExtraSimple']>>, ParentType, ContextType>;
  payId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ticketType?: Resolver<Maybe<ResolversTypes['TicketType']>, ParentType, ContextType>;
  ticketTypeText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentTicketInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentTicketInfo'] = ResolversParentTypes['ContentTicketInfo']> = {
  isSaleOwnTicket?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSaleRentalTicket?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  purchasableOwnTicketList?: Resolver<Array<ResolversTypes['TicketInfoApi']>, ParentType, ContextType>;
  purchasableRentalTicketList?: Resolver<Array<ResolversTypes['TicketInfoApi']>, ParentType, ContextType>;
  rentalPeriodByMinute?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContentWaitfreeInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContentWaitfreeInfo'] = ResolversParentTypes['ContentWaitfreeInfo']> = {
  activation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  baseDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  chargedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  chargedComplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  chargedPeriodByMinute?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ContinueInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ContinueInfo'] = ResolversParentTypes['ContinueInfo']> = {
  continueProductType?: Resolver<Maybe<ResolversTypes['ContinueProductType']>, ParentType, ContextType>;
  hasNewSingle?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasUnreadSingle?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isFree?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastReadProductId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  scheme?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomPropsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CustomProps'] = ResolversParentTypes['CustomProps']> = {
  banner_uid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  content_cnt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  event_layer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  event_series_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  event_ticket_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  helix_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  helix_seed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  helix_yn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  landing_path?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  play_url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rec_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  section_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  view_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export type DayOfWeekLayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['DayOfWeekLayout'] = ResolversParentTypes['DayOfWeekLayout']> = {
  dayList?: Resolver<Array<ResolversTypes['FilterOption']>, ParentType, ContextType>;
  referenceList?: Resolver<Array<ResolversTypes['FilterOption']>, ParentType, ContextType>;
  selectedDay?: Resolver<ResolversTypes['FilterOption'], ParentType, ContextType>;
  selectedReference?: Resolver<ResolversTypes['FilterOption'], ParentType, ContextType>;
  selectedSort?: Resolver<ResolversTypes['FilterOption'], ParentType, ContextType>;
  sortList?: Resolver<Array<ResolversTypes['FilterOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DayOfWeekListResolvers<ContextType = any, ParentType extends ResolversParentTypes['DayOfWeekList'] = ResolversParentTypes['DayOfWeekList']> = {
  banner?: Resolver<Maybe<ResolversTypes['BannerItem']>, ParentType, ContextType>;
  isEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['CardViewItem']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DayOfWeekSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DayOfWeekSection'] = ResolversParentTypes['DayOfWeekSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sectionMainTabList?: Resolver<Maybe<Array<ResolversTypes['SectionMainTab']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeclareCommonPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeclareCommonPayload'] = ResolversParentTypes['DeclareCommonPayload']> = {
  landingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteInvenPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeleteInvenPayload'] = ResolversParentTypes['DeleteInvenPayload']> = {
  status?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DependOnLoggedInSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DependOnLoggedInSection'] = ResolversParentTypes['DependOnLoggedInSection']> = {
  __resolveType: TypeResolveFn<'RecentViewedSection', ParentType, ContextType>;
  loggedInScheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loggedInTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type DeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Device'] = ResolversParentTypes['Device']> = {
  createdDt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  deviceModel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deviceUid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isCurrentDevice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lastUsedDt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceInfo'] = ResolversParentTypes['DeviceInfo']> = {
  deviceLimitCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  deviceList?: Resolver<Array<ResolversTypes['Device']>, ParentType, ContextType>;
  deviceReplaceableCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeviceStatusPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeviceStatusPayload'] = ResolversParentTypes['DeviceStatusPayload']> = {
  status?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisplayAdResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisplayAd'] = ResolversParentTypes['DisplayAd']> = {
  bannerUid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  momentUid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sectionUid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  treviUid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisplayAdGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisplayAdGroup'] = ResolversParentTypes['DisplayAdGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisplayAdItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisplayAdItem'] = ResolversParentTypes['DisplayAdItem']> = {
  displayAd?: Resolver<ResolversTypes['DisplayAd'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisplayAdSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisplayAdSection'] = ResolversParentTypes['DisplayAdSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DkpgRequestPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DkpgRequestPayload'] = ResolversParentTypes['DkpgRequestPayload']> = {
  status?: Resolver<Maybe<ResolversTypes['ResultStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DrawGotchaPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DrawGotchaPayload'] = ResolversParentTypes['DrawGotchaPayload']> = {
  expireDateText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receiveDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  spinWheelDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['GotchaStatus']>, ParentType, ContextType>;
  winPrize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  winPrizeType?: Resolver<Maybe<ResolversTypes['WinPrizeType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DrmInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['DrmInfo'] = ResolversParentTypes['DrmInfo']> = {
  assertion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fairplayCertificateUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fairplayLicenseUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  serverType?: Resolver<Maybe<ResolversTypes['DrmServerType']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['DrmType']>, ParentType, ContextType>;
  widevineLicenseUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DynamicLayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['DynamicLayout'] = ResolversParentTypes['DynamicLayout']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DynamicLayoutReferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['DynamicLayoutReference'] = ResolversParentTypes['DynamicLayoutReference']> = {
  dynamicLayout?: Resolver<Maybe<ResolversTypes['DynamicLayout']>, ParentType, ContextType>;
  layoutReference?: Resolver<Maybe<Array<ResolversTypes['LayoutReferenceViewData']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmoticonResolvers<ContextType = any, ParentType extends ResolversParentTypes['Emoticon'] = ResolversParentTypes['Emoticon']> = {
  itemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  itemSubType?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  itemVer?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resourceId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EpisodeSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EpisodeSection'] = ResolversParentTypes['EpisodeSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventBannerGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventBannerGroup'] = ResolversParentTypes['EventBannerGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventBannerItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventBannerItem'] = ResolversParentTypes['EventBannerItem']> = {
  badgeList?: Resolver<Array<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  bannerType?: Resolver<ResolversTypes['BannerType'], ParentType, ContextType>;
  bannerViewType?: Resolver<ResolversTypes['BannerViewType'], ParentType, ContextType>;
  caption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['EventLog']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusBadge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  subtitleList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  videoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventLog'] = ResolversParentTypes['EventLog']> = {
  click?: Resolver<Maybe<ResolversTypes['ClickLog']>, ParentType, ContextType>;
  customProps?: Resolver<Maybe<ResolversTypes['CustomProps']>, ParentType, ContextType>;
  eventMeta?: Resolver<Maybe<ResolversTypes['EventMeta']>, ParentType, ContextType>;
  fromGraphql?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  viewimp_contents?: Resolver<Maybe<ResolversTypes['ViewImpContents']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventMeta'] = ResolversParentTypes['EventMeta']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  series?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  series_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subcategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['EventSection'] = ResolversParentTypes['EventSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExpiredCreditResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExpiredCredit'] = ResolversParentTypes['ExpiredCredit']> = {
  expiredAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  expiredSum?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FilterOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FilterOption'] = ResolversParentTypes['FilterOption']> = {
  keys?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  param?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  translateProperty?: Resolver<Maybe<ResolversTypes['TranslateProperty']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FontResolvers<ContextType = any, ParentType extends ResolversParentTypes['Font'] = ResolversParentTypes['Font']> = {
  flag?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  target?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GetEventInfoPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GetEventInfoPayload'] = ResolversParentTypes['GetEventInfoPayload']> = {
  agreed?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  appUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentInfoList?: Resolver<Maybe<Array<ResolversTypes['AutomaticEvent']>>, ParentType, ContextType>;
  eventId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  eventTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  head?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isNeedUpdate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orgCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resultCode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stoken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GlobalAgreementInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalAgreementInfo'] = ResolversParentTypes['GlobalAgreementInfo']> = {
  agreement?: Resolver<ResolversTypes['AgreementContainer'], ParentType, ContextType>;
  isRegistered?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GlobalParentVerificationIsCompletedResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalParentVerificationIsCompleted'] = ResolversParentTypes['GlobalParentVerificationIsCompleted']> = {
  isCompleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GlobalSendParentVerifyPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalSendParentVerifyPayload'] = ResolversParentTypes['GlobalSendParentVerifyPayload']> = {
  verifyUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GlobalSignupPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalSignupPayload'] = ResolversParentTypes['GlobalSignupPayload']> = {
  refreshToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  responseTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serverToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['GlobalUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GlobalUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['GlobalUser'] = ResolversParentTypes['GlobalUser']> = {
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  memberId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nickname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profileThumbnailUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userCommentBlockMsg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GotchaInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['GotchaInfo'] = ResolversParentTypes['GotchaInfo']> = {
  adLocId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bannerAdLocId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  belowDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bgColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bgImg?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  buttonColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  buttonImg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entryType?: Resolver<Maybe<ResolversTypes['GotchaEntryType']>, ParentType, ContextType>;
  expireDateText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extBannerImg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  extBannerLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gotchaId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  receiveDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  resultImg?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spinWheelDesc?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spinWheelImgs?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  spinWheelReadyImgs?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['GotchaStatus'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  topTitleImg?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['GotchaType']>, ParentType, ContextType>;
  winPrize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  winPrizeType?: Resolver<Maybe<ResolversTypes['WinPrizeType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['Group'] = ResolversParentTypes['Group']> = {
  __resolveType: TypeResolveFn<'BigBannerGroup' | 'CardViewGroup' | 'CleanViewGroup' | 'ContentRecommendGroup' | 'DisplayAdGroup' | 'EventBannerGroup' | 'HorizontalScrollGroup' | 'LineBannerGroup' | 'ListViewGroup' | 'MainRankingListViewGroup' | 'OnAirGroup' | 'PosterViewGroup' | 'PromotionBannerGroup' | 'ResponsiveBannerGroup' | 'StandaloneBannerAndSubCardGroup' | 'StandaloneBannerGroup' | 'StrategyCategoryGroup' | 'SubCardGroup' | 'TodaySeriesGroup' | 'UnknownGroup', ParentType, ContextType>;
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
};

export type HelixSeriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['HelixSeries'] = ResolversParentTypes['HelixSeries']> = {
  ageGrade?: Resolver<Maybe<ResolversTypes['AgeGrade']>, ParentType, ContextType>;
  ageGradeBadge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  badgeList?: Resolver<Array<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['EventLog']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  itemOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scheme?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  selfCensorship?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  seriesId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  subCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  thumbnailUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ticketCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  viewCount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HelixSeriesListResolvers<ContextType = any, ParentType extends ResolversParentTypes['HelixSeriesList'] = ResolversParentTypes['HelixSeriesList']> = {
  ageGradeNum?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['HelixSeries']>, ParentType, ContextType>;
  nickname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  notification?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  selfCensorship?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  seriesId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  seriesThumbnailUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seriesTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['HelixSeriesStatus'], ParentType, ContextType>;
  ticketExpireDt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HelixThemeSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['HelixThemeSection'] = ResolversParentTypes['HelixThemeSection']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecommendArea?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  metaInfoType?: Resolver<Maybe<ResolversTypes['MetaInfoType']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HelixTodayGiftListResolvers<ContextType = any, ParentType extends ResolversParentTypes['HelixTodayGiftList'] = ResolversParentTypes['HelixTodayGiftList']> = {
  helixGiftTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['NormalListViewItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['History'] = ResolversParentTypes['History']> = {
  createDt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  creditMasterId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  detailText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detailText2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayDt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  expiredAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  extraLabelType?: Resolver<Maybe<ResolversTypes['ExtraLabelType']>, ParentType, ContextType>;
  historyType?: Resolver<ResolversTypes['HistoryType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  priceColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  purchasedItem?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purchasedItemColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  remainDays?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seriesId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HistoryLineBannerResolvers<ContextType = any, ParentType extends ResolversParentTypes['HistoryLineBanner'] = ResolversParentTypes['HistoryLineBanner']> = {
  bannerType?: Resolver<ResolversTypes['HistoryLineBannerType'], ParentType, ContextType>;
  bgColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HistoryListResolvers<ContextType = any, ParentType extends ResolversParentTypes['HistoryList'] = ResolversParentTypes['HistoryList']> = {
  expiredCredit?: Resolver<Maybe<ResolversTypes['ExpiredCredit']>, ParentType, ContextType>;
  isEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['History']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HorizontalScrollGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['HorizontalScrollGroup'] = ResolversParentTypes['HorizontalScrollGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImageDownloadDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImageDownloadData'] = ResolversParentTypes['ImageDownloadData']> = {
  files?: Resolver<Array<ResolversTypes['ImageDownloadFile']>, ParentType, ContextType>;
  gapBetweenImages?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  readType?: Resolver<ResolversTypes['ReadType'], ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalSize?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  viewDirection?: Resolver<ResolversTypes['ViewDirection'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImageDownloadFileResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImageDownloadFile'] = ResolversParentTypes['ImageDownloadFile']> = {
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  no?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  secureUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ImageViewerDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ImageViewerData'] = ResolversParentTypes['ImageViewerData']> = {
  imageDownloadData?: Resolver<ResolversTypes['ImageDownloadData'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ViewerDataType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvenListResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvenList'] = ResolversParentTypes['InvenList']> = {
  catOptList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  displayAd?: Resolver<Maybe<ResolversTypes['DisplayAd']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['NormalListViewItem']>, ParentType, ContextType>;
  selectedCatOpt?: Resolver<ResolversTypes['SortOption'], ParentType, ContextType>;
  selectedSortOpt?: Resolver<ResolversTypes['SortOption'], ParentType, ContextType>;
  sortOptList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvenMyInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvenMyInfo'] = ResolversParentTypes['InvenMyInfo']> = {
  displayAd?: Resolver<Maybe<ResolversTypes['DisplayAd']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  myInfo?: Resolver<ResolversTypes['MyInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvenRecommendListResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvenRecommendList'] = ResolversParentTypes['InvenRecommendList']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['PosterViewItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['Item'] = ResolversParentTypes['Item']> = {
  __resolveType: TypeResolveFn<'BannerItem' | 'CardViewItem' | 'CleanViewItem' | 'DisplayAdItem' | 'EventBannerItem' | 'LineBannerItem' | 'MoreItem' | 'NormalListViewItem' | 'OnAirItem' | 'PosterViewItem' | 'PromotionBannerItem' | 'PromotionCardViewItem' | 'RankingListViewItem' | 'SingleListViewItem' | 'StrategyViewItem' | 'UnknownItem', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
};

export type ItemBannerResolvers<ContextType = any, ParentType extends ResolversParentTypes['ItemBanner'] = ResolversParentTypes['ItemBanner']> = {
  adLocId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  adTrackingId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bgcolor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destination?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  destinationType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  expireDt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  image?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageHeight?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageWidth?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  impId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheme?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type KakaoCashReportDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['KakaoCashReportData'] = ResolversParentTypes['KakaoCashReportData']> = {
  amount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  creditMasterId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  creditStatus?: Resolver<Maybe<ResolversTypes['CreditStatus']>, ParentType, ContextType>;
  displayDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiredAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paymentMethod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purchasedItem?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  serviceEventName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LastViewInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['LastViewInfo'] = ResolversParentTypes['LastViewInfo']> = {
  isDone?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastViewDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  spineIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['Layout'] = ResolversParentTypes['Layout']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  screenUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sections?: Resolver<Array<ResolversTypes['Section']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LayoutType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LayoutReferenceViewDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['LayoutReferenceViewData'] = ResolversParentTypes['LayoutReferenceViewData']> = {
  dataKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegacySingleResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacySingle'] = ResolversParentTypes['LegacySingle']> = {
  ageGrade?: Resolver<Maybe<ResolversTypes['AgeGrade']>, ParentType, ContextType>;
  isFree?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  slideType?: Resolver<ResolversTypes['SlideType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LikeCommentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['LikeCommentPayload'] = ResolversParentTypes['LikeCommentPayload']> = {
  likeCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  recordid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LineBannerGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['LineBannerGroup'] = ResolversParentTypes['LineBannerGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LineBannerItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['LineBannerItem'] = ResolversParentTypes['LineBannerItem']> = {
  bgColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['EventLog']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rightImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LineBannerSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['LineBannerSection'] = ResolversParentTypes['LineBannerSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListViewGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListViewGroup'] = ResolversParentTypes['ListViewGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['ListViewGroupMeta']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListViewGroupMetaResolvers<ContextType = any, ParentType extends ResolversParentTypes['ListViewGroupMeta'] = ResolversParentTypes['ListViewGroupMeta']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocaleMapResolvers<ContextType = any, ParentType extends ResolversParentTypes['LocaleMap'] = ResolversParentTypes['LocaleMap']> = {
  en?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ko?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  th?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface LongScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Long'], any> {
  name: 'Long';
}

export type MainRankingListViewGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainRankingListViewGroup'] = ResolversParentTypes['MainRankingListViewGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MainRankingSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MainRankingSection'] = ResolversParentTypes['MainRankingSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sectionMainTabList?: Resolver<Maybe<Array<ResolversTypes['SectionMainTab']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MenuResolvers<ContextType = any, ParentType extends ResolversParentTypes['Menu'] = ResolversParentTypes['Menu']> = {
  __resolveType: TypeResolveFn<'SubtabMenu', ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MenuType'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type MetaInfoTypeSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['MetaInfoTypeSection'] = ResolversParentTypes['MetaInfoTypeSection']> = {
  __resolveType: TypeResolveFn<'HelixThemeSection' | 'RecentViewedSection' | 'ScrollThemeSection' | 'ThemeSection', ParentType, ContextType>;
  metaInfoType?: Resolver<Maybe<ResolversTypes['MetaInfoType']>, ParentType, ContextType>;
};

export type MoreItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['MoreItem'] = ResolversParentTypes['MoreItem']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPosterView?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  addDevice?: Resolver<ResolversTypes['DeviceStatusPayload'], ParentType, ContextType, RequireFields<MutationAddDeviceArgs, 'deviceModel'>>;
  appSetting?: Resolver<ResolversTypes['AppSettingPayload'], ParentType, ContextType, RequireFields<MutationAppSettingArgs, 'input'>>;
  blockUser?: Resolver<ResolversTypes['CommentCommonPayload'], ParentType, ContextType, RequireFields<MutationBlockUserArgs, 'blockUserInput'>>;
  buyAndUseTicket?: Resolver<ResolversTypes['TicketBuyAndUseMutationPayload'], ParentType, ContextType, RequireFields<MutationBuyAndUseTicketArgs, 'input'>>;
  buyTicket?: Resolver<ResolversTypes['TicketBuyMutationPayload'], ParentType, ContextType, RequireFields<MutationBuyTicketArgs, 'input'>>;
  changeEmailPassword?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType, RequireFields<MutationChangeEmailPasswordArgs, 'input'>>;
  checkEmailVerifyCode?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType, RequireFields<MutationCheckEmailVerifyCodeArgs, 'checkEmailVerifyCodeInput'>>;
  declareComment?: Resolver<ResolversTypes['DeclareCommonPayload'], ParentType, ContextType, RequireFields<MutationDeclareCommentArgs, 'declareCommentInput'>>;
  deleteDevice?: Resolver<ResolversTypes['DeviceStatusPayload'], ParentType, ContextType, RequireFields<MutationDeleteDeviceArgs, 'deviceUid'>>;
  deleteInvenLike?: Resolver<ResolversTypes['DeleteInvenPayload'], ParentType, ContextType, RequireFields<MutationDeleteInvenLikeArgs, 'seriesIdList'>>;
  deleteInvenPaid?: Resolver<ResolversTypes['DeleteInvenPayload'], ParentType, ContextType, RequireFields<MutationDeleteInvenPaidArgs, 'seriesIdList'>>;
  deleteInvenRecent?: Resolver<ResolversTypes['DeleteInvenPayload'], ParentType, ContextType, RequireFields<MutationDeleteInvenRecentArgs, 'seriesIdList'>>;
  deleteReceiptInfo?: Resolver<ResolversTypes['ReceiptInfoStatusPayload'], ParentType, ContextType>;
  drawGotcha?: Resolver<ResolversTypes['DrawGotchaPayload'], ParentType, ContextType, RequireFields<MutationDrawGotchaArgs, 'input'>>;
  getEventInfo?: Resolver<ResolversTypes['GetEventInfoPayload'], ParentType, ContextType, RequireFields<MutationGetEventInfoArgs, 'input'>>;
  globalCheckParentVerify?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType, RequireFields<MutationGlobalCheckParentVerifyArgs, 'input'>>;
  globalEmailSignup?: Resolver<ResolversTypes['GlobalSignupPayload'], ParentType, ContextType, RequireFields<MutationGlobalEmailSignupArgs, 'input'>>;
  globalSavePrivate?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType, RequireFields<MutationGlobalSavePrivateArgs, 'input'>>;
  globalSendParentVerify?: Resolver<ResolversTypes['GlobalSendParentVerifyPayload'], ParentType, ContextType, RequireFields<MutationGlobalSendParentVerifyArgs, 'input'>>;
  globalSnsSignup?: Resolver<ResolversTypes['GlobalSignupPayload'], ParentType, ContextType, RequireFields<MutationGlobalSnsSignupArgs, 'input'>>;
  kakaoBankSelfCertSupportedDevice?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationKakaoBankSelfCertSupportedDeviceArgs, 'input'>>;
  likeComment?: Resolver<ResolversTypes['LikeCommentPayload'], ParentType, ContextType, RequireFields<MutationLikeCommentArgs, 'likeCommentInput'>>;
  openPreview?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType, RequireFields<MutationOpenPreviewArgs, 'input'>>;
  prepareKakaoBankAuthRequestInfo?: Resolver<ResolversTypes['PrepareAuthRequestInfoPayload'], ParentType, ContextType, RequireFields<MutationPrepareKakaoBankAuthRequestInfoArgs, 'input'>>;
  receiveTicketFree?: Resolver<ResolversTypes['TodayGift'], ParentType, ContextType, RequireFields<MutationReceiveTicketFreeArgs, 'input'>>;
  refundRequest?: Resolver<ResolversTypes['RefundRequestPayload'], ParentType, ContextType, RequireFields<MutationRefundRequestArgs, 'input'>>;
  refundTicket?: Resolver<ResolversTypes['RefundTicketStatusPayload'], ParentType, ContextType, RequireFields<MutationRefundTicketArgs, 'ticketUid'>>;
  removeComment?: Resolver<ResolversTypes['CommentCommonPayload'], ParentType, ContextType, RequireFields<MutationRemoveCommentArgs, 'commentUid'>>;
  removeMyNews?: Resolver<ResolversTypes['RemoveMyNewsPayload'], ParentType, ContextType, RequireFields<MutationRemoveMyNewsArgs, 'input'>>;
  rouletteDraw?: Resolver<ResolversTypes['RouletteDrawPayload'], ParentType, ContextType, RequireFields<MutationRouletteDrawArgs, 'input'>>;
  saveAuthInfo?: Resolver<ResolversTypes['SaveAuthInfoPayload'], ParentType, ContextType, RequireFields<MutationSaveAuthInfoArgs, 'input'>>;
  sendEmailVerifyCode?: Resolver<ResolversTypes['SendEmailVerifyCodePayload'], ParentType, ContextType, RequireFields<MutationSendEmailVerifyCodeArgs, 'sendEmailVerifyCodeInput'>>;
  setAgreement?: Resolver<ResolversTypes['SetAgreementPayload'], ParentType, ContextType, RequireFields<MutationSetAgreementArgs, 'input'>>;
  setBuyTicket?: Resolver<ResolversTypes['TicketSetBuyMutationPayload'], ParentType, ContextType, RequireFields<MutationSetBuyTicketArgs, 'input'>>;
  setGlobalAgreement?: Resolver<ResolversTypes['SetGlobalAgreementPayload'], ParentType, ContextType, RequireFields<MutationSetGlobalAgreementArgs, 'input'>>;
  setMyRating?: Resolver<ResolversTypes['SetMyRatingPayload'], ParentType, ContextType, RequireFields<MutationSetMyRatingArgs, 'setMyRatingInput'>>;
  setSeriesAlarm?: Resolver<ResolversTypes['SetSeriesAlarmPayload'], ParentType, ContextType, RequireFields<MutationSetSeriesAlarmArgs, 'setSeriesAlarmInput'>>;
  setSeriesLike?: Resolver<ResolversTypes['SetSeriesLikePayload'], ParentType, ContextType, RequireFields<MutationSetSeriesLikeArgs, 'setSeriesLikeInput'>>;
  setTvPointAgreement?: Resolver<ResolversTypes['SetTvPointAgreementPayload'], ParentType, ContextType, RequireFields<MutationSetTvPointAgreementArgs, never>>;
  unregisterUser?: Resolver<ResolversTypes['UnregisterUserStatusPayload'], ParentType, ContextType>;
  updateNickname?: Resolver<ResolversTypes['UpdateNicknamePayload'], ParentType, ContextType, RequireFields<MutationUpdateNicknameArgs, 'input'>>;
  updateReceiptInfo?: Resolver<Maybe<ResolversTypes['ReceiptInfo']>, ParentType, ContextType, RequireFields<MutationUpdateReceiptInfoArgs, 'input'>>;
  useRedeem?: Resolver<ResolversTypes['RedeemCode'], ParentType, ContextType, RequireFields<MutationUseRedeemArgs, 'input'>>;
  useTicket?: Resolver<ResolversTypes['TicketUseMutationPayload'], ParentType, ContextType, RequireFields<MutationUseTicketArgs, 'input'>>;
  viewerLastPage?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType, RequireFields<MutationViewerLastPageArgs, 'input'>>;
  viewerOpenPage?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType, RequireFields<MutationViewerOpenPageArgs, 'input'>>;
  writeComment?: Resolver<ResolversTypes['WriteCommentPayload'], ParentType, ContextType, RequireFields<MutationWriteCommentArgs, 'writeCommentInput'>>;
};

export type MyInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyInfo'] = ResolversParentTypes['MyInfo']> = {
  cashBalance?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  numUnusedGift?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  profileImg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  useCashPassVip?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyNewsItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyNewsItem'] = ResolversParentTypes['MyNewsItem']> = {
  adLocId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  newsId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MyNewsType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyNewsListResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyNewsList'] = ResolversParentTypes['MyNewsList']> = {
  displayAd?: Resolver<Maybe<ResolversTypes['DisplayAd']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  news?: Resolver<Maybe<Array<ResolversTypes['MyNewsItem']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MyRatingResolvers<ContextType = any, ParentType extends ResolversParentTypes['MyRating'] = ResolversParentTypes['MyRating']> = {
  myRating?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NearItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['NearItem'] = ResolversParentTypes['NearItem']> = {
  ageGrade?: Resolver<ResolversTypes['AgeGrade'], ParentType, ContextType>;
  isFree?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  slideType?: Resolver<ResolversTypes['SlideType'], ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NormalListViewItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalListViewItem'] = ResolversParentTypes['NormalListViewItem']> = {
  ageGrade?: Resolver<ResolversTypes['AgeGrade'], ParentType, ContextType>;
  ageGradeBadge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  altText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeList?: Resolver<Array<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  continueData?: Resolver<Maybe<ResolversTypes['ContinueInfo']>, ParentType, ContextType>;
  continueScheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountRateText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['EventLog']>, ParentType, ContextType>;
  giftEventLog?: Resolver<Maybe<ResolversTypes['EventLog']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAlaramOn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isCheckMode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isChecked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHelixGift?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isReceived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSingle?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nextProductScheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  rank?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  row1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  row2?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  row3?: Resolver<Maybe<ResolversTypes['NormalListViewItemRow3']>, ParentType, ContextType>;
  row4?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  row5?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selfCensorship?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  seriesId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  showPlayerIcon?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  singleSlideType?: Resolver<Maybe<ResolversTypes['SlideType']>, ParentType, ContextType>;
  statusBadge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ticketUid?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NormalListViewItemRow3Resolvers<ContextType = any, ParentType extends ResolversParentTypes['NormalListViewItemRow3'] = ResolversParentTypes['NormalListViewItemRow3']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metaList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface ObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Object'], any> {
  name: 'Object';
}

export type OnAirGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnAirGroup'] = ResolversParentTypes['OnAirGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnAirItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnAirItem'] = ResolversParentTypes['OnAirItem']> = {
  caption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subtitleList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  titleImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  videoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnAirSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnAirSection'] = ResolversParentTypes['OnAirSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OperatorPropertyResolvers<ContextType = any, ParentType extends ResolversParentTypes['OperatorProperty'] = ResolversParentTypes['OperatorProperty']> = {
  bannerUid?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  cashInfo?: Resolver<Maybe<ResolversTypes['Cash']>, ParentType, ContextType>;
  copy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  helixImpId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isBook?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEvent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isTextViewer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isViewCount?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  rec_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selfCensorship?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ticketInfo?: Resolver<Maybe<Array<ResolversTypes['SingleTicketInfo']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PagingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Paging'] = ResolversParentTypes['Paging']> = {
  lastPageId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  shouldReloadPage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PopupResolvers<ContextType = any, ParentType extends ResolversParentTypes['Popup'] = ResolversParentTypes['Popup']> = {
  popupList?: Resolver<Maybe<Array<ResolversTypes['PopupInfo']>>, ParentType, ContextType>;
  useWelcome?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PopupInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PopupInfo'] = ResolversParentTypes['PopupInfo']> = {
  adLocId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bannerList?: Resolver<Array<ResolversTypes['ItemBanner']>, ParentType, ContextType>;
  bannerViewType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bgColor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endDt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  execUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  imageString?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUrlList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  legacy?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  popupId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  popupOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  startDt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targeted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['PopupType']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PosterViewGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['PosterViewGroup'] = ResolversParentTypes['PosterViewGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  meta?: Resolver<Maybe<ResolversTypes['ListViewGroupMeta']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PosterViewItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PosterViewItem'] = ResolversParentTypes['PosterViewItem']> = {
  ageGrade?: Resolver<ResolversTypes['AgeGrade'], ParentType, ContextType>;
  ageGradeBadge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  altText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeList?: Resolver<Array<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  discountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountRateText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['EventLog']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  labelBadgeList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  rank?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rankVariation?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selfCensorship?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  seriesId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  showDimmedThumbnail?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  showPlayerIcon?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  statusBadge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  subtitleList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PrepareAuthRequestInfoErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrepareAuthRequestInfoError'] = ResolversParentTypes['PrepareAuthRequestInfoError']> = {
  __resolveType: TypeResolveFn<'ReqInfoNotExist', ParentType, ContextType>;
};

export type PrepareAuthRequestInfoPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PrepareAuthRequestInfoPayload'] = ResolversParentTypes['PrepareAuthRequestInfoPayload']> = {
  authRequestInfo?: Resolver<Maybe<ResolversTypes['AuthRequestInfo']>, ParentType, ContextType>;
  authRequestInfoErrors?: Resolver<Array<ResolversTypes['PrepareAuthRequestInfoError']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['Preview'] = ResolversParentTypes['Preview']> = {
  item?: Resolver<Maybe<ResolversTypes['Single']>, ParentType, ContextType>;
  nextItem?: Resolver<Maybe<ResolversTypes['Single']>, ParentType, ContextType>;
  usingScroll?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreviewCommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PreviewComment'] = ResolversParentTypes['PreviewComment']> = {
  comment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commentUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  emoticon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userThumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotionBannerGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotionBannerGroup'] = ResolversParentTypes['PromotionBannerGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotionBannerItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotionBannerItem'] = ResolversParentTypes['PromotionBannerItem']> = {
  eventLog?: Resolver<Maybe<ResolversTypes['EventLog']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  leftImage?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rightImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotionBannerSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotionBannerSection'] = ResolversParentTypes['PromotionBannerSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PromotionCardViewItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['PromotionCardViewItem'] = ResolversParentTypes['PromotionCardViewItem']> = {
  ageGrade?: Resolver<ResolversTypes['AgeGrade'], ParentType, ContextType>;
  copy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountRateText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['EventLog']>, ParentType, ContextType>;
  giftEventLog?: Resolver<Maybe<ResolversTypes['EventLog']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  todayGift?: Resolver<Maybe<ResolversTypes['TodayGift']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurchaseInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurchaseInfo'] = ResolversParentTypes['PurchaseInfo']> = {
  expired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  purchaseType?: Resolver<ResolversTypes['PurchaseType'], ParentType, ContextType>;
  rentExpireDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  activateUser?: Resolver<ResolversTypes['ActivateUser'], ParentType, ContextType, RequireFields<QueryActivateUserArgs, never>>;
  ageAuth?: Resolver<Maybe<ResolversTypes['AgeAuth']>, ParentType, ContextType, RequireFields<QueryAgeAuthArgs, 'ageLimit'>>;
  agreements?: Resolver<Maybe<ResolversTypes['AgreementInfo']>, ParentType, ContextType>;
  appConfig?: Resolver<Maybe<ResolversTypes['AppConfig']>, ParentType, ContextType>;
  authBankAccount?: Resolver<ResolversTypes['DkpgRequestPayload'], ParentType, ContextType, RequireFields<QueryAuthBankAccountArgs, 'input'>>;
  bankCodeList?: Resolver<Maybe<Array<Maybe<ResolversTypes['BankCode']>>>, ParentType, ContextType>;
  bestCommentList?: Resolver<Maybe<ResolversTypes['CommentList']>, ParentType, ContextType, RequireFields<QueryBestCommentListArgs, 'bestCommentListInput'>>;
  blockUserList?: Resolver<Maybe<ResolversTypes['BlockUserList']>, ParentType, ContextType>;
  buyCashHistory?: Resolver<Maybe<ResolversTypes['BuyCashHistoryList']>, ParentType, ContextType, RequireFields<QueryBuyCashHistoryArgs, 'page'>>;
  buyTicketHistory?: Resolver<Maybe<ResolversTypes['HistoryList']>, ParentType, ContextType, RequireFields<QueryBuyTicketHistoryArgs, never>>;
  checkUnregister?: Resolver<Maybe<ResolversTypes['CheckUnregister']>, ParentType, ContextType>;
  commentItem?: Resolver<Maybe<ResolversTypes['CommentItem']>, ParentType, ContextType, RequireFields<QueryCommentItemArgs, 'parentUid'>>;
  commentList?: Resolver<Maybe<ResolversTypes['CommentList']>, ParentType, ContextType, RequireFields<QueryCommentListArgs, 'commentListInput'>>;
  contentBuyTicketPage?: Resolver<Maybe<ResolversTypes['ContentBuyTicketPage']>, ParentType, ContextType, RequireFields<QueryContentBuyTicketPageArgs, 'seriesId'>>;
  contentCheckFreeTicket?: Resolver<Maybe<ResolversTypes['ContentCheckFreeTicket']>, ParentType, ContextType, RequireFields<QueryContentCheckFreeTicketArgs, 'seriesId'>>;
  contentHomeAbout?: Resolver<Maybe<ResolversTypes['ContentHomeAbout']>, ParentType, ContextType, RequireFields<QueryContentHomeAboutArgs, 'seriesId'>>;
  contentHomeBriefList?: Resolver<Maybe<ResolversTypes['ContentHomeBriefList']>, ParentType, ContextType, RequireFields<QueryContentHomeBriefListArgs, 'seriesId'>>;
  contentHomeInfo?: Resolver<Maybe<ResolversTypes['ContentHomeInfo']>, ParentType, ContextType, RequireFields<QueryContentHomeInfoArgs, 'seriesId'>>;
  contentHomeNotice?: Resolver<Maybe<ResolversTypes['ContentHomeNotice']>, ParentType, ContextType, RequireFields<QueryContentHomeNoticeArgs, 'contentHomeNoticeInput'>>;
  contentHomeOverview?: Resolver<Maybe<ResolversTypes['ContentHomeOverview']>, ParentType, ContextType, RequireFields<QueryContentHomeOverviewArgs, 'seriesId'>>;
  contentHomeProductList?: Resolver<Maybe<ResolversTypes['SingleListConnection']>, ParentType, ContextType, RequireFields<QueryContentHomeProductListArgs, 'seriesId'>>;
  contentHomeRecommend?: Resolver<Maybe<ResolversTypes['ContentHomeRecommend']>, ParentType, ContextType, RequireFields<QueryContentHomeRecommendArgs, 'seriesId'>>;
  contentMyTicket?: Resolver<Maybe<ResolversTypes['ContentMyTicket']>, ParentType, ContextType, RequireFields<QueryContentMyTicketArgs, 'seriesId'>>;
  contentProductCursorIndex?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType, RequireFields<QueryContentProductCursorIndexArgs, 'seriesId'>>;
  contentSetList?: Resolver<Maybe<ResolversTypes['ContentSetList']>, ParentType, ContextType, RequireFields<QueryContentSetListArgs, 'productId' | 'seriesId'>>;
  contentSetOverview?: Resolver<Maybe<ResolversTypes['ContentSetOverview']>, ParentType, ContextType, RequireFields<QueryContentSetOverviewArgs, 'setId'>>;
  contentTicketDetail?: Resolver<Maybe<ResolversTypes['TicketDetail']>, ParentType, ContextType, RequireFields<QueryContentTicketDetailArgs, 'seriesId' | 'ticketUid'>>;
  contentTicketHistoryBuy?: Resolver<Maybe<ResolversTypes['ContentTicketHistoryBuy']>, ParentType, ContextType, RequireFields<QueryContentTicketHistoryBuyArgs, 'seriesId'>>;
  contentTicketHistoryBuyDetail?: Resolver<Maybe<ResolversTypes['ContentTicketHistoryBuyDetail']>, ParentType, ContextType, RequireFields<QueryContentTicketHistoryBuyDetailArgs, 'seriesId' | 'ticketId'>>;
  contentTicketInfo?: Resolver<Maybe<ResolversTypes['TicketInSeries']>, ParentType, ContextType, RequireFields<QueryContentTicketInfoArgs, 'seriesId'>>;
  dayOfWeekLayout?: Resolver<Maybe<ResolversTypes['DayOfWeekLayout']>, ParentType, ContextType, RequireFields<QueryDayOfWeekLayoutArgs, never>>;
  dayOfWeekList?: Resolver<Maybe<ResolversTypes['DayOfWeekList']>, ParentType, ContextType, RequireFields<QueryDayOfWeekListArgs, 'referenceKey'>>;
  deviceInfo?: Resolver<ResolversTypes['DeviceInfo'], ParentType, ContextType>;
  drmAssertion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<QueryDrmAssertionArgs, 'contentPackId' | 'productId'>>;
  dynamicLayoutReference?: Resolver<Maybe<ResolversTypes['DynamicLayoutReference']>, ParentType, ContextType, RequireFields<QueryDynamicLayoutReferenceArgs, 'dataKey' | 'sectionType'>>;
  fairplayCertificateUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  getGlobalAgreements?: Resolver<ResolversTypes['GlobalAgreementInfo'], ParentType, ContextType, RequireFields<QueryGetGlobalAgreementsArgs, 'globalAgreementInput'>>;
  getGlobalParentVerificationIsCompleted?: Resolver<Maybe<ResolversTypes['GlobalParentVerificationIsCompleted']>, ParentType, ContextType, RequireFields<QueryGetGlobalParentVerificationIsCompletedArgs, 'input'>>;
  gotcha?: Resolver<Maybe<ResolversTypes['GotchaInfo']>, ParentType, ContextType, RequireFields<QueryGotchaArgs, 'gotchaId'>>;
  helixSeriesList?: Resolver<Maybe<ResolversTypes['HelixSeriesList']>, ParentType, ContextType, RequireFields<QueryHelixSeriesListArgs, 'mapUid'>>;
  helps?: Resolver<Maybe<ResolversTypes['AnnouncementContainer']>, ParentType, ContextType, RequireFields<QueryHelpsArgs, never>>;
  invenLikeList?: Resolver<Maybe<ResolversTypes['InvenList']>, ParentType, ContextType, RequireFields<QueryInvenLikeListArgs, 'invenListInput'>>;
  invenMyInfo?: Resolver<Maybe<ResolversTypes['InvenMyInfo']>, ParentType, ContextType>;
  invenPaidList?: Resolver<Maybe<ResolversTypes['InvenList']>, ParentType, ContextType, RequireFields<QueryInvenPaidListArgs, 'invenListInput'>>;
  invenRecentList?: Resolver<Maybe<ResolversTypes['InvenList']>, ParentType, ContextType, RequireFields<QueryInvenRecentListArgs, 'invenListInput'>>;
  invenRecommendList?: Resolver<Maybe<ResolversTypes['InvenRecommendList']>, ParentType, ContextType, RequireFields<QueryInvenRecommendListArgs, 'type'>>;
  layout?: Resolver<Maybe<ResolversTypes['Layout']>, ParentType, ContextType, RequireFields<QueryLayoutArgs, 'screenUid'>>;
  layoutList?: Resolver<Maybe<Array<ResolversTypes['Layout']>>, ParentType, ContextType, RequireFields<QueryLayoutListArgs, 'screenUidList'>>;
  layoutReference?: Resolver<Array<ResolversTypes['LayoutReferenceViewData']>, ParentType, ContextType, RequireFields<QueryLayoutReferenceArgs, 'dataKey' | 'sectionType'>>;
  myCommentList?: Resolver<Maybe<ResolversTypes['CommentList']>, ParentType, ContextType, RequireFields<QueryMyCommentListArgs, 'page'>>;
  myNewsList?: Resolver<Maybe<ResolversTypes['MyNewsList']>, ParentType, ContextType, RequireFields<QueryMyNewsListArgs, 'myNewsListInput'>>;
  myRating?: Resolver<Maybe<ResolversTypes['MyRating']>, ParentType, ContextType, RequireFields<QueryMyRatingArgs, 'productId' | 'seriesId'>>;
  notices?: Resolver<Maybe<ResolversTypes['AnnouncementContainer']>, ParentType, ContextType, RequireFields<QueryNoticesArgs, never>>;
  popup?: Resolver<Maybe<ResolversTypes['Popup']>, ParentType, ContextType>;
  prepareAuthRequestInfo?: Resolver<ResolversTypes['PrepareAuthRequestInfoPayload'], ParentType, ContextType, RequireFields<QueryPrepareAuthRequestInfoArgs, 'input'>>;
  readyToUseTicket?: Resolver<Maybe<ResolversTypes['ReadyToUseTicket']>, ParentType, ContextType, RequireFields<QueryReadyToUseTicketArgs, 'productId' | 'seriesId'>>;
  receiptInfo?: Resolver<Maybe<ResolversTypes['ReceiptInfo']>, ParentType, ContextType>;
  receiptInfoResult?: Resolver<Maybe<ResolversTypes['ReceiptInfoResult']>, ParentType, ContextType, RequireFields<QueryReceiptInfoResultArgs, 'creditMasterId'>>;
  refundableAmount?: Resolver<Maybe<ResolversTypes['RefundableAmount']>, ParentType, ContextType>;
  replyCommentList?: Resolver<Maybe<ResolversTypes['CommentList']>, ParentType, ContextType, RequireFields<QueryReplyCommentListArgs, 'commentListInput'>>;
  rouletteInfo?: Resolver<Maybe<ResolversTypes['RouletteInfo']>, ParentType, ContextType, RequireFields<QueryRouletteInfoArgs, 'rouletteId'>>;
  sampleError?: Resolver<Maybe<ResolversTypes['SampleError']>, ParentType, ContextType, RequireFields<QuerySampleErrorArgs, 'pagewebErrorType'>>;
  searchAutoComplete?: Resolver<Maybe<ResolversTypes['SearchAutoComplete']>, ParentType, ContextType, RequireFields<QuerySearchAutoCompleteArgs, 'searchAutoCompleteInput'>>;
  searchInvenList?: Resolver<Maybe<ResolversTypes['InvenList']>, ParentType, ContextType, RequireFields<QuerySearchInvenListArgs, 'searchInvenListInput'>>;
  searchKeyword?: Resolver<Maybe<ResolversTypes['SearchKeyword']>, ParentType, ContextType, RequireFields<QuerySearchKeywordArgs, 'searchKeywordInput'>>;
  searchMain?: Resolver<Maybe<ResolversTypes['SearchMain']>, ParentType, ContextType>;
  searchThemeKeyword?: Resolver<Maybe<ResolversTypes['SearchThemeKeyword']>, ParentType, ContextType, RequireFields<QuerySearchThemeKeywordArgs, 'searchThemeKeywordInput'>>;
  selfCertAgreement?: Resolver<Maybe<ResolversTypes['AgreementContainer']>, ParentType, ContextType, RequireFields<QuerySelfCertAgreementArgs, 'authRequestType'>>;
  seriesCardViewLandingList?: Resolver<Maybe<ResolversTypes['SeriesCardViewLandingList']>, ParentType, ContextType, RequireFields<QuerySeriesCardViewLandingListArgs, 'dataKey'>>;
  seriesListViewLandingList?: Resolver<Maybe<ResolversTypes['SeriesListViewLandingList']>, ParentType, ContextType, RequireFields<QuerySeriesListViewLandingListArgs, 'dataKey'>>;
  seriesPosterViewLandingList?: Resolver<Maybe<ResolversTypes['SeriesPosterViewLandingList']>, ParentType, ContextType, RequireFields<QuerySeriesPosterViewLandingListArgs, 'dataKey'>>;
  setListViewLandingList?: Resolver<Maybe<ResolversTypes['SetListViewLandingList']>, ParentType, ContextType, RequireFields<QuerySetListViewLandingListArgs, 'dataKey'>>;
  setPosterViewLandingList?: Resolver<Maybe<ResolversTypes['SetPosterViewLandingList']>, ParentType, ContextType, RequireFields<QuerySetPosterViewLandingListArgs, 'dataKey'>>;
  setReadyToUseTicket?: Resolver<Maybe<ResolversTypes['SetReadyToUseTicket']>, ParentType, ContextType, RequireFields<QuerySetReadyToUseTicketArgs, 'seriesId' | 'setId'>>;
  shortcutList?: Resolver<Maybe<ResolversTypes['ShortcutList']>, ParentType, ContextType>;
  simpleSeriesSingleInfo?: Resolver<Maybe<ResolversTypes['SimpleSeriesSingleInfo']>, ParentType, ContextType, RequireFields<QuerySimpleSeriesSingleInfoArgs, 'seriesId'>>;
  singleListViewLandingList?: Resolver<Maybe<ResolversTypes['SingleListViewLandingList']>, ParentType, ContextType, RequireFields<QuerySingleListViewLandingListArgs, 'dataKey'>>;
  singlePreview?: Resolver<Maybe<ResolversTypes['SinglePreview']>, ParentType, ContextType, RequireFields<QuerySinglePreviewArgs, 'productId'>>;
  staticLandingDayOfWeekLayout?: Resolver<ResolversTypes['Layout'], ParentType, ContextType, RequireFields<QueryStaticLandingDayOfWeekLayoutArgs, 'input'>>;
  staticLandingDayOfWeekSection?: Resolver<ResolversTypes['Section'], ParentType, ContextType, RequireFields<QueryStaticLandingDayOfWeekSectionArgs, 'param' | 'sectionId'>>;
  staticLandingEventLayout?: Resolver<ResolversTypes['Layout'], ParentType, ContextType, RequireFields<QueryStaticLandingEventLayoutArgs, 'input'>>;
  staticLandingEventSection?: Resolver<ResolversTypes['Section'], ParentType, ContextType, RequireFields<QueryStaticLandingEventSectionArgs, 'param' | 'sectionId'>>;
  staticLandingFreeSeriesLayout?: Resolver<ResolversTypes['Layout'], ParentType, ContextType, RequireFields<QueryStaticLandingFreeSeriesLayoutArgs, 'input'>>;
  staticLandingFreeSeriesSection?: Resolver<ResolversTypes['Section'], ParentType, ContextType, RequireFields<QueryStaticLandingFreeSeriesSectionArgs, 'param' | 'sectionId'>>;
  staticLandingGenreLayout?: Resolver<ResolversTypes['Layout'], ParentType, ContextType, RequireFields<QueryStaticLandingGenreLayoutArgs, 'input'>>;
  staticLandingGenreSection?: Resolver<ResolversTypes['Section'], ParentType, ContextType, RequireFields<QueryStaticLandingGenreSectionArgs, 'param' | 'sectionId'>>;
  staticLandingOriginalLayout?: Resolver<ResolversTypes['Layout'], ParentType, ContextType, RequireFields<QueryStaticLandingOriginalLayoutArgs, 'input'>>;
  staticLandingOriginalSection?: Resolver<ResolversTypes['Section'], ParentType, ContextType, RequireFields<QueryStaticLandingOriginalSectionArgs, 'param' | 'sectionId'>>;
  staticLandingRankingLayout?: Resolver<ResolversTypes['Layout'], ParentType, ContextType, RequireFields<QueryStaticLandingRankingLayoutArgs, 'input'>>;
  staticLandingRankingSection?: Resolver<ResolversTypes['Section'], ParentType, ContextType, RequireFields<QueryStaticLandingRankingSectionArgs, 'param' | 'sectionId'>>;
  staticLandingTodayNewLayout?: Resolver<ResolversTypes['Layout'], ParentType, ContextType, RequireFields<QueryStaticLandingTodayNewLayoutArgs, 'input'>>;
  staticLandingTodayNewSection?: Resolver<ResolversTypes['Section'], ParentType, ContextType, RequireFields<QueryStaticLandingTodayNewSectionArgs, 'param' | 'sectionId'>>;
  staticLandingTodayUpLayout?: Resolver<ResolversTypes['Layout'], ParentType, ContextType, RequireFields<QueryStaticLandingTodayUpLayoutArgs, 'input'>>;
  staticLandingTodayUpSection?: Resolver<ResolversTypes['Section'], ParentType, ContextType, RequireFields<QueryStaticLandingTodayUpSectionArgs, 'param' | 'sectionId'>>;
  tastesServiceLang?: Resolver<Maybe<ResolversTypes['TastesServiceLang']>, ParentType, ContextType>;
  todayGiftList?: Resolver<Maybe<ResolversTypes['TodayGiftList']>, ParentType, ContextType, RequireFields<QueryTodayGiftListArgs, never>>;
  tvPointAgreement?: Resolver<Maybe<ResolversTypes['TvPointAgreement']>, ParentType, ContextType>;
  useCashHistory?: Resolver<Maybe<ResolversTypes['HistoryList']>, ParentType, ContextType, RequireFields<QueryUseCashHistoryArgs, 'page'>>;
  useTicketHistory?: Resolver<Maybe<ResolversTypes['HistoryList']>, ParentType, ContextType, RequireFields<QueryUseTicketHistoryArgs, never>>;
  userAndCash?: Resolver<Maybe<ResolversTypes['UserAndCashPayload']>, ParentType, ContextType, RequireFields<QueryUserAndCashArgs, never>>;
  userCash?: Resolver<Maybe<ResolversTypes['UserCash']>, ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  viewerEnd?: Resolver<Maybe<ResolversTypes['ViewerEnd']>, ParentType, ContextType, RequireFields<QueryViewerEndArgs, 'viewerEndInput'>>;
  viewerInfo?: Resolver<Maybe<ResolversTypes['ViewerInfo']>, ParentType, ContextType, RequireFields<QueryViewerInfoArgs, 'productId' | 'seriesId'>>;
  vodToken?: Resolver<Maybe<ResolversTypes['VodToken']>, ParentType, ContextType, RequireFields<QueryVodTokenArgs, 'contentPackId' | 'drmType' | 'productId'>>;
  welcome?: Resolver<Maybe<ResolversTypes['Welcome']>, ParentType, ContextType>;
};

export type RankingListViewItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['RankingListViewItem'] = ResolversParentTypes['RankingListViewItem']> = {
  ageGrade?: Resolver<ResolversTypes['AgeGrade'], ParentType, ContextType>;
  ageGradeBadge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  badgeList?: Resolver<Array<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  descriptionList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  discountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountRateText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['EventLog']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metaList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  rank?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  selfCensorship?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  statusBadge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RankingSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RankingSection'] = ResolversParentTypes['RankingSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RankingV2SectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RankingV2Section'] = ResolversParentTypes['RankingV2Section']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReadyToUseTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReadyToUseTicket'] = ResolversParentTypes['ReadyToUseTicket']> = {
  available?: Resolver<Maybe<ResolversTypes['TicketAvailable']>, ParentType, ContextType>;
  my?: Resolver<Maybe<ResolversTypes['TicketMy']>, ParentType, ContextType>;
  nextItem?: Resolver<Maybe<ResolversTypes['LegacySingle']>, ParentType, ContextType>;
  purchase?: Resolver<Maybe<ResolversTypes['TicketPurchase']>, ParentType, ContextType>;
  rentalPeriodByMinute?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  series?: Resolver<Maybe<ResolversTypes['TicketSeries']>, ParentType, ContextType>;
  single?: Resolver<Maybe<ResolversTypes['TicketSingle']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReceiptInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReceiptInfo'] = ResolversParentTypes['ReceiptInfo']> = {
  accountId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  receiptInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receiptInfoType?: Resolver<Maybe<ResolversTypes['ReceiptInfoType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReceiptInfoResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReceiptInfoResult'] = ResolversParentTypes['ReceiptInfoResult']> = {
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receiptAuthNum?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  receiptCancelNum?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  receiptCancelPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  receiptInfo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receiptInfoType?: Resolver<Maybe<ResolversTypes['ReceiptInfoType']>, ParentType, ContextType>;
  receiptPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  receiptType?: Resolver<Maybe<ResolversTypes['ReceiptResultType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReceiptInfoStatusPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReceiptInfoStatusPayload'] = ResolversParentTypes['ReceiptInfoStatusPayload']> = {
  status?: Resolver<Maybe<ResolversTypes['ResultStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecentViewedSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecentViewedSection'] = ResolversParentTypes['RecentViewedSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  loggedInScheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  loggedInTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metaInfoType?: Resolver<Maybe<ResolversTypes['MetaInfoType']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecommendEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecommendEvent'] = ResolversParentTypes['RecommendEvent']> = {
  bannerUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  itemOrder?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scheme?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecommendSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecommendSection'] = ResolversParentTypes['RecommendSection']> = {
  __resolveType: TypeResolveFn<'CardSection' | 'TopSection', ParentType, ContextType>;
  isRecommendArea?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isRecommendedItems?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type RedeemCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RedeemCode'] = ResolversParentTypes['RedeemCode']> = {
  age?: Resolver<Maybe<ResolversTypes['AgeGrade']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  resultCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seriesId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  shouldRedirect?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ticket?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['RedeemCodeType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundRequestPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundRequestPayload'] = ResolversParentTypes['RefundRequestPayload']> = {
  status?: Resolver<ResolversTypes['BillingStatusCode'], ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundTicketStatusPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundTicketStatusPayload'] = ResolversParentTypes['RefundTicketStatusPayload']> = {
  status?: Resolver<Maybe<ResolversTypes['ResultStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundableAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundableAmount'] = ResolversParentTypes['RefundableAmount']> = {
  finalRefundableAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notRefundableAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refundFee?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refundableAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalRemainAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  usedEventCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RefundableTicketInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundableTicketInfo'] = ResolversParentTypes['RefundableTicketInfo']> = {
  expiredEventCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  initialCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  normalCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notRefundableExpiredEventCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notRefundablePoint?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  notRefundableVodCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  paidTicketCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  point?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refundExceptEventCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refundTicketCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refundableNormalCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refundableValidEventCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  remainCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPaidCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  usedExpiredEventCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  usedNormalCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  usedPaidTicketPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  usedPoint?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  usedValidEventCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  usedVodCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  validEventCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vodCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveMyNewsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveMyNewsPayload'] = ResolversParentTypes['RemoveMyNewsPayload']> = {
  newsId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReqInfoNotExistResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReqInfoNotExist'] = ResolversParentTypes['ReqInfoNotExist']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ResponsiveBannerGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['ResponsiveBannerGroup'] = ResolversParentTypes['ResponsiveBannerGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RouletteDrawPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RouletteDrawPayload'] = ResolversParentTypes['RouletteDrawPayload']> = {
  expirationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prizeType?: Resolver<Maybe<ResolversTypes['RouletteWinPrizeType']>, ParentType, ContextType>;
  rouletteStatus?: Resolver<Maybe<ResolversTypes['RouletteStatus']>, ParentType, ContextType>;
  winningDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RouletteInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['RouletteInfo'] = ResolversParentTypes['RouletteInfo']> = {
  apiErrorHandleType?: Resolver<Maybe<ResolversTypes['RouletteApiErrorHandleType']>, ParentType, ContextType>;
  apiErrorMsg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badgeImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bannerAdLocId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bannerImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bannerLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bgColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bgImg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  entryType?: Resolver<Maybe<ResolversTypes['RouletteEntryType']>, ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headerTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isOldRoulette?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRedeemType?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSponsorType?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  maxCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  prize?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prizeImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prizeType?: Resolver<Maybe<ResolversTypes['RouletteWinPrizeType']>, ParentType, ContextType>;
  resultBottomTextList?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  rouletteAdLocId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rouletteId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rouletteStatus?: Resolver<ResolversTypes['RouletteStatus'], ParentType, ContextType>;
  screenTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['RouletteType']>, ParentType, ContextType>;
  winningDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesTicket'] = ResolversParentTypes['SalesTicket']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  categoryUid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createDt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  itemCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  itemCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paidNum?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paidYn?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  payId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  publisherUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  qty?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  receiveUserUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  saleType?: Resolver<ResolversTypes['SaleType'], ParentType, ContextType>;
  seriesId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  seriesTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subCategoryUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ticketType?: Resolver<ResolversTypes['TicketType'], ParentType, ContextType>;
  ticketUid?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userAgent?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SalesTicketItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SalesTicketItem'] = ResolversParentTypes['SalesTicketItem']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createDt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  itemCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  paidNum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  payId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  qty?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  saleType?: Resolver<Maybe<ResolversTypes['SaleType']>, ParentType, ContextType>;
  seriesId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subCategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ticketExpireDt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ticketType?: Resolver<Maybe<ResolversTypes['TicketType']>, ParentType, ContextType>;
  ticketUid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SampleErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['SampleError'] = ResolversParentTypes['SampleError']> = {
  sample?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SaveAuthInfoPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SaveAuthInfoPayload'] = ResolversParentTypes['SaveAuthInfoPayload']> = {
  authInfo?: Resolver<Maybe<ResolversTypes['AuthInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SchemeSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SchemeSection'] = ResolversParentTypes['SchemeSection']> = {
  __resolveType: TypeResolveFn<'CashFriendsSection' | 'EpisodeSection' | 'EventSection' | 'MainRankingSection' | 'RankingSection' | 'RankingV2Section' | 'RecentViewedSection' | 'ScrollThemeSection' | 'ThemeSection', ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ScreenResolvers<ContextType = any, ParentType extends ResolversParentTypes['Screen'] = ResolversParentTypes['Screen']> = {
  ageGrade?: Resolver<Maybe<ResolversTypes['AgeGrade']>, ParentType, ContextType>;
  categoryUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  landingType?: Resolver<Maybe<ResolversTypes['StaticLandingType']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScrollThemeSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ScrollThemeSection'] = ResolversParentTypes['ScrollThemeSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metaInfoType?: Resolver<Maybe<ResolversTypes['MetaInfoType']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchAutoCompleteResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchAutoComplete'] = ResolversParentTypes['SearchAutoComplete']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  keyword?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['AutoCompleteItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchKeywordResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchKeyword'] = ResolversParentTypes['SearchKeyword']> = {
  categoryOptionList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  keyword?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['NormalListViewItem']>, ParentType, ContextType>;
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  selectedCategoryOption?: Resolver<ResolversTypes['SortOption'], ParentType, ContextType>;
  selectedSortOption?: Resolver<ResolversTypes['SortOption'], ParentType, ContextType>;
  showOnlyComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sortOptionList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchMainResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchMain'] = ResolversParentTypes['SearchMain']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  keywordRankList?: Resolver<Array<ResolversTypes['SearchPopularKeywordRank']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchPopularKeywordRankResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchPopularKeywordRank'] = ResolversParentTypes['SearchPopularKeywordRank']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  keyword?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  rank?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SearchThemeKeywordResolvers<ContextType = any, ParentType extends ResolversParentTypes['SearchThemeKeyword'] = ResolversParentTypes['SearchThemeKeyword']> = {
  categoryOptionList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  filterList?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['NormalListViewItem']>, ParentType, ContextType>;
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  selectedCategoryOption?: Resolver<ResolversTypes['SortOption'], ParentType, ContextType>;
  selectedSortOption?: Resolver<ResolversTypes['SortOption'], ParentType, ContextType>;
  sortOptionList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Section'] = ResolversParentTypes['Section']> = {
  __resolveType: TypeResolveFn<'AlarmSection' | 'BigBannerSection' | 'CardSection' | 'CashFriendsSection' | 'DayOfWeekSection' | 'DisplayAdSection' | 'EpisodeSection' | 'EventSection' | 'HelixThemeSection' | 'LineBannerSection' | 'MainRankingSection' | 'OnAirSection' | 'PromotionBannerSection' | 'RankingSection' | 'RankingV2Section' | 'RecentViewedSection' | 'ScrollThemeSection' | 'SeriesBasedRecommendSection' | 'StaticLandingDayOfWeekSection' | 'StaticLandingEventSection' | 'StaticLandingFreeSeriesSection' | 'StaticLandingGenreSection' | 'StaticLandingOriginalSection' | 'StaticLandingRankingSection' | 'StaticLandingTodayNewSection' | 'StaticLandingTodayUpSection' | 'StrategyCategorySection' | 'ThemeSection' | 'TopSection' | 'UnknownSection' | 'UserBasedRecommendSection', ParentType, ContextType>;
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
};

export type SectionMainTabResolvers<ContextType = any, ParentType extends ResolversParentTypes['SectionMainTab'] = ResolversParentTypes['SectionMainTab']> = {
  additionalString?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSelected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subTabList?: Resolver<Array<ResolversTypes['SectionSubTab']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SectionSubTabResolvers<ContextType = any, ParentType extends ResolversParentTypes['SectionSubTab'] = ResolversParentTypes['SectionSubTab']> = {
  groupId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isSelected?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendEmailVerifyCodePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendEmailVerifyCodePayload'] = ResolversParentTypes['SendEmailVerifyCodePayload']> = {
  verifyUuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['Series'] = ResolversParentTypes['Series']> = {
  ageGrade?: Resolver<ResolversTypes['AgeGrade'], ParentType, ContextType>;
  assetProperty?: Resolver<Maybe<ResolversTypes['AssetProperty']>, ParentType, ContextType>;
  authors?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  badge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  bm?: Resolver<Maybe<ResolversTypes['Bm']>, ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  categoryType?: Resolver<ResolversTypes['CategoryType'], ParentType, ContextType>;
  categoryUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountRateText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  freeSlideCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAllFree?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isWaitfree?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  landThumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lang?: Resolver<ResolversTypes['Locale'], ParentType, ContextType>;
  lastSlideAddedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  onIssue?: Resolver<Maybe<ResolversTypes['OnIssue']>, ParentType, ContextType>;
  operatorProperty?: Resolver<Maybe<ResolversTypes['OperatorProperty']>, ParentType, ContextType>;
  pubPeriod?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleMethod?: Resolver<Maybe<ResolversTypes['SaleMethod']>, ParentType, ContextType>;
  saleState?: Resolver<Maybe<ResolversTypes['SaleState']>, ParentType, ContextType>;
  seriesId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  serviceProperty?: Resolver<Maybe<ResolversTypes['ServiceProperty']>, ParentType, ContextType>;
  startSaleDt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  state?: Resolver<ResolversTypes['SlideState'], ParentType, ContextType>;
  subcategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subcategoryUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  translateProperty?: Resolver<Maybe<ResolversTypes['TranslateProperty']>, ParentType, ContextType>;
  waitfreeBlockCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  waitfreePeriodByMinute?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeriesBasedRecommendSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeriesBasedRecommendSection'] = ResolversParentTypes['SeriesBasedRecommendSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeriesCardViewLandingListResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeriesCardViewLandingList'] = ResolversParentTypes['SeriesCardViewLandingList']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['CardViewItem']>, ParentType, ContextType>;
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  selectedThemeKeywordOpt?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  themeKeywordOptList?: Resolver<Maybe<Array<ResolversTypes['SortOption']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeriesListViewLandingListResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeriesListViewLandingList'] = ResolversParentTypes['SeriesListViewLandingList']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['NormalListViewItem']>, ParentType, ContextType>;
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  selectedThemeKeywordOpt?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  themeKeywordOptList?: Resolver<Maybe<Array<ResolversTypes['SortOption']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeriesNoticeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeriesNotice'] = ResolversParentTypes['SeriesNotice']> = {
  createDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isExposure?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isSystemNotice?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  modifyDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  noticeType?: Resolver<ResolversTypes['SeriesNoticeType'], ParentType, ContextType>;
  publisherUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seriesId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  seriesTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeriesNoticeListContainerResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeriesNoticeListContainer'] = ResolversParentTypes['SeriesNoticeListContainer']> = {
  currentPage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  noticeList?: Resolver<Array<ResolversTypes['SeriesNotice']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeriesPosterViewLandingListResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeriesPosterViewLandingList'] = ResolversParentTypes['SeriesPosterViewLandingList']> = {
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['PosterViewItem']>, ParentType, ContextType>;
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  selectedThemeKeywordOpt?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  themeKeywordOptList?: Resolver<Maybe<Array<ResolversTypes['SortOption']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SeriesPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['SeriesPreview'] = ResolversParentTypes['SeriesPreview']> = {
  author?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  landThumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ServicePropertyResolvers<ContextType = any, ParentType extends ResolversParentTypes['ServiceProperty'] = ResolversParentTypes['ServiceProperty']> = {
  commentCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isAlarmOn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLikeOn?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastViewInfo?: Resolver<Maybe<ResolversTypes['LastViewInfo']>, ParentType, ContextType>;
  pageContinue?: Resolver<Maybe<ResolversTypes['ContinueInfo']>, ParentType, ContextType>;
  preview?: Resolver<Maybe<ResolversTypes['Preview']>, ParentType, ContextType>;
  purchaseInfo?: Resolver<Maybe<ResolversTypes['PurchaseInfo']>, ParentType, ContextType>;
  purchasedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ratingSum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  readCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ticketCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ticketInfo?: Resolver<Maybe<ResolversTypes['SingleTicketInfo']>, ParentType, ContextType>;
  todayGift?: Resolver<Maybe<ResolversTypes['TodayGift']>, ParentType, ContextType>;
  viewCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  waitfreeTicket?: Resolver<Maybe<ResolversTypes['WaitfreeTicket']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetResolvers<ContextType = any, ParentType extends ResolversParentTypes['Set'] = ResolversParentTypes['Set']> = {
  ageGrade?: Resolver<Maybe<ResolversTypes['AgeGrade']>, ParentType, ContextType>;
  allVolumes?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  assetProperty?: Resolver<Maybe<ResolversTypes['AssetProperty']>, ParentType, ContextType>;
  authors?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  categoryUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  discountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountRateText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endSaleDt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  operatorProperty?: Resolver<Maybe<ResolversTypes['OperatorProperty']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rentalPeriodByMinute?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seriesId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  serviceProperty?: Resolver<Maybe<ResolversTypes['ServiceProperty']>, ParentType, ContextType>;
  setId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  startSaleDt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  subcategory?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subcategoryUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ticketKind?: Resolver<Maybe<ResolversTypes['TicketKind']>, ParentType, ContextType>;
  ticketType?: Resolver<Maybe<ResolversTypes['TicketType']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetAgreementPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetAgreementPayload'] = ResolversParentTypes['SetAgreementPayload']> = {
  agreementList?: Resolver<Array<ResolversTypes['AgreedAgreement']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetGlobalAgreementPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetGlobalAgreementPayload'] = ResolversParentTypes['SetGlobalAgreementPayload']> = {
  agreementList?: Resolver<Array<ResolversTypes['AgreedAgreement']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetListViewLandingListResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetListViewLandingList'] = ResolversParentTypes['SetListViewLandingList']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['NormalListViewItem']>, ParentType, ContextType>;
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetMyRatingPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetMyRatingPayload'] = ResolversParentTypes['SetMyRatingPayload']> = {
  status?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetPosterViewLandingListResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetPosterViewLandingList'] = ResolversParentTypes['SetPosterViewLandingList']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['PosterViewItem']>, ParentType, ContextType>;
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetProductResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetProduct'] = ResolversParentTypes['SetProduct']> = {
  productId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  purchaseInfo?: Resolver<Maybe<ResolversTypes['PurchaseInfo']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetReadyToUseTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetReadyToUseTicket'] = ResolversParentTypes['SetReadyToUseTicket']> = {
  my?: Resolver<Maybe<ResolversTypes['SetTicketMy']>, ParentType, ContextType>;
  purchase?: Resolver<Maybe<ResolversTypes['TicketPurchase']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetSeriesAlarmPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetSeriesAlarmPayload'] = ResolversParentTypes['SetSeriesAlarmPayload']> = {
  record?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  recordId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetSeriesLikePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetSeriesLikePayload'] = ResolversParentTypes['SetSeriesLikePayload']> = {
  record?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  recordId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetTicketMyResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetTicketMy'] = ResolversParentTypes['SetTicketMy']> = {
  cashAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  hasOwnProduct?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasRentalProduct?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetTvPointAgreementPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SetTvPointAgreementPayload'] = ResolversParentTypes['SetTvPointAgreementPayload']> = {
  status?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShortVodPreviewViewerInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShortVodPreviewViewerInfo'] = ResolversParentTypes['ShortVodPreviewViewerInfo']> = {
  item?: Resolver<ResolversTypes['Single'], ParentType, ContextType>;
  seriesItem?: Resolver<ResolversTypes['Series'], ParentType, ContextType>;
  viewerData?: Resolver<Maybe<ResolversTypes['VodViewerData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShortcutItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShortcutItem'] = ResolversParentTypes['ShortcutItem']> = {
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  scheme?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShortcutItemListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShortcutItemList'] = ResolversParentTypes['ShortcutItemList']> = {
  list?: Resolver<Array<ResolversTypes['ShortcutItem']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShortcutListResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShortcutList'] = ResolversParentTypes['ShortcutList']> = {
  menuList?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShortcutMenuItem']>>>, ParentType, ContextType>;
  promotionBanner?: Resolver<Maybe<ResolversTypes['PromotionBannerItem']>, ParentType, ContextType>;
  shortcutList?: Resolver<Maybe<Array<Maybe<ResolversTypes['ShortcutItemList']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ShortcutMenuItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ShortcutMenuItem'] = ResolversParentTypes['ShortcutMenuItem']> = {
  shortcutHomeType?: Resolver<Maybe<ResolversTypes['ShortcutHomeType']>, ParentType, ContextType>;
  shortcutHomeUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimpleImageBannerResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimpleImageBanner'] = ResolversParentTypes['SimpleImageBanner']> = {
  bgColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scheme?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shouldOpenNewWindow?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimpleSeriesSingleInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimpleSeriesSingleInfo'] = ResolversParentTypes['SimpleSeriesSingleInfo']> = {
  seriesAgeGrade?: Resolver<Maybe<ResolversTypes['AgeGrade']>, ParentType, ContextType>;
  seriesSaleState?: Resolver<Maybe<ResolversTypes['SaleState']>, ParentType, ContextType>;
  singleAgeGrade?: Resolver<Maybe<ResolversTypes['AgeGrade']>, ParentType, ContextType>;
  singleIsFree?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  singleIsTextViewer?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  singleSaleState?: Resolver<Maybe<ResolversTypes['SaleState']>, ParentType, ContextType>;
  singleSlideType?: Resolver<Maybe<ResolversTypes['SlideType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SimpleSetResolvers<ContextType = any, ParentType extends ResolversParentTypes['SimpleSet'] = ResolversParentTypes['SimpleSet']> = {
  discountRate?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isMultiple?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  setId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SingleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Single'] = ResolversParentTypes['Single']> = {
  ageGrade?: Resolver<ResolversTypes['AgeGrade'], ParentType, ContextType>;
  assetProperty?: Resolver<Maybe<ResolversTypes['AssetProperty']>, ParentType, ContextType>;
  badge?: Resolver<Maybe<ResolversTypes['BadgeType']>, ParentType, ContextType>;
  discountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountRateText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isFree?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isHidden?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isShortsDrama?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isWaitfreeBlocked?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastReleasedDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  operatorProperty?: Resolver<Maybe<ResolversTypes['OperatorProperty']>, ParentType, ContextType>;
  pageCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  remainText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  saleState?: Resolver<Maybe<ResolversTypes['SaleState']>, ParentType, ContextType>;
  series?: Resolver<Maybe<ResolversTypes['Series']>, ParentType, ContextType>;
  seriesId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  serviceProperty?: Resolver<Maybe<ResolversTypes['ServiceProperty']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  slideType?: Resolver<ResolversTypes['SlideType'], ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['SlideState']>, ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SingleEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleEdge'] = ResolversParentTypes['SingleEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['SingleListViewItem'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SingleListConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleListConnection'] = ResolversParentTypes['SingleListConnection']> = {
  edges?: Resolver<Array<ResolversTypes['SingleEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  selectedSortOption?: Resolver<ResolversTypes['SortOption'], ParentType, ContextType>;
  sortOptionList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SingleListViewItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleListViewItem'] = ResolversParentTypes['SingleListViewItem']> = {
  discountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountRateText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  eventLog?: Resolver<Maybe<ResolversTypes['EventLog']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isCheckMode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isChecked?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isViewed?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  row1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  row2?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  row3?: Resolver<Maybe<ResolversTypes['SingleListViewItemRow3']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  showPlayerIcon?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  single?: Resolver<ResolversTypes['Single'], ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SingleListViewItemRow3Resolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleListViewItemRow3'] = ResolversParentTypes['SingleListViewItemRow3']> = {
  badgeList?: Resolver<Maybe<Array<ResolversTypes['SingleBadgeType']>>, ParentType, ContextType>;
  priceList?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SingleListViewLandingListResolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleListViewLandingList'] = ResolversParentTypes['SingleListViewLandingList']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['NormalListViewItem']>, ParentType, ContextType>;
  page?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  selectedThemeKeywordOpt?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  themeKeywordOptList?: Resolver<Maybe<Array<ResolversTypes['SortOption']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  topImage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ContentsType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SinglePreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['SinglePreview'] = ResolversParentTypes['SinglePreview']> = {
  author?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  categoryUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isFree?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  landThumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  readAccessType?: Resolver<Maybe<ResolversTypes['ReadAccessType']>, ParentType, ContextType>;
  saleState?: Resolver<Maybe<ResolversTypes['SaleState']>, ParentType, ContextType>;
  seriesId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  seriesLang?: Resolver<ResolversTypes['Locale'], ParentType, ContextType>;
  seriesPreview?: Resolver<Maybe<ResolversTypes['SeriesPreview']>, ParentType, ContextType>;
  slideType?: Resolver<ResolversTypes['SlideType'], ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SingleTicketInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleTicketInfo'] = ResolversParentTypes['SingleTicketInfo']> = {
  discountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ticketType?: Resolver<Maybe<ResolversTypes['TicketType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SortOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SortOption'] = ResolversParentTypes['SortOption']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  param?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StandaloneBannerAndSubCardGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['StandaloneBannerAndSubCardGroup'] = ResolversParentTypes['StandaloneBannerAndSubCardGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StandaloneBannerGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['StandaloneBannerGroup'] = ResolversParentTypes['StandaloneBannerGroup']> = {
  bannerViewType?: Resolver<ResolversTypes['BannerViewType'], ParentType, ContextType>;
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingDayOfWeekSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingDayOfWeekSection'] = ResolversParentTypes['StaticLandingDayOfWeekSection']> = {
  businessModelList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  dayTabList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  param?: Resolver<ResolversTypes['StaticLandingDayOfWeekSectionParam'], ParentType, ContextType>;
  promotionBanner?: Resolver<Maybe<ResolversTypes['PromotionBannerItem']>, ParentType, ContextType>;
  subcategoryList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingDayOfWeekSectionParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingDayOfWeekSectionParam'] = ResolversParentTypes['StaticLandingDayOfWeekSectionParam']> = {
  businessModel?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  categoryUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  dayTab?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  screenUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subcategory?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingEventSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingEventSection'] = ResolversParentTypes['StaticLandingEventSection']> = {
  categoryTabList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  param?: Resolver<ResolversTypes['StaticLandingEventSectionParam'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingEventSectionParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingEventSectionParam'] = ResolversParentTypes['StaticLandingEventSectionParam']> = {
  categoryUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingFreeSeriesSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingFreeSeriesSection'] = ResolversParentTypes['StaticLandingFreeSeriesSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  param?: Resolver<ResolversTypes['StaticLandingFreeSeriesSectionParam'], ParentType, ContextType>;
  promotionBanner?: Resolver<Maybe<ResolversTypes['PromotionBannerItem']>, ParentType, ContextType>;
  tabList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingFreeSeriesSectionParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingFreeSeriesSectionParam'] = ResolversParentTypes['StaticLandingFreeSeriesSectionParam']> = {
  categoryUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  screenUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  tab?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingGenreSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingGenreSection'] = ResolversParentTypes['StaticLandingGenreSection']> = {
  displayAd?: Resolver<Maybe<ResolversTypes['DisplayAd']>, ParentType, ContextType>;
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  param?: Resolver<ResolversTypes['StaticLandingGenreSectionParam'], ParentType, ContextType>;
  promotionBanner?: Resolver<Maybe<ResolversTypes['PromotionBannerItem']>, ParentType, ContextType>;
  sortTypeList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  subcategoryList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingGenreSectionParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingGenreSectionParam'] = ResolversParentTypes['StaticLandingGenreSectionParam']> = {
  categoryUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isComplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  screenUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sortType?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  subcategory?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingOriginalSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingOriginalSection'] = ResolversParentTypes['StaticLandingOriginalSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  originalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  param?: Resolver<ResolversTypes['StaticLandingOriginalSectionParam'], ParentType, ContextType>;
  recommendItemList?: Resolver<Maybe<Array<ResolversTypes['CardViewItem']>>, ParentType, ContextType>;
  sortTypeList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  subcategoryList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingOriginalSectionParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingOriginalSectionParam'] = ResolversParentTypes['StaticLandingOriginalSectionParam']> = {
  categoryUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isComplete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  screenUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sortType?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  subcategory?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingRankingSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingRankingSection'] = ResolversParentTypes['StaticLandingRankingSection']> = {
  categoryTabList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  displayAd?: Resolver<Maybe<ResolversTypes['DisplayAd']>, ParentType, ContextType>;
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  param?: Resolver<ResolversTypes['StaticLandingRankingSectionParam'], ParentType, ContextType>;
  promotionBanner?: Resolver<Maybe<ResolversTypes['PromotionBannerItem']>, ParentType, ContextType>;
  rankingTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rankingTypeList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  subcategoryList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  viewType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  withOperationArea?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingRankingSectionParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingRankingSectionParam'] = ResolversParentTypes['StaticLandingRankingSectionParam']> = {
  categoryUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  rankingType?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  screenUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subcategory?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingTodayNewSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingTodayNewSection'] = ResolversParentTypes['StaticLandingTodayNewSection']> = {
  categoryTabList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  param?: Resolver<ResolversTypes['StaticLandingTodayNewSectionParam'], ParentType, ContextType>;
  promotionBanner?: Resolver<Maybe<ResolversTypes['PromotionBannerItem']>, ParentType, ContextType>;
  subcategoryList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  viewType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingTodayNewSectionParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingTodayNewSectionParam'] = ResolversParentTypes['StaticLandingTodayNewSectionParam']> = {
  categoryUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  screenUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subcategory?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingTodayUpSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingTodayUpSection'] = ResolversParentTypes['StaticLandingTodayUpSection']> = {
  categoryTabList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnd?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  param?: Resolver<ResolversTypes['StaticLandingTodayUpSectionParam'], ParentType, ContextType>;
  subcategoryList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StaticLandingTodayUpSectionParamResolvers<ContextType = any, ParentType extends ResolversParentTypes['StaticLandingTodayUpSectionParam'] = ResolversParentTypes['StaticLandingTodayUpSectionParam']> = {
  categoryUid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  subcategory?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StrategyCategoryGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['StrategyCategoryGroup'] = ResolversParentTypes['StrategyCategoryGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StrategyCategorySectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StrategyCategorySection'] = ResolversParentTypes['StrategyCategorySection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StrategyViewItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['StrategyViewItem'] = ResolversParentTypes['StrategyViewItem']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubCardGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubCardGroup'] = ResolversParentTypes['SubCardGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubtabMenuResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubtabMenu'] = ResolversParentTypes['SubtabMenu']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  screenList?: Resolver<Array<ResolversTypes['Screen']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['MenuType'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TabSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TabSection'] = ResolversParentTypes['TabSection']> = {
  __resolveType: TypeResolveFn<'DayOfWeekSection' | 'MainRankingSection', ParentType, ContextType>;
  sectionMainTabList?: Resolver<Maybe<Array<ResolversTypes['SectionMainTab']>>, ParentType, ContextType>;
};

export type TalkDownloadDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['TalkDownloadData'] = ResolversParentTypes['TalkDownloadData']> = {
  dec?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  host?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  talkViewerType?: Resolver<Maybe<ResolversTypes['TalkViewerType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TalkViewerDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['TalkViewerData'] = ResolversParentTypes['TalkViewerData']> = {
  talkDownloadData?: Resolver<ResolversTypes['TalkDownloadData'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ViewerDataType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TastesServiceLangResolvers<ContextType = any, ParentType extends ResolversParentTypes['TastesServiceLang'] = ResolversParentTypes['TastesServiceLang']> = {
  selectableServiceLang?: Resolver<Array<ResolversTypes['TastesServiceLangItem']>, ParentType, ContextType>;
  userServiceLang?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TastesServiceLangItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['TastesServiceLangItem'] = ResolversParentTypes['TastesServiceLangItem']> = {
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TextViewerContentDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['TextViewerContentData'] = ResolversParentTypes['TextViewerContentData']> = {
  chapterId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  contentId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  secureUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TextViewerDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['TextViewerData'] = ResolversParentTypes['TextViewerData']> = {
  atsServerUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentsList?: Resolver<Array<ResolversTypes['TextViewerContentData']>, ParentType, ContextType>;
  metaSecureUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ViewerDataType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ThemeKeywordResolvers<ContextType = any, ParentType extends ResolversParentTypes['ThemeKeyword'] = ResolversParentTypes['ThemeKeyword']> = {
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ThemeKeywordSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ThemeKeywordSection'] = ResolversParentTypes['ThemeKeywordSection']> = {
  __resolveType: TypeResolveFn<'ThemeSection', ParentType, ContextType>;
  themeKeywordList?: Resolver<Maybe<Array<ResolversTypes['ThemeKeyword']>>, ParentType, ContextType>;
};

export type ThemeSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ThemeSection'] = ResolversParentTypes['ThemeSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metaInfoType?: Resolver<Maybe<ResolversTypes['MetaInfoType']>, ParentType, ContextType>;
  scheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  themeKeywordList?: Resolver<Maybe<Array<ResolversTypes['ThemeKeyword']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketAvailableResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketAvailable'] = ResolversParentTypes['TicketAvailable']> = {
  ticketOwnType?: Resolver<Maybe<ResolversTypes['TicketType']>, ParentType, ContextType>;
  ticketRentalType?: Resolver<Maybe<ResolversTypes['TicketType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketBuyAndUseMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketBuyAndUseMutationPayload'] = ResolversParentTypes['TicketBuyAndUseMutationPayload']> = {
  buyTicketinfo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  remainCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ticketUid?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketBuyMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketBuyMutationPayload'] = ResolversParentTypes['TicketBuyMutationPayload']> = {
  purchasedTicketCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  remainCash?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketDetail'] = ResolversParentTypes['TicketDetail']> = {
  dateCompare?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isVod?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  productType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  refundTicketInfo?: Resolver<Maybe<ResolversTypes['RefundableTicketInfo']>, ParentType, ContextType>;
  refundableCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  refundableTicketNum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  salesTicket?: Resolver<Maybe<ResolversTypes['SalesTicketItem']>, ParentType, ContextType>;
  ticketUid?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  vodDiscountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketHistoryBuyExtraSimpleResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketHistoryBuyExtraSimple'] = ResolversParentTypes['TicketHistoryBuyExtraSimple']> = {
  productId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['TicketStatus']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketInSeriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketInSeries'] = ResolversParentTypes['TicketInSeries']> = {
  isEnd?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  refundInfo?: Resolver<Maybe<Array<ResolversTypes['TicketItemInSeries']>>, ParentType, ContextType>;
  seriesTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketInfo'] = ResolversParentTypes['TicketInfo']> = {
  discountPrice?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  discountRate?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rentalPeriodByMinute?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ticketId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ticketKind?: Resolver<ResolversTypes['TicketKind'], ParentType, ContextType>;
  ticketType?: Resolver<ResolversTypes['TicketType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketInfoApiResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketInfoApi'] = ResolversParentTypes['TicketInfoApi']> = {
  discount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isMovieDay?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  originPrice?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  packageOrder?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  paidTicketCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  rentExpireDurationMin?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  seriesId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  seriesTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ticketId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ticketKind?: Resolver<ResolversTypes['TicketKind'], ParentType, ContextType>;
  ticketType?: Resolver<ResolversTypes['TicketType'], ParentType, ContextType>;
  totalTicketCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  vodPromotionUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  vodServiceUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketItemInSeriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketItemInSeries'] = ResolversParentTypes['TicketItemInSeries']> = {
  createDt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  initialAmount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  remainCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  saleType?: Resolver<ResolversTypes['SaleType'], ParentType, ContextType>;
  ticketKind?: Resolver<ResolversTypes['TicketKind'], ParentType, ContextType>;
  ticketStatusText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ticketType?: Resolver<ResolversTypes['TicketType'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketMyResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketMy'] = ResolversParentTypes['TicketMy']> = {
  cashAmount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ticketOwnCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ticketRentalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketPurchaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketPurchase'] = ResolversParentTypes['TicketPurchase']> = {
  set?: Resolver<Maybe<ResolversTypes['SimpleSet']>, ParentType, ContextType>;
  ticketOwn?: Resolver<Maybe<ResolversTypes['TicketInfo']>, ParentType, ContextType>;
  ticketRental?: Resolver<Maybe<ResolversTypes['TicketInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketSeriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketSeries'] = ResolversParentTypes['TicketSeries']> = {
  isWaitfree?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  saleMethod?: Resolver<Maybe<ResolversTypes['SaleMethod']>, ParentType, ContextType>;
  waitfreeBlockCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketSetBuyMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketSetBuyMutationPayload'] = ResolversParentTypes['TicketSetBuyMutationPayload']> = {
  remainCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketSingleResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketSingle'] = ResolversParentTypes['TicketSingle']> = {
  isDone?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  readAccessType?: Resolver<ResolversTypes['ReadAccessType'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  waitfreeBlock?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketSumResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketSum'] = ResolversParentTypes['TicketSum']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ticketExpireAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  ticketKind?: Resolver<ResolversTypes['TicketKind'], ParentType, ContextType>;
  ticketType?: Resolver<ResolversTypes['TicketType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TicketUseMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['TicketUseMutationPayload'] = ResolversParentTypes['TicketUseMutationPayload']> = {
  ticketUid?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  waitfreeChargedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TodayGiftResolvers<ContextType = any, ParentType extends ResolversParentTypes['TodayGift'] = ResolversParentTypes['TodayGift']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isReceived?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  seriesId?: Resolver<Maybe<ResolversTypes['Long']>, ParentType, ContextType>;
  ticketCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ticketExpireAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  ticketExpiredText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ticketKind?: Resolver<ResolversTypes['TicketKind'], ParentType, ContextType>;
  ticketType?: Resolver<ResolversTypes['TicketType'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TodayGiftListResolvers<ContextType = any, ParentType extends ResolversParentTypes['TodayGiftList'] = ResolversParentTypes['TodayGiftList']> = {
  categoryList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  displayAd?: Resolver<Maybe<ResolversTypes['DisplayAd']>, ParentType, ContextType>;
  helixDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  helixList?: Resolver<Array<ResolversTypes['HelixTodayGiftList']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  list?: Resolver<Array<ResolversTypes['NormalListViewItem']>, ParentType, ContextType>;
  promotionList?: Resolver<Array<ResolversTypes['NormalListViewItem']>, ParentType, ContextType>;
  promotionTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receivableTicketCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  selectedCategory?: Resolver<ResolversTypes['SortOption'], ParentType, ContextType>;
  selectedSubCategory?: Resolver<Maybe<ResolversTypes['SortOption']>, ParentType, ContextType>;
  subCategoryList?: Resolver<Array<ResolversTypes['SortOption']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TodaySeriesGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['TodaySeriesGroup'] = ResolversParentTypes['TodaySeriesGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TopSection'] = ResolversParentTypes['TopSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRecommendArea?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isRecommendedItems?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TranslatePropertyResolvers<ContextType = any, ParentType extends ResolversParentTypes['TranslateProperty'] = ResolversParentTypes['TranslateProperty']> = {
  category?: Resolver<Maybe<ResolversTypes['LocaleMap']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['LocaleMap']>, ParentType, ContextType>;
  sub_category?: Resolver<Maybe<ResolversTypes['LocaleMap']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['LocaleMap']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TvPointAgreementResolvers<ContextType = any, ParentType extends ResolversParentTypes['TvPointAgreement'] = ResolversParentTypes['TvPointAgreement']> = {
  isAgree?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnknownGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnknownGroup'] = ResolversParentTypes['UnknownGroup']> = {
  dataKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  groups?: Resolver<Maybe<Array<ResolversTypes['Group']>>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  items?: Resolver<Maybe<Array<ResolversTypes['Item']>>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['GroupType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnknownItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnknownItem'] = ResolversParentTypes['UnknownItem']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ItemType'], ParentType, ContextType>;
  voType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnknownSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnknownSection'] = ResolversParentTypes['UnknownSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnregisterUserStatusPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnregisterUserStatusPayload'] = ResolversParentTypes['UnregisterUserStatusPayload']> = {
  status?: Resolver<Maybe<ResolversTypes['ResultStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdateNicknamePayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateNicknamePayload'] = ResolversParentTypes['UpdateNicknamePayload']> = {
  nickname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shouldUpdateProfile?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UsedTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['UsedTicket'] = ResolversParentTypes['UsedTicket']> = {
  cancelDt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createDt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paidTicket?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  productType?: Resolver<ResolversTypes['ProductType'], ParentType, ContextType>;
  publisherUid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  readEndDt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  saleType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seriesId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  seriesTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  singleTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ticketUid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userUid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  appUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authenticatedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  kakaoAccountId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  needProfileUpdate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['UserState']>, ParentType, ContextType>;
  thumbnail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['UserType']>, ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAndCashPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserAndCashPayload'] = ResolversParentTypes['UserAndCashPayload']> = {
  cash?: Resolver<Maybe<ResolversTypes['UserCash']>, ParentType, ContextType, RequireFields<UserAndCashPayloadCashArgs, never>>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<UserAndCashPayloadUserArgs, never>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserBasedRecommendSectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserBasedRecommendSection'] = ResolversParentTypes['UserBasedRecommendSection']> = {
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SectionType'], ParentType, ContextType>;
  uid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCashResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCash'] = ResolversParentTypes['UserCash']> = {
  detail?: Resolver<Maybe<ResolversTypes['UserCashDetail']>, ParentType, ContextType>;
  expiredCredit?: Resolver<Maybe<ResolversTypes['ExpiredCredit']>, ParentType, ContextType>;
  remainCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCashDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCashDetail'] = ResolversParentTypes['UserCashDetail']> = {
  eventSum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  paidSum?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalBalance?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ViewImpContentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewImpContents'] = ResolversParentTypes['ViewImpContents']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imp_area_ordnum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imp_id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imp_ordnum?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imp_provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imp_type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  layer1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  layer2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ViewerDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewerData'] = ResolversParentTypes['ViewerData']> = {
  __resolveType: TypeResolveFn<'ImageViewerData' | 'TalkViewerData' | 'TextViewerData' | 'VodViewerData', ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ViewerDataType'], ParentType, ContextType>;
};

export type ViewerEndResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewerEnd'] = ResolversParentTypes['ViewerEnd']> = {
  alarmOn?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  commentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  contentRecommendGroup?: Resolver<Maybe<ResolversTypes['ContentRecommendGroup']>, ParentType, ContextType>;
  displayAd?: Resolver<Maybe<ResolversTypes['DisplayAd']>, ParentType, ContextType>;
  likeOn?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  nextItem?: Resolver<Maybe<ResolversTypes['Single']>, ParentType, ContextType>;
  onIssue?: Resolver<ResolversTypes['OnIssue'], ParentType, ContextType>;
  originalRawDataStr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ratingCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  ratingSum?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  relatedSeries?: Resolver<Maybe<ResolversTypes['Series']>, ParentType, ContextType>;
  viewerEndPreviewComment?: Resolver<Maybe<ResolversTypes['ViewerEndComment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ViewerEndCommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewerEndComment'] = ResolversParentTypes['ViewerEndComment']> = {
  comment?: Resolver<ResolversTypes['PreviewComment'], ParentType, ContextType>;
  sortOpt?: Resolver<ResolversTypes['SortOption'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ViewerInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['ViewerInfo'] = ResolversParentTypes['ViewerInfo']> = {
  displayAd?: Resolver<Maybe<ResolversTypes['DisplayAd']>, ParentType, ContextType>;
  item?: Resolver<ResolversTypes['Single'], ParentType, ContextType>;
  nextItem?: Resolver<Maybe<ResolversTypes['NearItem']>, ParentType, ContextType>;
  prevItem?: Resolver<Maybe<ResolversTypes['NearItem']>, ParentType, ContextType>;
  seriesItem?: Resolver<ResolversTypes['Series'], ParentType, ContextType>;
  viewerData?: Resolver<Maybe<ResolversTypes['ViewerData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VodDownloadDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['VodDownloadData'] = ResolversParentTypes['VodDownloadData']> = {
  contentPackId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  drmServerType?: Resolver<ResolversTypes['DrmServerType'], ParentType, ContextType>;
  drmType?: Resolver<ResolversTypes['DrmType'], ParentType, ContextType>;
  duration?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  endpointUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VodTokenResolvers<ContextType = any, ParentType extends ResolversParentTypes['VodToken'] = ResolversParentTypes['VodToken']> = {
  provider?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VodViewerDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['VodViewerData'] = ResolversParentTypes['VodViewerData']> = {
  drmInfo?: Resolver<Maybe<ResolversTypes['DrmInfo']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ViewerDataType'], ParentType, ContextType>;
  vodDownloadData?: Resolver<Maybe<ResolversTypes['VodDownloadData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WaitfreeTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['WaitfreeTicket'] = ResolversParentTypes['WaitfreeTicket']> = {
  chargedAt?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  chargedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  chargedPeriod?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WelcomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Welcome'] = ResolversParentTypes['Welcome']> = {
  recommendContents?: Resolver<ResolversTypes['WelcomeRecommendContents'], ParentType, ContextType>;
  welcomeInfo?: Resolver<ResolversTypes['WelcomeInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WelcomeButtonInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['WelcomeButtonInfo'] = ResolversParentTypes['WelcomeButtonInfo']> = {
  kageId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scheme?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WelcomeInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['WelcomeInfo'] = ResolversParentTypes['WelcomeInfo']> = {
  userNickname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  welcomeButtons?: Resolver<Array<ResolversTypes['WelcomeButtonInfo']>, ParentType, ContextType>;
  welcomeCash?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  welcomeMessage?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WelcomeRecommendContentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['WelcomeRecommendContents'] = ResolversParentTypes['WelcomeRecommendContents']> = {
  novelList?: Resolver<Array<ResolversTypes['WelcomeRecommendItem']>, ParentType, ContextType>;
  webtoonList?: Resolver<Array<ResolversTypes['WelcomeRecommendItem']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WelcomeRecommendItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['WelcomeRecommendItem'] = ResolversParentTypes['WelcomeRecommendItem']> = {
  authors?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  categoryUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  freeSlideCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  scheme?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  seriesId?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  subCategory?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subCategoryUid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  themeKeywordList?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  viewCount?: Resolver<ResolversTypes['Long'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WriteCommentPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['WriteCommentPayload'] = ResolversParentTypes['WriteCommentPayload']> = {
  blockMsg?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recordid?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ResultStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  ActivateUser?: ActivateUserResolvers<ContextType>;
  AgeAuth?: AgeAuthResolvers<ContextType>;
  AgreedAgreement?: AgreedAgreementResolvers<ContextType>;
  Agreement?: AgreementResolvers<ContextType>;
  AgreementContainer?: AgreementContainerResolvers<ContextType>;
  AgreementInfo?: AgreementInfoResolvers<ContextType>;
  AgreementUnder14Container?: AgreementUnder14ContainerResolvers<ContextType>;
  AlarmSection?: AlarmSectionResolvers<ContextType>;
  Announcement?: AnnouncementResolvers<ContextType>;
  AnnouncementContainer?: AnnouncementContainerResolvers<ContextType>;
  AppBadge?: AppBadgeResolvers<ContextType>;
  AppConfig?: AppConfigResolvers<ContextType>;
  AppInit?: AppInitResolvers<ContextType>;
  AppSetting?: AppSettingResolvers<ContextType>;
  AppSettingPayload?: AppSettingPayloadResolvers<ContextType>;
  AssetProperty?: AssetPropertyResolvers<ContextType>;
  AuthInfo?: AuthInfoResolvers<ContextType>;
  AuthRequestInfo?: AuthRequestInfoResolvers<ContextType>;
  AuthRequestInfoError?: AuthRequestInfoErrorResolvers<ContextType>;
  Author?: AuthorResolvers<ContextType>;
  Authors?: AuthorsResolvers<ContextType>;
  AutoCompleteItem?: AutoCompleteItemResolvers<ContextType>;
  AutomaticEvent?: AutomaticEventResolvers<ContextType>;
  BankCode?: BankCodeResolvers<ContextType>;
  BannerItem?: BannerItemResolvers<ContextType>;
  BannerSet?: BannerSetResolvers<ContextType>;
  BigBannerGroup?: BigBannerGroupResolvers<ContextType>;
  BigBannerSection?: BigBannerSectionResolvers<ContextType>;
  BigInt?: GraphQLScalarType;
  BlockUserList?: BlockUserListResolvers<ContextType>;
  BuyCashHistoryList?: BuyCashHistoryListResolvers<ContextType>;
  BuyHistory?: BuyHistoryResolvers<ContextType>;
  CardCover?: CardCoverResolvers<ContextType>;
  CardSection?: CardSectionResolvers<ContextType>;
  CardSet?: CardSetResolvers<ContextType>;
  CardViewGroup?: CardViewGroupResolvers<ContextType>;
  CardViewItem?: CardViewItemResolvers<ContextType>;
  Cash?: CashResolvers<ContextType>;
  CashFriendsSection?: CashFriendsSectionResolvers<ContextType>;
  CategorySelectedDayPair?: CategorySelectedDayPairResolvers<ContextType>;
  Character?: CharacterResolvers<ContextType>;
  CheckUnregister?: CheckUnregisterResolvers<ContextType>;
  CleanViewGroup?: CleanViewGroupResolvers<ContextType>;
  CleanViewItem?: CleanViewItemResolvers<ContextType>;
  ClickLog?: ClickLogResolvers<ContextType>;
  CommentCommonPayload?: CommentCommonPayloadResolvers<ContextType>;
  CommentItem?: CommentItemResolvers<ContextType>;
  CommentList?: CommentListResolvers<ContextType>;
  ContentBuyTicketPage?: ContentBuyTicketPageResolvers<ContextType>;
  ContentCheckFreeTicket?: ContentCheckFreeTicketResolvers<ContextType>;
  ContentDetail?: ContentDetailResolvers<ContextType>;
  ContentHomeAbout?: ContentHomeAboutResolvers<ContextType>;
  ContentHomeBriefList?: ContentHomeBriefListResolvers<ContextType>;
  ContentHomeDetailInfo?: ContentHomeDetailInfoResolvers<ContextType>;
  ContentHomeInfo?: ContentHomeInfoResolvers<ContextType>;
  ContentHomeInfoRankingLanding?: ContentHomeInfoRankingLandingResolvers<ContextType>;
  ContentHomeLabelBadge?: ContentHomeLabelBadgeResolvers<ContextType>;
  ContentHomeNotice?: ContentHomeNoticeResolvers<ContextType>;
  ContentHomeOverview?: ContentHomeOverviewResolvers<ContextType>;
  ContentHomeRecommend?: ContentHomeRecommendResolvers<ContextType>;
  ContentMyTicket?: ContentMyTicketResolvers<ContextType>;
  ContentRecommendGroup?: ContentRecommendGroupResolvers<ContextType>;
  ContentSetList?: ContentSetListResolvers<ContextType>;
  ContentSetOverview?: ContentSetOverviewResolvers<ContextType>;
  ContentTicketHistoryBuy?: ContentTicketHistoryBuyResolvers<ContextType>;
  ContentTicketHistoryBuyDetail?: ContentTicketHistoryBuyDetailResolvers<ContextType>;
  ContentTicketInfo?: ContentTicketInfoResolvers<ContextType>;
  ContentWaitfreeInfo?: ContentWaitfreeInfoResolvers<ContextType>;
  ContinueInfo?: ContinueInfoResolvers<ContextType>;
  CustomProps?: CustomPropsResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DayOfWeekLayout?: DayOfWeekLayoutResolvers<ContextType>;
  DayOfWeekList?: DayOfWeekListResolvers<ContextType>;
  DayOfWeekSection?: DayOfWeekSectionResolvers<ContextType>;
  DeclareCommonPayload?: DeclareCommonPayloadResolvers<ContextType>;
  DeleteInvenPayload?: DeleteInvenPayloadResolvers<ContextType>;
  DependOnLoggedInSection?: DependOnLoggedInSectionResolvers<ContextType>;
  Device?: DeviceResolvers<ContextType>;
  DeviceInfo?: DeviceInfoResolvers<ContextType>;
  DeviceStatusPayload?: DeviceStatusPayloadResolvers<ContextType>;
  DisplayAd?: DisplayAdResolvers<ContextType>;
  DisplayAdGroup?: DisplayAdGroupResolvers<ContextType>;
  DisplayAdItem?: DisplayAdItemResolvers<ContextType>;
  DisplayAdSection?: DisplayAdSectionResolvers<ContextType>;
  DkpgRequestPayload?: DkpgRequestPayloadResolvers<ContextType>;
  DrawGotchaPayload?: DrawGotchaPayloadResolvers<ContextType>;
  DrmInfo?: DrmInfoResolvers<ContextType>;
  DynamicLayout?: DynamicLayoutResolvers<ContextType>;
  DynamicLayoutReference?: DynamicLayoutReferenceResolvers<ContextType>;
  Emoticon?: EmoticonResolvers<ContextType>;
  EpisodeSection?: EpisodeSectionResolvers<ContextType>;
  EventBannerGroup?: EventBannerGroupResolvers<ContextType>;
  EventBannerItem?: EventBannerItemResolvers<ContextType>;
  EventLog?: EventLogResolvers<ContextType>;
  EventMeta?: EventMetaResolvers<ContextType>;
  EventSection?: EventSectionResolvers<ContextType>;
  ExpiredCredit?: ExpiredCreditResolvers<ContextType>;
  FilterOption?: FilterOptionResolvers<ContextType>;
  Font?: FontResolvers<ContextType>;
  GetEventInfoPayload?: GetEventInfoPayloadResolvers<ContextType>;
  GlobalAgreementInfo?: GlobalAgreementInfoResolvers<ContextType>;
  GlobalParentVerificationIsCompleted?: GlobalParentVerificationIsCompletedResolvers<ContextType>;
  GlobalSendParentVerifyPayload?: GlobalSendParentVerifyPayloadResolvers<ContextType>;
  GlobalSignupPayload?: GlobalSignupPayloadResolvers<ContextType>;
  GlobalUser?: GlobalUserResolvers<ContextType>;
  GotchaInfo?: GotchaInfoResolvers<ContextType>;
  Group?: GroupResolvers<ContextType>;
  HelixSeries?: HelixSeriesResolvers<ContextType>;
  HelixSeriesList?: HelixSeriesListResolvers<ContextType>;
  HelixThemeSection?: HelixThemeSectionResolvers<ContextType>;
  HelixTodayGiftList?: HelixTodayGiftListResolvers<ContextType>;
  History?: HistoryResolvers<ContextType>;
  HistoryLineBanner?: HistoryLineBannerResolvers<ContextType>;
  HistoryList?: HistoryListResolvers<ContextType>;
  HorizontalScrollGroup?: HorizontalScrollGroupResolvers<ContextType>;
  ImageDownloadData?: ImageDownloadDataResolvers<ContextType>;
  ImageDownloadFile?: ImageDownloadFileResolvers<ContextType>;
  ImageViewerData?: ImageViewerDataResolvers<ContextType>;
  InvenList?: InvenListResolvers<ContextType>;
  InvenMyInfo?: InvenMyInfoResolvers<ContextType>;
  InvenRecommendList?: InvenRecommendListResolvers<ContextType>;
  Item?: ItemResolvers<ContextType>;
  ItemBanner?: ItemBannerResolvers<ContextType>;
  KakaoCashReportData?: KakaoCashReportDataResolvers<ContextType>;
  LastViewInfo?: LastViewInfoResolvers<ContextType>;
  Layout?: LayoutResolvers<ContextType>;
  LayoutReferenceViewData?: LayoutReferenceViewDataResolvers<ContextType>;
  LegacySingle?: LegacySingleResolvers<ContextType>;
  LikeCommentPayload?: LikeCommentPayloadResolvers<ContextType>;
  LineBannerGroup?: LineBannerGroupResolvers<ContextType>;
  LineBannerItem?: LineBannerItemResolvers<ContextType>;
  LineBannerSection?: LineBannerSectionResolvers<ContextType>;
  ListViewGroup?: ListViewGroupResolvers<ContextType>;
  ListViewGroupMeta?: ListViewGroupMetaResolvers<ContextType>;
  LocaleMap?: LocaleMapResolvers<ContextType>;
  Long?: GraphQLScalarType;
  MainRankingListViewGroup?: MainRankingListViewGroupResolvers<ContextType>;
  MainRankingSection?: MainRankingSectionResolvers<ContextType>;
  Menu?: MenuResolvers<ContextType>;
  MetaInfoTypeSection?: MetaInfoTypeSectionResolvers<ContextType>;
  MoreItem?: MoreItemResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  MyInfo?: MyInfoResolvers<ContextType>;
  MyNewsItem?: MyNewsItemResolvers<ContextType>;
  MyNewsList?: MyNewsListResolvers<ContextType>;
  MyRating?: MyRatingResolvers<ContextType>;
  NearItem?: NearItemResolvers<ContextType>;
  NormalListViewItem?: NormalListViewItemResolvers<ContextType>;
  NormalListViewItemRow3?: NormalListViewItemRow3Resolvers<ContextType>;
  Object?: GraphQLScalarType;
  OnAirGroup?: OnAirGroupResolvers<ContextType>;
  OnAirItem?: OnAirItemResolvers<ContextType>;
  OnAirSection?: OnAirSectionResolvers<ContextType>;
  OperatorProperty?: OperatorPropertyResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Paging?: PagingResolvers<ContextType>;
  Popup?: PopupResolvers<ContextType>;
  PopupInfo?: PopupInfoResolvers<ContextType>;
  PosterViewGroup?: PosterViewGroupResolvers<ContextType>;
  PosterViewItem?: PosterViewItemResolvers<ContextType>;
  PrepareAuthRequestInfoError?: PrepareAuthRequestInfoErrorResolvers<ContextType>;
  PrepareAuthRequestInfoPayload?: PrepareAuthRequestInfoPayloadResolvers<ContextType>;
  Preview?: PreviewResolvers<ContextType>;
  PreviewComment?: PreviewCommentResolvers<ContextType>;
  PromotionBannerGroup?: PromotionBannerGroupResolvers<ContextType>;
  PromotionBannerItem?: PromotionBannerItemResolvers<ContextType>;
  PromotionBannerSection?: PromotionBannerSectionResolvers<ContextType>;
  PromotionCardViewItem?: PromotionCardViewItemResolvers<ContextType>;
  PurchaseInfo?: PurchaseInfoResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RankingListViewItem?: RankingListViewItemResolvers<ContextType>;
  RankingSection?: RankingSectionResolvers<ContextType>;
  RankingV2Section?: RankingV2SectionResolvers<ContextType>;
  ReadyToUseTicket?: ReadyToUseTicketResolvers<ContextType>;
  ReceiptInfo?: ReceiptInfoResolvers<ContextType>;
  ReceiptInfoResult?: ReceiptInfoResultResolvers<ContextType>;
  ReceiptInfoStatusPayload?: ReceiptInfoStatusPayloadResolvers<ContextType>;
  RecentViewedSection?: RecentViewedSectionResolvers<ContextType>;
  RecommendEvent?: RecommendEventResolvers<ContextType>;
  RecommendSection?: RecommendSectionResolvers<ContextType>;
  RedeemCode?: RedeemCodeResolvers<ContextType>;
  RefundRequestPayload?: RefundRequestPayloadResolvers<ContextType>;
  RefundTicketStatusPayload?: RefundTicketStatusPayloadResolvers<ContextType>;
  RefundableAmount?: RefundableAmountResolvers<ContextType>;
  RefundableTicketInfo?: RefundableTicketInfoResolvers<ContextType>;
  RemoveMyNewsPayload?: RemoveMyNewsPayloadResolvers<ContextType>;
  ReqInfoNotExist?: ReqInfoNotExistResolvers<ContextType>;
  ResponsiveBannerGroup?: ResponsiveBannerGroupResolvers<ContextType>;
  RouletteDrawPayload?: RouletteDrawPayloadResolvers<ContextType>;
  RouletteInfo?: RouletteInfoResolvers<ContextType>;
  SalesTicket?: SalesTicketResolvers<ContextType>;
  SalesTicketItem?: SalesTicketItemResolvers<ContextType>;
  SampleError?: SampleErrorResolvers<ContextType>;
  SaveAuthInfoPayload?: SaveAuthInfoPayloadResolvers<ContextType>;
  SchemeSection?: SchemeSectionResolvers<ContextType>;
  Screen?: ScreenResolvers<ContextType>;
  ScrollThemeSection?: ScrollThemeSectionResolvers<ContextType>;
  SearchAutoComplete?: SearchAutoCompleteResolvers<ContextType>;
  SearchKeyword?: SearchKeywordResolvers<ContextType>;
  SearchMain?: SearchMainResolvers<ContextType>;
  SearchPopularKeywordRank?: SearchPopularKeywordRankResolvers<ContextType>;
  SearchThemeKeyword?: SearchThemeKeywordResolvers<ContextType>;
  Section?: SectionResolvers<ContextType>;
  SectionMainTab?: SectionMainTabResolvers<ContextType>;
  SectionSubTab?: SectionSubTabResolvers<ContextType>;
  SendEmailVerifyCodePayload?: SendEmailVerifyCodePayloadResolvers<ContextType>;
  Series?: SeriesResolvers<ContextType>;
  SeriesBasedRecommendSection?: SeriesBasedRecommendSectionResolvers<ContextType>;
  SeriesCardViewLandingList?: SeriesCardViewLandingListResolvers<ContextType>;
  SeriesListViewLandingList?: SeriesListViewLandingListResolvers<ContextType>;
  SeriesNotice?: SeriesNoticeResolvers<ContextType>;
  SeriesNoticeListContainer?: SeriesNoticeListContainerResolvers<ContextType>;
  SeriesPosterViewLandingList?: SeriesPosterViewLandingListResolvers<ContextType>;
  SeriesPreview?: SeriesPreviewResolvers<ContextType>;
  ServiceProperty?: ServicePropertyResolvers<ContextType>;
  Set?: SetResolvers<ContextType>;
  SetAgreementPayload?: SetAgreementPayloadResolvers<ContextType>;
  SetGlobalAgreementPayload?: SetGlobalAgreementPayloadResolvers<ContextType>;
  SetListViewLandingList?: SetListViewLandingListResolvers<ContextType>;
  SetMyRatingPayload?: SetMyRatingPayloadResolvers<ContextType>;
  SetPosterViewLandingList?: SetPosterViewLandingListResolvers<ContextType>;
  SetProduct?: SetProductResolvers<ContextType>;
  SetReadyToUseTicket?: SetReadyToUseTicketResolvers<ContextType>;
  SetSeriesAlarmPayload?: SetSeriesAlarmPayloadResolvers<ContextType>;
  SetSeriesLikePayload?: SetSeriesLikePayloadResolvers<ContextType>;
  SetTicketMy?: SetTicketMyResolvers<ContextType>;
  SetTvPointAgreementPayload?: SetTvPointAgreementPayloadResolvers<ContextType>;
  ShortVodPreviewViewerInfo?: ShortVodPreviewViewerInfoResolvers<ContextType>;
  ShortcutItem?: ShortcutItemResolvers<ContextType>;
  ShortcutItemList?: ShortcutItemListResolvers<ContextType>;
  ShortcutList?: ShortcutListResolvers<ContextType>;
  ShortcutMenuItem?: ShortcutMenuItemResolvers<ContextType>;
  SimpleImageBanner?: SimpleImageBannerResolvers<ContextType>;
  SimpleSeriesSingleInfo?: SimpleSeriesSingleInfoResolvers<ContextType>;
  SimpleSet?: SimpleSetResolvers<ContextType>;
  Single?: SingleResolvers<ContextType>;
  SingleEdge?: SingleEdgeResolvers<ContextType>;
  SingleListConnection?: SingleListConnectionResolvers<ContextType>;
  SingleListViewItem?: SingleListViewItemResolvers<ContextType>;
  SingleListViewItemRow3?: SingleListViewItemRow3Resolvers<ContextType>;
  SingleListViewLandingList?: SingleListViewLandingListResolvers<ContextType>;
  SinglePreview?: SinglePreviewResolvers<ContextType>;
  SingleTicketInfo?: SingleTicketInfoResolvers<ContextType>;
  SortOption?: SortOptionResolvers<ContextType>;
  StandaloneBannerAndSubCardGroup?: StandaloneBannerAndSubCardGroupResolvers<ContextType>;
  StandaloneBannerGroup?: StandaloneBannerGroupResolvers<ContextType>;
  StaticLandingDayOfWeekSection?: StaticLandingDayOfWeekSectionResolvers<ContextType>;
  StaticLandingDayOfWeekSectionParam?: StaticLandingDayOfWeekSectionParamResolvers<ContextType>;
  StaticLandingEventSection?: StaticLandingEventSectionResolvers<ContextType>;
  StaticLandingEventSectionParam?: StaticLandingEventSectionParamResolvers<ContextType>;
  StaticLandingFreeSeriesSection?: StaticLandingFreeSeriesSectionResolvers<ContextType>;
  StaticLandingFreeSeriesSectionParam?: StaticLandingFreeSeriesSectionParamResolvers<ContextType>;
  StaticLandingGenreSection?: StaticLandingGenreSectionResolvers<ContextType>;
  StaticLandingGenreSectionParam?: StaticLandingGenreSectionParamResolvers<ContextType>;
  StaticLandingOriginalSection?: StaticLandingOriginalSectionResolvers<ContextType>;
  StaticLandingOriginalSectionParam?: StaticLandingOriginalSectionParamResolvers<ContextType>;
  StaticLandingRankingSection?: StaticLandingRankingSectionResolvers<ContextType>;
  StaticLandingRankingSectionParam?: StaticLandingRankingSectionParamResolvers<ContextType>;
  StaticLandingTodayNewSection?: StaticLandingTodayNewSectionResolvers<ContextType>;
  StaticLandingTodayNewSectionParam?: StaticLandingTodayNewSectionParamResolvers<ContextType>;
  StaticLandingTodayUpSection?: StaticLandingTodayUpSectionResolvers<ContextType>;
  StaticLandingTodayUpSectionParam?: StaticLandingTodayUpSectionParamResolvers<ContextType>;
  StrategyCategoryGroup?: StrategyCategoryGroupResolvers<ContextType>;
  StrategyCategorySection?: StrategyCategorySectionResolvers<ContextType>;
  StrategyViewItem?: StrategyViewItemResolvers<ContextType>;
  SubCardGroup?: SubCardGroupResolvers<ContextType>;
  SubtabMenu?: SubtabMenuResolvers<ContextType>;
  TabSection?: TabSectionResolvers<ContextType>;
  TalkDownloadData?: TalkDownloadDataResolvers<ContextType>;
  TalkViewerData?: TalkViewerDataResolvers<ContextType>;
  TastesServiceLang?: TastesServiceLangResolvers<ContextType>;
  TastesServiceLangItem?: TastesServiceLangItemResolvers<ContextType>;
  TextViewerContentData?: TextViewerContentDataResolvers<ContextType>;
  TextViewerData?: TextViewerDataResolvers<ContextType>;
  ThemeKeyword?: ThemeKeywordResolvers<ContextType>;
  ThemeKeywordSection?: ThemeKeywordSectionResolvers<ContextType>;
  ThemeSection?: ThemeSectionResolvers<ContextType>;
  TicketAvailable?: TicketAvailableResolvers<ContextType>;
  TicketBuyAndUseMutationPayload?: TicketBuyAndUseMutationPayloadResolvers<ContextType>;
  TicketBuyMutationPayload?: TicketBuyMutationPayloadResolvers<ContextType>;
  TicketDetail?: TicketDetailResolvers<ContextType>;
  TicketHistoryBuyExtraSimple?: TicketHistoryBuyExtraSimpleResolvers<ContextType>;
  TicketInSeries?: TicketInSeriesResolvers<ContextType>;
  TicketInfo?: TicketInfoResolvers<ContextType>;
  TicketInfoApi?: TicketInfoApiResolvers<ContextType>;
  TicketItemInSeries?: TicketItemInSeriesResolvers<ContextType>;
  TicketMy?: TicketMyResolvers<ContextType>;
  TicketPurchase?: TicketPurchaseResolvers<ContextType>;
  TicketSeries?: TicketSeriesResolvers<ContextType>;
  TicketSetBuyMutationPayload?: TicketSetBuyMutationPayloadResolvers<ContextType>;
  TicketSingle?: TicketSingleResolvers<ContextType>;
  TicketSum?: TicketSumResolvers<ContextType>;
  TicketUseMutationPayload?: TicketUseMutationPayloadResolvers<ContextType>;
  TodayGift?: TodayGiftResolvers<ContextType>;
  TodayGiftList?: TodayGiftListResolvers<ContextType>;
  TodaySeriesGroup?: TodaySeriesGroupResolvers<ContextType>;
  TopSection?: TopSectionResolvers<ContextType>;
  TranslateProperty?: TranslatePropertyResolvers<ContextType>;
  TvPointAgreement?: TvPointAgreementResolvers<ContextType>;
  UnknownGroup?: UnknownGroupResolvers<ContextType>;
  UnknownItem?: UnknownItemResolvers<ContextType>;
  UnknownSection?: UnknownSectionResolvers<ContextType>;
  UnregisterUserStatusPayload?: UnregisterUserStatusPayloadResolvers<ContextType>;
  UpdateNicknamePayload?: UpdateNicknamePayloadResolvers<ContextType>;
  UsedTicket?: UsedTicketResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserAndCashPayload?: UserAndCashPayloadResolvers<ContextType>;
  UserBasedRecommendSection?: UserBasedRecommendSectionResolvers<ContextType>;
  UserCash?: UserCashResolvers<ContextType>;
  UserCashDetail?: UserCashDetailResolvers<ContextType>;
  ViewImpContents?: ViewImpContentsResolvers<ContextType>;
  ViewerData?: ViewerDataResolvers<ContextType>;
  ViewerEnd?: ViewerEndResolvers<ContextType>;
  ViewerEndComment?: ViewerEndCommentResolvers<ContextType>;
  ViewerInfo?: ViewerInfoResolvers<ContextType>;
  VodDownloadData?: VodDownloadDataResolvers<ContextType>;
  VodToken?: VodTokenResolvers<ContextType>;
  VodViewerData?: VodViewerDataResolvers<ContextType>;
  WaitfreeTicket?: WaitfreeTicketResolvers<ContextType>;
  Welcome?: WelcomeResolvers<ContextType>;
  WelcomeButtonInfo?: WelcomeButtonInfoResolvers<ContextType>;
  WelcomeInfo?: WelcomeInfoResolvers<ContextType>;
  WelcomeRecommendContents?: WelcomeRecommendContentsResolvers<ContextType>;
  WelcomeRecommendItem?: WelcomeRecommendItemResolvers<ContextType>;
  WriteCommentPayload?: WriteCommentPayloadResolvers<ContextType>;
};


export type ActivateUserQueryVariables = Exact<{
  authInput?: Maybe<AuthInput>;
}>;


export type ActivateUserQuery = (
  { __typename?: 'Query' }
  & { activateUser: (
    { __typename?: 'ActivateUser' }
    & Pick<ActivateUser, 'requestExpireTime'>
  ) }
);

export type NoticesQueryVariables = Exact<{
  target?: Maybe<AnnouncementTarget>;
}>;


export type NoticesQuery = (
  { __typename?: 'Query' }
  & { notices?: Maybe<(
    { __typename?: 'AnnouncementContainer' }
    & AnnouncementContainerFragment
  )> }
);

export type HelpsQueryVariables = Exact<{
  target?: Maybe<AnnouncementTarget>;
}>;


export type HelpsQuery = (
  { __typename?: 'Query' }
  & { helps?: Maybe<(
    { __typename?: 'AnnouncementContainer' }
    & AnnouncementContainerFragment
  )> }
);

export type AppConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type AppConfigQuery = (
  { __typename?: 'Query' }
  & { appConfig?: Maybe<(
    { __typename?: 'AppConfig' }
    & { appBadge?: Maybe<(
      { __typename?: 'AppBadge' }
      & AppBadgeFragment
    )> }
  )> }
);

export type AppInitQueryVariables = Exact<{ [key: string]: never; }>;


export type AppInitQuery = (
  { __typename?: 'Query' }
  & { appConfig?: Maybe<(
    { __typename?: 'AppConfig' }
    & { appInit?: Maybe<(
      { __typename?: 'AppInit' }
      & Pick<AppInit, 'certType'>
    )> }
  )> }
);

export type AppSettingMutationVariables = Exact<{
  input: AppSettingInput;
}>;


export type AppSettingMutation = (
  { __typename?: 'Mutation' }
  & { appSetting: (
    { __typename?: 'AppSettingPayload' }
    & Pick<AppSettingPayload, 'status'>
  ) }
);

export type TastesServiceLangQueryVariables = Exact<{ [key: string]: never; }>;


export type TastesServiceLangQuery = (
  { __typename?: 'Query' }
  & { tastesServiceLang?: Maybe<(
    { __typename?: 'TastesServiceLang' }
    & Pick<TastesServiceLang, 'userServiceLang'>
    & { selectableServiceLang: Array<(
      { __typename?: 'TastesServiceLangItem' }
      & Pick<TastesServiceLangItem, 'code' | 'title'>
    )> }
  )> }
);

export type UnregisterUserMutationVariables = Exact<{ [key: string]: never; }>;


export type UnregisterUserMutation = (
  { __typename?: 'Mutation' }
  & { unregisterUser: (
    { __typename?: 'UnregisterUserStatusPayload' }
    & Pick<UnregisterUserStatusPayload, 'status'>
  ) }
);

export type GlobalEmailSignupMutationVariables = Exact<{
  input: GlobalEmailSignupInput;
}>;


export type GlobalEmailSignupMutation = (
  { __typename?: 'Mutation' }
  & { globalEmailSignup: (
    { __typename?: 'GlobalSignupPayload' }
    & Pick<GlobalSignupPayload, 'serverToken' | 'refreshToken' | 'responseTime'>
    & { user: (
      { __typename?: 'GlobalUser' }
      & GlobalUserFragment
    ) }
  ) }
);

export type GlobalSnsSignupMutationVariables = Exact<{
  input: GlobalSnsSignupInput;
}>;


export type GlobalSnsSignupMutation = (
  { __typename?: 'Mutation' }
  & { globalSnsSignup: (
    { __typename?: 'GlobalSignupPayload' }
    & Pick<GlobalSignupPayload, 'serverToken' | 'refreshToken' | 'responseTime'>
    & { user: (
      { __typename?: 'GlobalUser' }
      & GlobalUserFragment
    ) }
  ) }
);

export type KakaoBankSelfCertSupportedDeviceMutationVariables = Exact<{
  input: KakaoBankSelfCertSupportedDeviceInput;
}>;


export type KakaoBankSelfCertSupportedDeviceMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'kakaoBankSelfCertSupportedDevice'>
);

export type PrepareAuthRequestInfoQueryVariables = Exact<{
  input: PrepareAuthRequestInfoInput;
}>;


export type PrepareAuthRequestInfoQuery = (
  { __typename?: 'Query' }
  & { prepareAuthRequestInfo: (
    { __typename?: 'PrepareAuthRequestInfoPayload' }
    & { authRequestInfo?: Maybe<(
      { __typename?: 'AuthRequestInfo' }
      & Pick<AuthRequestInfo, 'authUrl'>
    )>, authRequestInfoErrors: Array<(
      { __typename?: 'ReqInfoNotExist' }
      & Pick<ReqInfoNotExist, 'message'>
    )> }
  ) }
);

export type PrepareKakaoBankAuthRequestInfoMutationVariables = Exact<{
  input: PrepareAuthRequestInfoInput;
}>;


export type PrepareKakaoBankAuthRequestInfoMutation = (
  { __typename?: 'Mutation' }
  & { prepareKakaoBankAuthRequestInfo: (
    { __typename?: 'PrepareAuthRequestInfoPayload' }
    & { authRequestInfo?: Maybe<(
      { __typename?: 'AuthRequestInfo' }
      & Pick<AuthRequestInfo, 'authUrl'>
    )>, authRequestInfoErrors: Array<(
      { __typename?: 'ReqInfoNotExist' }
      & Pick<ReqInfoNotExist, 'message'>
    )> }
  ) }
);

export type SaveAuthInfoMutationVariables = Exact<{
  input: SaveAuthInfoInput;
}>;


export type SaveAuthInfoMutation = (
  { __typename?: 'Mutation' }
  & { saveAuthInfo: (
    { __typename?: 'SaveAuthInfoPayload' }
    & { authInfo?: Maybe<(
      { __typename?: 'AuthInfo' }
      & AuthInfoFragment
    )> }
  ) }
);

export type CheckUnregisterQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckUnregisterQuery = (
  { __typename?: 'Query' }
  & { checkUnregister?: Maybe<(
    { __typename?: 'CheckUnregister' }
    & Pick<CheckUnregister, 'hasPaidTickets' | 'hasPaidCash' | 'paidCashAmount'>
  )> }
);

export type ContentHomeAboutQueryVariables = Exact<{
  seriesId: Scalars['Long'];
}>;


export type ContentHomeAboutQuery = (
  { __typename?: 'Query' }
  & { contentHomeAbout?: Maybe<(
    { __typename?: 'ContentHomeAbout' }
    & Pick<ContentHomeAbout, 'id' | 'description' | 'screenshotList' | 'guideTitle'>
    & { themeKeywordList: Array<(
      { __typename?: 'ThemeKeyword' }
      & Pick<ThemeKeyword, 'uid' | 'title' | 'scheme'>
    )>, authorList: Array<(
      { __typename?: 'Author' }
      & Pick<Author, 'id' | 'name' | 'role' | 'roleDisplayName'>
    )>, detail?: Maybe<(
      { __typename?: 'ContentDetail' }
      & Pick<ContentDetail, 'id' | 'publisherName' | 'retailPrice' | 'ageGrade' | 'category'>
    )>, characterList?: Maybe<Array<Maybe<(
      { __typename?: 'Character' }
      & Pick<Character, 'thumbnail' | 'name' | 'description'>
    )>>>, detailInfoList?: Maybe<Array<(
      { __typename?: 'ContentHomeDetailInfo' }
      & Pick<ContentHomeDetailInfo, 'title' | 'info'>
    )>> }
  )> }
);

export type ContentHomeBriefListQueryVariables = Exact<{
  seriesId: Scalars['Long'];
}>;


export type ContentHomeBriefListQuery = (
  { __typename?: 'Query' }
  & { contentHomeBriefList?: Maybe<(
    { __typename?: 'ContentHomeBriefList' }
    & Pick<ContentHomeBriefList, 'id' | 'totalCount' | 'seriesId'>
    & { list: Array<(
      { __typename?: 'SingleListViewItem' }
      & SingleListViewItemFragment
    )> }
  )> }
);

export type ContentHomeInfoQueryVariables = Exact<{
  seriesId: Scalars['Long'];
}>;


export type ContentHomeInfoQuery = (
  { __typename?: 'Query' }
  & { contentHomeInfo?: Maybe<(
    { __typename?: 'ContentHomeInfo' }
    & { about?: Maybe<(
      { __typename?: 'ContentHomeAbout' }
      & Pick<ContentHomeAbout, 'id' | 'description' | 'screenshotList' | 'guideTitle'>
      & { themeKeywordList: Array<(
        { __typename?: 'ThemeKeyword' }
        & Pick<ThemeKeyword, 'uid' | 'title' | 'scheme'>
      )>, authorList: Array<(
        { __typename?: 'Author' }
        & Pick<Author, 'id' | 'name' | 'role' | 'roleDisplayName'>
      )>, detail?: Maybe<(
        { __typename?: 'ContentDetail' }
        & Pick<ContentDetail, 'id' | 'publisherName' | 'retailPrice' | 'ageGrade' | 'category' | 'rank'>
      )>, characterList?: Maybe<Array<Maybe<(
        { __typename?: 'Character' }
        & Pick<Character, 'thumbnail' | 'name' | 'description'>
      )>>>, detailInfoList?: Maybe<Array<(
        { __typename?: 'ContentHomeDetailInfo' }
        & Pick<ContentHomeDetailInfo, 'title' | 'info'>
      )>> }
    )>, recommend?: Maybe<(
      { __typename?: 'ContentHomeRecommend' }
      & Pick<ContentHomeRecommend, 'id' | 'seriesId'>
      & { list: Array<(
        { __typename?: 'ContentRecommendGroup' }
        & ContentRecommendGroupFragment
      )> }
    )> }
  )> }
);

export type ContentHomeNoticeQueryVariables = Exact<{
  contentHomeNoticeInput: ContentHomeNoticeInput;
}>;


export type ContentHomeNoticeQuery = (
  { __typename?: 'Query' }
  & { contentHomeNotice?: Maybe<(
    { __typename?: 'ContentHomeNotice' }
    & Pick<ContentHomeNotice, 'id' | 'seriesId'>
    & { relatedEventList: Array<(
      { __typename?: 'RecommendEvent' }
      & Pick<RecommendEvent, 'id' | 'title' | 'bannerUid' | 'imageUrl' | 'scheme' | 'itemOrder'>
    )>, lineBannerList: Array<(
      { __typename?: 'LineBannerItem' }
      & Pick<LineBannerItem, 'id' | 'type' | 'scheme' | 'title' | 'subTitle' | 'bgColor' | 'rightImage'>
      & { eventLog?: Maybe<(
        { __typename?: 'EventLog' }
        & EventLogFragmentFragment
      )> }
    )>, topNotice?: Maybe<(
      { __typename?: 'SeriesNotice' }
      & Pick<SeriesNotice, 'id' | 'uid' | 'seriesId' | 'publisherUid' | 'noticeType' | 'title' | 'description' | 'createDate' | 'modifyDate' | 'isExposure' | 'seriesTitle' | 'isSystemNotice'>
    )>, noticeListContainer?: Maybe<(
      { __typename?: 'SeriesNoticeListContainer' }
      & Pick<SeriesNoticeListContainer, 'id' | 'totalCount' | 'currentPage' | 'isEnd'>
      & { noticeList: Array<(
        { __typename?: 'SeriesNotice' }
        & Pick<SeriesNotice, 'id' | 'uid' | 'seriesId' | 'publisherUid' | 'noticeType' | 'title' | 'description' | 'createDate' | 'modifyDate' | 'isExposure' | 'seriesTitle' | 'isSystemNotice'>
      )> }
    )> }
  )> }
);

export type ContentHomeOverviewQueryVariables = Exact<{
  seriesId: Scalars['Long'];
}>;


export type ContentHomeOverviewQuery = (
  { __typename?: 'Query' }
  & { contentHomeOverview?: Maybe<(
    { __typename?: 'ContentHomeOverview' }
    & Pick<ContentHomeOverview, 'id' | 'seriesId' | 'lastNoticeDate'>
    & { displayAd?: Maybe<(
      { __typename?: 'DisplayAd' }
      & DisplayAdFragment
      & DisplayAdFragment
    )>, content?: Maybe<(
      { __typename?: 'Series' }
      & SeriesFragmentFragment
    )>, setList?: Maybe<Array<Maybe<(
      { __typename?: 'NormalListViewItem' }
      & NormalListViewItemFragment
    )>>>, relatedSeries?: Maybe<(
      { __typename?: 'Series' }
      & SeriesFragmentFragment
    )> }
  )> }
);

export type ContentHomeProductListQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  seriesId: Scalars['Long'];
  boughtOnly?: Maybe<Scalars['Boolean']>;
  sortType?: Maybe<Scalars['String']>;
}>;


export type ContentHomeProductListQuery = (
  { __typename?: 'Query' }
  & { contentHomeProductList?: Maybe<(
    { __typename?: 'SingleListConnection' }
    & Pick<SingleListConnection, 'totalCount'>
    & { pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<PageInfo, 'hasNextPage' | 'endCursor' | 'hasPreviousPage' | 'startCursor'>
    ), selectedSortOption: (
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'id' | 'name' | 'param'>
    ), sortOptionList: Array<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'id' | 'name' | 'param'>
    )>, edges: Array<(
      { __typename?: 'SingleEdge' }
      & Pick<SingleEdge, 'cursor'>
      & { node: (
        { __typename?: 'SingleListViewItem' }
        & SingleListViewItemFragment
      ) }
    )> }
  )> }
);

export type ContentHomeRecommendQueryVariables = Exact<{
  seriesId: Scalars['Long'];
}>;


export type ContentHomeRecommendQuery = (
  { __typename?: 'Query' }
  & { contentHomeRecommend?: Maybe<(
    { __typename?: 'ContentHomeRecommend' }
    & Pick<ContentHomeRecommend, 'id' | 'seriesId'>
    & { list: Array<(
      { __typename?: 'ContentRecommendGroup' }
      & ContentRecommendGroupFragment
    )> }
  )> }
);

export type ContentProductCursorIndexQueryVariables = Exact<{
  seriesId: Scalars['Long'];
  sortType?: Maybe<Scalars['String']>;
}>;


export type ContentProductCursorIndexQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'contentProductCursorIndex'>
);

export type ContentSetListQueryVariables = Exact<{
  seriesId: Scalars['Long'];
  productId: Scalars['Long'];
}>;


export type ContentSetListQuery = (
  { __typename?: 'Query' }
  & { contentSetList?: Maybe<(
    { __typename?: 'ContentSetList' }
    & { setList?: Maybe<Array<(
      { __typename?: 'NormalListViewItem' }
      & NormalListViewItemFragment
    )>> }
  )> }
);

export type ContentSetOverviewQueryVariables = Exact<{
  setId: Scalars['String'];
}>;


export type ContentSetOverviewQuery = (
  { __typename?: 'Query' }
  & { contentSetOverview?: Maybe<(
    { __typename?: 'ContentSetOverview' }
    & { set?: Maybe<(
      { __typename?: 'Set' }
      & SetFragmentFragment
    )>, series?: Maybe<(
      { __typename?: 'Series' }
      & SeriesFragmentFragment
    )>, productList?: Maybe<Array<Maybe<(
      { __typename?: 'PosterViewItem' }
      & PosterViewItemFragment
    )>>> }
  )> }
);

export type SimpleSeriesSingleInfoQueryVariables = Exact<{
  seriesId: Scalars['Long'];
  productId?: Maybe<Scalars['Long']>;
}>;


export type SimpleSeriesSingleInfoQuery = (
  { __typename?: 'Query' }
  & { simpleSeriesSingleInfo?: Maybe<(
    { __typename?: 'SimpleSeriesSingleInfo' }
    & Pick<SimpleSeriesSingleInfo, 'seriesAgeGrade' | 'singleAgeGrade' | 'singleSlideType' | 'singleIsFree' | 'singleIsTextViewer' | 'seriesSaleState' | 'singleSaleState'>
  )> }
);

export type GetRefundableAmountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRefundableAmountQuery = (
  { __typename?: 'Query' }
  & { refundableAmount?: Maybe<(
    { __typename?: 'RefundableAmount' }
    & Pick<RefundableAmount, 'totalRemainAmount' | 'notRefundableAmount' | 'usedEventCash' | 'refundableAmount' | 'refundFee' | 'finalRefundableAmount'>
  )> }
);

export type RequestCreditRefundMutationVariables = Exact<{
  input: RefundRequestInput;
}>;


export type RequestCreditRefundMutation = (
  { __typename?: 'Mutation' }
  & { refundRequest: (
    { __typename?: 'RefundRequestPayload' }
    & Pick<RefundRequestPayload, 'status' | 'statusCode'>
  ) }
);

export type DayOfWeekLayoutQueryVariables = Exact<{
  dayUid?: Maybe<Scalars['Int']>;
}>;


export type DayOfWeekLayoutQuery = (
  { __typename?: 'Query' }
  & { dayOfWeekLayout?: Maybe<(
    { __typename?: 'DayOfWeekLayout' }
    & DayOfWeekLayoutFragment
  )> }
);

export type DayOfWeekListQueryVariables = Exact<{
  referenceKey: Scalars['String'];
  dayUid?: Maybe<Scalars['Int']>;
  hasBanner?: Maybe<Scalars['Boolean']>;
  sortType?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
}>;


export type DayOfWeekListQuery = (
  { __typename?: 'Query' }
  & { dayOfWeekList?: Maybe<(
    { __typename?: 'DayOfWeekList' }
    & DayOfWeekListFragment
  )> }
);

export type SampleErrorQueryVariables = Exact<{
  pagewebErrorType: Scalars['String'];
}>;


export type SampleErrorQuery = (
  { __typename?: 'Query' }
  & { sampleError?: Maybe<(
    { __typename?: 'SampleError' }
    & Pick<SampleError, 'sample'>
  )> }
);

export type AddDeviceMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type AddDeviceMutation = (
  { __typename?: 'Mutation' }
  & { addDevice: (
    { __typename?: 'DeviceStatusPayload' }
    & Pick<DeviceStatusPayload, 'status'>
  ) }
);

export type DeleteDeviceMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type DeleteDeviceMutation = (
  { __typename?: 'Mutation' }
  & { deleteDevice: (
    { __typename?: 'DeviceStatusPayload' }
    & Pick<DeviceStatusPayload, 'status'>
  ) }
);

export type DeviceInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type DeviceInfoQuery = (
  { __typename?: 'Query' }
  & { deviceInfo: (
    { __typename?: 'DeviceInfo' }
    & Pick<DeviceInfo, 'deviceReplaceableCount' | 'deviceLimitCount'>
    & { deviceList: Array<(
      { __typename?: 'Device' }
      & DeviceFragment
    )> }
  ) }
);

export type GetBankCodeListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBankCodeListQuery = (
  { __typename?: 'Query' }
  & { bankCodeList?: Maybe<Array<Maybe<(
    { __typename?: 'BankCode' }
    & Pick<BankCode, 'code' | 'name'>
  )>>> }
);

export type VerifyBankAccountQueryVariables = Exact<{
  input: AuthBankAccountInput;
}>;


export type VerifyBankAccountQuery = (
  { __typename?: 'Query' }
  & { authBankAccount: (
    { __typename?: 'DkpgRequestPayload' }
    & Pick<DkpgRequestPayload, 'status'>
  ) }
);

export type CheckEmailVerifyCodeMutationVariables = Exact<{
  checkEmailVerifyCodeInput: CheckEmailVerifyCodeInput;
}>;


export type CheckEmailVerifyCodeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'checkEmailVerifyCode'>
);

export type GetGlobalParentVerificationIsCompletedQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type GetGlobalParentVerificationIsCompletedQuery = (
  { __typename?: 'Query' }
  & { getGlobalParentVerificationIsCompleted?: Maybe<(
    { __typename?: 'GlobalParentVerificationIsCompleted' }
    & Pick<GlobalParentVerificationIsCompleted, 'isCompleted'>
  )> }
);

export type GlobalCheckParentVerifyMutationVariables = Exact<{
  input: GlobalCheckParentVerifyInput;
}>;


export type GlobalCheckParentVerifyMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'globalCheckParentVerify'>
);

export type GlobalSavePrivateMutationVariables = Exact<{
  input: GlobalSavePrivateInput;
}>;


export type GlobalSavePrivateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'globalSavePrivate'>
);

export type SendEmailVerifyCodeMutationVariables = Exact<{
  sendEmailVerifyCodeInput: SendEmailVerifyCodeInput;
}>;


export type SendEmailVerifyCodeMutation = (
  { __typename?: 'Mutation' }
  & { sendEmailVerifyCode: (
    { __typename?: 'SendEmailVerifyCodePayload' }
    & Pick<SendEmailVerifyCodePayload, 'verifyUuid'>
  ) }
);

export type GlobalSendParentVerifyMutationVariables = Exact<{
  input: GlobalSendParentVerifyInput;
}>;


export type GlobalSendParentVerifyMutation = (
  { __typename?: 'Mutation' }
  & { globalSendParentVerify: (
    { __typename?: 'GlobalSendParentVerifyPayload' }
    & Pick<GlobalSendParentVerifyPayload, 'verifyUuid'>
  ) }
);

export type AgreementsQueryVariables = Exact<{ [key: string]: never; }>;


export type AgreementsQuery = (
  { __typename?: 'Query' }
  & { agreements?: Maybe<(
    { __typename?: 'AgreementInfo' }
    & Pick<AgreementInfo, 'isRegistered'>
    & { agreement: (
      { __typename?: 'AgreementContainer' }
      & { itemList: Array<(
        { __typename?: 'Agreement' }
        & AgreementFragment
      )> }
    ), agreementUnder14?: Maybe<(
      { __typename?: 'AgreementUnder14Container' }
      & Pick<AgreementUnder14Container, 'title' | 'atLeast14AgeType'>
      & { itemList: Array<(
        { __typename?: 'Agreement' }
        & AgreementFragment
      )> }
    )> }
  )> }
);

export type GetGlobalAgreementsQueryVariables = Exact<{
  globalAgreementInput: GetGlobalAgreementInfoInput;
}>;


export type GetGlobalAgreementsQuery = (
  { __typename?: 'Query' }
  & { getGlobalAgreements: (
    { __typename?: 'GlobalAgreementInfo' }
    & Pick<GlobalAgreementInfo, 'isRegistered'>
    & { agreement: (
      { __typename?: 'AgreementContainer' }
      & { itemList: Array<(
        { __typename?: 'Agreement' }
        & AgreementFragment
      )> }
    ) }
  ) }
);

export type SelfCertAgreementQueryVariables = Exact<{
  authRequestType: AuthRequestType;
}>;


export type SelfCertAgreementQuery = (
  { __typename?: 'Query' }
  & { selfCertAgreement?: Maybe<(
    { __typename?: 'AgreementContainer' }
    & { itemList: Array<(
      { __typename?: 'Agreement' }
      & AgreementFragment
    )> }
  )> }
);

export type GotchaQueryVariables = Exact<{
  gotchaId: Scalars['String'];
  adLocId?: Maybe<Scalars['String']>;
  hasMapUid?: Maybe<Scalars['Boolean']>;
}>;


export type GotchaQuery = (
  { __typename?: 'Query' }
  & { gotcha?: Maybe<(
    { __typename?: 'GotchaInfo' }
    & GotchaInfoFragment
  )> }
);

export type DrawGotchaMutationVariables = Exact<{
  input: DrawGotchaInput;
  hasMapUid?: Maybe<Scalars['Boolean']>;
}>;


export type DrawGotchaMutation = (
  { __typename?: 'Mutation' }
  & { drawGotcha: (
    { __typename?: 'DrawGotchaPayload' }
    & Pick<DrawGotchaPayload, 'spinWheelDesc' | 'status' | 'winPrize' | 'winPrizeType' | 'expireDateText' | 'receiveDate'>
  ) }
);

export type RouletteInfoQueryVariables = Exact<{
  rouletteId: Scalars['String'];
  hasMapUid?: Maybe<Scalars['Boolean']>;
  rouletteAdLocId?: Maybe<Scalars['String']>;
}>;


export type RouletteInfoQuery = (
  { __typename?: 'Query' }
  & { rouletteInfo?: Maybe<(
    { __typename?: 'RouletteInfo' }
    & RouletteInfoFragment
  )> }
);

export type RouletteDrawMutationVariables = Exact<{
  input: RouletteDrawInput;
  hasMapUid?: Maybe<Scalars['Boolean']>;
}>;


export type RouletteDrawMutation = (
  { __typename?: 'Mutation' }
  & { rouletteDraw: (
    { __typename?: 'RouletteDrawPayload' }
    & Pick<RouletteDrawPayload, 'rouletteStatus' | 'prize' | 'winningDate' | 'expirationDate'>
  ) }
);

export type HelixSeriesListQueryVariables = Exact<{
  mapUid: Scalars['String'];
}>;


export type HelixSeriesListQuery = (
  { __typename?: 'Query' }
  & { helixSeriesList?: Maybe<(
    { __typename?: 'HelixSeriesList' }
    & Pick<HelixSeriesList, 'id' | 'uid' | 'ticketExpireDt' | 'nickname' | 'seriesId' | 'seriesTitle' | 'seriesThumbnailUrl' | 'description' | 'notification' | 'status' | 'ageGradeNum' | 'selfCensorship'>
    & { list: Array<(
      { __typename?: 'HelixSeries' }
      & Pick<HelixSeries, 'id' | 'seriesId' | 'title' | 'ticketCount' | 'thumbnailUrl' | 'scheme' | 'category' | 'viewCount' | 'badgeList' | 'ageGradeBadge' | 'ageGrade' | 'selfCensorship' | 'itemOrder' | 'subCategory'>
      & { eventLog?: Maybe<(
        { __typename?: 'EventLog' }
        & EventLogFragmentFragment
      )> }
    )> }
  )> }
);

export type InvenMyInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type InvenMyInfoQuery = (
  { __typename?: 'Query' }
  & { invenMyInfo?: Maybe<(
    { __typename?: 'InvenMyInfo' }
    & Pick<InvenMyInfo, 'id'>
    & { displayAd?: Maybe<(
      { __typename?: 'DisplayAd' }
      & DisplayAdFragment
    )>, myInfo: (
      { __typename?: 'MyInfo' }
      & Pick<MyInfo, 'profileImg' | 'nickname' | 'useCashPassVip' | 'cashBalance' | 'numUnusedGift'>
    ) }
  )> }
);

export type InvenRecentListQueryVariables = Exact<{
  invenListInput: InvenListInput;
}>;


export type InvenRecentListQuery = (
  { __typename?: 'Query' }
  & { invenRecentList?: Maybe<(
    { __typename?: 'InvenList' }
    & InvenListFragment
  )> }
);

export type InvenLikeListQueryVariables = Exact<{
  invenListInput: InvenListInput;
}>;


export type InvenLikeListQuery = (
  { __typename?: 'Query' }
  & { invenLikeList?: Maybe<(
    { __typename?: 'InvenList' }
    & InvenListFragment
  )> }
);

export type InvenPaidListQueryVariables = Exact<{
  invenListInput: InvenListInput;
}>;


export type InvenPaidListQuery = (
  { __typename?: 'Query' }
  & { invenPaidList?: Maybe<(
    { __typename?: 'InvenList' }
    & InvenListFragment
  )> }
);

export type DeleteInvenLikeMutationVariables = Exact<{
  seriesIdList: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteInvenLikeMutation = (
  { __typename?: 'Mutation' }
  & { deleteInvenLike: (
    { __typename?: 'DeleteInvenPayload' }
    & Pick<DeleteInvenPayload, 'status'>
  ) }
);

export type DeleteInvenPaidMutationVariables = Exact<{
  seriesIdList: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteInvenPaidMutation = (
  { __typename?: 'Mutation' }
  & { deleteInvenPaid: (
    { __typename?: 'DeleteInvenPayload' }
    & Pick<DeleteInvenPayload, 'status'>
  ) }
);

export type DeleteInvenRecentMutationVariables = Exact<{
  seriesIdList: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteInvenRecentMutation = (
  { __typename?: 'Mutation' }
  & { deleteInvenRecent: (
    { __typename?: 'DeleteInvenPayload' }
    & Pick<DeleteInvenPayload, 'status'>
  ) }
);

export type SetSeriesAlarmMutationVariables = Exact<{
  setSeriesAlarmInput: SetSeriesAlarmInput;
}>;


export type SetSeriesAlarmMutation = (
  { __typename?: 'Mutation' }
  & { setSeriesAlarm: (
    { __typename?: 'SetSeriesAlarmPayload' }
    & Pick<SetSeriesAlarmPayload, 'record' | 'recordId' | 'status'>
  ) }
);

export type SetSeriesLikeMutationVariables = Exact<{
  setSeriesLikeInput: SetSeriesLikeInput;
}>;


export type SetSeriesLikeMutation = (
  { __typename?: 'Mutation' }
  & { setSeriesLike: (
    { __typename?: 'SetSeriesLikePayload' }
    & Pick<SetSeriesLikePayload, 'record' | 'recordId' | 'status'>
  ) }
);

export type SearchInvenListQueryVariables = Exact<{
  searchInvenListInput: SearchInvenListInput;
}>;


export type SearchInvenListQuery = (
  { __typename?: 'Query' }
  & { searchInvenList?: Maybe<(
    { __typename?: 'InvenList' }
    & InvenListFragment
  )> }
);

export type InvenRecommendListQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type InvenRecommendListQuery = (
  { __typename?: 'Query' }
  & { invenRecommendList?: Maybe<(
    { __typename?: 'InvenRecommendList' }
    & Pick<InvenRecommendList, 'id'>
    & { list: Array<(
      { __typename?: 'PosterViewItem' }
      & PosterViewItemFragment
    )> }
  )> }
);

export type OpenPreviewMutationVariables = Exact<{
  input: OpenPreviewMutationInput;
}>;


export type OpenPreviewMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'openPreview'>
);

export type OpenPageMutationVariables = Exact<{
  input: ViewerOpenPageMutationInput;
}>;


export type OpenPageMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'viewerOpenPage'>
);

export type SeriesCardViewLandingListQueryVariables = Exact<{
  dataKey: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  themeKeywordUid?: Maybe<Scalars['String']>;
}>;


export type SeriesCardViewLandingListQuery = (
  { __typename?: 'Query' }
  & { seriesCardViewLandingList?: Maybe<(
    { __typename?: 'SeriesCardViewLandingList' }
    & Pick<SeriesCardViewLandingList, 'id' | 'title' | 'isEnd' | 'totalCount' | 'type' | 'topImage' | 'category' | 'page'>
    & { themeKeywordOptList?: Maybe<Array<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'param' | 'name' | 'id'>
    )>>, selectedThemeKeywordOpt?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'param' | 'name' | 'id'>
    )>, list: Array<(
      { __typename?: 'CardViewItem' }
      & Pick<CardViewItem, 'id' | 'type'>
      & CardViewItemFragment
    )> }
  )> }
);

export type SeriesListViewLandingListQueryVariables = Exact<{
  dataKey: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  themeKeywordUid?: Maybe<Scalars['String']>;
}>;


export type SeriesListViewLandingListQuery = (
  { __typename?: 'Query' }
  & { seriesListViewLandingList?: Maybe<(
    { __typename?: 'SeriesListViewLandingList' }
    & Pick<SeriesListViewLandingList, 'id' | 'title' | 'isEnd' | 'totalCount' | 'type' | 'topImage' | 'page' | 'category'>
    & { themeKeywordOptList?: Maybe<Array<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'param' | 'name' | 'id'>
    )>>, selectedThemeKeywordOpt?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'param' | 'name' | 'id'>
    )>, list: Array<(
      { __typename?: 'NormalListViewItem' }
      & Pick<NormalListViewItem, 'id' | 'type'>
      & NormalListViewItemFragment
    )> }
  )> }
);

export type SeriesPosterViewLandingListQueryVariables = Exact<{
  dataKey: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  themeKeywordUid?: Maybe<Scalars['String']>;
}>;


export type SeriesPosterViewLandingListQuery = (
  { __typename?: 'Query' }
  & { seriesPosterViewLandingList?: Maybe<(
    { __typename?: 'SeriesPosterViewLandingList' }
    & Pick<SeriesPosterViewLandingList, 'id' | 'title' | 'isEnd' | 'totalCount' | 'type' | 'topImage' | 'category' | 'page'>
    & { themeKeywordOptList?: Maybe<Array<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'param' | 'name' | 'id'>
    )>>, selectedThemeKeywordOpt?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'param' | 'name' | 'id'>
    )>, list: Array<(
      { __typename?: 'PosterViewItem' }
      & Pick<PosterViewItem, 'id' | 'type'>
      & PosterViewItemFragment
    )> }
  )> }
);

export type SetListViewLandingListQueryVariables = Exact<{
  dataKey: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
}>;


export type SetListViewLandingListQuery = (
  { __typename?: 'Query' }
  & { setListViewLandingList?: Maybe<(
    { __typename?: 'SetListViewLandingList' }
    & Pick<SetListViewLandingList, 'id' | 'title' | 'isEnd' | 'totalCount' | 'type' | 'topImage' | 'page'>
    & { list: Array<(
      { __typename?: 'NormalListViewItem' }
      & Pick<NormalListViewItem, 'id' | 'type'>
      & NormalListViewItemFragment
    )> }
  )> }
);

export type SetPosterViewLandingListQueryVariables = Exact<{
  dataKey: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
}>;


export type SetPosterViewLandingListQuery = (
  { __typename?: 'Query' }
  & { setPosterViewLandingList?: Maybe<(
    { __typename?: 'SetPosterViewLandingList' }
    & Pick<SetPosterViewLandingList, 'id' | 'title' | 'isEnd' | 'totalCount' | 'type' | 'topImage' | 'page'>
    & { list: Array<(
      { __typename?: 'PosterViewItem' }
      & Pick<PosterViewItem, 'id' | 'type'>
      & PosterViewItemFragment
    )> }
  )> }
);

export type SingleListViewLandingListQueryVariables = Exact<{
  dataKey: Scalars['String'];
  page?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  themeKeywordUid?: Maybe<Scalars['String']>;
}>;


export type SingleListViewLandingListQuery = (
  { __typename?: 'Query' }
  & { singleListViewLandingList?: Maybe<(
    { __typename?: 'SingleListViewLandingList' }
    & Pick<SingleListViewLandingList, 'id' | 'title' | 'isEnd' | 'totalCount' | 'type' | 'topImage' | 'page'>
    & { themeKeywordOptList?: Maybe<Array<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'param' | 'name' | 'id'>
    )>>, selectedThemeKeywordOpt?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'param' | 'name' | 'id'>
    )>, list: Array<(
      { __typename?: 'NormalListViewItem' }
      & Pick<NormalListViewItem, 'id' | 'type'>
      & NormalListViewItemFragment
    )> }
  )> }
);

export type StaticLandingDayOfWeekLayoutQueryVariables = Exact<{
  queryInput: StaticLandingDayOfWeekParamInput;
}>;


export type StaticLandingDayOfWeekLayoutQuery = (
  { __typename?: 'Query' }
  & { staticLandingDayOfWeekLayout: (
    { __typename?: 'Layout' }
    & LayoutFragment
  ) }
);

export type StaticLandingTodayNewLayoutQueryVariables = Exact<{
  queryInput: StaticLandingTodayNewParamInput;
}>;


export type StaticLandingTodayNewLayoutQuery = (
  { __typename?: 'Query' }
  & { staticLandingTodayNewLayout: (
    { __typename?: 'Layout' }
    & LayoutFragment
  ) }
);

export type StaticLandingTodayUpLayoutQueryVariables = Exact<{
  queryInput: StaticLandingTodayUpParamInput;
}>;


export type StaticLandingTodayUpLayoutQuery = (
  { __typename?: 'Query' }
  & { staticLandingTodayUpLayout: (
    { __typename?: 'Layout' }
    & LayoutFragment
  ) }
);

export type StaticLandingRankingLayoutQueryVariables = Exact<{
  queryInput: StaticLandingRankingParamInput;
}>;


export type StaticLandingRankingLayoutQuery = (
  { __typename?: 'Query' }
  & { staticLandingRankingLayout: (
    { __typename?: 'Layout' }
    & LayoutFragment
  ) }
);

export type StaticLandingGenreLayoutQueryVariables = Exact<{
  queryInput: StaticLandingGenreParamInput;
}>;


export type StaticLandingGenreLayoutQuery = (
  { __typename?: 'Query' }
  & { staticLandingGenreLayout: (
    { __typename?: 'Layout' }
    & LayoutFragment
  ) }
);

export type StaticLandingFreeSeriesLayoutQueryVariables = Exact<{
  queryInput: StaticLandingFreeSeriesParamInput;
}>;


export type StaticLandingFreeSeriesLayoutQuery = (
  { __typename?: 'Query' }
  & { staticLandingFreeSeriesLayout: (
    { __typename?: 'Layout' }
    & LayoutFragment
  ) }
);

export type StaticLandingEventLayoutQueryVariables = Exact<{
  queryInput: StaticLandingEventParamInput;
}>;


export type StaticLandingEventLayoutQuery = (
  { __typename?: 'Query' }
  & { staticLandingEventLayout: (
    { __typename?: 'Layout' }
    & LayoutFragment
  ) }
);

export type StaticLandingOriginalLayoutQueryVariables = Exact<{
  queryInput: StaticLandingOriginalParamInput;
}>;


export type StaticLandingOriginalLayoutQuery = (
  { __typename?: 'Query' }
  & { staticLandingOriginalLayout: (
    { __typename?: 'Layout' }
    & LayoutFragment
  ) }
);

export type StaticLandingDayOfWeekSectionQueryVariables = Exact<{
  sectionId: Scalars['ID'];
  param: StaticLandingDayOfWeekParamInput;
}>;


export type StaticLandingDayOfWeekSectionQuery = (
  { __typename?: 'Query' }
  & { staticLandingDayOfWeekSection: (
    { __typename?: 'AlarmSection' }
    & Section_AlarmSection_Fragment
  ) | (
    { __typename?: 'BigBannerSection' }
    & Section_BigBannerSection_Fragment
  ) | (
    { __typename?: 'CardSection' }
    & Section_CardSection_Fragment
  ) | (
    { __typename?: 'CashFriendsSection' }
    & Section_CashFriendsSection_Fragment
  ) | (
    { __typename?: 'DayOfWeekSection' }
    & Section_DayOfWeekSection_Fragment
  ) | (
    { __typename?: 'DisplayAdSection' }
    & Section_DisplayAdSection_Fragment
  ) | (
    { __typename?: 'EpisodeSection' }
    & Section_EpisodeSection_Fragment
  ) | (
    { __typename?: 'EventSection' }
    & Section_EventSection_Fragment
  ) | (
    { __typename?: 'HelixThemeSection' }
    & Section_HelixThemeSection_Fragment
  ) | (
    { __typename?: 'LineBannerSection' }
    & Section_LineBannerSection_Fragment
  ) | (
    { __typename?: 'MainRankingSection' }
    & Section_MainRankingSection_Fragment
  ) | (
    { __typename?: 'OnAirSection' }
    & Section_OnAirSection_Fragment
  ) | (
    { __typename?: 'PromotionBannerSection' }
    & Section_PromotionBannerSection_Fragment
  ) | (
    { __typename?: 'RankingSection' }
    & Section_RankingSection_Fragment
  ) | (
    { __typename?: 'RankingV2Section' }
    & Section_RankingV2Section_Fragment
  ) | (
    { __typename?: 'RecentViewedSection' }
    & Section_RecentViewedSection_Fragment
  ) | (
    { __typename?: 'ScrollThemeSection' }
    & Section_ScrollThemeSection_Fragment
  ) | (
    { __typename?: 'SeriesBasedRecommendSection' }
    & Section_SeriesBasedRecommendSection_Fragment
  ) | (
    { __typename?: 'StaticLandingDayOfWeekSection' }
    & Section_StaticLandingDayOfWeekSection_Fragment
  ) | (
    { __typename?: 'StaticLandingEventSection' }
    & Section_StaticLandingEventSection_Fragment
  ) | (
    { __typename?: 'StaticLandingFreeSeriesSection' }
    & Section_StaticLandingFreeSeriesSection_Fragment
  ) | (
    { __typename?: 'StaticLandingGenreSection' }
    & Section_StaticLandingGenreSection_Fragment
  ) | (
    { __typename?: 'StaticLandingOriginalSection' }
    & Section_StaticLandingOriginalSection_Fragment
  ) | (
    { __typename?: 'StaticLandingRankingSection' }
    & Section_StaticLandingRankingSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayNewSection' }
    & Section_StaticLandingTodayNewSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayUpSection' }
    & Section_StaticLandingTodayUpSection_Fragment
  ) | (
    { __typename?: 'StrategyCategorySection' }
    & Section_StrategyCategorySection_Fragment
  ) | (
    { __typename?: 'ThemeSection' }
    & Section_ThemeSection_Fragment
  ) | (
    { __typename?: 'TopSection' }
    & Section_TopSection_Fragment
  ) | (
    { __typename?: 'UnknownSection' }
    & Section_UnknownSection_Fragment
  ) | (
    { __typename?: 'UserBasedRecommendSection' }
    & Section_UserBasedRecommendSection_Fragment
  ) }
);

export type StaticLandingTodayNewSectionQueryVariables = Exact<{
  sectionId: Scalars['ID'];
  param: StaticLandingTodayNewParamInput;
}>;


export type StaticLandingTodayNewSectionQuery = (
  { __typename?: 'Query' }
  & { staticLandingTodayNewSection: (
    { __typename?: 'AlarmSection' }
    & Section_AlarmSection_Fragment
  ) | (
    { __typename?: 'BigBannerSection' }
    & Section_BigBannerSection_Fragment
  ) | (
    { __typename?: 'CardSection' }
    & Section_CardSection_Fragment
  ) | (
    { __typename?: 'CashFriendsSection' }
    & Section_CashFriendsSection_Fragment
  ) | (
    { __typename?: 'DayOfWeekSection' }
    & Section_DayOfWeekSection_Fragment
  ) | (
    { __typename?: 'DisplayAdSection' }
    & Section_DisplayAdSection_Fragment
  ) | (
    { __typename?: 'EpisodeSection' }
    & Section_EpisodeSection_Fragment
  ) | (
    { __typename?: 'EventSection' }
    & Section_EventSection_Fragment
  ) | (
    { __typename?: 'HelixThemeSection' }
    & Section_HelixThemeSection_Fragment
  ) | (
    { __typename?: 'LineBannerSection' }
    & Section_LineBannerSection_Fragment
  ) | (
    { __typename?: 'MainRankingSection' }
    & Section_MainRankingSection_Fragment
  ) | (
    { __typename?: 'OnAirSection' }
    & Section_OnAirSection_Fragment
  ) | (
    { __typename?: 'PromotionBannerSection' }
    & Section_PromotionBannerSection_Fragment
  ) | (
    { __typename?: 'RankingSection' }
    & Section_RankingSection_Fragment
  ) | (
    { __typename?: 'RankingV2Section' }
    & Section_RankingV2Section_Fragment
  ) | (
    { __typename?: 'RecentViewedSection' }
    & Section_RecentViewedSection_Fragment
  ) | (
    { __typename?: 'ScrollThemeSection' }
    & Section_ScrollThemeSection_Fragment
  ) | (
    { __typename?: 'SeriesBasedRecommendSection' }
    & Section_SeriesBasedRecommendSection_Fragment
  ) | (
    { __typename?: 'StaticLandingDayOfWeekSection' }
    & Section_StaticLandingDayOfWeekSection_Fragment
  ) | (
    { __typename?: 'StaticLandingEventSection' }
    & Section_StaticLandingEventSection_Fragment
  ) | (
    { __typename?: 'StaticLandingFreeSeriesSection' }
    & Section_StaticLandingFreeSeriesSection_Fragment
  ) | (
    { __typename?: 'StaticLandingGenreSection' }
    & Section_StaticLandingGenreSection_Fragment
  ) | (
    { __typename?: 'StaticLandingOriginalSection' }
    & Section_StaticLandingOriginalSection_Fragment
  ) | (
    { __typename?: 'StaticLandingRankingSection' }
    & Section_StaticLandingRankingSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayNewSection' }
    & Section_StaticLandingTodayNewSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayUpSection' }
    & Section_StaticLandingTodayUpSection_Fragment
  ) | (
    { __typename?: 'StrategyCategorySection' }
    & Section_StrategyCategorySection_Fragment
  ) | (
    { __typename?: 'ThemeSection' }
    & Section_ThemeSection_Fragment
  ) | (
    { __typename?: 'TopSection' }
    & Section_TopSection_Fragment
  ) | (
    { __typename?: 'UnknownSection' }
    & Section_UnknownSection_Fragment
  ) | (
    { __typename?: 'UserBasedRecommendSection' }
    & Section_UserBasedRecommendSection_Fragment
  ) }
);

export type StaticLandingTodayUpSectionQueryVariables = Exact<{
  sectionId: Scalars['ID'];
  param: StaticLandingTodayUpParamInput;
}>;


export type StaticLandingTodayUpSectionQuery = (
  { __typename?: 'Query' }
  & { staticLandingTodayUpSection: (
    { __typename?: 'AlarmSection' }
    & Section_AlarmSection_Fragment
  ) | (
    { __typename?: 'BigBannerSection' }
    & Section_BigBannerSection_Fragment
  ) | (
    { __typename?: 'CardSection' }
    & Section_CardSection_Fragment
  ) | (
    { __typename?: 'CashFriendsSection' }
    & Section_CashFriendsSection_Fragment
  ) | (
    { __typename?: 'DayOfWeekSection' }
    & Section_DayOfWeekSection_Fragment
  ) | (
    { __typename?: 'DisplayAdSection' }
    & Section_DisplayAdSection_Fragment
  ) | (
    { __typename?: 'EpisodeSection' }
    & Section_EpisodeSection_Fragment
  ) | (
    { __typename?: 'EventSection' }
    & Section_EventSection_Fragment
  ) | (
    { __typename?: 'HelixThemeSection' }
    & Section_HelixThemeSection_Fragment
  ) | (
    { __typename?: 'LineBannerSection' }
    & Section_LineBannerSection_Fragment
  ) | (
    { __typename?: 'MainRankingSection' }
    & Section_MainRankingSection_Fragment
  ) | (
    { __typename?: 'OnAirSection' }
    & Section_OnAirSection_Fragment
  ) | (
    { __typename?: 'PromotionBannerSection' }
    & Section_PromotionBannerSection_Fragment
  ) | (
    { __typename?: 'RankingSection' }
    & Section_RankingSection_Fragment
  ) | (
    { __typename?: 'RankingV2Section' }
    & Section_RankingV2Section_Fragment
  ) | (
    { __typename?: 'RecentViewedSection' }
    & Section_RecentViewedSection_Fragment
  ) | (
    { __typename?: 'ScrollThemeSection' }
    & Section_ScrollThemeSection_Fragment
  ) | (
    { __typename?: 'SeriesBasedRecommendSection' }
    & Section_SeriesBasedRecommendSection_Fragment
  ) | (
    { __typename?: 'StaticLandingDayOfWeekSection' }
    & Section_StaticLandingDayOfWeekSection_Fragment
  ) | (
    { __typename?: 'StaticLandingEventSection' }
    & Section_StaticLandingEventSection_Fragment
  ) | (
    { __typename?: 'StaticLandingFreeSeriesSection' }
    & Section_StaticLandingFreeSeriesSection_Fragment
  ) | (
    { __typename?: 'StaticLandingGenreSection' }
    & Section_StaticLandingGenreSection_Fragment
  ) | (
    { __typename?: 'StaticLandingOriginalSection' }
    & Section_StaticLandingOriginalSection_Fragment
  ) | (
    { __typename?: 'StaticLandingRankingSection' }
    & Section_StaticLandingRankingSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayNewSection' }
    & Section_StaticLandingTodayNewSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayUpSection' }
    & Section_StaticLandingTodayUpSection_Fragment
  ) | (
    { __typename?: 'StrategyCategorySection' }
    & Section_StrategyCategorySection_Fragment
  ) | (
    { __typename?: 'ThemeSection' }
    & Section_ThemeSection_Fragment
  ) | (
    { __typename?: 'TopSection' }
    & Section_TopSection_Fragment
  ) | (
    { __typename?: 'UnknownSection' }
    & Section_UnknownSection_Fragment
  ) | (
    { __typename?: 'UserBasedRecommendSection' }
    & Section_UserBasedRecommendSection_Fragment
  ) }
);

export type StaticLandingRankingSectionQueryVariables = Exact<{
  sectionId: Scalars['ID'];
  param: StaticLandingRankingParamInput;
}>;


export type StaticLandingRankingSectionQuery = (
  { __typename?: 'Query' }
  & { staticLandingRankingSection: (
    { __typename?: 'AlarmSection' }
    & Section_AlarmSection_Fragment
  ) | (
    { __typename?: 'BigBannerSection' }
    & Section_BigBannerSection_Fragment
  ) | (
    { __typename?: 'CardSection' }
    & Section_CardSection_Fragment
  ) | (
    { __typename?: 'CashFriendsSection' }
    & Section_CashFriendsSection_Fragment
  ) | (
    { __typename?: 'DayOfWeekSection' }
    & Section_DayOfWeekSection_Fragment
  ) | (
    { __typename?: 'DisplayAdSection' }
    & Section_DisplayAdSection_Fragment
  ) | (
    { __typename?: 'EpisodeSection' }
    & Section_EpisodeSection_Fragment
  ) | (
    { __typename?: 'EventSection' }
    & Section_EventSection_Fragment
  ) | (
    { __typename?: 'HelixThemeSection' }
    & Section_HelixThemeSection_Fragment
  ) | (
    { __typename?: 'LineBannerSection' }
    & Section_LineBannerSection_Fragment
  ) | (
    { __typename?: 'MainRankingSection' }
    & Section_MainRankingSection_Fragment
  ) | (
    { __typename?: 'OnAirSection' }
    & Section_OnAirSection_Fragment
  ) | (
    { __typename?: 'PromotionBannerSection' }
    & Section_PromotionBannerSection_Fragment
  ) | (
    { __typename?: 'RankingSection' }
    & Section_RankingSection_Fragment
  ) | (
    { __typename?: 'RankingV2Section' }
    & Section_RankingV2Section_Fragment
  ) | (
    { __typename?: 'RecentViewedSection' }
    & Section_RecentViewedSection_Fragment
  ) | (
    { __typename?: 'ScrollThemeSection' }
    & Section_ScrollThemeSection_Fragment
  ) | (
    { __typename?: 'SeriesBasedRecommendSection' }
    & Section_SeriesBasedRecommendSection_Fragment
  ) | (
    { __typename?: 'StaticLandingDayOfWeekSection' }
    & Section_StaticLandingDayOfWeekSection_Fragment
  ) | (
    { __typename?: 'StaticLandingEventSection' }
    & Section_StaticLandingEventSection_Fragment
  ) | (
    { __typename?: 'StaticLandingFreeSeriesSection' }
    & Section_StaticLandingFreeSeriesSection_Fragment
  ) | (
    { __typename?: 'StaticLandingGenreSection' }
    & Section_StaticLandingGenreSection_Fragment
  ) | (
    { __typename?: 'StaticLandingOriginalSection' }
    & Section_StaticLandingOriginalSection_Fragment
  ) | (
    { __typename?: 'StaticLandingRankingSection' }
    & Section_StaticLandingRankingSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayNewSection' }
    & Section_StaticLandingTodayNewSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayUpSection' }
    & Section_StaticLandingTodayUpSection_Fragment
  ) | (
    { __typename?: 'StrategyCategorySection' }
    & Section_StrategyCategorySection_Fragment
  ) | (
    { __typename?: 'ThemeSection' }
    & Section_ThemeSection_Fragment
  ) | (
    { __typename?: 'TopSection' }
    & Section_TopSection_Fragment
  ) | (
    { __typename?: 'UnknownSection' }
    & Section_UnknownSection_Fragment
  ) | (
    { __typename?: 'UserBasedRecommendSection' }
    & Section_UserBasedRecommendSection_Fragment
  ) }
);

export type StaticLandingGenreSectionQueryVariables = Exact<{
  sectionId: Scalars['ID'];
  param: StaticLandingGenreParamInput;
}>;


export type StaticLandingGenreSectionQuery = (
  { __typename?: 'Query' }
  & { staticLandingGenreSection: (
    { __typename?: 'AlarmSection' }
    & Section_AlarmSection_Fragment
  ) | (
    { __typename?: 'BigBannerSection' }
    & Section_BigBannerSection_Fragment
  ) | (
    { __typename?: 'CardSection' }
    & Section_CardSection_Fragment
  ) | (
    { __typename?: 'CashFriendsSection' }
    & Section_CashFriendsSection_Fragment
  ) | (
    { __typename?: 'DayOfWeekSection' }
    & Section_DayOfWeekSection_Fragment
  ) | (
    { __typename?: 'DisplayAdSection' }
    & Section_DisplayAdSection_Fragment
  ) | (
    { __typename?: 'EpisodeSection' }
    & Section_EpisodeSection_Fragment
  ) | (
    { __typename?: 'EventSection' }
    & Section_EventSection_Fragment
  ) | (
    { __typename?: 'HelixThemeSection' }
    & Section_HelixThemeSection_Fragment
  ) | (
    { __typename?: 'LineBannerSection' }
    & Section_LineBannerSection_Fragment
  ) | (
    { __typename?: 'MainRankingSection' }
    & Section_MainRankingSection_Fragment
  ) | (
    { __typename?: 'OnAirSection' }
    & Section_OnAirSection_Fragment
  ) | (
    { __typename?: 'PromotionBannerSection' }
    & Section_PromotionBannerSection_Fragment
  ) | (
    { __typename?: 'RankingSection' }
    & Section_RankingSection_Fragment
  ) | (
    { __typename?: 'RankingV2Section' }
    & Section_RankingV2Section_Fragment
  ) | (
    { __typename?: 'RecentViewedSection' }
    & Section_RecentViewedSection_Fragment
  ) | (
    { __typename?: 'ScrollThemeSection' }
    & Section_ScrollThemeSection_Fragment
  ) | (
    { __typename?: 'SeriesBasedRecommendSection' }
    & Section_SeriesBasedRecommendSection_Fragment
  ) | (
    { __typename?: 'StaticLandingDayOfWeekSection' }
    & Section_StaticLandingDayOfWeekSection_Fragment
  ) | (
    { __typename?: 'StaticLandingEventSection' }
    & Section_StaticLandingEventSection_Fragment
  ) | (
    { __typename?: 'StaticLandingFreeSeriesSection' }
    & Section_StaticLandingFreeSeriesSection_Fragment
  ) | (
    { __typename?: 'StaticLandingGenreSection' }
    & Section_StaticLandingGenreSection_Fragment
  ) | (
    { __typename?: 'StaticLandingOriginalSection' }
    & Section_StaticLandingOriginalSection_Fragment
  ) | (
    { __typename?: 'StaticLandingRankingSection' }
    & Section_StaticLandingRankingSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayNewSection' }
    & Section_StaticLandingTodayNewSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayUpSection' }
    & Section_StaticLandingTodayUpSection_Fragment
  ) | (
    { __typename?: 'StrategyCategorySection' }
    & Section_StrategyCategorySection_Fragment
  ) | (
    { __typename?: 'ThemeSection' }
    & Section_ThemeSection_Fragment
  ) | (
    { __typename?: 'TopSection' }
    & Section_TopSection_Fragment
  ) | (
    { __typename?: 'UnknownSection' }
    & Section_UnknownSection_Fragment
  ) | (
    { __typename?: 'UserBasedRecommendSection' }
    & Section_UserBasedRecommendSection_Fragment
  ) }
);

export type StaticLandingFreeSeriesSectionQueryVariables = Exact<{
  sectionId: Scalars['ID'];
  param: StaticLandingFreeSeriesParamInput;
}>;


export type StaticLandingFreeSeriesSectionQuery = (
  { __typename?: 'Query' }
  & { staticLandingFreeSeriesSection: (
    { __typename?: 'AlarmSection' }
    & Section_AlarmSection_Fragment
  ) | (
    { __typename?: 'BigBannerSection' }
    & Section_BigBannerSection_Fragment
  ) | (
    { __typename?: 'CardSection' }
    & Section_CardSection_Fragment
  ) | (
    { __typename?: 'CashFriendsSection' }
    & Section_CashFriendsSection_Fragment
  ) | (
    { __typename?: 'DayOfWeekSection' }
    & Section_DayOfWeekSection_Fragment
  ) | (
    { __typename?: 'DisplayAdSection' }
    & Section_DisplayAdSection_Fragment
  ) | (
    { __typename?: 'EpisodeSection' }
    & Section_EpisodeSection_Fragment
  ) | (
    { __typename?: 'EventSection' }
    & Section_EventSection_Fragment
  ) | (
    { __typename?: 'HelixThemeSection' }
    & Section_HelixThemeSection_Fragment
  ) | (
    { __typename?: 'LineBannerSection' }
    & Section_LineBannerSection_Fragment
  ) | (
    { __typename?: 'MainRankingSection' }
    & Section_MainRankingSection_Fragment
  ) | (
    { __typename?: 'OnAirSection' }
    & Section_OnAirSection_Fragment
  ) | (
    { __typename?: 'PromotionBannerSection' }
    & Section_PromotionBannerSection_Fragment
  ) | (
    { __typename?: 'RankingSection' }
    & Section_RankingSection_Fragment
  ) | (
    { __typename?: 'RankingV2Section' }
    & Section_RankingV2Section_Fragment
  ) | (
    { __typename?: 'RecentViewedSection' }
    & Section_RecentViewedSection_Fragment
  ) | (
    { __typename?: 'ScrollThemeSection' }
    & Section_ScrollThemeSection_Fragment
  ) | (
    { __typename?: 'SeriesBasedRecommendSection' }
    & Section_SeriesBasedRecommendSection_Fragment
  ) | (
    { __typename?: 'StaticLandingDayOfWeekSection' }
    & Section_StaticLandingDayOfWeekSection_Fragment
  ) | (
    { __typename?: 'StaticLandingEventSection' }
    & Section_StaticLandingEventSection_Fragment
  ) | (
    { __typename?: 'StaticLandingFreeSeriesSection' }
    & Section_StaticLandingFreeSeriesSection_Fragment
  ) | (
    { __typename?: 'StaticLandingGenreSection' }
    & Section_StaticLandingGenreSection_Fragment
  ) | (
    { __typename?: 'StaticLandingOriginalSection' }
    & Section_StaticLandingOriginalSection_Fragment
  ) | (
    { __typename?: 'StaticLandingRankingSection' }
    & Section_StaticLandingRankingSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayNewSection' }
    & Section_StaticLandingTodayNewSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayUpSection' }
    & Section_StaticLandingTodayUpSection_Fragment
  ) | (
    { __typename?: 'StrategyCategorySection' }
    & Section_StrategyCategorySection_Fragment
  ) | (
    { __typename?: 'ThemeSection' }
    & Section_ThemeSection_Fragment
  ) | (
    { __typename?: 'TopSection' }
    & Section_TopSection_Fragment
  ) | (
    { __typename?: 'UnknownSection' }
    & Section_UnknownSection_Fragment
  ) | (
    { __typename?: 'UserBasedRecommendSection' }
    & Section_UserBasedRecommendSection_Fragment
  ) }
);

export type StaticLandingEventSectionQueryVariables = Exact<{
  sectionId: Scalars['ID'];
  param: StaticLandingEventParamInput;
}>;


export type StaticLandingEventSectionQuery = (
  { __typename?: 'Query' }
  & { staticLandingEventSection: (
    { __typename?: 'AlarmSection' }
    & Section_AlarmSection_Fragment
  ) | (
    { __typename?: 'BigBannerSection' }
    & Section_BigBannerSection_Fragment
  ) | (
    { __typename?: 'CardSection' }
    & Section_CardSection_Fragment
  ) | (
    { __typename?: 'CashFriendsSection' }
    & Section_CashFriendsSection_Fragment
  ) | (
    { __typename?: 'DayOfWeekSection' }
    & Section_DayOfWeekSection_Fragment
  ) | (
    { __typename?: 'DisplayAdSection' }
    & Section_DisplayAdSection_Fragment
  ) | (
    { __typename?: 'EpisodeSection' }
    & Section_EpisodeSection_Fragment
  ) | (
    { __typename?: 'EventSection' }
    & Section_EventSection_Fragment
  ) | (
    { __typename?: 'HelixThemeSection' }
    & Section_HelixThemeSection_Fragment
  ) | (
    { __typename?: 'LineBannerSection' }
    & Section_LineBannerSection_Fragment
  ) | (
    { __typename?: 'MainRankingSection' }
    & Section_MainRankingSection_Fragment
  ) | (
    { __typename?: 'OnAirSection' }
    & Section_OnAirSection_Fragment
  ) | (
    { __typename?: 'PromotionBannerSection' }
    & Section_PromotionBannerSection_Fragment
  ) | (
    { __typename?: 'RankingSection' }
    & Section_RankingSection_Fragment
  ) | (
    { __typename?: 'RankingV2Section' }
    & Section_RankingV2Section_Fragment
  ) | (
    { __typename?: 'RecentViewedSection' }
    & Section_RecentViewedSection_Fragment
  ) | (
    { __typename?: 'ScrollThemeSection' }
    & Section_ScrollThemeSection_Fragment
  ) | (
    { __typename?: 'SeriesBasedRecommendSection' }
    & Section_SeriesBasedRecommendSection_Fragment
  ) | (
    { __typename?: 'StaticLandingDayOfWeekSection' }
    & Section_StaticLandingDayOfWeekSection_Fragment
  ) | (
    { __typename?: 'StaticLandingEventSection' }
    & Section_StaticLandingEventSection_Fragment
  ) | (
    { __typename?: 'StaticLandingFreeSeriesSection' }
    & Section_StaticLandingFreeSeriesSection_Fragment
  ) | (
    { __typename?: 'StaticLandingGenreSection' }
    & Section_StaticLandingGenreSection_Fragment
  ) | (
    { __typename?: 'StaticLandingOriginalSection' }
    & Section_StaticLandingOriginalSection_Fragment
  ) | (
    { __typename?: 'StaticLandingRankingSection' }
    & Section_StaticLandingRankingSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayNewSection' }
    & Section_StaticLandingTodayNewSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayUpSection' }
    & Section_StaticLandingTodayUpSection_Fragment
  ) | (
    { __typename?: 'StrategyCategorySection' }
    & Section_StrategyCategorySection_Fragment
  ) | (
    { __typename?: 'ThemeSection' }
    & Section_ThemeSection_Fragment
  ) | (
    { __typename?: 'TopSection' }
    & Section_TopSection_Fragment
  ) | (
    { __typename?: 'UnknownSection' }
    & Section_UnknownSection_Fragment
  ) | (
    { __typename?: 'UserBasedRecommendSection' }
    & Section_UserBasedRecommendSection_Fragment
  ) }
);

export type StaticLandingOriginalSectionQueryVariables = Exact<{
  sectionId: Scalars['ID'];
  param: StaticLandingOriginalParamInput;
}>;


export type StaticLandingOriginalSectionQuery = (
  { __typename?: 'Query' }
  & { staticLandingOriginalSection: (
    { __typename?: 'AlarmSection' }
    & Section_AlarmSection_Fragment
  ) | (
    { __typename?: 'BigBannerSection' }
    & Section_BigBannerSection_Fragment
  ) | (
    { __typename?: 'CardSection' }
    & Section_CardSection_Fragment
  ) | (
    { __typename?: 'CashFriendsSection' }
    & Section_CashFriendsSection_Fragment
  ) | (
    { __typename?: 'DayOfWeekSection' }
    & Section_DayOfWeekSection_Fragment
  ) | (
    { __typename?: 'DisplayAdSection' }
    & Section_DisplayAdSection_Fragment
  ) | (
    { __typename?: 'EpisodeSection' }
    & Section_EpisodeSection_Fragment
  ) | (
    { __typename?: 'EventSection' }
    & Section_EventSection_Fragment
  ) | (
    { __typename?: 'HelixThemeSection' }
    & Section_HelixThemeSection_Fragment
  ) | (
    { __typename?: 'LineBannerSection' }
    & Section_LineBannerSection_Fragment
  ) | (
    { __typename?: 'MainRankingSection' }
    & Section_MainRankingSection_Fragment
  ) | (
    { __typename?: 'OnAirSection' }
    & Section_OnAirSection_Fragment
  ) | (
    { __typename?: 'PromotionBannerSection' }
    & Section_PromotionBannerSection_Fragment
  ) | (
    { __typename?: 'RankingSection' }
    & Section_RankingSection_Fragment
  ) | (
    { __typename?: 'RankingV2Section' }
    & Section_RankingV2Section_Fragment
  ) | (
    { __typename?: 'RecentViewedSection' }
    & Section_RecentViewedSection_Fragment
  ) | (
    { __typename?: 'ScrollThemeSection' }
    & Section_ScrollThemeSection_Fragment
  ) | (
    { __typename?: 'SeriesBasedRecommendSection' }
    & Section_SeriesBasedRecommendSection_Fragment
  ) | (
    { __typename?: 'StaticLandingDayOfWeekSection' }
    & Section_StaticLandingDayOfWeekSection_Fragment
  ) | (
    { __typename?: 'StaticLandingEventSection' }
    & Section_StaticLandingEventSection_Fragment
  ) | (
    { __typename?: 'StaticLandingFreeSeriesSection' }
    & Section_StaticLandingFreeSeriesSection_Fragment
  ) | (
    { __typename?: 'StaticLandingGenreSection' }
    & Section_StaticLandingGenreSection_Fragment
  ) | (
    { __typename?: 'StaticLandingOriginalSection' }
    & Section_StaticLandingOriginalSection_Fragment
  ) | (
    { __typename?: 'StaticLandingRankingSection' }
    & Section_StaticLandingRankingSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayNewSection' }
    & Section_StaticLandingTodayNewSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayUpSection' }
    & Section_StaticLandingTodayUpSection_Fragment
  ) | (
    { __typename?: 'StrategyCategorySection' }
    & Section_StrategyCategorySection_Fragment
  ) | (
    { __typename?: 'ThemeSection' }
    & Section_ThemeSection_Fragment
  ) | (
    { __typename?: 'TopSection' }
    & Section_TopSection_Fragment
  ) | (
    { __typename?: 'UnknownSection' }
    & Section_UnknownSection_Fragment
  ) | (
    { __typename?: 'UserBasedRecommendSection' }
    & Section_UserBasedRecommendSection_Fragment
  ) }
);

export type MainQueryVariables = Exact<{
  screenUid: Scalars['Int'];
  type?: Maybe<LayoutType>;
}>;


export type MainQuery = (
  { __typename?: 'Query' }
  & { layout?: Maybe<(
    { __typename?: 'Layout' }
    & LayoutFragment
  )> }
);

export type LayoutListQueryVariables = Exact<{
  screenUidList: Array<Scalars['Int']> | Scalars['Int'];
  type?: Maybe<LayoutType>;
}>;


export type LayoutListQuery = (
  { __typename?: 'Query' }
  & { layoutList?: Maybe<Array<(
    { __typename?: 'Layout' }
    & LayoutFragment
  )>> }
);

export type UseRedeemMutationVariables = Exact<{
  input: RedeemCodeInput;
}>;


export type UseRedeemMutation = (
  { __typename?: 'Mutation' }
  & { useRedeem: (
    { __typename?: 'RedeemCode' }
    & RedeemCodeFragment
  ) }
);

export type SearchAutoCompleteQueryVariables = Exact<{
  input: SearchAutoCompleteInput;
}>;


export type SearchAutoCompleteQuery = (
  { __typename?: 'Query' }
  & { searchAutoComplete?: Maybe<(
    { __typename?: 'SearchAutoComplete' }
    & Pick<SearchAutoComplete, 'id' | 'keyword'>
    & { list: Array<(
      { __typename?: 'AutoCompleteItem' }
      & Pick<AutoCompleteItem, 'text' | 'url'>
    )> }
  )> }
);

export type SearchKeywordQueryVariables = Exact<{
  input: SearchKeywordInput;
}>;


export type SearchKeywordQuery = (
  { __typename?: 'Query' }
  & { searchKeyword?: Maybe<(
    { __typename?: 'SearchKeyword' }
    & Pick<SearchKeyword, 'id' | 'total' | 'isEnd' | 'keyword' | 'showOnlyComplete' | 'page'>
    & { list: Array<(
      { __typename?: 'NormalListViewItem' }
      & NormalListViewItemFragment
    )>, sortOptionList: Array<(
      { __typename?: 'SortOption' }
      & SortOptionFragment
    )>, selectedSortOption: (
      { __typename?: 'SortOption' }
      & SortOptionFragment
    ), categoryOptionList: Array<(
      { __typename?: 'SortOption' }
      & SortOptionFragment
    )>, selectedCategoryOption: (
      { __typename?: 'SortOption' }
      & SortOptionFragment
    ) }
  )> }
);

export type SearchMainQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchMainQuery = (
  { __typename?: 'Query' }
  & { searchMain?: Maybe<(
    { __typename?: 'SearchMain' }
    & Pick<SearchMain, 'id'>
    & { keywordRankList: Array<(
      { __typename?: 'SearchPopularKeywordRank' }
      & Pick<SearchPopularKeywordRank, 'id' | 'rank' | 'keyword' | 'url'>
    )> }
  )> }
);

export type SearchThemeKeywordQueryVariables = Exact<{
  input: SearchThemeKeywordInput;
}>;


export type SearchThemeKeywordQuery = (
  { __typename?: 'Query' }
  & { searchThemeKeyword?: Maybe<(
    { __typename?: 'SearchThemeKeyword' }
    & Pick<SearchThemeKeyword, 'id' | 'total' | 'isEnd' | 'filterList' | 'page'>
    & { list: Array<(
      { __typename?: 'NormalListViewItem' }
      & NormalListViewItemFragment
    )>, sortOptionList: Array<(
      { __typename?: 'SortOption' }
      & SortOptionFragment
    )>, selectedSortOption: (
      { __typename?: 'SortOption' }
      & SortOptionFragment
    ), categoryOptionList: Array<(
      { __typename?: 'SortOption' }
      & SortOptionFragment
    )>, selectedCategoryOption: (
      { __typename?: 'SortOption' }
      & SortOptionFragment
    ) }
  )> }
);

export type SetAgreementMutationVariables = Exact<{
  input: SetAgreementInput;
}>;


export type SetAgreementMutation = (
  { __typename?: 'Mutation' }
  & { setAgreement: (
    { __typename?: 'SetAgreementPayload' }
    & Pick<SetAgreementPayload, 'status'>
    & { agreementList: Array<(
      { __typename?: 'AgreedAgreement' }
      & Pick<AgreedAgreement, 'type' | 'isAgreed' | 'version' | 'agreedDate'>
    )> }
  ) }
);

export type SetGlobalAgreementMutationVariables = Exact<{
  input: SetGlobalAgreementInput;
}>;


export type SetGlobalAgreementMutation = (
  { __typename?: 'Mutation' }
  & { setGlobalAgreement: (
    { __typename?: 'SetGlobalAgreementPayload' }
    & { agreementList: Array<(
      { __typename?: 'AgreedAgreement' }
      & Pick<AgreedAgreement, 'type' | 'isAgreed' | 'version' | 'agreedDate'>
    )> }
  ) }
);

export type ShortcutListQueryVariables = Exact<{ [key: string]: never; }>;


export type ShortcutListQuery = (
  { __typename?: 'Query' }
  & { shortcutList?: Maybe<(
    { __typename?: 'ShortcutList' }
    & { promotionBanner?: Maybe<(
      { __typename?: 'PromotionBannerItem' }
      & Pick<PromotionBannerItem, 'scheme' | 'title' | 'leftImage' | 'rightImage'>
      & { eventLog?: Maybe<(
        { __typename?: 'EventLog' }
        & EventLogFragmentFragment
      )> }
    )>, menuList?: Maybe<Array<Maybe<(
      { __typename?: 'ShortcutMenuItem' }
      & Pick<ShortcutMenuItem, 'shortcutHomeType' | 'shortcutHomeUrl'>
    )>>>, shortcutList?: Maybe<Array<Maybe<(
      { __typename?: 'ShortcutItemList' }
      & Pick<ShortcutItemList, 'title' | 'totalCount'>
      & { list: Array<(
        { __typename?: 'ShortcutItem' }
        & ShortcutItemFragment
      )> }
    )>>> }
  )> }
);

export type LayoutReferenceQueryVariables = Exact<{
  dataKey: Scalars['String'];
  sectionType: SectionType;
  metaInfoType?: Maybe<MetaInfoType>;
}>;


export type LayoutReferenceQuery = (
  { __typename?: 'Query' }
  & { layoutReference: Array<(
    { __typename?: 'LayoutReferenceViewData' }
    & LayoutReferenceViewDataFragment
  )> }
);

export type DynamicLayoutReferenceQueryVariables = Exact<{
  dataKey: Scalars['String'];
  sectionType: SectionType;
  metaInfoType?: Maybe<MetaInfoType>;
}>;


export type DynamicLayoutReferenceQuery = (
  { __typename?: 'Query' }
  & { dynamicLayoutReference?: Maybe<(
    { __typename?: 'DynamicLayoutReference' }
    & DynamicLayoutReferenceFragment
  )> }
);

export type BuyTicketHistoryQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  freeOnly?: Maybe<Scalars['Boolean']>;
}>;


export type BuyTicketHistoryQuery = (
  { __typename?: 'Query' }
  & { buyTicketHistory?: Maybe<(
    { __typename?: 'HistoryList' }
    & Pick<HistoryList, 'isEnd'>
    & { list: Array<(
      { __typename?: 'History' }
      & HistoryFragment
    )> }
  )> }
);

export type BuyCashHistoryQueryVariables = Exact<{
  page: Scalars['Int'];
  usePaging?: Maybe<Scalars['Boolean']>;
  lastPageId?: Maybe<Scalars['BigInt']>;
}>;


export type BuyCashHistoryQuery = (
  { __typename?: 'Query' }
  & { buyCashHistory?: Maybe<(
    { __typename?: 'BuyCashHistoryList' }
    & { expiredCredit?: Maybe<(
      { __typename?: 'ExpiredCredit' }
      & ExpiredCreditFragment
    )>, list: Array<(
      { __typename?: 'History' }
      & HistoryFragment
    )>, paging?: Maybe<(
      { __typename?: 'Paging' }
      & Pick<Paging, 'lastPageId' | 'shouldReloadPage'>
    )>, banner?: Maybe<(
      { __typename?: 'HistoryLineBanner' }
      & Pick<HistoryLineBanner, 'title' | 'subTitle' | 'bgColor' | 'scheme' | 'bannerType'>
    )> }
  )> }
);

export type UseCashHistoryQueryVariables = Exact<{
  page: Scalars['Int'];
}>;


export type UseCashHistoryQuery = (
  { __typename?: 'Query' }
  & { useCashHistory?: Maybe<(
    { __typename?: 'HistoryList' }
    & Pick<HistoryList, 'isEnd'>
    & { list: Array<(
      { __typename?: 'History' }
      & HistoryFragment
    )> }
  )> }
);

export type CommentListQueryVariables = Exact<{
  commentListInput: CommentListInput;
}>;


export type CommentListQuery = (
  { __typename?: 'Query' }
  & { commentList?: Maybe<(
    { __typename?: 'CommentList' }
    & CommentListFragment
  )> }
);

export type BestCommentListQueryVariables = Exact<{
  bestCommentListInput: BestCommentListInput;
}>;


export type BestCommentListQuery = (
  { __typename?: 'Query' }
  & { bestCommentList?: Maybe<(
    { __typename?: 'CommentList' }
    & CommentListFragment
  )> }
);

export type ReplyCommentListQueryVariables = Exact<{
  commentListInput: CommentListInput;
}>;


export type ReplyCommentListQuery = (
  { __typename?: 'Query' }
  & { replyCommentList?: Maybe<(
    { __typename?: 'CommentList' }
    & CommentListFragment
  )> }
);

export type CommentItemQueryVariables = Exact<{
  parentUid: Scalars['Int'];
  seriesId?: Maybe<Scalars['Long']>;
}>;


export type CommentItemQuery = (
  { __typename?: 'Query' }
  & { commentItem?: Maybe<(
    { __typename?: 'CommentItem' }
    & CommentItemFragment
  )> }
);

export type BlockUserListQueryVariables = Exact<{ [key: string]: never; }>;


export type BlockUserListQuery = (
  { __typename?: 'Query' }
  & { blockUserList?: Maybe<(
    { __typename?: 'BlockUserList' }
    & Pick<BlockUserList, 'list'>
  )> }
);

export type MyCommentListQueryVariables = Exact<{
  page: Scalars['Int'];
}>;


export type MyCommentListQuery = (
  { __typename?: 'Query' }
  & { myCommentList?: Maybe<(
    { __typename?: 'CommentList' }
    & CommentListFragment
  )> }
);

export type WriteCommentMutationVariables = Exact<{
  writeCommentInput: WriteCommentInput;
}>;


export type WriteCommentMutation = (
  { __typename?: 'Mutation' }
  & { writeComment: (
    { __typename?: 'WriteCommentPayload' }
    & Pick<WriteCommentPayload, 'status' | 'blockMsg'>
  ) }
);

export type RemoveCommentMutationVariables = Exact<{
  commentUid: Scalars['Int'];
}>;


export type RemoveCommentMutation = (
  { __typename?: 'Mutation' }
  & { removeComment: (
    { __typename?: 'CommentCommonPayload' }
    & Pick<CommentCommonPayload, 'recordid' | 'status'>
  ) }
);

export type LikeCommentMutationVariables = Exact<{
  likeCommentInput: LikeCommentInput;
}>;


export type LikeCommentMutation = (
  { __typename?: 'Mutation' }
  & { likeComment: (
    { __typename?: 'LikeCommentPayload' }
    & Pick<LikeCommentPayload, 'status' | 'likeCount' | 'recordid'>
  ) }
);

export type DeclareCommentMutationVariables = Exact<{
  declareCommentInput: DeclareCommentInput;
}>;


export type DeclareCommentMutation = (
  { __typename?: 'Mutation' }
  & { declareComment: (
    { __typename?: 'DeclareCommonPayload' }
    & Pick<DeclareCommonPayload, 'status' | 'landingUrl'>
  ) }
);

export type BlockUserMutationVariables = Exact<{
  blockUserInput: BlockUserInput;
}>;


export type BlockUserMutation = (
  { __typename?: 'Mutation' }
  & { blockUser: (
    { __typename?: 'CommentCommonPayload' }
    & Pick<CommentCommonPayload, 'status'>
  ) }
);

export type ContentTicketDetailQueryVariables = Exact<{
  ticketUid: Scalars['String'];
  seriesId: Scalars['Long'];
}>;


export type ContentTicketDetailQuery = (
  { __typename?: 'Query' }
  & { contentTicketDetail?: Maybe<(
    { __typename?: 'TicketDetail' }
    & Pick<TicketDetail, 'isVod' | 'refundableCash' | 'refundableTicketNum' | 'dateCompare' | 'vodDiscountPrice' | 'ticketUid' | 'productType'>
    & { refundTicketInfo?: Maybe<(
      { __typename?: 'RefundableTicketInfo' }
      & RefundableTicketInfoFragment
    )>, salesTicket?: Maybe<(
      { __typename?: 'SalesTicketItem' }
      & SalesTicketItemFragment
    )> }
  )> }
);

export type RefundableTicketInfoFragment = (
  { __typename?: 'RefundableTicketInfo' }
  & Pick<RefundableTicketInfo, 'expiredEventCash' | 'initialCount' | 'normalCash' | 'notRefundableExpiredEventCash' | 'notRefundablePoint' | 'notRefundableVodCash' | 'paidTicketCount' | 'point' | 'price' | 'qty' | 'refundTicketCount' | 'refundExceptEventCash' | 'refundableNormalCash' | 'refundableValidEventCash' | 'remainCount' | 'totalPaidCash' | 'usedExpiredEventCash' | 'usedNormalCash' | 'usedPaidTicketPrice' | 'usedPoint' | 'usedValidEventCash' | 'usedVodCash' | 'validEventCash' | 'vodCash'>
);

export type SalesTicketItemFragment = (
  { __typename?: 'SalesTicketItem' }
  & Pick<SalesTicketItem, 'ticketUid' | 'ticketType' | 'seriesTitle' | 'itemCount' | 'price' | 'createDt' | 'saleType' | 'payId' | 'qty' | 'paidNum' | 'ticketExpireDt'>
);

export type ContentTicketInfoQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  seriesId: Scalars['Long'];
}>;


export type ContentTicketInfoQuery = (
  { __typename?: 'Query' }
  & { contentTicketInfo?: Maybe<(
    { __typename?: 'TicketInSeries' }
    & Pick<TicketInSeries, 'seriesTitle' | 'isEnd'>
    & { refundInfo?: Maybe<Array<(
      { __typename?: 'TicketItemInSeries' }
      & Pick<TicketItemInSeries, 'uid' | 'createDt' | 'saleType' | 'remainCount' | 'initialAmount' | 'ticketType' | 'ticketKind' | 'ticketStatusText' | 'productType'>
    )>> }
  )> }
);

export type RefundTicketMutationVariables = Exact<{
  ticketUid: Scalars['String'];
}>;


export type RefundTicketMutation = (
  { __typename?: 'Mutation' }
  & { refundTicket: (
    { __typename?: 'RefundTicketStatusPayload' }
    & Pick<RefundTicketStatusPayload, 'status'>
  ) }
);

export type GetEventInfoMutationVariables = Exact<{
  input: GetEventInfoInput;
}>;


export type GetEventInfoMutation = (
  { __typename?: 'Mutation' }
  & { getEventInfo: (
    { __typename?: 'GetEventInfoPayload' }
    & Pick<GetEventInfoPayload, 'eventId' | 'eventTitle' | 'eventVersion' | 'isNeedUpdate' | 'userUid' | 'stoken' | 'head' | 'body' | 'agreed' | 'appUserId' | 'nickname' | 'orgCode'>
    & { contentInfoList?: Maybe<Array<(
      { __typename?: 'AutomaticEvent' }
      & AutomaticEventFragment
    )>> }
  ) }
);

export type MyNewsQueryVariables = Exact<{
  myNewsListInput: MyNewsListInput;
}>;


export type MyNewsQuery = (
  { __typename?: 'Query' }
  & { myNewsList?: Maybe<(
    { __typename?: 'MyNewsList' }
    & Pick<MyNewsList, 'id'>
    & { news?: Maybe<Array<(
      { __typename?: 'MyNewsItem' }
      & Pick<MyNewsItem, 'id' | 'type' | 'scheme' | 'title' | 'message' | 'thumbnail' | 'date' | 'logName' | 'newsId' | 'adLocId'>
    )>>, displayAd?: Maybe<(
      { __typename?: 'DisplayAd' }
      & Pick<DisplayAd, 'sectionUid' | 'bannerUid' | 'treviUid' | 'momentUid'>
    )> }
  )> }
);

export type MyRatingQueryVariables = Exact<{
  seriesId: Scalars['Long'];
  productId: Scalars['Long'];
}>;


export type MyRatingQuery = (
  { __typename?: 'Query' }
  & { myRating?: Maybe<(
    { __typename?: 'MyRating' }
    & Pick<MyRating, 'myRating'>
  )> }
);

export type PopupQueryVariables = Exact<{ [key: string]: never; }>;


export type PopupQuery = (
  { __typename?: 'Query' }
  & { popup?: Maybe<(
    { __typename?: 'Popup' }
    & Pick<Popup, 'useWelcome'>
  )> }
);

export type ReceiptInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ReceiptInfoQuery = (
  { __typename?: 'Query' }
  & { receiptInfo?: Maybe<(
    { __typename?: 'ReceiptInfo' }
    & ReceiptInfoFragment
  )> }
);

export type DeleteReceiptInfoMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteReceiptInfoMutation = (
  { __typename?: 'Mutation' }
  & { deleteReceiptInfo: (
    { __typename?: 'ReceiptInfoStatusPayload' }
    & Pick<ReceiptInfoStatusPayload, 'status'>
  ) }
);

export type UpdateReceiptInfoMutationVariables = Exact<{
  input: UpdateReceiptInfoInput;
}>;


export type UpdateReceiptInfoMutation = (
  { __typename?: 'Mutation' }
  & { updateReceiptInfo?: Maybe<(
    { __typename?: 'ReceiptInfo' }
    & ReceiptInfoFragment
  )> }
);

export type ReceiptInfoResultQueryVariables = Exact<{
  creditMasterId: Scalars['BigInt'];
}>;


export type ReceiptInfoResultQuery = (
  { __typename?: 'Query' }
  & { receiptInfoResult?: Maybe<(
    { __typename?: 'ReceiptInfoResult' }
    & ReceiptInfoResultFragment
  )> }
);

export type TvPointAgreementQueryVariables = Exact<{ [key: string]: never; }>;


export type TvPointAgreementQuery = (
  { __typename?: 'Query' }
  & { tvPointAgreement?: Maybe<(
    { __typename?: 'TvPointAgreement' }
    & Pick<TvPointAgreement, 'isAgree'>
  )> }
);

export type SetTvPointAgreemenMutationVariables = Exact<{
  isAgree: Scalars['Boolean'];
}>;


export type SetTvPointAgreemenMutation = (
  { __typename?: 'Mutation' }
  & { setTvPointAgreement: (
    { __typename?: 'SetTvPointAgreementPayload' }
    & Pick<SetTvPointAgreementPayload, 'status'>
  ) }
);

export type RemoveMyNewsItemMutationVariables = Exact<{
  input: RemoveMyNewsInput;
}>;


export type RemoveMyNewsItemMutation = (
  { __typename?: 'Mutation' }
  & { removeMyNews: (
    { __typename?: 'RemoveMyNewsPayload' }
    & Pick<RemoveMyNewsPayload, 'newsId'>
  ) }
);

export type SetMyRatingMutationVariables = Exact<{
  setMyRatingInput: SetMyRatingInput;
}>;


export type SetMyRatingMutation = (
  { __typename?: 'Mutation' }
  & { setMyRating: (
    { __typename?: 'SetMyRatingPayload' }
    & Pick<SetMyRatingPayload, 'status'>
  ) }
);

export type SinglePreviewQueryVariables = Exact<{
  productId: Scalars['Long'];
}>;


export type SinglePreviewQuery = (
  { __typename?: 'Query' }
  & { singlePreview?: Maybe<(
    { __typename?: 'SinglePreview' }
    & Pick<SinglePreview, 'title' | 'productId' | 'isFree' | 'slideType' | 'saleState' | 'categoryUid' | 'thumbnail' | 'landThumbnail' | 'author' | 'seriesId' | 'readAccessType' | 'seriesLang'>
    & { seriesPreview?: Maybe<(
      { __typename?: 'SeriesPreview' }
      & Pick<SeriesPreview, 'title' | 'landThumbnail' | 'thumbnail' | 'description' | 'author'>
    )> }
  )> }
);

export type TodayGiftListQueryVariables = Exact<{
  categoryUid?: Maybe<Scalars['String']>;
  subCategoryUid?: Maybe<Scalars['String']>;
}>;


export type TodayGiftListQuery = (
  { __typename?: 'Query' }
  & { todayGiftList?: Maybe<(
    { __typename?: 'TodayGiftList' }
    & Pick<TodayGiftList, 'id' | 'receivableTicketCount' | 'promotionTitle' | 'helixDescription'>
    & { displayAd?: Maybe<(
      { __typename?: 'DisplayAd' }
      & Pick<DisplayAd, 'sectionUid' | 'bannerUid' | 'treviUid' | 'momentUid'>
    )>, list: Array<(
      { __typename?: 'NormalListViewItem' }
      & Pick<NormalListViewItem, 'id' | 'type'>
      & NormalListViewItemFragment
    )>, categoryList: Array<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'id' | 'name' | 'param'>
    )>, subCategoryList: Array<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'id' | 'name' | 'param'>
    )>, promotionList: Array<(
      { __typename?: 'NormalListViewItem' }
      & Pick<NormalListViewItem, 'id' | 'type'>
      & NormalListViewItemFragment
    )>, helixList: Array<(
      { __typename?: 'HelixTodayGiftList' }
      & HelixTodayGiftListFragment
    )>, selectedCategory: (
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'id' | 'name' | 'param'>
    ), selectedSubCategory?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'id' | 'name' | 'param'>
    )> }
  )> }
);

export type UpdateNicknameMutationVariables = Exact<{
  input: UpdateNicknameInput;
}>;


export type UpdateNicknameMutation = (
  { __typename?: 'Mutation' }
  & { updateNickname: (
    { __typename?: 'UpdateNicknamePayload' }
    & Pick<UpdateNicknamePayload, 'nickname' | 'shouldUpdateProfile' | 'status'>
  ) }
);

export type UseTicketMutationVariables = Exact<{
  input: TicketUseMutationInput;
}>;


export type UseTicketMutation = (
  { __typename?: 'Mutation' }
  & { useTicket: (
    { __typename?: 'TicketUseMutationPayload' }
    & Pick<TicketUseMutationPayload, 'waitfreeChargedAt' | 'ticketUid'>
  ) }
);

export type UseTicketHistoryQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  freeOnly?: Maybe<Scalars['Boolean']>;
}>;


export type UseTicketHistoryQuery = (
  { __typename?: 'Query' }
  & { useTicketHistory?: Maybe<(
    { __typename?: 'HistoryList' }
    & Pick<HistoryList, 'isEnd'>
    & { list: Array<(
      { __typename?: 'History' }
      & HistoryFragment
    )> }
  )> }
);

export type UserAndCashQueryVariables = Exact<{
  authInput?: Maybe<AuthInput>;
}>;


export type UserAndCashQuery = (
  { __typename?: 'Query' }
  & { userAndCash?: Maybe<(
    { __typename?: 'UserAndCashPayload' }
    & { user?: Maybe<(
      { __typename?: 'User' }
      & UserFragment
    )>, cash?: Maybe<(
      { __typename?: 'UserCash' }
      & UserCashFragment
    )> }
  )> }
);

export type UserCashQueryVariables = Exact<{ [key: string]: never; }>;


export type UserCashQuery = (
  { __typename?: 'Query' }
  & { userCash?: Maybe<(
    { __typename?: 'UserCash' }
    & UserCashFragment
  )> }
);

export type FairplayCertificateUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type FairplayCertificateUrlQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'fairplayCertificateUrl'>
);

export type VodTokenQueryVariables = Exact<{
  productId: Scalars['Long'];
  contentPackId: Scalars['String'];
  drmType: DrmType;
}>;


export type VodTokenQuery = (
  { __typename?: 'Query' }
  & { vodToken?: Maybe<(
    { __typename?: 'VodToken' }
    & Pick<VodToken, 'token' | 'provider'>
  )> }
);

export type DrmAssertionQueryVariables = Exact<{
  productId: Scalars['Long'];
  contentPackId: Scalars['String'];
}>;


export type DrmAssertionQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'drmAssertion'>
);

export type WelcomeQueryVariables = Exact<{ [key: string]: never; }>;


export type WelcomeQuery = (
  { __typename?: 'Query' }
  & { welcome?: Maybe<(
    { __typename?: 'Welcome' }
    & { welcomeInfo: (
      { __typename?: 'WelcomeInfo' }
      & Pick<WelcomeInfo, 'userNickname' | 'welcomeCash'>
      & { welcomeButtons: Array<(
        { __typename?: 'WelcomeButtonInfo' }
        & Pick<WelcomeButtonInfo, 'title' | 'scheme' | 'kageId'>
      )> }
    ), recommendContents: (
      { __typename?: 'WelcomeRecommendContents' }
      & { webtoonList: Array<(
        { __typename?: 'WelcomeRecommendItem' }
        & WelcomeRecommendItemFragment
      )>, novelList: Array<(
        { __typename?: 'WelcomeRecommendItem' }
        & WelcomeRecommendItemFragment
      )> }
    ) }
  )> }
);

export type BuyAndUseTicketMutationVariables = Exact<{
  input: TicketBuyAndUseMutationInput;
}>;


export type BuyAndUseTicketMutation = (
  { __typename?: 'Mutation' }
  & { buyAndUseTicket: (
    { __typename?: 'TicketBuyAndUseMutationPayload' }
    & Pick<TicketBuyAndUseMutationPayload, 'buyTicketinfo' | 'remainCash' | 'ticketUid'>
  ) }
);

export type BuyTicketMutationVariables = Exact<{
  input: TicketBuyMutationInput;
}>;


export type BuyTicketMutation = (
  { __typename?: 'Mutation' }
  & { buyTicket: (
    { __typename?: 'TicketBuyMutationPayload' }
    & Pick<TicketBuyMutationPayload, 'remainCash' | 'purchasedTicketCount'>
  ) }
);

export type ContentBuyTicketPageQueryVariables = Exact<{
  seriesId: Scalars['Long'];
}>;


export type ContentBuyTicketPageQuery = (
  { __typename?: 'Query' }
  & { contentBuyTicketPage?: Maybe<(
    { __typename?: 'ContentBuyTicketPage' }
    & { bannerList: Array<(
      { __typename?: 'SimpleImageBanner' }
      & Pick<SimpleImageBanner, 'uid' | 'title' | 'imageUrl' | 'scheme' | 'shouldOpenNewWindow' | 'bgColor'>
    )>, ticketInfo?: Maybe<(
      { __typename?: 'ContentTicketInfo' }
      & Pick<ContentTicketInfo, 'isSaleOwnTicket' | 'isSaleRentalTicket' | 'rentalPeriodByMinute'>
      & { purchasableOwnTicketList: Array<(
        { __typename?: 'TicketInfoApi' }
        & TicketInfoApiFragment
      )>, purchasableRentalTicketList: Array<(
        { __typename?: 'TicketInfoApi' }
        & TicketInfoApiFragment
      )> }
    )> }
  )> }
);

export type TicketInfoApiFragment = (
  { __typename?: 'TicketInfoApi' }
  & Pick<TicketInfoApi, 'ticketType' | 'price' | 'ticketId' | 'ticketKind' | 'paidTicketCount' | 'totalTicketCount' | 'discount' | 'packageOrder'>
);

export type ContentCheckFreeTicketQueryVariables = Exact<{
  seriesId: Scalars['Long'];
}>;


export type ContentCheckFreeTicketQuery = (
  { __typename?: 'Query' }
  & { contentCheckFreeTicket?: Maybe<(
    { __typename?: 'ContentCheckFreeTicket' }
    & { list: Array<(
      { __typename?: 'TicketSum' }
      & Pick<TicketSum, 'ticketType' | 'ticketKind' | 'count' | 'ticketExpireAt'>
    )> }
  )> }
);

export type ContentMyTicketQueryVariables = Exact<{
  seriesId: Scalars['Long'];
  includeSingle?: Maybe<Scalars['Boolean']>;
  includeWaitfree?: Maybe<Scalars['Boolean']>;
  onlyPaidTicket?: Maybe<Scalars['Boolean']>;
}>;


export type ContentMyTicketQuery = (
  { __typename?: 'Query' }
  & { contentMyTicket?: Maybe<(
    { __typename?: 'ContentMyTicket' }
    & Pick<ContentMyTicket, 'notOwnCount' | 'notReadCount' | 'ticketOwnCount' | 'ticketRentalCount'>
    & { waitfree?: Maybe<(
      { __typename?: 'ContentWaitfreeInfo' }
      & Pick<ContentWaitfreeInfo, 'activation' | 'chargedAt' | 'chargedComplete' | 'chargedPeriodByMinute' | 'baseDate'>
    )> }
  )> }
);

export type ContentTicketHistoryBuyQueryVariables = Exact<{
  seriesId: Scalars['Long'];
  page?: Maybe<Scalars['Int']>;
}>;


export type ContentTicketHistoryBuyQuery = (
  { __typename?: 'Query' }
  & { contentTicketHistoryBuy?: Maybe<(
    { __typename?: 'ContentTicketHistoryBuy' }
    & Pick<ContentTicketHistoryBuy, 'isEnd' | 'totalCount'>
    & { list?: Maybe<Array<(
      { __typename?: 'BuyHistory' }
      & Pick<BuyHistory, 'title' | 'ticketUid' | 'ticketType' | 'ticketKind' | 'saleType' | 'createdDt' | 'isRefundable'>
    )>> }
  )> }
);

export type ContentTicketHistoryBuyDetailQueryVariables = Exact<{
  seriesId: Scalars['Long'];
  ticketId: Scalars['String'];
}>;


export type ContentTicketHistoryBuyDetailQuery = (
  { __typename?: 'Query' }
  & { contentTicketHistoryBuyDetail?: Maybe<(
    { __typename?: 'ContentTicketHistoryBuyDetail' }
    & Pick<ContentTicketHistoryBuyDetail, 'payId' | 'ticketType' | 'price' | 'expiredAmount' | 'availableAmount' | 'createdDt' | 'ticketTypeText' | 'isSet'>
    & { list?: Maybe<Array<(
      { __typename?: 'TicketHistoryBuyExtraSimple' }
      & Pick<TicketHistoryBuyExtraSimple, 'productId' | 'title' | 'status'>
    )>> }
  )> }
);

export type ReadyToUseTicketQueryVariables = Exact<{
  seriesId: Scalars['Long'];
  productId: Scalars['Long'];
}>;


export type ReadyToUseTicketQuery = (
  { __typename?: 'Query' }
  & { readyToUseTicket?: Maybe<(
    { __typename?: 'ReadyToUseTicket' }
    & Pick<ReadyToUseTicket, 'rentalPeriodByMinute'>
    & { series?: Maybe<(
      { __typename?: 'TicketSeries' }
      & Pick<TicketSeries, 'isWaitfree' | 'waitfreeBlockCount' | 'saleMethod'>
    )>, single?: Maybe<(
      { __typename?: 'TicketSingle' }
      & Pick<TicketSingle, 'readAccessType' | 'title' | 'waitfreeBlock' | 'isDone'>
    )>, my?: Maybe<(
      { __typename?: 'TicketMy' }
      & Pick<TicketMy, 'cashAmount' | 'ticketOwnCount' | 'ticketRentalCount'>
    )>, available?: Maybe<(
      { __typename?: 'TicketAvailable' }
      & Pick<TicketAvailable, 'ticketOwnType' | 'ticketRentalType'>
    )>, purchase?: Maybe<(
      { __typename?: 'TicketPurchase' }
      & { ticketRental?: Maybe<(
        { __typename?: 'TicketInfo' }
        & Pick<TicketInfo, 'ticketId' | 'ticketType' | 'ticketKind' | 'price' | 'discountPrice'>
      )>, ticketOwn?: Maybe<(
        { __typename?: 'TicketInfo' }
        & Pick<TicketInfo, 'ticketId' | 'ticketType' | 'ticketKind' | 'price' | 'discountPrice'>
      )>, set?: Maybe<(
        { __typename?: 'SimpleSet' }
        & Pick<SimpleSet, 'setId' | 'discountRate' | 'isMultiple'>
      )> }
    )>, nextItem?: Maybe<(
      { __typename?: 'LegacySingle' }
      & Pick<LegacySingle, 'productId' | 'isFree' | 'slideType' | 'ageGrade'>
    )> }
  )> }
);

export type ReceiveTicketFreeMutationVariables = Exact<{
  input: TicketFreeMutationInput;
}>;


export type ReceiveTicketFreeMutation = (
  { __typename?: 'Mutation' }
  & { receiveTicketFree: (
    { __typename?: 'TodayGift' }
    & TodayGiftFragment
  ) }
);

export type SetBuyTicketMutationVariables = Exact<{
  input: TicketSetBuyMutationInput;
}>;


export type SetBuyTicketMutation = (
  { __typename?: 'Mutation' }
  & { setBuyTicket: (
    { __typename?: 'TicketSetBuyMutationPayload' }
    & Pick<TicketSetBuyMutationPayload, 'remainCash'>
  ) }
);

export type SetReadyToUseTicketQueryVariables = Exact<{
  setId: Scalars['Long'];
  seriesId: Scalars['Long'];
}>;


export type SetReadyToUseTicketQuery = (
  { __typename?: 'Query' }
  & { setReadyToUseTicket?: Maybe<(
    { __typename?: 'SetReadyToUseTicket' }
    & { my?: Maybe<(
      { __typename?: 'SetTicketMy' }
      & Pick<SetTicketMy, 'hasRentalProduct' | 'hasOwnProduct' | 'cashAmount'>
    )>, purchase?: Maybe<(
      { __typename?: 'TicketPurchase' }
      & { ticketRental?: Maybe<(
        { __typename?: 'TicketInfo' }
        & Pick<TicketInfo, 'ticketId' | 'ticketType' | 'ticketKind' | 'price' | 'discountPrice' | 'discountRate' | 'rentalPeriodByMinute'>
      )>, ticketOwn?: Maybe<(
        { __typename?: 'TicketInfo' }
        & Pick<TicketInfo, 'ticketId' | 'ticketType' | 'ticketKind' | 'price' | 'discountPrice' | 'discountRate'>
      )> }
    )> }
  )> }
);

export type AgeAuthQueryVariables = Exact<{
  ageLimit: Scalars['Int'];
}>;


export type AgeAuthQuery = (
  { __typename?: 'Query' }
  & { ageAuth?: Maybe<(
    { __typename?: 'AgeAuth' }
    & Pick<AgeAuth, 'age' | 'authenticatedAt' | 'status'>
  )> }
);

export type ChangeEmailPasswordMutationVariables = Exact<{
  changeEmailPasswordInput: ChangeEmailPasswordInput;
}>;


export type ChangeEmailPasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'changeEmailPassword'>
);

export type ViewerEndQueryVariables = Exact<{
  viewerEndInput: ViewerEndInput;
}>;


export type ViewerEndQuery = (
  { __typename?: 'Query' }
  & { viewerEnd?: Maybe<(
    { __typename?: 'ViewerEnd' }
    & ViewerEndFragment
  )> }
);

export type ViewerInfoQueryVariables = Exact<{
  seriesId: Scalars['Long'];
  productId: Scalars['Long'];
}>;


export type ViewerInfoQuery = (
  { __typename?: 'Query' }
  & { viewerInfo?: Maybe<(
    { __typename?: 'ViewerInfo' }
    & { item: (
      { __typename?: 'Single' }
      & SingleFragmentFragment
    ), seriesItem: (
      { __typename?: 'Series' }
      & SeriesFragmentFragment
    ), prevItem?: Maybe<(
      { __typename?: 'NearItem' }
      & NearItemFragmentFragment
    )>, nextItem?: Maybe<(
      { __typename?: 'NearItem' }
      & NearItemFragmentFragment
    )>, viewerData?: Maybe<(
      { __typename?: 'ImageViewerData' }
      & ImageViewerDataFragment
    ) | (
      { __typename?: 'TalkViewerData' }
      & TalkViewerDataFragment
    ) | (
      { __typename?: 'TextViewerData' }
      & TextViewerDataFragment
    ) | (
      { __typename?: 'VodViewerData' }
      & VodViewerDataFragment
    )>, displayAd?: Maybe<(
      { __typename?: 'DisplayAd' }
      & DisplayAdFragment
    )> }
  )> }
);

export type LastPageMutationVariables = Exact<{
  input: ViewerLastPageMutationInput;
}>;


export type LastPageMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'viewerLastPage'>
);

export type AgreementFragment = (
  { __typename?: 'Agreement' }
  & Pick<Agreement, 'type' | 'isRequired' | 'title' | 'url' | 'version' | 'uid'>
);

export type AnnouncementFragment = (
  { __typename?: 'Announcement' }
  & Pick<Announcement, 'id' | 'title' | 'contents' | 'createDt'>
);

export type AnnouncementContainerFragment = (
  { __typename?: 'AnnouncementContainer' }
  & Pick<AnnouncementContainer, 'totalCount'>
  & { items: Array<(
    { __typename?: 'Announcement' }
    & AnnouncementFragment
  )> }
);

export type AppBadgeFragment = (
  { __typename?: 'AppBadge' }
  & Pick<AppBadge, 'giftLastAddedDate' | 'myNewsLastAddedDate' | 'noticeLastAddedDate'>
);

export type AssetPropertyFragmentFragment = (
  { __typename?: 'AssetProperty' }
  & Pick<AssetProperty, 'bannerImage' | 'cardImage' | 'cardTextImage' | 'cleanImage' | 'ipxVideo'>
  & { bannerSet?: Maybe<(
    { __typename?: 'BannerSet' }
    & BannerSetFragmentFragment
  )>, cardSet?: Maybe<(
    { __typename?: 'CardSet' }
    & CardSetFragmentFragment
  )>, cardCover?: Maybe<(
    { __typename?: 'CardCover' }
    & CardCoverFragmentFragment
  )> }
);

export type AuthInfoFragment = (
  { __typename?: 'AuthInfo' }
  & Pick<AuthInfo, 'age' | 'updatedAt'>
);

export type AutomaticEventFragment = (
  { __typename?: 'AutomaticEvent' }
  & Pick<AutomaticEvent, 'itemOrder' | 'resourceUrl' | 'destinationTypeIos' | 'destinationTypeAndroid' | 'destinationInfoIos' | 'destinationInfoWeb' | 'schemeIos' | 'schemeWeb' | 'schemeAndroid' | 'resourceHeight' | 'resourceWidth'>
);

export type BannerItemFragment = (
  { __typename?: 'BannerItem' }
  & Pick<BannerItem, 'bannerType' | 'bannerViewType' | 'thumbnail' | 'videoUrl' | 'badgeList' | 'statusBadge' | 'titleImage' | 'title' | 'altText' | 'metaList' | 'caption' | 'scheme' | 'seriesId' | 'discountRate' | 'discountRateText' | 'backgroundColor' | 'characterImage'>
  & { eventLog?: Maybe<(
    { __typename?: 'EventLog' }
    & EventLogFragmentFragment
  )> }
);

export type BannerSetFragmentFragment = (
  { __typename?: 'BannerSet' }
  & Pick<BannerSet, 'backgroundImage' | 'backgroundColor' | 'mainImage' | 'titleImage'>
);

export type CardCoverFragmentFragment = (
  { __typename?: 'CardCover' }
  & Pick<CardCover, 'coverImg' | 'coverRestricted'>
);

export type CardSetFragmentFragment = (
  { __typename?: 'CardSet' }
  & Pick<CardSet, 'backgroundColor' | 'backgroundImage'>
);

export type CardViewItemFragment = (
  { __typename?: 'CardViewItem' }
  & Pick<CardViewItem, 'title' | 'altText' | 'thumbnail' | 'scheme' | 'badgeList' | 'ageGradeBadge' | 'statusBadge' | 'ageGrade' | 'selfCensorship' | 'subtitleList' | 'caption' | 'rank' | 'rankVariation' | 'isEventBanner' | 'categoryType' | 'discountRate' | 'discountRateText' | 'backgroundColor' | 'isBook' | 'isLegacy'>
  & { cardCover?: Maybe<(
    { __typename?: 'CardCover' }
    & CardCoverFragmentFragment
  )>, eventLog?: Maybe<(
    { __typename?: 'EventLog' }
    & EventLogFragmentFragment
  )> }
);

export type CleanViewItemFragment = (
  { __typename?: 'CleanViewItem' }
  & Pick<CleanViewItem, 'id' | 'type' | 'showPlayerIcon' | 'scheme' | 'title' | 'thumbnail' | 'badgeList' | 'ageGradeBadge' | 'statusBadge' | 'subtitleList' | 'rank' | 'ageGrade' | 'selfCensorship' | 'discountRate' | 'discountRateText'>
  & { eventLog?: Maybe<(
    { __typename?: 'EventLog' }
    & EventLogFragmentFragment
  )> }
);

export type ContentRecommendGroupFragment = (
  { __typename?: 'ContentRecommendGroup' }
  & Pick<ContentRecommendGroup, 'id' | 'impLabel' | 'type' | 'title' | 'description'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Pick<BannerItem, 'id' | 'type'>
  ) | (
    { __typename?: 'CardViewItem' }
    & Pick<CardViewItem, 'id' | 'type'>
  ) | (
    { __typename?: 'CleanViewItem' }
    & Pick<CleanViewItem, 'id' | 'type'>
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Pick<DisplayAdItem, 'id' | 'type'>
  ) | (
    { __typename?: 'EventBannerItem' }
    & Pick<EventBannerItem, 'id' | 'type'>
  ) | (
    { __typename?: 'LineBannerItem' }
    & Pick<LineBannerItem, 'id' | 'type'>
  ) | (
    { __typename?: 'MoreItem' }
    & Pick<MoreItem, 'id' | 'type'>
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Pick<NormalListViewItem, 'id' | 'type'>
  ) | (
    { __typename?: 'OnAirItem' }
    & Pick<OnAirItem, 'id' | 'type'>
  ) | (
    { __typename?: 'PosterViewItem' }
    & Pick<PosterViewItem, 'id' | 'type'>
    & PosterViewItemFragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Pick<PromotionBannerItem, 'id' | 'type'>
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Pick<PromotionCardViewItem, 'id' | 'type'>
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Pick<RankingListViewItem, 'id' | 'type'>
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Pick<SingleListViewItem, 'id' | 'type'>
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Pick<StrategyViewItem, 'id' | 'type'>
  ) | (
    { __typename?: 'UnknownItem' }
    & Pick<UnknownItem, 'id' | 'type'>
  )>> }
);

export type ContinueInfoFragmentFragment = (
  { __typename?: 'ContinueInfo' }
  & Pick<ContinueInfo, 'title' | 'isFree' | 'productId' | 'lastReadProductId' | 'scheme' | 'continueProductType' | 'hasNewSingle' | 'hasUnreadSingle'>
);

export type DayOfWeekLayoutFragment = (
  { __typename?: 'DayOfWeekLayout' }
  & { selectedDay: (
    { __typename?: 'FilterOption' }
    & Pick<FilterOption, 'name' | 'param'>
    & { translateProperty?: Maybe<(
      { __typename?: 'TranslateProperty' }
      & TranslatePropertyFragmentFragment
    )> }
  ), selectedSort: (
    { __typename?: 'FilterOption' }
    & Pick<FilterOption, 'name' | 'param'>
    & { translateProperty?: Maybe<(
      { __typename?: 'TranslateProperty' }
      & TranslatePropertyFragmentFragment
    )> }
  ), selectedReference: (
    { __typename?: 'FilterOption' }
    & Pick<FilterOption, 'name' | 'param' | 'keys'>
    & { translateProperty?: Maybe<(
      { __typename?: 'TranslateProperty' }
      & TranslatePropertyFragmentFragment
    )> }
  ), dayList: Array<(
    { __typename?: 'FilterOption' }
    & Pick<FilterOption, 'name' | 'param'>
    & { translateProperty?: Maybe<(
      { __typename?: 'TranslateProperty' }
      & TranslatePropertyFragmentFragment
    )> }
  )>, sortList: Array<(
    { __typename?: 'FilterOption' }
    & Pick<FilterOption, 'name' | 'param'>
    & { translateProperty?: Maybe<(
      { __typename?: 'TranslateProperty' }
      & TranslatePropertyFragmentFragment
    )> }
  )>, referenceList: Array<(
    { __typename?: 'FilterOption' }
    & Pick<FilterOption, 'name' | 'param' | 'keys'>
    & { translateProperty?: Maybe<(
      { __typename?: 'TranslateProperty' }
      & TranslatePropertyFragmentFragment
    )> }
  )> }
);

export type DayOfWeekListFragment = (
  { __typename?: 'DayOfWeekList' }
  & Pick<DayOfWeekList, 'title' | 'isEnd'>
  & { list: Array<(
    { __typename?: 'CardViewItem' }
    & CardViewItemFragment
  )>, banner?: Maybe<(
    { __typename?: 'BannerItem' }
    & BannerItemFragment
  )> }
);

export type DeviceFragment = (
  { __typename?: 'Device' }
  & Pick<Device, 'deviceUid' | 'deviceModel' | 'isCurrentDevice' | 'lastUsedDt' | 'createdDt'>
);

export type DynamicLayoutReferenceFragment = (
  { __typename?: 'DynamicLayoutReference' }
  & { layoutReference?: Maybe<Array<(
    { __typename?: 'LayoutReferenceViewData' }
    & LayoutReferenceViewDataFragment
  )>>, dynamicLayout?: Maybe<(
    { __typename?: 'DynamicLayout' }
    & Pick<DynamicLayout, 'title' | 'subTitle' | 'description' | 'scheme'>
  )> }
);

export type EventBannerItemFragment = (
  { __typename?: 'EventBannerItem' }
  & Pick<EventBannerItem, 'bannerType' | 'thumbnail' | 'videoUrl' | 'titleImage' | 'title' | 'subtitleList' | 'caption' | 'scheme'>
  & { eventLog?: Maybe<(
    { __typename?: 'EventLog' }
    & EventLogFragmentFragment
  )> }
);

export type EventLogFragmentFragment = (
  { __typename?: 'EventLog' }
  & Pick<EventLog, 'fromGraphql'>
  & { click?: Maybe<(
    { __typename?: 'ClickLog' }
    & Pick<ClickLog, 'layer1' | 'layer2' | 'setnum' | 'ordnum' | 'copy' | 'imp_id' | 'imp_provider'>
  )>, eventMeta?: Maybe<(
    { __typename?: 'EventMeta' }
    & Pick<EventMeta, 'id' | 'name' | 'subcategory' | 'category' | 'series' | 'provider' | 'series_id' | 'type'>
  )>, viewimp_contents?: Maybe<(
    { __typename?: 'ViewImpContents' }
    & Pick<ViewImpContents, 'type' | 'name' | 'id' | 'imp_area_ordnum' | 'imp_id' | 'imp_provider' | 'imp_type' | 'layer1' | 'layer2'>
  )>, customProps?: Maybe<(
    { __typename?: 'CustomProps' }
    & Pick<CustomProps, 'landing_path' | 'view_type' | 'helix_id' | 'helix_yn' | 'helix_seed' | 'content_cnt' | 'event_series_id' | 'event_ticket_type' | 'play_url' | 'banner_uid' | 'rec_id'>
  )> }
);

export type ExpiredCreditFragment = (
  { __typename?: 'ExpiredCredit' }
  & Pick<ExpiredCredit, 'expiredAt' | 'expiredSum'>
);

export type GlobalUserFragment = (
  { __typename?: 'GlobalUser' }
  & Pick<GlobalUser, 'userUid' | 'countryCode' | 'profileThumbnailUrl' | 'nickname' | 'email' | 'memberId' | 'age' | 'userCommentBlockMsg'>
);

export type GotchaInfoFragment = (
  { __typename?: 'GotchaInfo' }
  & Pick<GotchaInfo, 'gotchaId' | 'type' | 'entryType' | 'title' | 'bgImg' | 'bgColor' | 'topTitleImg' | 'spinWheelReadyImgs' | 'spinWheelImgs' | 'resultImg' | 'buttonImg' | 'buttonColor' | 'extBannerImg' | 'extBannerLink' | 'expireDateText' | 'belowDesc' | 'adLocId' | 'bannerAdLocId' | 'status' | 'spinWheelDesc' | 'winPrizeType' | 'winPrize' | 'receiveDate' | 'maxCash'>
);

type Group_BigBannerGroup_Fragment = (
  { __typename?: 'BigBannerGroup' }
  & Pick<BigBannerGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_CardViewGroup_Fragment = (
  { __typename?: 'CardViewGroup' }
  & Pick<CardViewGroup, 'id' | 'type' | 'dataKey'>
  & { meta?: Maybe<(
    { __typename?: 'ListViewGroupMeta' }
    & Pick<ListViewGroupMeta, 'title' | 'count'>
  )>, groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_CleanViewGroup_Fragment = (
  { __typename?: 'CleanViewGroup' }
  & Pick<CleanViewGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_ContentRecommendGroup_Fragment = (
  { __typename?: 'ContentRecommendGroup' }
  & Pick<ContentRecommendGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_DisplayAdGroup_Fragment = (
  { __typename?: 'DisplayAdGroup' }
  & Pick<DisplayAdGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_EventBannerGroup_Fragment = (
  { __typename?: 'EventBannerGroup' }
  & Pick<EventBannerGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_HorizontalScrollGroup_Fragment = (
  { __typename?: 'HorizontalScrollGroup' }
  & Pick<HorizontalScrollGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_LineBannerGroup_Fragment = (
  { __typename?: 'LineBannerGroup' }
  & Pick<LineBannerGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_ListViewGroup_Fragment = (
  { __typename?: 'ListViewGroup' }
  & Pick<ListViewGroup, 'id' | 'type' | 'dataKey'>
  & { meta?: Maybe<(
    { __typename?: 'ListViewGroupMeta' }
    & Pick<ListViewGroupMeta, 'title' | 'count'>
  )>, groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_MainRankingListViewGroup_Fragment = (
  { __typename?: 'MainRankingListViewGroup' }
  & Pick<MainRankingListViewGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_OnAirGroup_Fragment = (
  { __typename?: 'OnAirGroup' }
  & Pick<OnAirGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_PosterViewGroup_Fragment = (
  { __typename?: 'PosterViewGroup' }
  & Pick<PosterViewGroup, 'id' | 'type' | 'dataKey'>
  & { meta?: Maybe<(
    { __typename?: 'ListViewGroupMeta' }
    & Pick<ListViewGroupMeta, 'title' | 'count'>
  )>, groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_PromotionBannerGroup_Fragment = (
  { __typename?: 'PromotionBannerGroup' }
  & Pick<PromotionBannerGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_ResponsiveBannerGroup_Fragment = (
  { __typename?: 'ResponsiveBannerGroup' }
  & Pick<ResponsiveBannerGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_StandaloneBannerAndSubCardGroup_Fragment = (
  { __typename?: 'StandaloneBannerAndSubCardGroup' }
  & Pick<StandaloneBannerAndSubCardGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_StandaloneBannerGroup_Fragment = (
  { __typename?: 'StandaloneBannerGroup' }
  & Pick<StandaloneBannerGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_StrategyCategoryGroup_Fragment = (
  { __typename?: 'StrategyCategoryGroup' }
  & Pick<StrategyCategoryGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_SubCardGroup_Fragment = (
  { __typename?: 'SubCardGroup' }
  & Pick<SubCardGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_TodaySeriesGroup_Fragment = (
  { __typename?: 'TodaySeriesGroup' }
  & Pick<TodaySeriesGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type Group_UnknownGroup_Fragment = (
  { __typename?: 'UnknownGroup' }
  & Pick<UnknownGroup, 'id' | 'type' | 'dataKey'>
  & { groups?: Maybe<Array<(
    { __typename?: 'BigBannerGroup' }
    & GroupInGroup_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & GroupInGroup_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & GroupInGroup_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & GroupInGroup_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & GroupInGroup_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & GroupInGroup_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & GroupInGroup_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & GroupInGroup_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & GroupInGroup_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & GroupInGroup_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & GroupInGroup_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & GroupInGroup_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & GroupInGroup_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & GroupInGroup_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & GroupInGroup_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & GroupInGroup_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & GroupInGroup_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & GroupInGroup_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & GroupInGroup_UnknownGroup_Fragment
  )>>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

export type GroupFragment = Group_BigBannerGroup_Fragment | Group_CardViewGroup_Fragment | Group_CleanViewGroup_Fragment | Group_ContentRecommendGroup_Fragment | Group_DisplayAdGroup_Fragment | Group_EventBannerGroup_Fragment | Group_HorizontalScrollGroup_Fragment | Group_LineBannerGroup_Fragment | Group_ListViewGroup_Fragment | Group_MainRankingListViewGroup_Fragment | Group_OnAirGroup_Fragment | Group_PosterViewGroup_Fragment | Group_PromotionBannerGroup_Fragment | Group_ResponsiveBannerGroup_Fragment | Group_StandaloneBannerAndSubCardGroup_Fragment | Group_StandaloneBannerGroup_Fragment | Group_StrategyCategoryGroup_Fragment | Group_SubCardGroup_Fragment | Group_TodaySeriesGroup_Fragment | Group_UnknownGroup_Fragment;

type GroupInGroup_BigBannerGroup_Fragment = (
  { __typename?: 'BigBannerGroup' }
  & Pick<BigBannerGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_CardViewGroup_Fragment = (
  { __typename?: 'CardViewGroup' }
  & Pick<CardViewGroup, 'id' | 'type' | 'dataKey'>
  & { meta?: Maybe<(
    { __typename?: 'ListViewGroupMeta' }
    & Pick<ListViewGroupMeta, 'title' | 'count'>
  )>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_CleanViewGroup_Fragment = (
  { __typename?: 'CleanViewGroup' }
  & Pick<CleanViewGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_ContentRecommendGroup_Fragment = (
  { __typename?: 'ContentRecommendGroup' }
  & Pick<ContentRecommendGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_DisplayAdGroup_Fragment = (
  { __typename?: 'DisplayAdGroup' }
  & Pick<DisplayAdGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_EventBannerGroup_Fragment = (
  { __typename?: 'EventBannerGroup' }
  & Pick<EventBannerGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_HorizontalScrollGroup_Fragment = (
  { __typename?: 'HorizontalScrollGroup' }
  & Pick<HorizontalScrollGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_LineBannerGroup_Fragment = (
  { __typename?: 'LineBannerGroup' }
  & Pick<LineBannerGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_ListViewGroup_Fragment = (
  { __typename?: 'ListViewGroup' }
  & Pick<ListViewGroup, 'id' | 'type' | 'dataKey'>
  & { meta?: Maybe<(
    { __typename?: 'ListViewGroupMeta' }
    & Pick<ListViewGroupMeta, 'title' | 'count'>
  )>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_MainRankingListViewGroup_Fragment = (
  { __typename?: 'MainRankingListViewGroup' }
  & Pick<MainRankingListViewGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_OnAirGroup_Fragment = (
  { __typename?: 'OnAirGroup' }
  & Pick<OnAirGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_PosterViewGroup_Fragment = (
  { __typename?: 'PosterViewGroup' }
  & Pick<PosterViewGroup, 'id' | 'type' | 'dataKey'>
  & { meta?: Maybe<(
    { __typename?: 'ListViewGroupMeta' }
    & Pick<ListViewGroupMeta, 'title' | 'count'>
  )>, items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_PromotionBannerGroup_Fragment = (
  { __typename?: 'PromotionBannerGroup' }
  & Pick<PromotionBannerGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_ResponsiveBannerGroup_Fragment = (
  { __typename?: 'ResponsiveBannerGroup' }
  & Pick<ResponsiveBannerGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment = (
  { __typename?: 'StandaloneBannerAndSubCardGroup' }
  & Pick<StandaloneBannerAndSubCardGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_StandaloneBannerGroup_Fragment = (
  { __typename?: 'StandaloneBannerGroup' }
  & Pick<StandaloneBannerGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_StrategyCategoryGroup_Fragment = (
  { __typename?: 'StrategyCategoryGroup' }
  & Pick<StrategyCategoryGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_SubCardGroup_Fragment = (
  { __typename?: 'SubCardGroup' }
  & Pick<SubCardGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_TodaySeriesGroup_Fragment = (
  { __typename?: 'TodaySeriesGroup' }
  & Pick<TodaySeriesGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

type GroupInGroup_UnknownGroup_Fragment = (
  { __typename?: 'UnknownGroup' }
  & Pick<UnknownGroup, 'id' | 'type' | 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

export type GroupInGroupFragment = GroupInGroup_BigBannerGroup_Fragment | GroupInGroup_CardViewGroup_Fragment | GroupInGroup_CleanViewGroup_Fragment | GroupInGroup_ContentRecommendGroup_Fragment | GroupInGroup_DisplayAdGroup_Fragment | GroupInGroup_EventBannerGroup_Fragment | GroupInGroup_HorizontalScrollGroup_Fragment | GroupInGroup_LineBannerGroup_Fragment | GroupInGroup_ListViewGroup_Fragment | GroupInGroup_MainRankingListViewGroup_Fragment | GroupInGroup_OnAirGroup_Fragment | GroupInGroup_PosterViewGroup_Fragment | GroupInGroup_PromotionBannerGroup_Fragment | GroupInGroup_ResponsiveBannerGroup_Fragment | GroupInGroup_StandaloneBannerAndSubCardGroup_Fragment | GroupInGroup_StandaloneBannerGroup_Fragment | GroupInGroup_StrategyCategoryGroup_Fragment | GroupInGroup_SubCardGroup_Fragment | GroupInGroup_TodaySeriesGroup_Fragment | GroupInGroup_UnknownGroup_Fragment;

export type HelixTodayGiftListFragment = (
  { __typename?: 'HelixTodayGiftList' }
  & Pick<HelixTodayGiftList, 'id' | 'helixGiftTitle'>
  & { list: Array<(
    { __typename?: 'NormalListViewItem' }
    & Pick<NormalListViewItem, 'id' | 'type'>
    & NormalListViewItemFragment
  )> }
);

export type HistoryFragment = (
  { __typename?: 'History' }
  & Pick<History, 'id' | 'seriesId' | 'purchasedItem' | 'detailText' | 'detailText2' | 'createDt' | 'displayDt' | 'price' | 'productType' | 'expiredAt' | 'remainDays' | 'purchasedItemColor' | 'priceColor' | 'extraLabelType' | 'creditMasterId' | 'historyType'>
);

export type ImageDownloadDataFragment = (
  { __typename?: 'ImageDownloadData' }
  & Pick<ImageDownloadData, 'totalCount' | 'totalSize' | 'viewDirection' | 'gapBetweenImages' | 'readType'>
  & { files: Array<(
    { __typename?: 'ImageDownloadFile' }
    & ImageDownloadFileFragment
  )> }
);

export type ImageDownloadFileFragment = (
  { __typename?: 'ImageDownloadFile' }
  & Pick<ImageDownloadFile, 'no' | 'size' | 'secureUrl' | 'width' | 'height'>
);

export type ImageViewerDataFragment = (
  { __typename?: 'ImageViewerData' }
  & Pick<ImageViewerData, 'type'>
  & { imageDownloadData: (
    { __typename?: 'ImageDownloadData' }
    & ImageDownloadDataFragment
  ) }
);

export type InvenListFragment = (
  { __typename?: 'InvenList' }
  & Pick<InvenList, 'id' | 'totalCount' | 'isEnd'>
  & { catOptList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'id' | 'name' | 'param'>
  )>, selectedCatOpt: (
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'id' | 'name' | 'param'>
  ), sortOptList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'id' | 'name' | 'param'>
  )>, selectedSortOpt: (
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'id' | 'name' | 'param'>
  ), list: Array<(
    { __typename?: 'NormalListViewItem' }
    & Pick<NormalListViewItem, 'id' | 'type'>
    & NormalListViewItemFragment
  )>, displayAd?: Maybe<(
    { __typename?: 'DisplayAd' }
    & DisplayAdFragment
  )> }
);

type Item_BannerItem_Fragment = (
  { __typename?: 'BannerItem' }
  & Pick<BannerItem, 'id' | 'type'>
  & BannerItemFragment
);

type Item_CardViewItem_Fragment = (
  { __typename?: 'CardViewItem' }
  & Pick<CardViewItem, 'id' | 'type'>
  & CardViewItemFragment
);

type Item_CleanViewItem_Fragment = (
  { __typename?: 'CleanViewItem' }
  & Pick<CleanViewItem, 'id' | 'type'>
  & CleanViewItemFragment
);

type Item_DisplayAdItem_Fragment = (
  { __typename?: 'DisplayAdItem' }
  & Pick<DisplayAdItem, 'id' | 'type'>
  & { displayAd: (
    { __typename?: 'DisplayAd' }
    & DisplayAdFragment
  ) }
);

type Item_EventBannerItem_Fragment = (
  { __typename?: 'EventBannerItem' }
  & Pick<EventBannerItem, 'id' | 'type'>
  & EventBannerItemFragment
);

type Item_LineBannerItem_Fragment = (
  { __typename?: 'LineBannerItem' }
  & Pick<LineBannerItem, 'id' | 'type'>
  & LineBannerItemFragment
);

type Item_MoreItem_Fragment = (
  { __typename?: 'MoreItem' }
  & Pick<MoreItem, 'id' | 'type'>
  & MoreItemFragment
);

type Item_NormalListViewItem_Fragment = (
  { __typename?: 'NormalListViewItem' }
  & Pick<NormalListViewItem, 'id' | 'type'>
  & NormalListViewItemFragment
);

type Item_OnAirItem_Fragment = (
  { __typename?: 'OnAirItem' }
  & Pick<OnAirItem, 'id' | 'type'>
  & OnAirItemFragment
);

type Item_PosterViewItem_Fragment = (
  { __typename?: 'PosterViewItem' }
  & Pick<PosterViewItem, 'id' | 'type'>
  & PosterViewItemFragment
);

type Item_PromotionBannerItem_Fragment = (
  { __typename?: 'PromotionBannerItem' }
  & Pick<PromotionBannerItem, 'id' | 'type'>
  & PromotionBannerItemFragment
);

type Item_PromotionCardViewItem_Fragment = (
  { __typename?: 'PromotionCardViewItem' }
  & Pick<PromotionCardViewItem, 'id' | 'type'>
);

type Item_RankingListViewItem_Fragment = (
  { __typename?: 'RankingListViewItem' }
  & Pick<RankingListViewItem, 'id' | 'type'>
  & RankingListViewItemFragment
);

type Item_SingleListViewItem_Fragment = (
  { __typename?: 'SingleListViewItem' }
  & Pick<SingleListViewItem, 'id' | 'type'>
);

type Item_StrategyViewItem_Fragment = (
  { __typename?: 'StrategyViewItem' }
  & Pick<StrategyViewItem, 'id' | 'type'>
  & StrategyViewItemFragment
);

type Item_UnknownItem_Fragment = (
  { __typename?: 'UnknownItem' }
  & Pick<UnknownItem, 'id' | 'type'>
);

export type ItemFragment = Item_BannerItem_Fragment | Item_CardViewItem_Fragment | Item_CleanViewItem_Fragment | Item_DisplayAdItem_Fragment | Item_EventBannerItem_Fragment | Item_LineBannerItem_Fragment | Item_MoreItem_Fragment | Item_NormalListViewItem_Fragment | Item_OnAirItem_Fragment | Item_PosterViewItem_Fragment | Item_PromotionBannerItem_Fragment | Item_PromotionCardViewItem_Fragment | Item_RankingListViewItem_Fragment | Item_SingleListViewItem_Fragment | Item_StrategyViewItem_Fragment | Item_UnknownItem_Fragment;

export type LastViewInfoFragmentFragment = (
  { __typename?: 'LastViewInfo' }
  & Pick<LastViewInfo, 'isDone' | 'lastViewDate' | 'rate' | 'spineIndex'>
);

export type LayoutFragment = (
  { __typename?: 'Layout' }
  & Pick<Layout, 'id' | 'type' | 'screenUid'>
  & { sections: Array<(
    { __typename?: 'AlarmSection' }
    & Section_AlarmSection_Fragment
  ) | (
    { __typename?: 'BigBannerSection' }
    & Section_BigBannerSection_Fragment
  ) | (
    { __typename?: 'CardSection' }
    & Section_CardSection_Fragment
  ) | (
    { __typename?: 'CashFriendsSection' }
    & Section_CashFriendsSection_Fragment
  ) | (
    { __typename?: 'DayOfWeekSection' }
    & Section_DayOfWeekSection_Fragment
  ) | (
    { __typename?: 'DisplayAdSection' }
    & Section_DisplayAdSection_Fragment
  ) | (
    { __typename?: 'EpisodeSection' }
    & Section_EpisodeSection_Fragment
  ) | (
    { __typename?: 'EventSection' }
    & Section_EventSection_Fragment
  ) | (
    { __typename?: 'HelixThemeSection' }
    & Section_HelixThemeSection_Fragment
  ) | (
    { __typename?: 'LineBannerSection' }
    & Section_LineBannerSection_Fragment
  ) | (
    { __typename?: 'MainRankingSection' }
    & Section_MainRankingSection_Fragment
  ) | (
    { __typename?: 'OnAirSection' }
    & Section_OnAirSection_Fragment
  ) | (
    { __typename?: 'PromotionBannerSection' }
    & Section_PromotionBannerSection_Fragment
  ) | (
    { __typename?: 'RankingSection' }
    & Section_RankingSection_Fragment
  ) | (
    { __typename?: 'RankingV2Section' }
    & Section_RankingV2Section_Fragment
  ) | (
    { __typename?: 'RecentViewedSection' }
    & Section_RecentViewedSection_Fragment
  ) | (
    { __typename?: 'ScrollThemeSection' }
    & Section_ScrollThemeSection_Fragment
  ) | (
    { __typename?: 'SeriesBasedRecommendSection' }
    & Section_SeriesBasedRecommendSection_Fragment
  ) | (
    { __typename?: 'StaticLandingDayOfWeekSection' }
    & Section_StaticLandingDayOfWeekSection_Fragment
  ) | (
    { __typename?: 'StaticLandingEventSection' }
    & Section_StaticLandingEventSection_Fragment
  ) | (
    { __typename?: 'StaticLandingFreeSeriesSection' }
    & Section_StaticLandingFreeSeriesSection_Fragment
  ) | (
    { __typename?: 'StaticLandingGenreSection' }
    & Section_StaticLandingGenreSection_Fragment
  ) | (
    { __typename?: 'StaticLandingOriginalSection' }
    & Section_StaticLandingOriginalSection_Fragment
  ) | (
    { __typename?: 'StaticLandingRankingSection' }
    & Section_StaticLandingRankingSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayNewSection' }
    & Section_StaticLandingTodayNewSection_Fragment
  ) | (
    { __typename?: 'StaticLandingTodayUpSection' }
    & Section_StaticLandingTodayUpSection_Fragment
  ) | (
    { __typename?: 'StrategyCategorySection' }
    & Section_StrategyCategorySection_Fragment
  ) | (
    { __typename?: 'ThemeSection' }
    & Section_ThemeSection_Fragment
  ) | (
    { __typename?: 'TopSection' }
    & Section_TopSection_Fragment
  ) | (
    { __typename?: 'UnknownSection' }
    & Section_UnknownSection_Fragment
  ) | (
    { __typename?: 'UserBasedRecommendSection' }
    & Section_UserBasedRecommendSection_Fragment
  )> }
);

export type LayoutReferenceViewDataFragment = (
  { __typename?: 'LayoutReferenceViewData' }
  & Pick<LayoutReferenceViewData, 'dataKey'>
  & { items?: Maybe<Array<(
    { __typename?: 'BannerItem' }
    & Item_BannerItem_Fragment
  ) | (
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  ) | (
    { __typename?: 'CleanViewItem' }
    & Item_CleanViewItem_Fragment
  ) | (
    { __typename?: 'DisplayAdItem' }
    & Item_DisplayAdItem_Fragment
  ) | (
    { __typename?: 'EventBannerItem' }
    & Item_EventBannerItem_Fragment
  ) | (
    { __typename?: 'LineBannerItem' }
    & Item_LineBannerItem_Fragment
  ) | (
    { __typename?: 'MoreItem' }
    & Item_MoreItem_Fragment
  ) | (
    { __typename?: 'NormalListViewItem' }
    & Item_NormalListViewItem_Fragment
  ) | (
    { __typename?: 'OnAirItem' }
    & Item_OnAirItem_Fragment
  ) | (
    { __typename?: 'PosterViewItem' }
    & Item_PosterViewItem_Fragment
  ) | (
    { __typename?: 'PromotionBannerItem' }
    & Item_PromotionBannerItem_Fragment
  ) | (
    { __typename?: 'PromotionCardViewItem' }
    & Item_PromotionCardViewItem_Fragment
  ) | (
    { __typename?: 'RankingListViewItem' }
    & Item_RankingListViewItem_Fragment
  ) | (
    { __typename?: 'SingleListViewItem' }
    & Item_SingleListViewItem_Fragment
  ) | (
    { __typename?: 'StrategyViewItem' }
    & Item_StrategyViewItem_Fragment
  ) | (
    { __typename?: 'UnknownItem' }
    & Item_UnknownItem_Fragment
  )>> }
);

export type LineBannerItemFragment = (
  { __typename?: 'LineBannerItem' }
  & Pick<LineBannerItem, 'title' | 'scheme' | 'subTitle' | 'bgColor' | 'rightImage'>
  & { eventLog?: Maybe<(
    { __typename?: 'EventLog' }
    & EventLogFragmentFragment
  )> }
);

export type LocaleMapFragmentFragment = (
  { __typename?: 'LocaleMap' }
  & Pick<LocaleMap, 'ko' | 'en' | 'th'>
);

export type MoreItemFragment = (
  { __typename?: 'MoreItem' }
  & Pick<MoreItem, 'id' | 'scheme' | 'title'>
);

export type NearItemFragmentFragment = (
  { __typename?: 'NearItem' }
  & Pick<NearItem, 'productId' | 'slideType' | 'ageGrade' | 'isFree' | 'title' | 'thumbnail'>
);

export type NormalListViewItemFragment = (
  { __typename?: 'NormalListViewItem' }
  & Pick<NormalListViewItem, 'id' | 'type' | 'altText' | 'ticketUid' | 'thumbnail' | 'badgeList' | 'ageGradeBadge' | 'statusBadge' | 'ageGrade' | 'isAlaramOn' | 'row1' | 'row2' | 'row4' | 'row5' | 'scheme' | 'continueScheme' | 'nextProductScheme' | 'seriesId' | 'isCheckMode' | 'isChecked' | 'isReceived' | 'isHelixGift' | 'price' | 'discountPrice' | 'discountRate' | 'discountRateText' | 'showPlayerIcon' | 'rank' | 'isSingle' | 'singleSlideType' | 'selfCensorship'>
  & { row3?: Maybe<(
    { __typename?: 'NormalListViewItemRow3' }
    & Pick<NormalListViewItemRow3, 'id' | 'metaList'>
  )>, continueData?: Maybe<(
    { __typename?: 'ContinueInfo' }
    & ContinueInfoFragmentFragment
  )>, eventLog?: Maybe<(
    { __typename?: 'EventLog' }
    & EventLogFragmentFragment
  )>, giftEventLog?: Maybe<(
    { __typename?: 'EventLog' }
    & EventLogFragmentFragment
  )> }
);

export type OnAirItemFragment = (
  { __typename?: 'OnAirItem' }
  & Pick<OnAirItem, 'thumbnail' | 'videoUrl' | 'titleImage' | 'title' | 'subtitleList' | 'caption' | 'scheme'>
);

export type OperatorPropertyFragmentFragment = (
  { __typename?: 'OperatorProperty' }
  & Pick<OperatorProperty, 'thumbnail' | 'copy' | 'helixImpId' | 'isTextViewer' | 'selfCensorship' | 'isBook' | 'rec_id'>
  & { cashInfo?: Maybe<(
    { __typename?: 'Cash' }
    & Pick<Cash, 'discountRate' | 'setDiscountRate'>
  )>, ticketInfo?: Maybe<Array<(
    { __typename?: 'SingleTicketInfo' }
    & Pick<SingleTicketInfo, 'price' | 'discountPrice' | 'ticketType'>
  )>> }
);

export type PosterViewItemFragment = (
  { __typename?: 'PosterViewItem' }
  & Pick<PosterViewItem, 'id' | 'type' | 'showPlayerIcon' | 'scheme' | 'title' | 'altText' | 'thumbnail' | 'badgeList' | 'labelBadgeList' | 'ageGradeBadge' | 'statusBadge' | 'subtitleList' | 'rank' | 'rankVariation' | 'ageGrade' | 'selfCensorship' | 'seriesId' | 'showDimmedThumbnail' | 'discountRate' | 'discountRateText'>
  & { eventLog?: Maybe<(
    { __typename?: 'EventLog' }
    & EventLogFragmentFragment
  )> }
);

export type PreviewFragmentFragment = (
  { __typename?: 'Preview' }
  & Pick<Preview, 'usingScroll'>
  & { item?: Maybe<(
    { __typename?: 'Single' }
    & PreviewSingleFragmentFragment
  )>, nextItem?: Maybe<(
    { __typename?: 'Single' }
    & PreviewSingleFragmentFragment
  )> }
);

export type PreviewCommentFragment = (
  { __typename?: 'PreviewComment' }
  & Pick<PreviewComment, 'commentUid' | 'userUid' | 'userName' | 'userThumbnailUrl' | 'comment' | 'emoticon'>
);

export type PreviewSingleFragmentFragment = (
  { __typename?: 'Single' }
  & Pick<Single, 'id' | 'productId' | 'seriesId' | 'title' | 'thumbnail' | 'badge' | 'isFree' | 'ageGrade' | 'state' | 'slideType' | 'lastReleasedDate' | 'size' | 'pageCount' | 'isHidden' | 'remainText' | 'isWaitfreeBlocked' | 'saleState'>
  & { operatorProperty?: Maybe<(
    { __typename?: 'OperatorProperty' }
    & OperatorPropertyFragmentFragment
  )>, assetProperty?: Maybe<(
    { __typename?: 'AssetProperty' }
    & AssetPropertyFragmentFragment
  )> }
);

export type PromotionBannerItemFragment = (
  { __typename?: 'PromotionBannerItem' }
  & Pick<PromotionBannerItem, 'title' | 'scheme' | 'leftImage' | 'rightImage'>
  & { eventLog?: Maybe<(
    { __typename?: 'EventLog' }
    & EventLogFragmentFragment
  )> }
);

export type PurchaseInfoFragmentFragment = (
  { __typename?: 'PurchaseInfo' }
  & Pick<PurchaseInfo, 'purchaseType' | 'rentExpireDate' | 'expired'>
);

export type RankingListViewItemFragment = (
  { __typename?: 'RankingListViewItem' }
  & Pick<RankingListViewItem, 'title' | 'thumbnail' | 'badgeList' | 'ageGradeBadge' | 'statusBadge' | 'ageGrade' | 'selfCensorship' | 'metaList' | 'descriptionList' | 'scheme' | 'rank' | 'discountRate' | 'discountRateText'>
  & { eventLog?: Maybe<(
    { __typename?: 'EventLog' }
    & EventLogFragmentFragment
  )> }
);

export type ReceiptInfoFragment = (
  { __typename?: 'ReceiptInfo' }
  & Pick<ReceiptInfo, 'accountId' | 'receiptInfoType' | 'receiptInfo'>
);

export type ReceiptInfoResultFragment = (
  { __typename?: 'ReceiptInfoResult' }
  & Pick<ReceiptInfoResult, 'receiptInfoType' | 'receiptInfo' | 'receiptPrice' | 'receiptCancelPrice' | 'createdAt' | 'receiptType' | 'receiptAuthNum' | 'receiptCancelNum'>
);

export type RedeemCodeFragment = (
  { __typename?: 'RedeemCode' }
  & Pick<RedeemCode, 'type' | 'amount' | 'ticket' | 'title' | 'seriesId' | 'age' | 'category' | 'shouldRedirect' | 'resultCode'>
);

export type RouletteInfoFragment = (
  { __typename?: 'RouletteInfo' }
  & Pick<RouletteInfo, 'rouletteId' | 'rouletteAdLocId' | 'rouletteStatus' | 'headerTitle' | 'screenTitle' | 'maxCash' | 'resultBottomTextList' | 'bgImg' | 'bgColor' | 'isSponsorType' | 'isRedeemType' | 'isOldRoulette' | 'type' | 'entryType' | 'prize' | 'prizeType' | 'prizeImageUrl' | 'badgeImageUrl' | 'winningDate' | 'expirationDate' | 'bannerAdLocId' | 'bannerImageUrl' | 'bannerLink' | 'apiErrorHandleType' | 'apiErrorMsg'>
);

export type ScreenFragment = (
  { __typename?: 'Screen' }
  & Pick<Screen, 'id' | 'uid' | 'title' | 'type' | 'landingType' | 'categoryUid' | 'ageGrade'>
);

type Section_AlarmSection_Fragment = (
  { __typename?: 'AlarmSection' }
  & Pick<AlarmSection, 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_BigBannerSection_Fragment = (
  { __typename?: 'BigBannerSection' }
  & Pick<BigBannerSection, 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_CardSection_Fragment = (
  { __typename?: 'CardSection' }
  & Pick<CardSection, 'isRecommendArea' | 'isRecommendedItems' | 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_CashFriendsSection_Fragment = (
  { __typename?: 'CashFriendsSection' }
  & Pick<CashFriendsSection, 'scheme' | 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_DayOfWeekSection_Fragment = (
  { __typename?: 'DayOfWeekSection' }
  & Pick<DayOfWeekSection, 'id' | 'uid' | 'type' | 'title'>
  & { sectionMainTabList?: Maybe<Array<(
    { __typename?: 'SectionMainTab' }
    & Pick<SectionMainTab, 'uid' | 'title' | 'isSelected' | 'scheme' | 'additionalString'>
    & { subTabList: Array<(
      { __typename?: 'SectionSubTab' }
      & Pick<SectionSubTab, 'uid' | 'title' | 'isSelected' | 'groupId'>
    )> }
  )>>, groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_DisplayAdSection_Fragment = (
  { __typename?: 'DisplayAdSection' }
  & Pick<DisplayAdSection, 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_EpisodeSection_Fragment = (
  { __typename?: 'EpisodeSection' }
  & Pick<EpisodeSection, 'scheme' | 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_EventSection_Fragment = (
  { __typename?: 'EventSection' }
  & Pick<EventSection, 'scheme' | 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_HelixThemeSection_Fragment = (
  { __typename?: 'HelixThemeSection' }
  & Pick<HelixThemeSection, 'metaInfoType' | 'subtitle' | 'isRecommendArea' | 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_LineBannerSection_Fragment = (
  { __typename?: 'LineBannerSection' }
  & Pick<LineBannerSection, 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_MainRankingSection_Fragment = (
  { __typename?: 'MainRankingSection' }
  & Pick<MainRankingSection, 'scheme' | 'id' | 'uid' | 'type' | 'title'>
  & { sectionMainTabList?: Maybe<Array<(
    { __typename?: 'SectionMainTab' }
    & Pick<SectionMainTab, 'uid' | 'title' | 'isSelected' | 'scheme' | 'additionalString'>
    & { subTabList: Array<(
      { __typename?: 'SectionSubTab' }
      & Pick<SectionSubTab, 'uid' | 'title' | 'isSelected' | 'groupId'>
    )> }
  )>>, groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_OnAirSection_Fragment = (
  { __typename?: 'OnAirSection' }
  & Pick<OnAirSection, 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_PromotionBannerSection_Fragment = (
  { __typename?: 'PromotionBannerSection' }
  & Pick<PromotionBannerSection, 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_RankingSection_Fragment = (
  { __typename?: 'RankingSection' }
  & Pick<RankingSection, 'scheme' | 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_RankingV2Section_Fragment = (
  { __typename?: 'RankingV2Section' }
  & Pick<RankingV2Section, 'scheme' | 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_RecentViewedSection_Fragment = (
  { __typename?: 'RecentViewedSection' }
  & Pick<RecentViewedSection, 'loggedInTitle' | 'loggedInScheme' | 'scheme' | 'metaInfoType' | 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_ScrollThemeSection_Fragment = (
  { __typename?: 'ScrollThemeSection' }
  & Pick<ScrollThemeSection, 'scheme' | 'metaInfoType' | 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_SeriesBasedRecommendSection_Fragment = (
  { __typename?: 'SeriesBasedRecommendSection' }
  & Pick<SeriesBasedRecommendSection, 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_StaticLandingDayOfWeekSection_Fragment = (
  { __typename?: 'StaticLandingDayOfWeekSection' }
  & Pick<StaticLandingDayOfWeekSection, 'isEnd' | 'totalCount' | 'id' | 'uid' | 'type' | 'title'>
  & { param: (
    { __typename?: 'StaticLandingDayOfWeekSectionParam' }
    & Pick<StaticLandingDayOfWeekSectionParam, 'categoryUid' | 'page' | 'size' | 'screenUid'>
    & { businessModel?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'name' | 'param'>
    )>, subcategory?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'name' | 'param'>
    )>, dayTab?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'name' | 'param'>
    )> }
  ), businessModelList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, subcategoryList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, dayTabList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, promotionBanner?: Maybe<(
    { __typename?: 'PromotionBannerItem' }
    & PromotionBannerItemFragment
  )>, groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_StaticLandingEventSection_Fragment = (
  { __typename?: 'StaticLandingEventSection' }
  & Pick<StaticLandingEventSection, 'isEnd' | 'totalCount' | 'id' | 'uid' | 'type' | 'title'>
  & { param: (
    { __typename?: 'StaticLandingEventSectionParam' }
    & Pick<StaticLandingEventSectionParam, 'categoryUid' | 'page'>
  ), categoryTabList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_StaticLandingFreeSeriesSection_Fragment = (
  { __typename?: 'StaticLandingFreeSeriesSection' }
  & Pick<StaticLandingFreeSeriesSection, 'isEnd' | 'totalCount' | 'id' | 'uid' | 'type' | 'title'>
  & { param: (
    { __typename?: 'StaticLandingFreeSeriesSectionParam' }
    & Pick<StaticLandingFreeSeriesSectionParam, 'categoryUid' | 'page' | 'screenUid'>
    & { tab?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'name' | 'param'>
    )> }
  ), tabList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, promotionBanner?: Maybe<(
    { __typename?: 'PromotionBannerItem' }
    & PromotionBannerItemFragment
  )>, groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_StaticLandingGenreSection_Fragment = (
  { __typename?: 'StaticLandingGenreSection' }
  & Pick<StaticLandingGenreSection, 'isEnd' | 'totalCount' | 'id' | 'uid' | 'type' | 'title'>
  & { param: (
    { __typename?: 'StaticLandingGenreSectionParam' }
    & Pick<StaticLandingGenreSectionParam, 'categoryUid' | 'page' | 'isComplete' | 'screenUid'>
    & { subcategory?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'name' | 'param'>
    )>, sortType?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'name' | 'param'>
    )> }
  ), subcategoryList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, sortTypeList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, displayAd?: Maybe<(
    { __typename?: 'DisplayAd' }
    & DisplayAdFragment
  )>, promotionBanner?: Maybe<(
    { __typename?: 'PromotionBannerItem' }
    & PromotionBannerItemFragment
  )>, groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_StaticLandingOriginalSection_Fragment = (
  { __typename?: 'StaticLandingOriginalSection' }
  & Pick<StaticLandingOriginalSection, 'isEnd' | 'totalCount' | 'originalCount' | 'id' | 'uid' | 'type' | 'title'>
  & { param: (
    { __typename?: 'StaticLandingOriginalSectionParam' }
    & Pick<StaticLandingOriginalSectionParam, 'categoryUid' | 'isComplete' | 'page' | 'screenUid'>
    & { subcategory?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'name' | 'param'>
    )>, sortType?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'name' | 'param'>
    )> }
  ), subcategoryList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, sortTypeList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, recommendItemList?: Maybe<Array<(
    { __typename?: 'CardViewItem' }
    & Item_CardViewItem_Fragment
  )>>, groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_StaticLandingRankingSection_Fragment = (
  { __typename?: 'StaticLandingRankingSection' }
  & Pick<StaticLandingRankingSection, 'isEnd' | 'rankingTime' | 'totalCount' | 'withOperationArea' | 'viewType' | 'id' | 'uid' | 'type' | 'title'>
  & { param: (
    { __typename?: 'StaticLandingRankingSectionParam' }
    & Pick<StaticLandingRankingSectionParam, 'categoryUid' | 'page' | 'screenUid'>
    & { subcategory?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'name' | 'param'>
    )>, rankingType?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'name' | 'param'>
    )> }
  ), categoryTabList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, subcategoryList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, rankingTypeList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, displayAd?: Maybe<(
    { __typename?: 'DisplayAd' }
    & DisplayAdFragment
  )>, promotionBanner?: Maybe<(
    { __typename?: 'PromotionBannerItem' }
    & PromotionBannerItemFragment
  )>, groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_StaticLandingTodayNewSection_Fragment = (
  { __typename?: 'StaticLandingTodayNewSection' }
  & Pick<StaticLandingTodayNewSection, 'totalCount' | 'viewType' | 'id' | 'uid' | 'type' | 'title'>
  & { param: (
    { __typename?: 'StaticLandingTodayNewSectionParam' }
    & Pick<StaticLandingTodayNewSectionParam, 'categoryUid' | 'screenUid'>
    & { subcategory?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'name' | 'param'>
    )> }
  ), categoryTabList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, subcategoryList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, promotionBanner?: Maybe<(
    { __typename?: 'PromotionBannerItem' }
    & PromotionBannerItemFragment
  )>, groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_StaticLandingTodayUpSection_Fragment = (
  { __typename?: 'StaticLandingTodayUpSection' }
  & Pick<StaticLandingTodayUpSection, 'isEnd' | 'totalCount' | 'id' | 'uid' | 'type' | 'title'>
  & { param: (
    { __typename?: 'StaticLandingTodayUpSectionParam' }
    & Pick<StaticLandingTodayUpSectionParam, 'categoryUid' | 'page'>
    & { subcategory?: Maybe<(
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'name' | 'param'>
    )> }
  ), categoryTabList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, subcategoryList: Array<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'name' | 'param'>
  )>, groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_StrategyCategorySection_Fragment = (
  { __typename?: 'StrategyCategorySection' }
  & Pick<StrategyCategorySection, 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_ThemeSection_Fragment = (
  { __typename?: 'ThemeSection' }
  & Pick<ThemeSection, 'scheme' | 'metaInfoType' | 'id' | 'uid' | 'type' | 'title'>
  & { themeKeywordList?: Maybe<Array<(
    { __typename?: 'ThemeKeyword' }
    & Pick<ThemeKeyword, 'uid' | 'title' | 'scheme'>
  )>>, groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_TopSection_Fragment = (
  { __typename?: 'TopSection' }
  & Pick<TopSection, 'isRecommendArea' | 'isRecommendedItems' | 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_UnknownSection_Fragment = (
  { __typename?: 'UnknownSection' }
  & Pick<UnknownSection, 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

type Section_UserBasedRecommendSection_Fragment = (
  { __typename?: 'UserBasedRecommendSection' }
  & Pick<UserBasedRecommendSection, 'id' | 'uid' | 'type' | 'title'>
  & { groups: Array<(
    { __typename?: 'BigBannerGroup' }
    & Group_BigBannerGroup_Fragment
  ) | (
    { __typename?: 'CardViewGroup' }
    & Group_CardViewGroup_Fragment
  ) | (
    { __typename?: 'CleanViewGroup' }
    & Group_CleanViewGroup_Fragment
  ) | (
    { __typename?: 'ContentRecommendGroup' }
    & Group_ContentRecommendGroup_Fragment
  ) | (
    { __typename?: 'DisplayAdGroup' }
    & Group_DisplayAdGroup_Fragment
  ) | (
    { __typename?: 'EventBannerGroup' }
    & Group_EventBannerGroup_Fragment
  ) | (
    { __typename?: 'HorizontalScrollGroup' }
    & Group_HorizontalScrollGroup_Fragment
  ) | (
    { __typename?: 'LineBannerGroup' }
    & Group_LineBannerGroup_Fragment
  ) | (
    { __typename?: 'ListViewGroup' }
    & Group_ListViewGroup_Fragment
  ) | (
    { __typename?: 'MainRankingListViewGroup' }
    & Group_MainRankingListViewGroup_Fragment
  ) | (
    { __typename?: 'OnAirGroup' }
    & Group_OnAirGroup_Fragment
  ) | (
    { __typename?: 'PosterViewGroup' }
    & Group_PosterViewGroup_Fragment
  ) | (
    { __typename?: 'PromotionBannerGroup' }
    & Group_PromotionBannerGroup_Fragment
  ) | (
    { __typename?: 'ResponsiveBannerGroup' }
    & Group_ResponsiveBannerGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerAndSubCardGroup' }
    & Group_StandaloneBannerAndSubCardGroup_Fragment
  ) | (
    { __typename?: 'StandaloneBannerGroup' }
    & Group_StandaloneBannerGroup_Fragment
  ) | (
    { __typename?: 'StrategyCategoryGroup' }
    & Group_StrategyCategoryGroup_Fragment
  ) | (
    { __typename?: 'SubCardGroup' }
    & Group_SubCardGroup_Fragment
  ) | (
    { __typename?: 'TodaySeriesGroup' }
    & Group_TodaySeriesGroup_Fragment
  ) | (
    { __typename?: 'UnknownGroup' }
    & Group_UnknownGroup_Fragment
  )> }
);

export type SectionFragment = Section_AlarmSection_Fragment | Section_BigBannerSection_Fragment | Section_CardSection_Fragment | Section_CashFriendsSection_Fragment | Section_DayOfWeekSection_Fragment | Section_DisplayAdSection_Fragment | Section_EpisodeSection_Fragment | Section_EventSection_Fragment | Section_HelixThemeSection_Fragment | Section_LineBannerSection_Fragment | Section_MainRankingSection_Fragment | Section_OnAirSection_Fragment | Section_PromotionBannerSection_Fragment | Section_RankingSection_Fragment | Section_RankingV2Section_Fragment | Section_RecentViewedSection_Fragment | Section_ScrollThemeSection_Fragment | Section_SeriesBasedRecommendSection_Fragment | Section_StaticLandingDayOfWeekSection_Fragment | Section_StaticLandingEventSection_Fragment | Section_StaticLandingFreeSeriesSection_Fragment | Section_StaticLandingGenreSection_Fragment | Section_StaticLandingOriginalSection_Fragment | Section_StaticLandingRankingSection_Fragment | Section_StaticLandingTodayNewSection_Fragment | Section_StaticLandingTodayUpSection_Fragment | Section_StrategyCategorySection_Fragment | Section_ThemeSection_Fragment | Section_TopSection_Fragment | Section_UnknownSection_Fragment | Section_UserBasedRecommendSection_Fragment;

export type SeriesFragmentFragment = (
  { __typename?: 'Series' }
  & Pick<Series, 'id' | 'seriesId' | 'title' | 'thumbnail' | 'landThumbnail' | 'categoryUid' | 'lang' | 'category' | 'categoryType' | 'subcategoryUid' | 'subcategory' | 'badge' | 'isAllFree' | 'isWaitfree' | 'ageGrade' | 'state' | 'onIssue' | 'authors' | 'description' | 'pubPeriod' | 'freeSlideCount' | 'lastSlideAddedDate' | 'waitfreeBlockCount' | 'waitfreePeriodByMinute' | 'bm' | 'saleState' | 'startSaleDt' | 'saleMethod' | 'discountRate' | 'discountRateText'>
  & { serviceProperty?: Maybe<(
    { __typename?: 'ServiceProperty' }
    & ServicePropertyFragmentFragment
  )>, operatorProperty?: Maybe<(
    { __typename?: 'OperatorProperty' }
    & OperatorPropertyFragmentFragment
  )>, assetProperty?: Maybe<(
    { __typename?: 'AssetProperty' }
    & AssetPropertyFragmentFragment
  )>, translateProperty?: Maybe<(
    { __typename?: 'TranslateProperty' }
    & TranslatePropertyFragmentFragment
  )> }
);

export type ServicePropertyFragmentFragment = (
  { __typename?: 'ServiceProperty' }
  & Pick<ServiceProperty, 'viewCount' | 'readCount' | 'ratingCount' | 'ratingSum' | 'commentCount' | 'isAlarmOn' | 'isLikeOn' | 'ticketCount' | 'purchasedDate'>
  & { pageContinue?: Maybe<(
    { __typename?: 'ContinueInfo' }
    & ContinueInfoFragmentFragment
  )>, todayGift?: Maybe<(
    { __typename?: 'TodayGift' }
    & TodayGiftFragment
  )>, preview?: Maybe<(
    { __typename?: 'Preview' }
    & PreviewFragmentFragment
    & PreviewFragmentFragment
  )>, waitfreeTicket?: Maybe<(
    { __typename?: 'WaitfreeTicket' }
    & WaitfreeTicketFragmentFragment
  )>, lastViewInfo?: Maybe<(
    { __typename?: 'LastViewInfo' }
    & LastViewInfoFragmentFragment
  )>, purchaseInfo?: Maybe<(
    { __typename?: 'PurchaseInfo' }
    & PurchaseInfoFragmentFragment
  )>, ticketInfo?: Maybe<(
    { __typename?: 'SingleTicketInfo' }
    & Pick<SingleTicketInfo, 'price' | 'discountPrice' | 'ticketType'>
  )> }
);

export type SetFragmentFragment = (
  { __typename?: 'Set' }
  & Pick<Set, 'setId' | 'seriesId' | 'title' | 'thumbnail' | 'productCount' | 'startSaleDt' | 'endSaleDt' | 'ticketType' | 'ticketKind' | 'price' | 'allVolumes' | 'discountPrice' | 'discountRate' | 'discountRateText' | 'rentalPeriodByMinute' | 'ageGrade' | 'categoryUid' | 'category' | 'subcategoryUid' | 'subcategory' | 'authors' | 'description'>
  & { serviceProperty?: Maybe<(
    { __typename?: 'ServiceProperty' }
    & ServicePropertyFragmentFragment
  )>, operatorProperty?: Maybe<(
    { __typename?: 'OperatorProperty' }
    & OperatorPropertyFragmentFragment
  )>, assetProperty?: Maybe<(
    { __typename?: 'AssetProperty' }
    & AssetPropertyFragmentFragment
  )> }
);

export type ShortcutItemFragment = (
  { __typename?: 'ShortcutItem' }
  & Pick<ShortcutItem, 'title' | 'scheme' | 'icon'>
);

export type SingleFragmentFragment = (
  { __typename?: 'Single' }
  & Pick<Single, 'id' | 'productId' | 'seriesId' | 'title' | 'thumbnail' | 'badge' | 'isFree' | 'ageGrade' | 'state' | 'slideType' | 'lastReleasedDate' | 'size' | 'pageCount' | 'isHidden' | 'remainText' | 'isWaitfreeBlocked' | 'saleState' | 'discountRate' | 'discountRateText' | 'isShortsDrama'>
  & { series?: Maybe<(
    { __typename?: 'Series' }
    & SeriesFragmentFragment
  )>, serviceProperty?: Maybe<(
    { __typename?: 'ServiceProperty' }
    & ServicePropertyFragmentFragment
  )>, operatorProperty?: Maybe<(
    { __typename?: 'OperatorProperty' }
    & OperatorPropertyFragmentFragment
  )>, assetProperty?: Maybe<(
    { __typename?: 'AssetProperty' }
    & AssetPropertyFragmentFragment
  )> }
);

export type SingleListViewItemFragment = (
  { __typename?: 'SingleListViewItem' }
  & Pick<SingleListViewItem, 'id' | 'type' | 'thumbnail' | 'showPlayerIcon' | 'isCheckMode' | 'isChecked' | 'scheme' | 'row1' | 'row2' | 'isViewed' | 'discountRate' | 'discountRateText'>
  & { row3?: Maybe<(
    { __typename?: 'SingleListViewItemRow3' }
    & Pick<SingleListViewItemRow3, 'badgeList' | 'text' | 'priceList'>
  )>, single: (
    { __typename?: 'Single' }
    & Pick<Single, 'productId' | 'ageGrade' | 'id' | 'isFree' | 'thumbnail' | 'title' | 'slideType'>
    & { operatorProperty?: Maybe<(
      { __typename?: 'OperatorProperty' }
      & Pick<OperatorProperty, 'isTextViewer'>
    )> }
  ), eventLog?: Maybe<(
    { __typename?: 'EventLog' }
    & EventLogFragmentFragment
  )> }
);

export type StrategyViewItemFragment = (
  { __typename?: 'StrategyViewItem' }
  & Pick<StrategyViewItem, 'id' | 'title' | 'count' | 'scheme'>
);

export type SubtabMenuFragment = (
  { __typename?: 'SubtabMenu' }
  & Pick<SubtabMenu, 'id' | 'uid' | 'type' | 'title'>
  & { screenList: Array<(
    { __typename?: 'Screen' }
    & ScreenFragment
  )> }
);

export type TalkViewerDataFragment = (
  { __typename?: 'TalkViewerData' }
  & Pick<TalkViewerData, 'type'>
  & { talkDownloadData: (
    { __typename?: 'TalkDownloadData' }
    & Pick<TalkDownloadData, 'dec' | 'host' | 'path' | 'talkViewerType'>
  ) }
);

export type TextViewerDataFragment = (
  { __typename?: 'TextViewerData' }
  & Pick<TextViewerData, 'type' | 'atsServerUrl' | 'metaSecureUrl'>
  & { contentsList: Array<(
    { __typename?: 'TextViewerContentData' }
    & Pick<TextViewerContentData, 'chapterId' | 'contentId' | 'secureUrl'>
  )> }
);

export type TodayGiftFragment = (
  { __typename?: 'TodayGift' }
  & Pick<TodayGift, 'id' | 'uid' | 'ticketType' | 'ticketKind' | 'ticketCount' | 'ticketExpireAt' | 'ticketExpiredText' | 'isReceived' | 'seriesId'>
);

export type TranslatePropertyFragmentFragment = (
  { __typename?: 'TranslateProperty' }
  & { category?: Maybe<(
    { __typename?: 'LocaleMap' }
    & LocaleMapFragmentFragment
  )>, sub_category?: Maybe<(
    { __typename?: 'LocaleMap' }
    & LocaleMapFragmentFragment
  )>, title?: Maybe<(
    { __typename?: 'LocaleMap' }
    & LocaleMapFragmentFragment
  )>, name?: Maybe<(
    { __typename?: 'LocaleMap' }
    & LocaleMapFragmentFragment
  )> }
);

export type UserFragment = (
  { __typename?: 'User' }
  & Pick<User, 'uid' | 'appUserId' | 'nickname' | 'email' | 'needProfileUpdate' | 'thumbnail' | 'type' | 'state' | 'age' | 'authenticatedAt' | 'kakaoAccountId'>
);

export type UserCashFragment = (
  { __typename?: 'UserCash' }
  & Pick<UserCash, 'remainCash'>
  & { expiredCredit?: Maybe<(
    { __typename?: 'ExpiredCredit' }
    & Pick<ExpiredCredit, 'expiredAt' | 'expiredSum'>
  )>, detail?: Maybe<(
    { __typename?: 'UserCashDetail' }
    & Pick<UserCashDetail, 'eventSum' | 'paidSum' | 'totalBalance'>
  )> }
);

export type ViewerEndFragment = (
  { __typename?: 'ViewerEnd' }
  & Pick<ViewerEnd, 'ratingCount' | 'ratingSum' | 'commentCount' | 'likeOn' | 'alarmOn' | 'onIssue' | 'originalRawDataStr'>
  & { contentRecommendGroup?: Maybe<(
    { __typename?: 'ContentRecommendGroup' }
    & ContentRecommendGroupFragment
  )>, nextItem?: Maybe<(
    { __typename?: 'Single' }
    & Pick<Single, 'id' | 'productId' | 'seriesId' | 'title' | 'thumbnail' | 'badge' | 'isFree' | 'ageGrade' | 'state' | 'slideType' | 'lastReleasedDate' | 'size' | 'pageCount' | 'isHidden' | 'remainText' | 'isWaitfreeBlocked'>
  )>, displayAd?: Maybe<(
    { __typename?: 'DisplayAd' }
    & DisplayAdFragment
  )>, viewerEndPreviewComment?: Maybe<(
    { __typename?: 'ViewerEndComment' }
    & { sortOpt: (
      { __typename?: 'SortOption' }
      & Pick<SortOption, 'id' | 'name' | 'param'>
    ), comment: (
      { __typename?: 'PreviewComment' }
      & PreviewCommentFragment
    ) }
  )>, relatedSeries?: Maybe<(
    { __typename?: 'Series' }
    & SeriesFragmentFragment
  )> }
);

export type VodViewerDataFragment = (
  { __typename?: 'VodViewerData' }
  & Pick<VodViewerData, 'type'>
  & { vodDownloadData?: Maybe<(
    { __typename?: 'VodDownloadData' }
    & Pick<VodDownloadData, 'contentPackId' | 'drmType' | 'endpointUrl' | 'width' | 'height' | 'duration'>
  )>, drmInfo?: Maybe<(
    { __typename?: 'DrmInfo' }
    & Pick<DrmInfo, 'type' | 'serverType' | 'error' | 'fairplayCertificateUrl' | 'widevineLicenseUrl' | 'fairplayLicenseUrl' | 'token' | 'provider' | 'assertion'>
  )> }
);

export type WaitfreeTicketFragmentFragment = (
  { __typename?: 'WaitfreeTicket' }
  & Pick<WaitfreeTicket, 'chargedPeriod' | 'chargedCount' | 'chargedAt'>
);

export type WelcomeRecommendItemFragment = (
  { __typename?: 'WelcomeRecommendItem' }
  & Pick<WelcomeRecommendItem, 'seriesId' | 'scheme' | 'title' | 'category' | 'subCategory' | 'viewCount' | 'freeSlideCount' | 'thumbnail' | 'themeKeywordList' | 'authors' | 'description'>
);

export type CommentItemFragment = (
  { __typename?: 'CommentItem' }
  & Pick<CommentItem, 'parentUid' | 'userUid' | 'productId' | 'seriesId' | 'comment' | 'likeCount' | 'replyCount' | 'createDt' | 'commentType' | 'commentUid' | 'title' | 'hidden' | 'isBest' | 'blocked' | 'commentStatus' | 'deleted' | 'expose' | 'myReplyCount' | 'userThumbnailUrl' | 'userName' | 'liked' | 'isSpoiler'>
  & { emoticon?: Maybe<(
    { __typename?: 'Emoticon' }
    & Pick<Emoticon, 'itemSubType' | 'resourceId' | 'itemId' | 'itemVer'>
  )> }
);

export type CommentListFragment = (
  { __typename?: 'CommentList' }
  & Pick<CommentList, 'isEnd' | 'totalCount' | 'bestTotalCount'>
  & { selectedSortOpt?: Maybe<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'id' | 'name' | 'param'>
  )>, sortOptList?: Maybe<Array<Maybe<(
    { __typename?: 'SortOption' }
    & Pick<SortOption, 'id' | 'name' | 'param'>
  )>>>, commentList: Array<(
    { __typename?: 'CommentItem' }
    & CommentItemFragment
  )> }
);

export type DisplayAdFragment = (
  { __typename?: 'DisplayAd' }
  & Pick<DisplayAd, 'sectionUid' | 'bannerUid' | 'treviUid' | 'momentUid'>
);

export type SortOptionFragment = (
  { __typename?: 'SortOption' }
  & Pick<SortOption, 'id' | 'name' | 'param'>
);


/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockActivateUserQuery((req, res, ctx) => {
 *   const { authInput } = req.variables;
 *   return res(
 *     ctx.data({ activateUser })
 *   )
 * })
 */
export const mockActivateUserQuery = (resolver: ResponseResolver<GraphQLRequest<ActivateUserQueryVariables>, GraphQLContext<ActivateUserQuery>, any>) =>
  graphql.query<ActivateUserQuery, ActivateUserQueryVariables>(
    'activateUser',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockNoticesQuery((req, res, ctx) => {
 *   const { target } = req.variables;
 *   return res(
 *     ctx.data({ notices })
 *   )
 * })
 */
export const mockNoticesQuery = (resolver: ResponseResolver<GraphQLRequest<NoticesQueryVariables>, GraphQLContext<NoticesQuery>, any>) =>
  graphql.query<NoticesQuery, NoticesQueryVariables>(
    'notices',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockHelpsQuery((req, res, ctx) => {
 *   const { target } = req.variables;
 *   return res(
 *     ctx.data({ helps })
 *   )
 * })
 */
export const mockHelpsQuery = (resolver: ResponseResolver<GraphQLRequest<HelpsQueryVariables>, GraphQLContext<HelpsQuery>, any>) =>
  graphql.query<HelpsQuery, HelpsQueryVariables>(
    'helps',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAppConfigQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ appConfig })
 *   )
 * })
 */
export const mockAppConfigQuery = (resolver: ResponseResolver<GraphQLRequest<AppConfigQueryVariables>, GraphQLContext<AppConfigQuery>, any>) =>
  graphql.query<AppConfigQuery, AppConfigQueryVariables>(
    'appConfig',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAppInitQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ appConfig })
 *   )
 * })
 */
export const mockAppInitQuery = (resolver: ResponseResolver<GraphQLRequest<AppInitQueryVariables>, GraphQLContext<AppInitQuery>, any>) =>
  graphql.query<AppInitQuery, AppInitQueryVariables>(
    'appInit',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAppSettingMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ appSetting })
 *   )
 * })
 */
export const mockAppSettingMutation = (resolver: ResponseResolver<GraphQLRequest<AppSettingMutationVariables>, GraphQLContext<AppSettingMutation>, any>) =>
  graphql.mutation<AppSettingMutation, AppSettingMutationVariables>(
    'AppSetting',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTastesServiceLangQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ tastesServiceLang })
 *   )
 * })
 */
export const mockTastesServiceLangQuery = (resolver: ResponseResolver<GraphQLRequest<TastesServiceLangQueryVariables>, GraphQLContext<TastesServiceLangQuery>, any>) =>
  graphql.query<TastesServiceLangQuery, TastesServiceLangQueryVariables>(
    'tastesServiceLang',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUnregisterUserMutation((req, res, ctx) => {
 *   return res(
 *     ctx.data({ unregisterUser })
 *   )
 * })
 */
export const mockUnregisterUserMutation = (resolver: ResponseResolver<GraphQLRequest<UnregisterUserMutationVariables>, GraphQLContext<UnregisterUserMutation>, any>) =>
  graphql.mutation<UnregisterUserMutation, UnregisterUserMutationVariables>(
    'unregisterUser',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGlobalEmailSignupMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ globalEmailSignup })
 *   )
 * })
 */
export const mockGlobalEmailSignupMutation = (resolver: ResponseResolver<GraphQLRequest<GlobalEmailSignupMutationVariables>, GraphQLContext<GlobalEmailSignupMutation>, any>) =>
  graphql.mutation<GlobalEmailSignupMutation, GlobalEmailSignupMutationVariables>(
    'globalEmailSignup',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGlobalSnsSignupMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ globalSnsSignup })
 *   )
 * })
 */
export const mockGlobalSnsSignupMutation = (resolver: ResponseResolver<GraphQLRequest<GlobalSnsSignupMutationVariables>, GraphQLContext<GlobalSnsSignupMutation>, any>) =>
  graphql.mutation<GlobalSnsSignupMutation, GlobalSnsSignupMutationVariables>(
    'globalSnsSignup',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockKakaoBankSelfCertSupportedDeviceMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ kakaoBankSelfCertSupportedDevice })
 *   )
 * })
 */
export const mockKakaoBankSelfCertSupportedDeviceMutation = (resolver: ResponseResolver<GraphQLRequest<KakaoBankSelfCertSupportedDeviceMutationVariables>, GraphQLContext<KakaoBankSelfCertSupportedDeviceMutation>, any>) =>
  graphql.mutation<KakaoBankSelfCertSupportedDeviceMutation, KakaoBankSelfCertSupportedDeviceMutationVariables>(
    'kakaoBankSelfCertSupportedDevice',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPrepareAuthRequestInfoQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ prepareAuthRequestInfo })
 *   )
 * })
 */
export const mockPrepareAuthRequestInfoQuery = (resolver: ResponseResolver<GraphQLRequest<PrepareAuthRequestInfoQueryVariables>, GraphQLContext<PrepareAuthRequestInfoQuery>, any>) =>
  graphql.query<PrepareAuthRequestInfoQuery, PrepareAuthRequestInfoQueryVariables>(
    'prepareAuthRequestInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPrepareKakaoBankAuthRequestInfoMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ prepareKakaoBankAuthRequestInfo })
 *   )
 * })
 */
export const mockPrepareKakaoBankAuthRequestInfoMutation = (resolver: ResponseResolver<GraphQLRequest<PrepareKakaoBankAuthRequestInfoMutationVariables>, GraphQLContext<PrepareKakaoBankAuthRequestInfoMutation>, any>) =>
  graphql.mutation<PrepareKakaoBankAuthRequestInfoMutation, PrepareKakaoBankAuthRequestInfoMutationVariables>(
    'prepareKakaoBankAuthRequestInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSaveAuthInfoMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ saveAuthInfo })
 *   )
 * })
 */
export const mockSaveAuthInfoMutation = (resolver: ResponseResolver<GraphQLRequest<SaveAuthInfoMutationVariables>, GraphQLContext<SaveAuthInfoMutation>, any>) =>
  graphql.mutation<SaveAuthInfoMutation, SaveAuthInfoMutationVariables>(
    'saveAuthInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCheckUnregisterQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ checkUnregister })
 *   )
 * })
 */
export const mockCheckUnregisterQuery = (resolver: ResponseResolver<GraphQLRequest<CheckUnregisterQueryVariables>, GraphQLContext<CheckUnregisterQuery>, any>) =>
  graphql.query<CheckUnregisterQuery, CheckUnregisterQueryVariables>(
    'checkUnregister',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentHomeAboutQuery((req, res, ctx) => {
 *   const { seriesId } = req.variables;
 *   return res(
 *     ctx.data({ contentHomeAbout })
 *   )
 * })
 */
export const mockContentHomeAboutQuery = (resolver: ResponseResolver<GraphQLRequest<ContentHomeAboutQueryVariables>, GraphQLContext<ContentHomeAboutQuery>, any>) =>
  graphql.query<ContentHomeAboutQuery, ContentHomeAboutQueryVariables>(
    'contentHomeAbout',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentHomeBriefListQuery((req, res, ctx) => {
 *   const { seriesId } = req.variables;
 *   return res(
 *     ctx.data({ contentHomeBriefList })
 *   )
 * })
 */
export const mockContentHomeBriefListQuery = (resolver: ResponseResolver<GraphQLRequest<ContentHomeBriefListQueryVariables>, GraphQLContext<ContentHomeBriefListQuery>, any>) =>
  graphql.query<ContentHomeBriefListQuery, ContentHomeBriefListQueryVariables>(
    'contentHomeBriefList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentHomeInfoQuery((req, res, ctx) => {
 *   const { seriesId } = req.variables;
 *   return res(
 *     ctx.data({ contentHomeInfo })
 *   )
 * })
 */
export const mockContentHomeInfoQuery = (resolver: ResponseResolver<GraphQLRequest<ContentHomeInfoQueryVariables>, GraphQLContext<ContentHomeInfoQuery>, any>) =>
  graphql.query<ContentHomeInfoQuery, ContentHomeInfoQueryVariables>(
    'contentHomeInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentHomeNoticeQuery((req, res, ctx) => {
 *   const { contentHomeNoticeInput } = req.variables;
 *   return res(
 *     ctx.data({ contentHomeNotice })
 *   )
 * })
 */
export const mockContentHomeNoticeQuery = (resolver: ResponseResolver<GraphQLRequest<ContentHomeNoticeQueryVariables>, GraphQLContext<ContentHomeNoticeQuery>, any>) =>
  graphql.query<ContentHomeNoticeQuery, ContentHomeNoticeQueryVariables>(
    'contentHomeNotice',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentHomeOverviewQuery((req, res, ctx) => {
 *   const { seriesId } = req.variables;
 *   return res(
 *     ctx.data({ contentHomeOverview })
 *   )
 * })
 */
export const mockContentHomeOverviewQuery = (resolver: ResponseResolver<GraphQLRequest<ContentHomeOverviewQueryVariables>, GraphQLContext<ContentHomeOverviewQuery>, any>) =>
  graphql.query<ContentHomeOverviewQuery, ContentHomeOverviewQueryVariables>(
    'contentHomeOverview',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentHomeProductListQuery((req, res, ctx) => {
 *   const { after, before, first, last, seriesId, boughtOnly, sortType } = req.variables;
 *   return res(
 *     ctx.data({ contentHomeProductList })
 *   )
 * })
 */
export const mockContentHomeProductListQuery = (resolver: ResponseResolver<GraphQLRequest<ContentHomeProductListQueryVariables>, GraphQLContext<ContentHomeProductListQuery>, any>) =>
  graphql.query<ContentHomeProductListQuery, ContentHomeProductListQueryVariables>(
    'contentHomeProductList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentHomeRecommendQuery((req, res, ctx) => {
 *   const { seriesId } = req.variables;
 *   return res(
 *     ctx.data({ contentHomeRecommend })
 *   )
 * })
 */
export const mockContentHomeRecommendQuery = (resolver: ResponseResolver<GraphQLRequest<ContentHomeRecommendQueryVariables>, GraphQLContext<ContentHomeRecommendQuery>, any>) =>
  graphql.query<ContentHomeRecommendQuery, ContentHomeRecommendQueryVariables>(
    'contentHomeRecommend',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentProductCursorIndexQuery((req, res, ctx) => {
 *   const { seriesId, sortType } = req.variables;
 *   return res(
 *     ctx.data({ contentProductCursorIndex })
 *   )
 * })
 */
export const mockContentProductCursorIndexQuery = (resolver: ResponseResolver<GraphQLRequest<ContentProductCursorIndexQueryVariables>, GraphQLContext<ContentProductCursorIndexQuery>, any>) =>
  graphql.query<ContentProductCursorIndexQuery, ContentProductCursorIndexQueryVariables>(
    'contentProductCursorIndex',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentSetListQuery((req, res, ctx) => {
 *   const { seriesId, productId } = req.variables;
 *   return res(
 *     ctx.data({ contentSetList })
 *   )
 * })
 */
export const mockContentSetListQuery = (resolver: ResponseResolver<GraphQLRequest<ContentSetListQueryVariables>, GraphQLContext<ContentSetListQuery>, any>) =>
  graphql.query<ContentSetListQuery, ContentSetListQueryVariables>(
    'contentSetList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentSetOverviewQuery((req, res, ctx) => {
 *   const { setId } = req.variables;
 *   return res(
 *     ctx.data({ contentSetOverview })
 *   )
 * })
 */
export const mockContentSetOverviewQuery = (resolver: ResponseResolver<GraphQLRequest<ContentSetOverviewQueryVariables>, GraphQLContext<ContentSetOverviewQuery>, any>) =>
  graphql.query<ContentSetOverviewQuery, ContentSetOverviewQueryVariables>(
    'contentSetOverview',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSimpleSeriesSingleInfoQuery((req, res, ctx) => {
 *   const { seriesId, productId } = req.variables;
 *   return res(
 *     ctx.data({ simpleSeriesSingleInfo })
 *   )
 * })
 */
export const mockSimpleSeriesSingleInfoQuery = (resolver: ResponseResolver<GraphQLRequest<SimpleSeriesSingleInfoQueryVariables>, GraphQLContext<SimpleSeriesSingleInfoQuery>, any>) =>
  graphql.query<SimpleSeriesSingleInfoQuery, SimpleSeriesSingleInfoQueryVariables>(
    'simpleSeriesSingleInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetRefundableAmountQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ refundableAmount })
 *   )
 * })
 */
export const mockGetRefundableAmountQuery = (resolver: ResponseResolver<GraphQLRequest<GetRefundableAmountQueryVariables>, GraphQLContext<GetRefundableAmountQuery>, any>) =>
  graphql.query<GetRefundableAmountQuery, GetRefundableAmountQueryVariables>(
    'getRefundableAmount',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRequestCreditRefundMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ refundRequest })
 *   )
 * })
 */
export const mockRequestCreditRefundMutation = (resolver: ResponseResolver<GraphQLRequest<RequestCreditRefundMutationVariables>, GraphQLContext<RequestCreditRefundMutation>, any>) =>
  graphql.mutation<RequestCreditRefundMutation, RequestCreditRefundMutationVariables>(
    'requestCreditRefund',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDayOfWeekLayoutQuery((req, res, ctx) => {
 *   const { dayUid } = req.variables;
 *   return res(
 *     ctx.data({ dayOfWeekLayout })
 *   )
 * })
 */
export const mockDayOfWeekLayoutQuery = (resolver: ResponseResolver<GraphQLRequest<DayOfWeekLayoutQueryVariables>, GraphQLContext<DayOfWeekLayoutQuery>, any>) =>
  graphql.query<DayOfWeekLayoutQuery, DayOfWeekLayoutQueryVariables>(
    'dayOfWeekLayout',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDayOfWeekListQuery((req, res, ctx) => {
 *   const { referenceKey, dayUid, hasBanner, sortType, page, size } = req.variables;
 *   return res(
 *     ctx.data({ dayOfWeekList })
 *   )
 * })
 */
export const mockDayOfWeekListQuery = (resolver: ResponseResolver<GraphQLRequest<DayOfWeekListQueryVariables>, GraphQLContext<DayOfWeekListQuery>, any>) =>
  graphql.query<DayOfWeekListQuery, DayOfWeekListQueryVariables>(
    'dayOfWeekList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSampleErrorQuery((req, res, ctx) => {
 *   const { pagewebErrorType } = req.variables;
 *   return res(
 *     ctx.data({ sampleError })
 *   )
 * })
 */
export const mockSampleErrorQuery = (resolver: ResponseResolver<GraphQLRequest<SampleErrorQueryVariables>, GraphQLContext<SampleErrorQuery>, any>) =>
  graphql.query<SampleErrorQuery, SampleErrorQueryVariables>(
    'sampleError',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddDeviceMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ addDevice })
 *   )
 * })
 */
export const mockAddDeviceMutation = (resolver: ResponseResolver<GraphQLRequest<AddDeviceMutationVariables>, GraphQLContext<AddDeviceMutation>, any>) =>
  graphql.mutation<AddDeviceMutation, AddDeviceMutationVariables>(
    'addDevice',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteDeviceMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ deleteDevice })
 *   )
 * })
 */
export const mockDeleteDeviceMutation = (resolver: ResponseResolver<GraphQLRequest<DeleteDeviceMutationVariables>, GraphQLContext<DeleteDeviceMutation>, any>) =>
  graphql.mutation<DeleteDeviceMutation, DeleteDeviceMutationVariables>(
    'deleteDevice',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeviceInfoQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ deviceInfo })
 *   )
 * })
 */
export const mockDeviceInfoQuery = (resolver: ResponseResolver<GraphQLRequest<DeviceInfoQueryVariables>, GraphQLContext<DeviceInfoQuery>, any>) =>
  graphql.query<DeviceInfoQuery, DeviceInfoQueryVariables>(
    'deviceInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetBankCodeListQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ bankCodeList })
 *   )
 * })
 */
export const mockGetBankCodeListQuery = (resolver: ResponseResolver<GraphQLRequest<GetBankCodeListQueryVariables>, GraphQLContext<GetBankCodeListQuery>, any>) =>
  graphql.query<GetBankCodeListQuery, GetBankCodeListQueryVariables>(
    'getBankCodeList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockVerifyBankAccountQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ authBankAccount })
 *   )
 * })
 */
export const mockVerifyBankAccountQuery = (resolver: ResponseResolver<GraphQLRequest<VerifyBankAccountQueryVariables>, GraphQLContext<VerifyBankAccountQuery>, any>) =>
  graphql.query<VerifyBankAccountQuery, VerifyBankAccountQueryVariables>(
    'verifyBankAccount',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCheckEmailVerifyCodeMutation((req, res, ctx) => {
 *   const { checkEmailVerifyCodeInput } = req.variables;
 *   return res(
 *     ctx.data({ checkEmailVerifyCode })
 *   )
 * })
 */
export const mockCheckEmailVerifyCodeMutation = (resolver: ResponseResolver<GraphQLRequest<CheckEmailVerifyCodeMutationVariables>, GraphQLContext<CheckEmailVerifyCodeMutation>, any>) =>
  graphql.mutation<CheckEmailVerifyCodeMutation, CheckEmailVerifyCodeMutationVariables>(
    'checkEmailVerifyCode',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetGlobalParentVerificationIsCompletedQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ getGlobalParentVerificationIsCompleted })
 *   )
 * })
 */
export const mockGetGlobalParentVerificationIsCompletedQuery = (resolver: ResponseResolver<GraphQLRequest<GetGlobalParentVerificationIsCompletedQueryVariables>, GraphQLContext<GetGlobalParentVerificationIsCompletedQuery>, any>) =>
  graphql.query<GetGlobalParentVerificationIsCompletedQuery, GetGlobalParentVerificationIsCompletedQueryVariables>(
    'getGlobalParentVerificationIsCompleted',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGlobalCheckParentVerifyMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ globalCheckParentVerify })
 *   )
 * })
 */
export const mockGlobalCheckParentVerifyMutation = (resolver: ResponseResolver<GraphQLRequest<GlobalCheckParentVerifyMutationVariables>, GraphQLContext<GlobalCheckParentVerifyMutation>, any>) =>
  graphql.mutation<GlobalCheckParentVerifyMutation, GlobalCheckParentVerifyMutationVariables>(
    'globalCheckParentVerify',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGlobalSavePrivateMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ globalSavePrivate })
 *   )
 * })
 */
export const mockGlobalSavePrivateMutation = (resolver: ResponseResolver<GraphQLRequest<GlobalSavePrivateMutationVariables>, GraphQLContext<GlobalSavePrivateMutation>, any>) =>
  graphql.mutation<GlobalSavePrivateMutation, GlobalSavePrivateMutationVariables>(
    'globalSavePrivate',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSendEmailVerifyCodeMutation((req, res, ctx) => {
 *   const { sendEmailVerifyCodeInput } = req.variables;
 *   return res(
 *     ctx.data({ sendEmailVerifyCode })
 *   )
 * })
 */
export const mockSendEmailVerifyCodeMutation = (resolver: ResponseResolver<GraphQLRequest<SendEmailVerifyCodeMutationVariables>, GraphQLContext<SendEmailVerifyCodeMutation>, any>) =>
  graphql.mutation<SendEmailVerifyCodeMutation, SendEmailVerifyCodeMutationVariables>(
    'sendEmailVerifyCode',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGlobalSendParentVerifyMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ globalSendParentVerify })
 *   )
 * })
 */
export const mockGlobalSendParentVerifyMutation = (resolver: ResponseResolver<GraphQLRequest<GlobalSendParentVerifyMutationVariables>, GraphQLContext<GlobalSendParentVerifyMutation>, any>) =>
  graphql.mutation<GlobalSendParentVerifyMutation, GlobalSendParentVerifyMutationVariables>(
    'globalSendParentVerify',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAgreementsQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ agreements })
 *   )
 * })
 */
export const mockAgreementsQuery = (resolver: ResponseResolver<GraphQLRequest<AgreementsQueryVariables>, GraphQLContext<AgreementsQuery>, any>) =>
  graphql.query<AgreementsQuery, AgreementsQueryVariables>(
    'agreements',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetGlobalAgreementsQuery((req, res, ctx) => {
 *   const { globalAgreementInput } = req.variables;
 *   return res(
 *     ctx.data({ getGlobalAgreements })
 *   )
 * })
 */
export const mockGetGlobalAgreementsQuery = (resolver: ResponseResolver<GraphQLRequest<GetGlobalAgreementsQueryVariables>, GraphQLContext<GetGlobalAgreementsQuery>, any>) =>
  graphql.query<GetGlobalAgreementsQuery, GetGlobalAgreementsQueryVariables>(
    'getGlobalAgreements',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSelfCertAgreementQuery((req, res, ctx) => {
 *   const { authRequestType } = req.variables;
 *   return res(
 *     ctx.data({ selfCertAgreement })
 *   )
 * })
 */
export const mockSelfCertAgreementQuery = (resolver: ResponseResolver<GraphQLRequest<SelfCertAgreementQueryVariables>, GraphQLContext<SelfCertAgreementQuery>, any>) =>
  graphql.query<SelfCertAgreementQuery, SelfCertAgreementQueryVariables>(
    'selfCertAgreement',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGotchaQuery((req, res, ctx) => {
 *   const { gotchaId, adLocId, hasMapUid } = req.variables;
 *   return res(
 *     ctx.data({ gotcha })
 *   )
 * })
 */
export const mockGotchaQuery = (resolver: ResponseResolver<GraphQLRequest<GotchaQueryVariables>, GraphQLContext<GotchaQuery>, any>) =>
  graphql.query<GotchaQuery, GotchaQueryVariables>(
    'gotcha',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDrawGotchaMutation((req, res, ctx) => {
 *   const { input, hasMapUid } = req.variables;
 *   return res(
 *     ctx.data({ drawGotcha })
 *   )
 * })
 */
export const mockDrawGotchaMutation = (resolver: ResponseResolver<GraphQLRequest<DrawGotchaMutationVariables>, GraphQLContext<DrawGotchaMutation>, any>) =>
  graphql.mutation<DrawGotchaMutation, DrawGotchaMutationVariables>(
    'drawGotcha',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRouletteInfoQuery((req, res, ctx) => {
 *   const { rouletteId, hasMapUid, rouletteAdLocId } = req.variables;
 *   return res(
 *     ctx.data({ rouletteInfo })
 *   )
 * })
 */
export const mockRouletteInfoQuery = (resolver: ResponseResolver<GraphQLRequest<RouletteInfoQueryVariables>, GraphQLContext<RouletteInfoQuery>, any>) =>
  graphql.query<RouletteInfoQuery, RouletteInfoQueryVariables>(
    'rouletteInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRouletteDrawMutation((req, res, ctx) => {
 *   const { input, hasMapUid } = req.variables;
 *   return res(
 *     ctx.data({ rouletteDraw })
 *   )
 * })
 */
export const mockRouletteDrawMutation = (resolver: ResponseResolver<GraphQLRequest<RouletteDrawMutationVariables>, GraphQLContext<RouletteDrawMutation>, any>) =>
  graphql.mutation<RouletteDrawMutation, RouletteDrawMutationVariables>(
    'rouletteDraw',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockHelixSeriesListQuery((req, res, ctx) => {
 *   const { mapUid } = req.variables;
 *   return res(
 *     ctx.data({ helixSeriesList })
 *   )
 * })
 */
export const mockHelixSeriesListQuery = (resolver: ResponseResolver<GraphQLRequest<HelixSeriesListQueryVariables>, GraphQLContext<HelixSeriesListQuery>, any>) =>
  graphql.query<HelixSeriesListQuery, HelixSeriesListQueryVariables>(
    'helixSeriesList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInvenMyInfoQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ invenMyInfo })
 *   )
 * })
 */
export const mockInvenMyInfoQuery = (resolver: ResponseResolver<GraphQLRequest<InvenMyInfoQueryVariables>, GraphQLContext<InvenMyInfoQuery>, any>) =>
  graphql.query<InvenMyInfoQuery, InvenMyInfoQueryVariables>(
    'invenMyInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInvenRecentListQuery((req, res, ctx) => {
 *   const { invenListInput } = req.variables;
 *   return res(
 *     ctx.data({ invenRecentList })
 *   )
 * })
 */
export const mockInvenRecentListQuery = (resolver: ResponseResolver<GraphQLRequest<InvenRecentListQueryVariables>, GraphQLContext<InvenRecentListQuery>, any>) =>
  graphql.query<InvenRecentListQuery, InvenRecentListQueryVariables>(
    'invenRecentList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInvenLikeListQuery((req, res, ctx) => {
 *   const { invenListInput } = req.variables;
 *   return res(
 *     ctx.data({ invenLikeList })
 *   )
 * })
 */
export const mockInvenLikeListQuery = (resolver: ResponseResolver<GraphQLRequest<InvenLikeListQueryVariables>, GraphQLContext<InvenLikeListQuery>, any>) =>
  graphql.query<InvenLikeListQuery, InvenLikeListQueryVariables>(
    'invenLikeList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInvenPaidListQuery((req, res, ctx) => {
 *   const { invenListInput } = req.variables;
 *   return res(
 *     ctx.data({ invenPaidList })
 *   )
 * })
 */
export const mockInvenPaidListQuery = (resolver: ResponseResolver<GraphQLRequest<InvenPaidListQueryVariables>, GraphQLContext<InvenPaidListQuery>, any>) =>
  graphql.query<InvenPaidListQuery, InvenPaidListQueryVariables>(
    'invenPaidList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteInvenLikeMutation((req, res, ctx) => {
 *   const { seriesIdList } = req.variables;
 *   return res(
 *     ctx.data({ deleteInvenLike })
 *   )
 * })
 */
export const mockDeleteInvenLikeMutation = (resolver: ResponseResolver<GraphQLRequest<DeleteInvenLikeMutationVariables>, GraphQLContext<DeleteInvenLikeMutation>, any>) =>
  graphql.mutation<DeleteInvenLikeMutation, DeleteInvenLikeMutationVariables>(
    'deleteInvenLike',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteInvenPaidMutation((req, res, ctx) => {
 *   const { seriesIdList } = req.variables;
 *   return res(
 *     ctx.data({ deleteInvenPaid })
 *   )
 * })
 */
export const mockDeleteInvenPaidMutation = (resolver: ResponseResolver<GraphQLRequest<DeleteInvenPaidMutationVariables>, GraphQLContext<DeleteInvenPaidMutation>, any>) =>
  graphql.mutation<DeleteInvenPaidMutation, DeleteInvenPaidMutationVariables>(
    'deleteInvenPaid',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteInvenRecentMutation((req, res, ctx) => {
 *   const { seriesIdList } = req.variables;
 *   return res(
 *     ctx.data({ deleteInvenRecent })
 *   )
 * })
 */
export const mockDeleteInvenRecentMutation = (resolver: ResponseResolver<GraphQLRequest<DeleteInvenRecentMutationVariables>, GraphQLContext<DeleteInvenRecentMutation>, any>) =>
  graphql.mutation<DeleteInvenRecentMutation, DeleteInvenRecentMutationVariables>(
    'deleteInvenRecent',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSetSeriesAlarmMutation((req, res, ctx) => {
 *   const { setSeriesAlarmInput } = req.variables;
 *   return res(
 *     ctx.data({ setSeriesAlarm })
 *   )
 * })
 */
export const mockSetSeriesAlarmMutation = (resolver: ResponseResolver<GraphQLRequest<SetSeriesAlarmMutationVariables>, GraphQLContext<SetSeriesAlarmMutation>, any>) =>
  graphql.mutation<SetSeriesAlarmMutation, SetSeriesAlarmMutationVariables>(
    'setSeriesAlarm',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSetSeriesLikeMutation((req, res, ctx) => {
 *   const { setSeriesLikeInput } = req.variables;
 *   return res(
 *     ctx.data({ setSeriesLike })
 *   )
 * })
 */
export const mockSetSeriesLikeMutation = (resolver: ResponseResolver<GraphQLRequest<SetSeriesLikeMutationVariables>, GraphQLContext<SetSeriesLikeMutation>, any>) =>
  graphql.mutation<SetSeriesLikeMutation, SetSeriesLikeMutationVariables>(
    'setSeriesLike',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSearchInvenListQuery((req, res, ctx) => {
 *   const { searchInvenListInput } = req.variables;
 *   return res(
 *     ctx.data({ searchInvenList })
 *   )
 * })
 */
export const mockSearchInvenListQuery = (resolver: ResponseResolver<GraphQLRequest<SearchInvenListQueryVariables>, GraphQLContext<SearchInvenListQuery>, any>) =>
  graphql.query<SearchInvenListQuery, SearchInvenListQueryVariables>(
    'searchInvenList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInvenRecommendListQuery((req, res, ctx) => {
 *   const { type } = req.variables;
 *   return res(
 *     ctx.data({ invenRecommendList })
 *   )
 * })
 */
export const mockInvenRecommendListQuery = (resolver: ResponseResolver<GraphQLRequest<InvenRecommendListQueryVariables>, GraphQLContext<InvenRecommendListQuery>, any>) =>
  graphql.query<InvenRecommendListQuery, InvenRecommendListQueryVariables>(
    'invenRecommendList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOpenPreviewMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ openPreview })
 *   )
 * })
 */
export const mockOpenPreviewMutation = (resolver: ResponseResolver<GraphQLRequest<OpenPreviewMutationVariables>, GraphQLContext<OpenPreviewMutation>, any>) =>
  graphql.mutation<OpenPreviewMutation, OpenPreviewMutationVariables>(
    'OpenPreview',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOpenPageMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ viewerOpenPage })
 *   )
 * })
 */
export const mockOpenPageMutation = (resolver: ResponseResolver<GraphQLRequest<OpenPageMutationVariables>, GraphQLContext<OpenPageMutation>, any>) =>
  graphql.mutation<OpenPageMutation, OpenPageMutationVariables>(
    'OpenPage',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSeriesCardViewLandingListQuery((req, res, ctx) => {
 *   const { dataKey, page, size, themeKeywordUid } = req.variables;
 *   return res(
 *     ctx.data({ seriesCardViewLandingList })
 *   )
 * })
 */
export const mockSeriesCardViewLandingListQuery = (resolver: ResponseResolver<GraphQLRequest<SeriesCardViewLandingListQueryVariables>, GraphQLContext<SeriesCardViewLandingListQuery>, any>) =>
  graphql.query<SeriesCardViewLandingListQuery, SeriesCardViewLandingListQueryVariables>(
    'seriesCardViewLandingList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSeriesListViewLandingListQuery((req, res, ctx) => {
 *   const { dataKey, page, size, themeKeywordUid } = req.variables;
 *   return res(
 *     ctx.data({ seriesListViewLandingList })
 *   )
 * })
 */
export const mockSeriesListViewLandingListQuery = (resolver: ResponseResolver<GraphQLRequest<SeriesListViewLandingListQueryVariables>, GraphQLContext<SeriesListViewLandingListQuery>, any>) =>
  graphql.query<SeriesListViewLandingListQuery, SeriesListViewLandingListQueryVariables>(
    'seriesListViewLandingList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSeriesPosterViewLandingListQuery((req, res, ctx) => {
 *   const { dataKey, page, size, themeKeywordUid } = req.variables;
 *   return res(
 *     ctx.data({ seriesPosterViewLandingList })
 *   )
 * })
 */
export const mockSeriesPosterViewLandingListQuery = (resolver: ResponseResolver<GraphQLRequest<SeriesPosterViewLandingListQueryVariables>, GraphQLContext<SeriesPosterViewLandingListQuery>, any>) =>
  graphql.query<SeriesPosterViewLandingListQuery, SeriesPosterViewLandingListQueryVariables>(
    'seriesPosterViewLandingList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSetListViewLandingListQuery((req, res, ctx) => {
 *   const { dataKey, page, size } = req.variables;
 *   return res(
 *     ctx.data({ setListViewLandingList })
 *   )
 * })
 */
export const mockSetListViewLandingListQuery = (resolver: ResponseResolver<GraphQLRequest<SetListViewLandingListQueryVariables>, GraphQLContext<SetListViewLandingListQuery>, any>) =>
  graphql.query<SetListViewLandingListQuery, SetListViewLandingListQueryVariables>(
    'setListViewLandingList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSetPosterViewLandingListQuery((req, res, ctx) => {
 *   const { dataKey, page, size } = req.variables;
 *   return res(
 *     ctx.data({ setPosterViewLandingList })
 *   )
 * })
 */
export const mockSetPosterViewLandingListQuery = (resolver: ResponseResolver<GraphQLRequest<SetPosterViewLandingListQueryVariables>, GraphQLContext<SetPosterViewLandingListQuery>, any>) =>
  graphql.query<SetPosterViewLandingListQuery, SetPosterViewLandingListQueryVariables>(
    'setPosterViewLandingList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSingleListViewLandingListQuery((req, res, ctx) => {
 *   const { dataKey, page, size, themeKeywordUid } = req.variables;
 *   return res(
 *     ctx.data({ singleListViewLandingList })
 *   )
 * })
 */
export const mockSingleListViewLandingListQuery = (resolver: ResponseResolver<GraphQLRequest<SingleListViewLandingListQueryVariables>, GraphQLContext<SingleListViewLandingListQuery>, any>) =>
  graphql.query<SingleListViewLandingListQuery, SingleListViewLandingListQueryVariables>(
    'singleListViewLandingList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingDayOfWeekLayoutQuery((req, res, ctx) => {
 *   const { queryInput } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingDayOfWeekLayout })
 *   )
 * })
 */
export const mockStaticLandingDayOfWeekLayoutQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingDayOfWeekLayoutQueryVariables>, GraphQLContext<StaticLandingDayOfWeekLayoutQuery>, any>) =>
  graphql.query<StaticLandingDayOfWeekLayoutQuery, StaticLandingDayOfWeekLayoutQueryVariables>(
    'staticLandingDayOfWeekLayout',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingTodayNewLayoutQuery((req, res, ctx) => {
 *   const { queryInput } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingTodayNewLayout })
 *   )
 * })
 */
export const mockStaticLandingTodayNewLayoutQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingTodayNewLayoutQueryVariables>, GraphQLContext<StaticLandingTodayNewLayoutQuery>, any>) =>
  graphql.query<StaticLandingTodayNewLayoutQuery, StaticLandingTodayNewLayoutQueryVariables>(
    'staticLandingTodayNewLayout',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingTodayUpLayoutQuery((req, res, ctx) => {
 *   const { queryInput } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingTodayUpLayout })
 *   )
 * })
 */
export const mockStaticLandingTodayUpLayoutQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingTodayUpLayoutQueryVariables>, GraphQLContext<StaticLandingTodayUpLayoutQuery>, any>) =>
  graphql.query<StaticLandingTodayUpLayoutQuery, StaticLandingTodayUpLayoutQueryVariables>(
    'staticLandingTodayUpLayout',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingRankingLayoutQuery((req, res, ctx) => {
 *   const { queryInput } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingRankingLayout })
 *   )
 * })
 */
export const mockStaticLandingRankingLayoutQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingRankingLayoutQueryVariables>, GraphQLContext<StaticLandingRankingLayoutQuery>, any>) =>
  graphql.query<StaticLandingRankingLayoutQuery, StaticLandingRankingLayoutQueryVariables>(
    'staticLandingRankingLayout',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingGenreLayoutQuery((req, res, ctx) => {
 *   const { queryInput } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingGenreLayout })
 *   )
 * })
 */
export const mockStaticLandingGenreLayoutQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingGenreLayoutQueryVariables>, GraphQLContext<StaticLandingGenreLayoutQuery>, any>) =>
  graphql.query<StaticLandingGenreLayoutQuery, StaticLandingGenreLayoutQueryVariables>(
    'staticLandingGenreLayout',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingFreeSeriesLayoutQuery((req, res, ctx) => {
 *   const { queryInput } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingFreeSeriesLayout })
 *   )
 * })
 */
export const mockStaticLandingFreeSeriesLayoutQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingFreeSeriesLayoutQueryVariables>, GraphQLContext<StaticLandingFreeSeriesLayoutQuery>, any>) =>
  graphql.query<StaticLandingFreeSeriesLayoutQuery, StaticLandingFreeSeriesLayoutQueryVariables>(
    'staticLandingFreeSeriesLayout',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingEventLayoutQuery((req, res, ctx) => {
 *   const { queryInput } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingEventLayout })
 *   )
 * })
 */
export const mockStaticLandingEventLayoutQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingEventLayoutQueryVariables>, GraphQLContext<StaticLandingEventLayoutQuery>, any>) =>
  graphql.query<StaticLandingEventLayoutQuery, StaticLandingEventLayoutQueryVariables>(
    'staticLandingEventLayout',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingOriginalLayoutQuery((req, res, ctx) => {
 *   const { queryInput } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingOriginalLayout })
 *   )
 * })
 */
export const mockStaticLandingOriginalLayoutQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingOriginalLayoutQueryVariables>, GraphQLContext<StaticLandingOriginalLayoutQuery>, any>) =>
  graphql.query<StaticLandingOriginalLayoutQuery, StaticLandingOriginalLayoutQueryVariables>(
    'staticLandingOriginalLayout',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingDayOfWeekSectionQuery((req, res, ctx) => {
 *   const { sectionId, param } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingDayOfWeekSection })
 *   )
 * })
 */
export const mockStaticLandingDayOfWeekSectionQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingDayOfWeekSectionQueryVariables>, GraphQLContext<StaticLandingDayOfWeekSectionQuery>, any>) =>
  graphql.query<StaticLandingDayOfWeekSectionQuery, StaticLandingDayOfWeekSectionQueryVariables>(
    'staticLandingDayOfWeekSection',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingTodayNewSectionQuery((req, res, ctx) => {
 *   const { sectionId, param } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingTodayNewSection })
 *   )
 * })
 */
export const mockStaticLandingTodayNewSectionQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingTodayNewSectionQueryVariables>, GraphQLContext<StaticLandingTodayNewSectionQuery>, any>) =>
  graphql.query<StaticLandingTodayNewSectionQuery, StaticLandingTodayNewSectionQueryVariables>(
    'staticLandingTodayNewSection',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingTodayUpSectionQuery((req, res, ctx) => {
 *   const { sectionId, param } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingTodayUpSection })
 *   )
 * })
 */
export const mockStaticLandingTodayUpSectionQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingTodayUpSectionQueryVariables>, GraphQLContext<StaticLandingTodayUpSectionQuery>, any>) =>
  graphql.query<StaticLandingTodayUpSectionQuery, StaticLandingTodayUpSectionQueryVariables>(
    'staticLandingTodayUpSection',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingRankingSectionQuery((req, res, ctx) => {
 *   const { sectionId, param } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingRankingSection })
 *   )
 * })
 */
export const mockStaticLandingRankingSectionQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingRankingSectionQueryVariables>, GraphQLContext<StaticLandingRankingSectionQuery>, any>) =>
  graphql.query<StaticLandingRankingSectionQuery, StaticLandingRankingSectionQueryVariables>(
    'staticLandingRankingSection',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingGenreSectionQuery((req, res, ctx) => {
 *   const { sectionId, param } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingGenreSection })
 *   )
 * })
 */
export const mockStaticLandingGenreSectionQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingGenreSectionQueryVariables>, GraphQLContext<StaticLandingGenreSectionQuery>, any>) =>
  graphql.query<StaticLandingGenreSectionQuery, StaticLandingGenreSectionQueryVariables>(
    'staticLandingGenreSection',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingFreeSeriesSectionQuery((req, res, ctx) => {
 *   const { sectionId, param } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingFreeSeriesSection })
 *   )
 * })
 */
export const mockStaticLandingFreeSeriesSectionQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingFreeSeriesSectionQueryVariables>, GraphQLContext<StaticLandingFreeSeriesSectionQuery>, any>) =>
  graphql.query<StaticLandingFreeSeriesSectionQuery, StaticLandingFreeSeriesSectionQueryVariables>(
    'staticLandingFreeSeriesSection',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingEventSectionQuery((req, res, ctx) => {
 *   const { sectionId, param } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingEventSection })
 *   )
 * })
 */
export const mockStaticLandingEventSectionQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingEventSectionQueryVariables>, GraphQLContext<StaticLandingEventSectionQuery>, any>) =>
  graphql.query<StaticLandingEventSectionQuery, StaticLandingEventSectionQueryVariables>(
    'staticLandingEventSection',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStaticLandingOriginalSectionQuery((req, res, ctx) => {
 *   const { sectionId, param } = req.variables;
 *   return res(
 *     ctx.data({ staticLandingOriginalSection })
 *   )
 * })
 */
export const mockStaticLandingOriginalSectionQuery = (resolver: ResponseResolver<GraphQLRequest<StaticLandingOriginalSectionQueryVariables>, GraphQLContext<StaticLandingOriginalSectionQuery>, any>) =>
  graphql.query<StaticLandingOriginalSectionQuery, StaticLandingOriginalSectionQueryVariables>(
    'staticLandingOriginalSection',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMainQuery((req, res, ctx) => {
 *   const { screenUid, type } = req.variables;
 *   return res(
 *     ctx.data({ layout })
 *   )
 * })
 */
export const mockMainQuery = (resolver: ResponseResolver<GraphQLRequest<MainQueryVariables>, GraphQLContext<MainQuery>, any>) =>
  graphql.query<MainQuery, MainQueryVariables>(
    'main',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLayoutListQuery((req, res, ctx) => {
 *   const { screenUidList, type } = req.variables;
 *   return res(
 *     ctx.data({ layoutList })
 *   )
 * })
 */
export const mockLayoutListQuery = (resolver: ResponseResolver<GraphQLRequest<LayoutListQueryVariables>, GraphQLContext<LayoutListQuery>, any>) =>
  graphql.query<LayoutListQuery, LayoutListQueryVariables>(
    'layoutList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUseRedeemMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ useRedeem })
 *   )
 * })
 */
export const mockUseRedeemMutation = (resolver: ResponseResolver<GraphQLRequest<UseRedeemMutationVariables>, GraphQLContext<UseRedeemMutation>, any>) =>
  graphql.mutation<UseRedeemMutation, UseRedeemMutationVariables>(
    'useRedeem',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSearchAutoCompleteQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ searchAutoComplete })
 *   )
 * })
 */
export const mockSearchAutoCompleteQuery = (resolver: ResponseResolver<GraphQLRequest<SearchAutoCompleteQueryVariables>, GraphQLContext<SearchAutoCompleteQuery>, any>) =>
  graphql.query<SearchAutoCompleteQuery, SearchAutoCompleteQueryVariables>(
    'searchAutoComplete',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSearchKeywordQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ searchKeyword })
 *   )
 * })
 */
export const mockSearchKeywordQuery = (resolver: ResponseResolver<GraphQLRequest<SearchKeywordQueryVariables>, GraphQLContext<SearchKeywordQuery>, any>) =>
  graphql.query<SearchKeywordQuery, SearchKeywordQueryVariables>(
    'SearchKeyword',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSearchMainQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ searchMain })
 *   )
 * })
 */
export const mockSearchMainQuery = (resolver: ResponseResolver<GraphQLRequest<SearchMainQueryVariables>, GraphQLContext<SearchMainQuery>, any>) =>
  graphql.query<SearchMainQuery, SearchMainQueryVariables>(
    'searchMain',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSearchThemeKeywordQuery((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ searchThemeKeyword })
 *   )
 * })
 */
export const mockSearchThemeKeywordQuery = (resolver: ResponseResolver<GraphQLRequest<SearchThemeKeywordQueryVariables>, GraphQLContext<SearchThemeKeywordQuery>, any>) =>
  graphql.query<SearchThemeKeywordQuery, SearchThemeKeywordQueryVariables>(
    'searchThemeKeyword',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSetAgreementMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ setAgreement })
 *   )
 * })
 */
export const mockSetAgreementMutation = (resolver: ResponseResolver<GraphQLRequest<SetAgreementMutationVariables>, GraphQLContext<SetAgreementMutation>, any>) =>
  graphql.mutation<SetAgreementMutation, SetAgreementMutationVariables>(
    'setAgreement',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSetGlobalAgreementMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ setGlobalAgreement })
 *   )
 * })
 */
export const mockSetGlobalAgreementMutation = (resolver: ResponseResolver<GraphQLRequest<SetGlobalAgreementMutationVariables>, GraphQLContext<SetGlobalAgreementMutation>, any>) =>
  graphql.mutation<SetGlobalAgreementMutation, SetGlobalAgreementMutationVariables>(
    'setGlobalAgreement',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockShortcutListQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ shortcutList })
 *   )
 * })
 */
export const mockShortcutListQuery = (resolver: ResponseResolver<GraphQLRequest<ShortcutListQueryVariables>, GraphQLContext<ShortcutListQuery>, any>) =>
  graphql.query<ShortcutListQuery, ShortcutListQueryVariables>(
    'shortcutList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLayoutReferenceQuery((req, res, ctx) => {
 *   const { dataKey, sectionType, metaInfoType } = req.variables;
 *   return res(
 *     ctx.data({ layoutReference })
 *   )
 * })
 */
export const mockLayoutReferenceQuery = (resolver: ResponseResolver<GraphQLRequest<LayoutReferenceQueryVariables>, GraphQLContext<LayoutReferenceQuery>, any>) =>
  graphql.query<LayoutReferenceQuery, LayoutReferenceQueryVariables>(
    'layoutReference',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDynamicLayoutReferenceQuery((req, res, ctx) => {
 *   const { dataKey, sectionType, metaInfoType } = req.variables;
 *   return res(
 *     ctx.data({ dynamicLayoutReference })
 *   )
 * })
 */
export const mockDynamicLayoutReferenceQuery = (resolver: ResponseResolver<GraphQLRequest<DynamicLayoutReferenceQueryVariables>, GraphQLContext<DynamicLayoutReferenceQuery>, any>) =>
  graphql.query<DynamicLayoutReferenceQuery, DynamicLayoutReferenceQueryVariables>(
    'dynamicLayoutReference',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBuyTicketHistoryQuery((req, res, ctx) => {
 *   const { page, freeOnly } = req.variables;
 *   return res(
 *     ctx.data({ buyTicketHistory })
 *   )
 * })
 */
export const mockBuyTicketHistoryQuery = (resolver: ResponseResolver<GraphQLRequest<BuyTicketHistoryQueryVariables>, GraphQLContext<BuyTicketHistoryQuery>, any>) =>
  graphql.query<BuyTicketHistoryQuery, BuyTicketHistoryQueryVariables>(
    'buyTicketHistory',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBuyCashHistoryQuery((req, res, ctx) => {
 *   const { page, usePaging, lastPageId } = req.variables;
 *   return res(
 *     ctx.data({ buyCashHistory })
 *   )
 * })
 */
export const mockBuyCashHistoryQuery = (resolver: ResponseResolver<GraphQLRequest<BuyCashHistoryQueryVariables>, GraphQLContext<BuyCashHistoryQuery>, any>) =>
  graphql.query<BuyCashHistoryQuery, BuyCashHistoryQueryVariables>(
    'buyCashHistory',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUseCashHistoryQuery((req, res, ctx) => {
 *   const { page } = req.variables;
 *   return res(
 *     ctx.data({ useCashHistory })
 *   )
 * })
 */
export const mockUseCashHistoryQuery = (resolver: ResponseResolver<GraphQLRequest<UseCashHistoryQueryVariables>, GraphQLContext<UseCashHistoryQuery>, any>) =>
  graphql.query<UseCashHistoryQuery, UseCashHistoryQueryVariables>(
    'useCashHistory',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCommentListQuery((req, res, ctx) => {
 *   const { commentListInput } = req.variables;
 *   return res(
 *     ctx.data({ commentList })
 *   )
 * })
 */
export const mockCommentListQuery = (resolver: ResponseResolver<GraphQLRequest<CommentListQueryVariables>, GraphQLContext<CommentListQuery>, any>) =>
  graphql.query<CommentListQuery, CommentListQueryVariables>(
    'commentList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBestCommentListQuery((req, res, ctx) => {
 *   const { bestCommentListInput } = req.variables;
 *   return res(
 *     ctx.data({ bestCommentList })
 *   )
 * })
 */
export const mockBestCommentListQuery = (resolver: ResponseResolver<GraphQLRequest<BestCommentListQueryVariables>, GraphQLContext<BestCommentListQuery>, any>) =>
  graphql.query<BestCommentListQuery, BestCommentListQueryVariables>(
    'bestCommentList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockReplyCommentListQuery((req, res, ctx) => {
 *   const { commentListInput } = req.variables;
 *   return res(
 *     ctx.data({ replyCommentList })
 *   )
 * })
 */
export const mockReplyCommentListQuery = (resolver: ResponseResolver<GraphQLRequest<ReplyCommentListQueryVariables>, GraphQLContext<ReplyCommentListQuery>, any>) =>
  graphql.query<ReplyCommentListQuery, ReplyCommentListQueryVariables>(
    'replyCommentList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCommentItemQuery((req, res, ctx) => {
 *   const { parentUid, seriesId } = req.variables;
 *   return res(
 *     ctx.data({ commentItem })
 *   )
 * })
 */
export const mockCommentItemQuery = (resolver: ResponseResolver<GraphQLRequest<CommentItemQueryVariables>, GraphQLContext<CommentItemQuery>, any>) =>
  graphql.query<CommentItemQuery, CommentItemQueryVariables>(
    'commentItem',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBlockUserListQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ blockUserList })
 *   )
 * })
 */
export const mockBlockUserListQuery = (resolver: ResponseResolver<GraphQLRequest<BlockUserListQueryVariables>, GraphQLContext<BlockUserListQuery>, any>) =>
  graphql.query<BlockUserListQuery, BlockUserListQueryVariables>(
    'blockUserList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMyCommentListQuery((req, res, ctx) => {
 *   const { page } = req.variables;
 *   return res(
 *     ctx.data({ myCommentList })
 *   )
 * })
 */
export const mockMyCommentListQuery = (resolver: ResponseResolver<GraphQLRequest<MyCommentListQueryVariables>, GraphQLContext<MyCommentListQuery>, any>) =>
  graphql.query<MyCommentListQuery, MyCommentListQueryVariables>(
    'myCommentList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWriteCommentMutation((req, res, ctx) => {
 *   const { writeCommentInput } = req.variables;
 *   return res(
 *     ctx.data({ writeComment })
 *   )
 * })
 */
export const mockWriteCommentMutation = (resolver: ResponseResolver<GraphQLRequest<WriteCommentMutationVariables>, GraphQLContext<WriteCommentMutation>, any>) =>
  graphql.mutation<WriteCommentMutation, WriteCommentMutationVariables>(
    'writeComment',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveCommentMutation((req, res, ctx) => {
 *   const { commentUid } = req.variables;
 *   return res(
 *     ctx.data({ removeComment })
 *   )
 * })
 */
export const mockRemoveCommentMutation = (resolver: ResponseResolver<GraphQLRequest<RemoveCommentMutationVariables>, GraphQLContext<RemoveCommentMutation>, any>) =>
  graphql.mutation<RemoveCommentMutation, RemoveCommentMutationVariables>(
    'removeComment',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLikeCommentMutation((req, res, ctx) => {
 *   const { likeCommentInput } = req.variables;
 *   return res(
 *     ctx.data({ likeComment })
 *   )
 * })
 */
export const mockLikeCommentMutation = (resolver: ResponseResolver<GraphQLRequest<LikeCommentMutationVariables>, GraphQLContext<LikeCommentMutation>, any>) =>
  graphql.mutation<LikeCommentMutation, LikeCommentMutationVariables>(
    'likeComment',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeclareCommentMutation((req, res, ctx) => {
 *   const { declareCommentInput } = req.variables;
 *   return res(
 *     ctx.data({ declareComment })
 *   )
 * })
 */
export const mockDeclareCommentMutation = (resolver: ResponseResolver<GraphQLRequest<DeclareCommentMutationVariables>, GraphQLContext<DeclareCommentMutation>, any>) =>
  graphql.mutation<DeclareCommentMutation, DeclareCommentMutationVariables>(
    'declareComment',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBlockUserMutation((req, res, ctx) => {
 *   const { blockUserInput } = req.variables;
 *   return res(
 *     ctx.data({ blockUser })
 *   )
 * })
 */
export const mockBlockUserMutation = (resolver: ResponseResolver<GraphQLRequest<BlockUserMutationVariables>, GraphQLContext<BlockUserMutation>, any>) =>
  graphql.mutation<BlockUserMutation, BlockUserMutationVariables>(
    'blockUser',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentTicketDetailQuery((req, res, ctx) => {
 *   const { ticketUid, seriesId } = req.variables;
 *   return res(
 *     ctx.data({ contentTicketDetail })
 *   )
 * })
 */
export const mockContentTicketDetailQuery = (resolver: ResponseResolver<GraphQLRequest<ContentTicketDetailQueryVariables>, GraphQLContext<ContentTicketDetailQuery>, any>) =>
  graphql.query<ContentTicketDetailQuery, ContentTicketDetailQueryVariables>(
    'contentTicketDetail',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentTicketInfoQuery((req, res, ctx) => {
 *   const { page, seriesId } = req.variables;
 *   return res(
 *     ctx.data({ contentTicketInfo })
 *   )
 * })
 */
export const mockContentTicketInfoQuery = (resolver: ResponseResolver<GraphQLRequest<ContentTicketInfoQueryVariables>, GraphQLContext<ContentTicketInfoQuery>, any>) =>
  graphql.query<ContentTicketInfoQuery, ContentTicketInfoQueryVariables>(
    'contentTicketInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRefundTicketMutation((req, res, ctx) => {
 *   const { ticketUid } = req.variables;
 *   return res(
 *     ctx.data({ refundTicket })
 *   )
 * })
 */
export const mockRefundTicketMutation = (resolver: ResponseResolver<GraphQLRequest<RefundTicketMutationVariables>, GraphQLContext<RefundTicketMutation>, any>) =>
  graphql.mutation<RefundTicketMutation, RefundTicketMutationVariables>(
    'refundTicket',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetEventInfoMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ getEventInfo })
 *   )
 * })
 */
export const mockGetEventInfoMutation = (resolver: ResponseResolver<GraphQLRequest<GetEventInfoMutationVariables>, GraphQLContext<GetEventInfoMutation>, any>) =>
  graphql.mutation<GetEventInfoMutation, GetEventInfoMutationVariables>(
    'getEventInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMyNewsQuery((req, res, ctx) => {
 *   const { myNewsListInput } = req.variables;
 *   return res(
 *     ctx.data({ myNewsList })
 *   )
 * })
 */
export const mockMyNewsQuery = (resolver: ResponseResolver<GraphQLRequest<MyNewsQueryVariables>, GraphQLContext<MyNewsQuery>, any>) =>
  graphql.query<MyNewsQuery, MyNewsQueryVariables>(
    'myNews',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMyRatingQuery((req, res, ctx) => {
 *   const { seriesId, productId } = req.variables;
 *   return res(
 *     ctx.data({ myRating })
 *   )
 * })
 */
export const mockMyRatingQuery = (resolver: ResponseResolver<GraphQLRequest<MyRatingQueryVariables>, GraphQLContext<MyRatingQuery>, any>) =>
  graphql.query<MyRatingQuery, MyRatingQueryVariables>(
    'myRating',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPopupQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ popup })
 *   )
 * })
 */
export const mockPopupQuery = (resolver: ResponseResolver<GraphQLRequest<PopupQueryVariables>, GraphQLContext<PopupQuery>, any>) =>
  graphql.query<PopupQuery, PopupQueryVariables>(
    'Popup',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockReceiptInfoQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ receiptInfo })
 *   )
 * })
 */
export const mockReceiptInfoQuery = (resolver: ResponseResolver<GraphQLRequest<ReceiptInfoQueryVariables>, GraphQLContext<ReceiptInfoQuery>, any>) =>
  graphql.query<ReceiptInfoQuery, ReceiptInfoQueryVariables>(
    'receiptInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteReceiptInfoMutation((req, res, ctx) => {
 *   return res(
 *     ctx.data({ deleteReceiptInfo })
 *   )
 * })
 */
export const mockDeleteReceiptInfoMutation = (resolver: ResponseResolver<GraphQLRequest<DeleteReceiptInfoMutationVariables>, GraphQLContext<DeleteReceiptInfoMutation>, any>) =>
  graphql.mutation<DeleteReceiptInfoMutation, DeleteReceiptInfoMutationVariables>(
    'deleteReceiptInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateReceiptInfoMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateReceiptInfo })
 *   )
 * })
 */
export const mockUpdateReceiptInfoMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateReceiptInfoMutationVariables>, GraphQLContext<UpdateReceiptInfoMutation>, any>) =>
  graphql.mutation<UpdateReceiptInfoMutation, UpdateReceiptInfoMutationVariables>(
    'updateReceiptInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockReceiptInfoResultQuery((req, res, ctx) => {
 *   const { creditMasterId } = req.variables;
 *   return res(
 *     ctx.data({ receiptInfoResult })
 *   )
 * })
 */
export const mockReceiptInfoResultQuery = (resolver: ResponseResolver<GraphQLRequest<ReceiptInfoResultQueryVariables>, GraphQLContext<ReceiptInfoResultQuery>, any>) =>
  graphql.query<ReceiptInfoResultQuery, ReceiptInfoResultQueryVariables>(
    'receiptInfoResult',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTvPointAgreementQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ tvPointAgreement })
 *   )
 * })
 */
export const mockTvPointAgreementQuery = (resolver: ResponseResolver<GraphQLRequest<TvPointAgreementQueryVariables>, GraphQLContext<TvPointAgreementQuery>, any>) =>
  graphql.query<TvPointAgreementQuery, TvPointAgreementQueryVariables>(
    'tvPointAgreement',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSetTvPointAgreemenMutation((req, res, ctx) => {
 *   const { isAgree } = req.variables;
 *   return res(
 *     ctx.data({ setTvPointAgreement })
 *   )
 * })
 */
export const mockSetTvPointAgreemenMutation = (resolver: ResponseResolver<GraphQLRequest<SetTvPointAgreemenMutationVariables>, GraphQLContext<SetTvPointAgreemenMutation>, any>) =>
  graphql.mutation<SetTvPointAgreemenMutation, SetTvPointAgreemenMutationVariables>(
    'setTvPointAgreemen',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveMyNewsItemMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ removeMyNews })
 *   )
 * })
 */
export const mockRemoveMyNewsItemMutation = (resolver: ResponseResolver<GraphQLRequest<RemoveMyNewsItemMutationVariables>, GraphQLContext<RemoveMyNewsItemMutation>, any>) =>
  graphql.mutation<RemoveMyNewsItemMutation, RemoveMyNewsItemMutationVariables>(
    'removeMyNewsItem',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSetMyRatingMutation((req, res, ctx) => {
 *   const { setMyRatingInput } = req.variables;
 *   return res(
 *     ctx.data({ setMyRating })
 *   )
 * })
 */
export const mockSetMyRatingMutation = (resolver: ResponseResolver<GraphQLRequest<SetMyRatingMutationVariables>, GraphQLContext<SetMyRatingMutation>, any>) =>
  graphql.mutation<SetMyRatingMutation, SetMyRatingMutationVariables>(
    'setMyRating',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSinglePreviewQuery((req, res, ctx) => {
 *   const { productId } = req.variables;
 *   return res(
 *     ctx.data({ singlePreview })
 *   )
 * })
 */
export const mockSinglePreviewQuery = (resolver: ResponseResolver<GraphQLRequest<SinglePreviewQueryVariables>, GraphQLContext<SinglePreviewQuery>, any>) =>
  graphql.query<SinglePreviewQuery, SinglePreviewQueryVariables>(
    'singlePreview',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTodayGiftListQuery((req, res, ctx) => {
 *   const { categoryUid, subCategoryUid } = req.variables;
 *   return res(
 *     ctx.data({ todayGiftList })
 *   )
 * })
 */
export const mockTodayGiftListQuery = (resolver: ResponseResolver<GraphQLRequest<TodayGiftListQueryVariables>, GraphQLContext<TodayGiftListQuery>, any>) =>
  graphql.query<TodayGiftListQuery, TodayGiftListQueryVariables>(
    'todayGiftList',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateNicknameMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ updateNickname })
 *   )
 * })
 */
export const mockUpdateNicknameMutation = (resolver: ResponseResolver<GraphQLRequest<UpdateNicknameMutationVariables>, GraphQLContext<UpdateNicknameMutation>, any>) =>
  graphql.mutation<UpdateNicknameMutation, UpdateNicknameMutationVariables>(
    'UpdateNickname',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUseTicketMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ useTicket })
 *   )
 * })
 */
export const mockUseTicketMutation = (resolver: ResponseResolver<GraphQLRequest<UseTicketMutationVariables>, GraphQLContext<UseTicketMutation>, any>) =>
  graphql.mutation<UseTicketMutation, UseTicketMutationVariables>(
    'UseTicket',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUseTicketHistoryQuery((req, res, ctx) => {
 *   const { page, freeOnly } = req.variables;
 *   return res(
 *     ctx.data({ useTicketHistory })
 *   )
 * })
 */
export const mockUseTicketHistoryQuery = (resolver: ResponseResolver<GraphQLRequest<UseTicketHistoryQueryVariables>, GraphQLContext<UseTicketHistoryQuery>, any>) =>
  graphql.query<UseTicketHistoryQuery, UseTicketHistoryQueryVariables>(
    'useTicketHistory',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUserAndCashQuery((req, res, ctx) => {
 *   const { authInput } = req.variables;
 *   return res(
 *     ctx.data({ userAndCash })
 *   )
 * })
 */
export const mockUserAndCashQuery = (resolver: ResponseResolver<GraphQLRequest<UserAndCashQueryVariables>, GraphQLContext<UserAndCashQuery>, any>) =>
  graphql.query<UserAndCashQuery, UserAndCashQueryVariables>(
    'userAndCash',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUserCashQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ userCash })
 *   )
 * })
 */
export const mockUserCashQuery = (resolver: ResponseResolver<GraphQLRequest<UserCashQueryVariables>, GraphQLContext<UserCashQuery>, any>) =>
  graphql.query<UserCashQuery, UserCashQueryVariables>(
    'userCash',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFairplayCertificateUrlQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ fairplayCertificateUrl })
 *   )
 * })
 */
export const mockFairplayCertificateUrlQuery = (resolver: ResponseResolver<GraphQLRequest<FairplayCertificateUrlQueryVariables>, GraphQLContext<FairplayCertificateUrlQuery>, any>) =>
  graphql.query<FairplayCertificateUrlQuery, FairplayCertificateUrlQueryVariables>(
    'fairplayCertificateUrl',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockVodTokenQuery((req, res, ctx) => {
 *   const { productId, contentPackId, drmType } = req.variables;
 *   return res(
 *     ctx.data({ vodToken })
 *   )
 * })
 */
export const mockVodTokenQuery = (resolver: ResponseResolver<GraphQLRequest<VodTokenQueryVariables>, GraphQLContext<VodTokenQuery>, any>) =>
  graphql.query<VodTokenQuery, VodTokenQueryVariables>(
    'vodToken',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDrmAssertionQuery((req, res, ctx) => {
 *   const { productId, contentPackId } = req.variables;
 *   return res(
 *     ctx.data({ drmAssertion })
 *   )
 * })
 */
export const mockDrmAssertionQuery = (resolver: ResponseResolver<GraphQLRequest<DrmAssertionQueryVariables>, GraphQLContext<DrmAssertionQuery>, any>) =>
  graphql.query<DrmAssertionQuery, DrmAssertionQueryVariables>(
    'drmAssertion',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWelcomeQuery((req, res, ctx) => {
 *   return res(
 *     ctx.data({ welcome })
 *   )
 * })
 */
export const mockWelcomeQuery = (resolver: ResponseResolver<GraphQLRequest<WelcomeQueryVariables>, GraphQLContext<WelcomeQuery>, any>) =>
  graphql.query<WelcomeQuery, WelcomeQueryVariables>(
    'Welcome',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBuyAndUseTicketMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ buyAndUseTicket })
 *   )
 * })
 */
export const mockBuyAndUseTicketMutation = (resolver: ResponseResolver<GraphQLRequest<BuyAndUseTicketMutationVariables>, GraphQLContext<BuyAndUseTicketMutation>, any>) =>
  graphql.mutation<BuyAndUseTicketMutation, BuyAndUseTicketMutationVariables>(
    'BuyAndUseTicket',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBuyTicketMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ buyTicket })
 *   )
 * })
 */
export const mockBuyTicketMutation = (resolver: ResponseResolver<GraphQLRequest<BuyTicketMutationVariables>, GraphQLContext<BuyTicketMutation>, any>) =>
  graphql.mutation<BuyTicketMutation, BuyTicketMutationVariables>(
    'buyTicket',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentBuyTicketPageQuery((req, res, ctx) => {
 *   const { seriesId } = req.variables;
 *   return res(
 *     ctx.data({ contentBuyTicketPage })
 *   )
 * })
 */
export const mockContentBuyTicketPageQuery = (resolver: ResponseResolver<GraphQLRequest<ContentBuyTicketPageQueryVariables>, GraphQLContext<ContentBuyTicketPageQuery>, any>) =>
  graphql.query<ContentBuyTicketPageQuery, ContentBuyTicketPageQueryVariables>(
    'contentBuyTicketPage',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentCheckFreeTicketQuery((req, res, ctx) => {
 *   const { seriesId } = req.variables;
 *   return res(
 *     ctx.data({ contentCheckFreeTicket })
 *   )
 * })
 */
export const mockContentCheckFreeTicketQuery = (resolver: ResponseResolver<GraphQLRequest<ContentCheckFreeTicketQueryVariables>, GraphQLContext<ContentCheckFreeTicketQuery>, any>) =>
  graphql.query<ContentCheckFreeTicketQuery, ContentCheckFreeTicketQueryVariables>(
    'contentCheckFreeTicket',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentMyTicketQuery((req, res, ctx) => {
 *   const { seriesId, includeSingle, includeWaitfree, onlyPaidTicket } = req.variables;
 *   return res(
 *     ctx.data({ contentMyTicket })
 *   )
 * })
 */
export const mockContentMyTicketQuery = (resolver: ResponseResolver<GraphQLRequest<ContentMyTicketQueryVariables>, GraphQLContext<ContentMyTicketQuery>, any>) =>
  graphql.query<ContentMyTicketQuery, ContentMyTicketQueryVariables>(
    'contentMyTicket',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentTicketHistoryBuyQuery((req, res, ctx) => {
 *   const { seriesId, page } = req.variables;
 *   return res(
 *     ctx.data({ contentTicketHistoryBuy })
 *   )
 * })
 */
export const mockContentTicketHistoryBuyQuery = (resolver: ResponseResolver<GraphQLRequest<ContentTicketHistoryBuyQueryVariables>, GraphQLContext<ContentTicketHistoryBuyQuery>, any>) =>
  graphql.query<ContentTicketHistoryBuyQuery, ContentTicketHistoryBuyQueryVariables>(
    'contentTicketHistoryBuy',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContentTicketHistoryBuyDetailQuery((req, res, ctx) => {
 *   const { seriesId, ticketId } = req.variables;
 *   return res(
 *     ctx.data({ contentTicketHistoryBuyDetail })
 *   )
 * })
 */
export const mockContentTicketHistoryBuyDetailQuery = (resolver: ResponseResolver<GraphQLRequest<ContentTicketHistoryBuyDetailQueryVariables>, GraphQLContext<ContentTicketHistoryBuyDetailQuery>, any>) =>
  graphql.query<ContentTicketHistoryBuyDetailQuery, ContentTicketHistoryBuyDetailQueryVariables>(
    'contentTicketHistoryBuyDetail',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockReadyToUseTicketQuery((req, res, ctx) => {
 *   const { seriesId, productId } = req.variables;
 *   return res(
 *     ctx.data({ readyToUseTicket })
 *   )
 * })
 */
export const mockReadyToUseTicketQuery = (resolver: ResponseResolver<GraphQLRequest<ReadyToUseTicketQueryVariables>, GraphQLContext<ReadyToUseTicketQuery>, any>) =>
  graphql.query<ReadyToUseTicketQuery, ReadyToUseTicketQueryVariables>(
    'readyToUseTicket',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockReceiveTicketFreeMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ receiveTicketFree })
 *   )
 * })
 */
export const mockReceiveTicketFreeMutation = (resolver: ResponseResolver<GraphQLRequest<ReceiveTicketFreeMutationVariables>, GraphQLContext<ReceiveTicketFreeMutation>, any>) =>
  graphql.mutation<ReceiveTicketFreeMutation, ReceiveTicketFreeMutationVariables>(
    'ReceiveTicketFree',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSetBuyTicketMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ setBuyTicket })
 *   )
 * })
 */
export const mockSetBuyTicketMutation = (resolver: ResponseResolver<GraphQLRequest<SetBuyTicketMutationVariables>, GraphQLContext<SetBuyTicketMutation>, any>) =>
  graphql.mutation<SetBuyTicketMutation, SetBuyTicketMutationVariables>(
    'SetBuyTicket',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSetReadyToUseTicketQuery((req, res, ctx) => {
 *   const { setId, seriesId } = req.variables;
 *   return res(
 *     ctx.data({ setReadyToUseTicket })
 *   )
 * })
 */
export const mockSetReadyToUseTicketQuery = (resolver: ResponseResolver<GraphQLRequest<SetReadyToUseTicketQueryVariables>, GraphQLContext<SetReadyToUseTicketQuery>, any>) =>
  graphql.query<SetReadyToUseTicketQuery, SetReadyToUseTicketQueryVariables>(
    'setReadyToUseTicket',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAgeAuthQuery((req, res, ctx) => {
 *   const { ageLimit } = req.variables;
 *   return res(
 *     ctx.data({ ageAuth })
 *   )
 * })
 */
export const mockAgeAuthQuery = (resolver: ResponseResolver<GraphQLRequest<AgeAuthQueryVariables>, GraphQLContext<AgeAuthQuery>, any>) =>
  graphql.query<AgeAuthQuery, AgeAuthQueryVariables>(
    'ageAuth',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockChangeEmailPasswordMutation((req, res, ctx) => {
 *   const { changeEmailPasswordInput } = req.variables;
 *   return res(
 *     ctx.data({ changeEmailPassword })
 *   )
 * })
 */
export const mockChangeEmailPasswordMutation = (resolver: ResponseResolver<GraphQLRequest<ChangeEmailPasswordMutationVariables>, GraphQLContext<ChangeEmailPasswordMutation>, any>) =>
  graphql.mutation<ChangeEmailPasswordMutation, ChangeEmailPasswordMutationVariables>(
    'changeEmailPassword',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockViewerEndQuery((req, res, ctx) => {
 *   const { viewerEndInput } = req.variables;
 *   return res(
 *     ctx.data({ viewerEnd })
 *   )
 * })
 */
export const mockViewerEndQuery = (resolver: ResponseResolver<GraphQLRequest<ViewerEndQueryVariables>, GraphQLContext<ViewerEndQuery>, any>) =>
  graphql.query<ViewerEndQuery, ViewerEndQueryVariables>(
    'viewerEnd',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockViewerInfoQuery((req, res, ctx) => {
 *   const { seriesId, productId } = req.variables;
 *   return res(
 *     ctx.data({ viewerInfo })
 *   )
 * })
 */
export const mockViewerInfoQuery = (resolver: ResponseResolver<GraphQLRequest<ViewerInfoQueryVariables>, GraphQLContext<ViewerInfoQuery>, any>) =>
  graphql.query<ViewerInfoQuery, ViewerInfoQueryVariables>(
    'viewerInfo',
    resolver
  )

/**
 * @param resolver a function that accepts a captured request and may return a mocked response.
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLastPageMutation((req, res, ctx) => {
 *   const { input } = req.variables;
 *   return res(
 *     ctx.data({ viewerLastPage })
 *   )
 * })
 */
export const mockLastPageMutation = (resolver: ResponseResolver<GraphQLRequest<LastPageMutationVariables>, GraphQLContext<LastPageMutation>, any>) =>
  graphql.mutation<LastPageMutation, LastPageMutationVariables>(
    'LastPage',
    resolver
  )
